'use strict';

angular.module('apm.components.resources', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmResourcesLocationsListModalGrid = function () {

  /** @ngInject */
  function ApmResourcesLocationsListModalGrid($scope, apmResourcesLocationsService, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ApmResourcesLocationsListModalGrid);

    _.assign(this, {
      $scope: $scope,
      apmResourcesLocationsService: apmResourcesLocationsService,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      columnsSort: ['fullAddress', 'city', 'county', 'state', 'zip', ''],
      errorMessage: null,
      locationsListModalGridPage: {},
      page: 0,
      sorting: [],

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ApmResourcesLocationsListModalGrid, [{
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj && changeObj.location && changeObj.location.currentValue !== changeObj.location.previousValue) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      var params = this._getApiParams();

      return this.apmResourcesLocationsService.getLocationGroupByParentId(params).then(function (response) {
        return _this._getLocationGroupByParentIdSuccessHandler(response);
      }).catch(function (err) {
        return _this._getLocationGroupByParentIdErrorHandler(err);
      });
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'onClickLocationRemove',
    value: function onClickLocationRemove(e, locationId) {
      var _this2 = this;

      angular.element(e.currentTarget).hide();
      this.apmResourcesLocationsService.setLocationGroup({ childrenIds: locationId }).then(function () {
        return _this2._setLocationGroupSuccessHandler();
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        'page': this.page,
        '_count': this.pageSize,
        locationId: this.location.locationId
      }, this._getSortingParam());
    }
  }, {
    key: '_getLocationGroupByParentIdSuccessHandler',
    value: function _getLocationGroupByParentIdSuccessHandler(response) {
      var reportsListPage = {
        results: this._resolveFullAddress(_.get(_.first(response.data), 'children', [])),
        totalResultCount: _.get(_.first(response.data), 'children', []).length
      };
      this.errorMessage = null;

      this.locationsListModalGridPage = _.clone(reportsListPage.results, true);
      return reportsListPage;
    }
  }, {
    key: '_getLocationGroupByParentIdErrorHandler',
    value: function _getLocationGroupByParentIdErrorHandler(err) {
      var reportsListPage = {
        results: [],
        totalResultCount: 0
      };
      this._errorHandler(err);

      return reportsListPage;
    }
  }, {
    key: '_resolveFullAddress',
    value: function _resolveFullAddress(locations) {
      var result = [];
      _.forEach(locations, function (location) {
        location.fullAddress = {
          address1: location.address1,
          address2: _.get(location, 'address2', null)
        };
        delete location['address1'];
        delete location['address2'];
        result.push(location);
      });

      return result;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {};
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_setLocationGroupSuccessHandler',
    value: function _setLocationGroupSuccessHandler() {
      this.errorMessage = null;
      this.scNotificationsFactory.success('Location successfully removed');
      this.loadPageCallback(1);
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return ApmResourcesLocationsListModalGrid;
}();

angular.module('apm.components.resources').component('apmResourcesLocationsListModalGrid', {
  templateUrl: 'app/components/resources/locations/grid/modals/grid/apm.resources.locations.list.modal.grid.component.html',
  controller: ApmResourcesLocationsListModalGrid,
  bindings: {
    location: '<'
  }
});
'use strict';

angular.module('apm.components.actionPlans', ['apm.components.actionPlans.factories', 'apm.components.actionPlans.modals', 'chart.js']);

angular.module('apm.components.actionPlans.modals', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OnHoldModalController = function () {
  function OnHoldModalController($mdDialog, $scope, apmActionPlanService) {
    _classCallCheck(this, OnHoldModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      apmActionPlanService: apmActionPlanService,

      errorMessage: null,
      isNoteRequired: false,
      postObj: {
        onHoldReason: '',
        onHoldComments: ''
      }
    });
  }

  _createClass(OnHoldModalController, [{
    key: 'setReason',
    value: function setReason(code) {
      if (code === 'OTHER') {
        this.isNoteRequired = true;
      } else {
        this.isNoteRequired = false;
      }
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      var configObj = this.$scope.$parent.actionPlanContext;
      configObj.currentOperation = 'PutActionPlanOnHold';
      configObj.onHoldResult = {
        onHoldReason: this.postObj.onHoldReason,
        comments: this.postObj.onHoldComments
      };

      this.apmActionPlanService.saveActionPlanConfig(configObj, 'putActionPlanConfig').then(function (response) {
        return _this._saveSuccess(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$mdDialog.cancel();
    }
  }, {
    key: '_saveSuccess',
    value: function _saveSuccess(response) {
      this.errorMessage = null;
      if (response) {
        this.$mdDialog.hide();
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return OnHoldModalController;
}();

angular.module('apm.components.actionPlans.modals').component('onHoldModal', {
  templateUrl: 'app/components/actionPlans/details/header/modals/onHold/apm.details.onHoldModal.html',
  controller: OnHoldModalController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CancelModalController = function () {
  function CancelModalController($mdDialog, $scope, apmActionPlanService) {
    _classCallCheck(this, CancelModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      apmActionPlanService: apmActionPlanService,

      errorMessage: null,
      isNoteRequired: false,
      reasonObj: {
        cancellationReason: null,
        comments: ''
      },
      reasonsForCancellation: []
    });
  }

  _createClass(CancelModalController, [{
    key: '$onInit',
    value: function $onInit() {
      this._fetchReasonsForCancellation();
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      var configObj = this.$scope.$parent.actionPlanContext;
      configObj.currentOperation = 'CancelActionPlan';
      configObj.nextOperation = 'ConfigureActionPlan';
      configObj.cancellationResult = {
        cancellationReason: this.reasonObj.cancellationReason,
        comments: this.reasonObj.comments
      };

      this.apmActionPlanService.saveActionPlanConfig(configObj, 'putActionPlanConfig').then(function (response) {
        return _this._saveSuccess(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: 'setReason',
    value: function setReason(code) {
      if (code === 'OTHER') {
        this.isNoteRequired = true;
      }
    }
  }, {
    key: '_saveSuccess',
    value: function _saveSuccess(response) {
      this.errorMessage = null;
      if (response) {
        this.$mdDialog.hide();
      }
    }
  }, {
    key: '_fetchReasonsForCancellation',
    value: function _fetchReasonsForCancellation() {
      var _this2 = this;

      this.apmActionPlanService.getValueSetGroup('sc-actionplan-message-group', 'cancellationReason').then(function (response) {
        return _this2._fetchReasonsForCancellationSuccessHandler(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_fetchReasonsForCancellationSuccessHandler',
    value: function _fetchReasonsForCancellationSuccessHandler(response) {
      this.errorMessage = null;
      this.reasonsForCancellation = [];
      if (_.has(response, 'data')) {
        this.reasonsForCancellation = response.data;
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return CancelModalController;
}();

angular.module('apm.components.actionPlans.modals').component('cancelModal', {
  templateUrl: 'app/components/actionPlans/details/header/modals/cancel/apm.details.cancelModal.html',
  controller: CancelModalController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmResourcesLocationsListModal = function () {
  function ApmResourcesLocationsListModal($mdDialog, $state, scNotificationsFactory) {
    _classCallCheck(this, ApmResourcesLocationsListModal);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $state: $state,
      scNotificationsFactory: scNotificationsFactory
    });
  }

  _createClass(ApmResourcesLocationsListModal, [{
    key: '$onDestroy',
    value: function $onDestroy() {
      this.$state.reload();
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: '_showMessage',
    value: function _showMessage(message) {
      this.scNotificationsFactory.success(message);
    }
  }]);

  return ApmResourcesLocationsListModal;
}();

angular.module('apm.components.resources').component('resourcesLocationsListModal', {
  templateUrl: 'app/components/resources/locations/grid/modals/apm.resources.locations.list.modal.html',
  controller: ApmResourcesLocationsListModal,
  bindings: {
    location: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderProposedController = function () {

  /** @ngInject */
  function ApmDetailsHeaderProposedController($scope, $interval, $mdDialog, $state, apmActionPlanService, apmDetailsHeaderWorkflowService, scNotificationsFactory) {
    _classCallCheck(this, ApmDetailsHeaderProposedController);

    _.assign(this, {
      $scope: $scope,
      $interval: $interval,
      $mdDialog: $mdDialog,
      $state: $state,
      apmActionPlanService: apmActionPlanService,
      apmDetailsHeaderWorkflowService: apmDetailsHeaderWorkflowService,
      scNotificationsFactory: scNotificationsFactory,

      loading: false,
      processing: false,
      processingHandler: null,
      processingMessage: '',
      statusToDisplay: ''
    });
  }

  _createClass(ApmDetailsHeaderProposedController, [{
    key: '$onInit',
    value: function $onInit() {
      this.processing = true;
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (_.has(changesObj, 'actionPlan.currentValue') && changesObj.actionPlan.currentValue._id) {
        this.actionPlan.dates = this.apmDetailsHeaderWorkflowService.setEventDate(this.actionPlan);
        this.actionPlan.statusToDisplay = this.actionPlan.status === 'ON_HOLD' ? 'On Hold' : this.actionPlan.status.toLowerCase();
      }

      if (_.has(changesObj, 'actionPlanContext.currentValue')) {
        this.processing = changesObj.actionPlanContext.currentValue.processing;
        if (this.processing) {
          this._startStatusCheck();
        }
      }
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.$interval.cancel(this.processingHandler);
    }
  }, {
    key: 'getOperationPermissions',
    value: function getOperationPermissions(operation) {
      return _.compact(['scAPAdmin', this.apmActionPlanService.getPermissionsByOperation(operation.operationName)]).join(',');
    }
  }, {
    key: 'getClickEvent',
    value: function getClickEvent(type) {
      if (type === 'CancelActionPlan' || type === 'PutActionPlanOnHold') {
        this._setModalType(type);
      } else {
        this._updateActionPlanStatus(type);
      }
    }
  }, {
    key: '_saveActionPlanConfig',
    value: function _saveActionPlanConfig(actionPlanContext) {
      return this.apmActionPlanService.saveActionPlanConfig(actionPlanContext, 'putActionPlanConfig');
    }
  }, {
    key: '_getActionPlanStatus',
    value: function _getActionPlanStatus() {
      var _this = this;

      this._saveActionPlanConfig(this.actionPlanContext).then(function (response) {
        return _this._getActionPlanStatusSuccessHandler(response);
      }).catch(function (err) {
        return _this._getActionPlanStatusErrorHandler(err);
      });
    }
  }, {
    key: '_getActionPlanStatusSuccessHandler',
    value: function _getActionPlanStatusSuccessHandler(response) {
      if (_.has(response, 'processing') && !response.processing) {
        this.$interval.cancel(this.processingHandler);
        this.$state.reload();
      } else {
        this.actionPlanContext = response;
      }
    }
  }, {
    key: '_getActionPlanStatusErrorHandler',
    value: function _getActionPlanStatusErrorHandler(err) {
      var _this2 = this;

      this.$interval.cancel(this.processingHandler);

      if (this.actionPlanContext.currentOperation === 'CheckIsActionPlanProcessing') {
        this._errorHandler(err).finally(function () {
          return _this2.$state.reload();
        });
      } else {
        this._errorHandler(err);
      }
    }
  }, {
    key: '_startStatusCheck',
    value: function _startStatusCheck() {
      this.processingMessage = 'The Action Plan is currently processing a request';
      this.processingHandler = this.$interval(angular.bind(this, this._getActionPlanStatus), 5000);
    }
  }, {
    key: '_updateActionPlanStatus',
    value: function _updateActionPlanStatus(type) {
      var _this3 = this;

      this.loading = true;
      this.actionPlanContext.currentOperation = type;
      this._saveActionPlanConfig(this.actionPlanContext).then(function (response) {
        return _this3._updateActionPlanStatusSuccess(response, type);
      }).catch(function (err) {
        return _this3._errorHandler(err);
      });
    }
  }, {
    key: '_setModalType',
    value: function _setModalType(type) {
      var _this4 = this;

      var component = void 0;
      var scope = angular.extend(this.$scope.$new(true), {
        actionPlanContext: this.actionPlanContext
      });
      if (type === 'CancelActionPlan') {
        component = '<md-dialog aria-label="cancel modal" action-plan-context="actionPlanContext"><cancel-modal/></md-dialog>';
      } else {
        component = '<md-dialog aria-label="onHold modal"  action-plan-context="actionPlanContext"><on-hold-modal/></md-dialog>';
      }

      this.$mdDialog.show({
        template: component,
        clickOutsideToClose: true,
        scope: scope
      }).then(function () {
        return _this4.$state.reload();
      });
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.loading = false;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_updateActionPlanStatusSuccess',
    value: function _updateActionPlanStatusSuccess(response, type) {
      this.actionPlanContext = response;
      this.loading = false;
      if (type === 'SubmitActionPlanForApproval' || type === 'ApproveActionPlan') {
        this.scNotificationsFactory.success('Action Plan Approved successfully');
        this.$state.reload();
      } else {
        this.processing = true;
        this._startStatusCheck();
      }
    }
  }]);

  return ApmDetailsHeaderProposedController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderProposed', {
  templateUrl: 'app/components/actionPlans/details/header/proposed/apm.details.header.proposed.html',
  controller: ApmDetailsHeaderProposedController,
  bindings: {
    actionPlan: '<',
    actionPlanContext: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderActivePlansController = function () {

  /** @ngInject */
  function ApmDetailsHeaderActivePlansController($scope, $mdDialog, $state, apmActionPlanService, scNotificationsFactory) {
    _classCallCheck(this, ApmDetailsHeaderActivePlansController);

    _.assign(this, {
      $scope: $scope,
      $mdDialog: $mdDialog,
      $state: $state,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,

      hideIneligiblePatients: true,
      loading: false
    });
  }

  _createClass(ApmDetailsHeaderActivePlansController, [{
    key: '$onInit',
    value: function $onInit() {
      this.setPatients();
    }
  }, {
    key: 'getOperationPermissions',
    value: function getOperationPermissions(operation) {
      return _.compact(['scAPAdmin', this.apmActionPlanService.getPermissionsByOperation(operation.operationName)]).join(',');
    }
  }, {
    key: 'getClickEvent',
    value: function getClickEvent(type) {
      if (type !== 'CancelActionPlan') {
        this._updateActionPlanStatus(type);
      } else {
        this._openCancelModal();
      }
    }
  }, {
    key: 'setPatients',
    value: function setPatients() {
      this.$scope.$emit('hideIneligiblePatientsChanged', this.hideIneligiblePatients);
    }
  }, {
    key: '_updateActionPlanStatus',
    value: function _updateActionPlanStatus(type) {
      var _this = this;

      this.actionPlanContext.currentOperation = type;
      this.loading = true;
      this.apmActionPlanService.saveActionPlanConfig(this.actionPlanContext, 'putActionPlanConfig').then(function () {
        return _this._updateActionPlanStatusSuccess();
      }).catch(function (err) {
        return _this._updateActionPlanStatusError(err);
      });
    }
  }, {
    key: '_updateActionPlanStatusSuccess',
    value: function _updateActionPlanStatusSuccess() {
      this.loading = false;
      this.scNotificationsFactory.success('Action Plan Advanced Successfully');
      this.$state.reload();
    }
  }, {
    key: '_updateActionPlanStatusError',
    value: function _updateActionPlanStatusError(err) {
      this.loading = false;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_openCancelModal',
    value: function _openCancelModal() {
      var _this2 = this;

      this.loading = false;
      var scope = angular.extend(this.$scope.$new(true), {
        actionPlanContext: this.actionPlanContext
      });
      this.$mdDialog.show({
        template: '<md-dialog aria-label="cancel modal" action-plan-context="actionPlanContext"><cancel-modal/></md-dialog>',
        clickOutsideToClose: true,
        scope: scope
      }).then(function () {
        return _this2.$state.reload();
      });
    }
  }]);

  return ApmDetailsHeaderActivePlansController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderActivePlans', {
  templateUrl: 'app/components/actionPlans/details/header/activePlans/apm.details.header.activePlans.html',
  controller: ApmDetailsHeaderActivePlansController,
  bindings: {
    actionPlan: '<',
    actionPlanContext: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsGridScheduleController = function () {

  /** @ngInject */
  function ApmDetailsGridScheduleController($filter, $state, $stateParams, $window, apmActionPlanService, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ApmDetailsGridScheduleController);

    _.assign(this, {
      $filter: $filter,
      $state: $state,
      $stateParams: $stateParams,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      actionPlanPatientsPage: {
        results: [],
        totalResultCount: 0
      },
      columns: ['fullName', 'phone', 'lastVisit', 'pendingHCCValue', 'unmetCount', 'careTeamSummaries', 'apptStatus'],
      columnsSort: ['lastName', 'phone', 'lastVisit', 'pendingHCCValue', 'unmetSortableCount', 'careTeamSummaries', 'appointment'],
      hasPatients: true,
      isCancelled: false,
      restoreStateWhenComingFrom: ['patients.profile', 'actionPlans.schedule'],
      stateRestored: false,

      getStateCallback: function getStateCallback() {},
      loadPageCallback: function loadPageCallback() {},
      saveStateCallback: function saveStateCallback() {}
    });
  }

  _createClass(ApmDetailsGridScheduleController, [{
    key: '$onInit',
    value: function $onInit() {
      if (this.actionPlan.status === 'CANCELLED') {
        this.columns = _.without(this.columns, 'apptStatus');
        this.columnsSort = _.without(this.columnsSort, 'appointment');
        this.isCancelled = true;
      }
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (this._hideIneligiblePatientsHasChanged(changesObj.hideIneligiblePatients)) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'setGetStateCallback',
    value: function setGetStateCallback(callback) {
      this.getStateCallback = callback;
    }
  }, {
    key: 'setSaveStateCallback',
    value: function setSaveStateCallback(callback) {
      this.saveStateCallback = callback;
    }
  }, {
    key: 'restoreStateCallback',
    value: function restoreStateCallback(callback) {
      if (this._stateShouldBeRestored()) {
        callback();
      }
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      if (this._stateShouldBeRestored()) {
        var _getStateCallback = this.getStateCallback();

        page = _getStateCallback.page;
        pageSize = _getStateCallback.pageSize;
        options = _getStateCallback.options;

        this.stateRestored = true;
      }

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      this.saveStateCallback({ page: page, pageSize: pageSize, options: options });

      return this.apmActionPlanService.getActionPlanPatients(this.actionPlan._id, this._getApiParams()).then(function (response) {
        return _this._getActionPlanPatientsSuccessHandler(response);
      }).catch(function (err) {
        return _this._getActionPlanPatientsErrorHandler(err);
      });
    }
  }, {
    key: 'getPatientGaps',
    value: function getPatientGaps(patientId) {
      var gap = _.find(this.actionPlanPatientsPage.results, { patient: patientId });
      return _.has(gap, 'currentGaps') ? gap.currentGaps : undefined;
    }
  }, {
    key: 'getGapsTooltipTemplate',
    value: function getGapsTooltipTemplate(patientId) {
      var patientGaps = this.getPatientGaps(patientId);
      return _.map(patientGaps, function (gap, i) {
        return i + 1 + '. ' + gap.measureName;
      }).join('\n');
    }
  }, {
    key: 'getVendorTooltipTemplate',
    value: function getVendorTooltipTemplate(vendors) {
      var _this2 = this;

      return _.map(vendors, function (vendor) {
        return _this2._resolveVendorStatus(vendor.status) + ' with ' + vendor.name;
      }).join('\n');
    }
  }, {
    key: 'getVendorIcon',
    value: function getVendorIcon(vendors) {
      var active = _.uniq(vendors, 'status').length === 1 && _.uniq(vendors, 'status')[0].status === 'active';
      if (active === true) {
        return 'check_circle';
      } else if (active === false) {
        return 'not_interested';
      }
    }
  }, {
    key: 'navigateToPatientDetails',
    value: function navigateToPatientDetails(patientId) {
      this.$window.sessionStorage.setItem('returnState', this.$stateParams.id);
      this.$state.go('patients.profile', { patientId: patientId });
    }
  }, {
    key: '_resolveVendorStatus',
    value: function _resolveVendorStatus(status) {
      return status === 'active' ? 'Active' : 'Inactive';
    }
  }, {
    key: '_hideIneligiblePatientsHasChanged',
    value: function _hideIneligiblePatientsHasChanged(hideIneligiblePatients) {
      return !hideIneligiblePatients.isFirstChange() && !_.isUndefined(hideIneligiblePatients.previousValue) && hideIneligiblePatients.currentValue !== hideIneligiblePatients.previousValue;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      var params = {
        sorting: [this._getSortingParam()],
        paging: {
          page: this.page,
          '_count': this.pageSize
        }
      };

      if (this.hideIneligiblePatients) {
        params.active = this.hideIneligiblePatients;
      }

      return params;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = this.actionPlan.sortBy === 'LAST_VISIT' ? {
        key: '_sort:asc',
        value: 'lastVisit'
      } : { key: '_sort:desc', value: 'unmetSortableCount' };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting.key = '_sort:' + value.sort;
          sorting.value = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_getActionPlanPatientsSuccessHandler',
    value: function _getActionPlanPatientsSuccessHandler(response) {
      var _this3 = this;

      this.actionPlanPatientsPage.results = [];
      if (_.has(response, 'data.patients')) {
        var responseData = response.data.patients;

        angular.forEach(responseData.content, function (patient) {
          patient.fullName = patient.lastName + ', ' + patient.firstName;
          patient.birthDate = '' + moment(patient.birthDate).format('MM/DD/YYYY');
          patient.lastVisit = _this3._setLastVisitDate(patient.lastVisit);
          patient.apptStatus = _this3._getAppointmentStatus(patient);
          patient.pendingHCCValue = _this3._resolveHCC(patient.pendingHCCValue);

          _this3.actionPlanPatientsPage.results.push(patient);
        });
        this.hasPatients = responseData.totalElements > 0;
        this.actionPlanPatientsPage.results = _.uniq(this.actionPlanPatientsPage.results, 'patient');
        this.actionPlanPatientsPage.totalResultCount = responseData.totalElements;
      }

      return this.actionPlanPatientsPage;
    }
  }, {
    key: '_getActionPlanPatientsErrorHandler',
    value: function _getActionPlanPatientsErrorHandler(err) {
      this.actionPlanPatientsPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return this.actionPlanPatientsPage;
    }
  }, {
    key: '_resolveHCC',
    value: function _resolveHCC(value) {
      if (value) {
        return this.$filter('number')(value, 3);
      } else {
        return 'N/A';
      }
    }
  }, {
    key: '_setLastVisitDate',
    value: function _setLastVisitDate(date) {
      return angular.isDefined(date) ? '' + moment(date).format('MM/DD/YYYY') : '';
    }
  }, {
    key: '_getAppointmentStatus',
    value: function _getAppointmentStatus(patient) {
      var apptStatus = {};
      apptStatus.accent = false;

      switch (patient.iconCode) {
        case 0:
          apptStatus.icon = 'chat_bubble';
          apptStatus.text = 'Not Called';
          break;
        case 1:
          apptStatus.text = 'Scheduled';
          if (patient.appointment) {
            apptStatus.time = patient.appointment.displayValue || 'N/A';
          }
          break;
        case 2:
          apptStatus.icon = 'close';
          apptStatus.text = 'Do Not Call';
          break;
        case 3:
          apptStatus.icon = 'chat';
          apptStatus.text = 'Calls Made';
          apptStatus.accent = true;
          break;
      }

      return apptStatus;
    }
  }, {
    key: '_stateShouldBeRestored',
    value: function _stateShouldBeRestored() {
      return _.has(this.$state, 'previous.name') && _.includes(this.restoreStateWhenComingFrom, this.$state.previous.name) && !this.stateRestored;
    }
  }]);

  return ApmDetailsGridScheduleController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsGridSchedule', {
  templateUrl: 'app/components/actionPlans/details/grid/schedule/apm.details.grid.schedule.html',
  controller: ApmDetailsGridScheduleController,
  bindings: {
    actionPlan: '<',
    hideIneligiblePatients: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsGridReminderController = function () {

  /** @ngInject */
  function ApmDetailsGridReminderController($filter, $state, $stateParams, $window, apmActionPlanService, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ApmDetailsGridReminderController);

    _.assign(this, {
      $filter: $filter,
      $state: $state,
      $stateParams: $stateParams,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      actionPlanPatientsPage: {
        results: [],
        totalResultCount: 0
      },
      columns: ['fullName', 'phone', 'pendingHCCValue', 'unmetCount', 'careTeamSummaries', 'appt', 'results'],
      columnsSort: ['lastName', 'phone', 'pendingHCCValue', 'unmetSortableCount', 'careTeamSummaries', 'appointment', 'results'],
      isCancelled: false,
      restoreStateWhenComingFrom: ['patients.profile', 'actionPlans.reminder'],
      stateRestored: false,

      getStateCallback: function getStateCallback() {},
      loadPageCallback: function loadPageCallback() {},
      saveStateCallback: function saveStateCallback() {}
    });
  }

  _createClass(ApmDetailsGridReminderController, [{
    key: '$onInit',
    value: function $onInit() {
      if (this.actionPlan.status === 'CANCELLED') {
        this.columns = _.without(this.columns, 'results');
        this.isCancelled = true;
      }
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (this._hideIneligiblePatientsHasChanged(changesObj.hideIneligiblePatients)) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'setGetStateCallback',
    value: function setGetStateCallback(callback) {
      this.getStateCallback = callback;
    }
  }, {
    key: 'setSaveStateCallback',
    value: function setSaveStateCallback(callback) {
      this.saveStateCallback = callback;
    }
  }, {
    key: 'restoreStateCallback',
    value: function restoreStateCallback(callback) {
      if (this._stateShouldBeRestored()) {
        callback();
      }
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      if (this._stateShouldBeRestored()) {
        var _getStateCallback = this.getStateCallback();

        page = _getStateCallback.page;
        pageSize = _getStateCallback.pageSize;
        options = _getStateCallback.options;

        this.stateRestored = true;
      }

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      this.saveStateCallback({ page: page, pageSize: pageSize, options: options });

      return this.apmActionPlanService.getActionPlanPatients(this.actionPlan._id, this._getApiParams()).then(function (response) {
        return _this._getActionPlanPatientsSuccessHandler(response);
      }).catch(function (err) {
        return _this._getActionPlanPatientsErrorHandler(err);
      });
    }
  }, {
    key: 'getPatientGaps',
    value: function getPatientGaps(patientId) {
      var gap = _.find(this.actionPlanPatientsPage.results, { patient: patientId });
      return _.has(gap, 'currentGaps') ? gap.currentGaps : undefined;
    }
  }, {
    key: 'getGapsTooltipTemplate',
    value: function getGapsTooltipTemplate(patientId) {
      var patientGaps = this.getPatientGaps(patientId);
      return _.map(patientGaps, function (gap, i) {
        return i + 1 + '. ' + gap.measureName;
      }).join('\n');
    }
  }, {
    key: 'getVendorTooltipTemplate',
    value: function getVendorTooltipTemplate(vendors) {
      var _this2 = this;

      return _.map(vendors, function (vendor) {
        return _this2._resolveVendorStatus(vendor.status) + ' with ' + vendor.name;
      }).join('\n');
    }
  }, {
    key: 'getVendorIcon',
    value: function getVendorIcon(vendors) {
      var active = _.uniq(vendors, 'status').length === 1 && _.uniq(vendors, 'status')[0].status === 'active';
      if (active === true) {
        return 'check_circle';
      } else if (active === false) {
        return 'not_interested';
      }
    }
  }, {
    key: 'navigateToPatientDetails',
    value: function navigateToPatientDetails(patientId) {
      this.$window.sessionStorage.setItem('returnState', this.$stateParams.id);
      this.$state.go('patients.profile', { patientId: patientId });
    }
  }, {
    key: '_resolveVendorStatus',
    value: function _resolveVendorStatus(status) {
      return status === 'active' ? 'Active' : 'Inactive';
    }
  }, {
    key: '_hideIneligiblePatientsHasChanged',
    value: function _hideIneligiblePatientsHasChanged(hideIneligiblePatients) {
      return !hideIneligiblePatients.isFirstChange() && !_.isUndefined(hideIneligiblePatients.previousValue) && hideIneligiblePatients.currentValue !== hideIneligiblePatients.previousValue;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      var params = {
        sorting: [this._getSortingParam()],
        paging: {
          page: this.page,
          '_count': this.pageSize
        }
      };

      if (this.hideIneligiblePatients) {
        params.active = this.hideIneligiblePatients;
      }

      return params;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = { key: '_sort:asc', value: 'appointment' };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {

        if (value.sort !== false) {
          sorting = {};
          sorting.key = '_sort:' + value.sort;
          sorting.value = columnSortMapping[index];
          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_getActionPlanPatientsSuccessHandler',
    value: function _getActionPlanPatientsSuccessHandler(response) {
      var _this3 = this;

      this.actionPlanPatientsPage.results = [];
      if (_.has(response, 'data.patients')) {
        var responseData = response.data.patients;

        angular.forEach(responseData.content, function (patient) {

          patient.fullName = patient.lastName + ', ' + patient.firstName;
          patient.birthDate = '' + moment(patient.birthDate).format('MM/DD/YYYY');
          patient.appt = _this3._getAppointment(patient);
          patient.results = _this3._getReminderStatus(patient);
          patient.pendingHCCValue = _this3._resolveHCC(patient.pendingHCCValue);

          _this3.actionPlanPatientsPage.results.push(patient);
        }, this);
        this.actionPlanPatientsPage.results = _.uniq(this.actionPlanPatientsPage.results, 'patient');
        this.actionPlanPatientsPage.totalResultCount = responseData.totalElements;
      }

      return this.actionPlanPatientsPage;
    }
  }, {
    key: '_getActionPlanPatientsErrorHandler',
    value: function _getActionPlanPatientsErrorHandler(err) {
      this.actionPlanPatientsPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return this.actionPlanPatientsPage;
    }
  }, {
    key: '_resolveHCC',
    value: function _resolveHCC(value) {
      if (value) {
        return this.$filter('number')(value, 3);
      } else {
        return 'N/A';
      }
    }
  }, {
    key: '_getAppointment',
    value: function _getAppointment(patient) {
      var appt = '';

      var isCancelled = false;
      _.forEach(patient.actionPlanActivities, function (el) {
        if (el.reminderStatus === 'cancelled') {
          isCancelled = true;
        }
      });

      if (patient.appointment) {
        appt = patient.appointment.displayValue;
      }
      if (isCancelled) {
        appt = 'Cancelled';
      }
      return appt;
    }
  }, {
    key: '_getReminderStatus',
    value: function _getReminderStatus(patient) {
      var reminderStatus = {};
      reminderStatus.accent = false;
      reminderStatus.lightGray = false;

      switch (patient.iconCode) {
        case 0:
          reminderStatus.icon = 'chat_bubble';
          reminderStatus.text = 'Not Called';
          reminderStatus.lightGray = true;
          break;
        case 1:
          reminderStatus.icon = 'check_circle';
          reminderStatus.text = 'Confirmed';
          break;
        case 2:
          reminderStatus.icon = 'close';
          reminderStatus.text = 'Do Not Call';
          reminderStatus.lightGray = true;
          break;
        case 3:
          reminderStatus.icon = 'chat';
          reminderStatus.text = 'Calls Made';
          reminderStatus.accent = true;
          break;
      }

      return reminderStatus;
    }
  }, {
    key: '_stateShouldBeRestored',
    value: function _stateShouldBeRestored() {
      return _.has(this.$state, 'previous.name') && _.includes(this.restoreStateWhenComingFrom, this.$state.previous.name) && !this.stateRestored;
    }
  }]);

  return ApmDetailsGridReminderController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsGridReminder', {
  templateUrl: 'app/components/actionPlans/details/grid/reminder/apm.details.grid.reminder.html',
  controller: ApmDetailsGridReminderController,
  bindings: {
    actionPlan: '<',
    hideIneligiblePatients: '<'
  }
});
'use strict';

angular.module('apm.components.actionPlans').component('apmDetailsGridProposed', {
  templateUrl: 'app/components/actionPlans/details/grid/proposed/apm.details.grid.proposed.html',
  controller: function controller() {},
  bindings: {
    actionPlan: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsGridEncounterController = function () {

  /** @ngInject */
  function ApmDetailsGridEncounterController($filter, $state, $stateParams, $window, apmActionPlanService, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ApmDetailsGridEncounterController);

    _.assign(this, {
      $filter: $filter,
      $state: $state,
      $stateParams: $stateParams,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      actionPlanPatientsPage: {
        results: [],
        totalResultCount: 0
      },
      columns: ['fullName', 'phone', 'pendingHCCValue', 'unmetCount', 'appt', 'results'],
      columnsSort: ['lastName', 'phone', 'pendingHCCValue', 'unmetSortableCount', 'appointment', 'results'],
      restoreStateWhenComingFrom: ['patients.profile', 'actionPlans.encounter'],
      stateRestored: false,

      getStateCallback: function getStateCallback() {},
      loadPageCallback: function loadPageCallback() {},
      saveStateCallback: function saveStateCallback() {}
    });
  }

  _createClass(ApmDetailsGridEncounterController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (this._hideIneligiblePatientsHasChanged(changesObj.hideIneligiblePatients)) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'setGetStateCallback',
    value: function setGetStateCallback(callback) {
      this.getStateCallback = callback;
    }
  }, {
    key: 'setSaveStateCallback',
    value: function setSaveStateCallback(callback) {
      this.saveStateCallback = callback;
    }
  }, {
    key: 'restoreStateCallback',
    value: function restoreStateCallback(callback) {
      if (this._stateShouldBeRestored()) {
        callback();
      }
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      if (this._stateShouldBeRestored()) {
        var _getStateCallback = this.getStateCallback();

        page = _getStateCallback.page;
        pageSize = _getStateCallback.pageSize;
        options = _getStateCallback.options;

        this.stateRestored = true;
      }

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      this.saveStateCallback({ page: page, pageSize: pageSize, options: options });

      return this.apmActionPlanService.getActionPlanPatients(this.actionPlan._id, this._getApiParams()).then(function (response) {
        return _this._getActionPlanPatientsSuccessHandler(response);
      }).catch(function (err) {
        return _this._getActionPlanPatientsErrorHandler(err);
      });
    }
  }, {
    key: 'getPatientGaps',
    value: function getPatientGaps(patientId) {
      var gap = _.find(this.actionPlanPatientsPage.results, { patient: patientId });
      return _.has(gap, 'currentGaps') ? gap.currentGaps : undefined;
    }
  }, {
    key: 'getGapsTooltipTemplate',
    value: function getGapsTooltipTemplate(patientId) {
      var patientGaps = this.getPatientGaps(patientId);
      return _.map(patientGaps, function (gap, i) {
        return i + 1 + '. ' + gap.measureName;
      }).join('\n');
    }
  }, {
    key: 'navigateToPatientDetails',
    value: function navigateToPatientDetails(patientId) {
      this.$window.sessionStorage.setItem('returnState', this.$stateParams.id);
      this.$state.go('patients.profile', { patientId: patientId });
    }
  }, {
    key: '_hideIneligiblePatientsHasChanged',
    value: function _hideIneligiblePatientsHasChanged(hideIneligiblePatients) {
      return !hideIneligiblePatients.isFirstChange() && !_.isUndefined(hideIneligiblePatients.previousValue) && hideIneligiblePatients.currentValue !== hideIneligiblePatients.previousValue;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      var params = {
        sorting: [this._getSortingParam()],
        paging: {
          page: this.page,
          '_count': this.pageSize
        }
      };

      if (this.hideIneligiblePatients) {
        params.active = this.hideIneligiblePatients;
      }

      return params;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = { key: '_sort:asc', value: 'appointment' };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting.key = '_sort:' + value.sort;
          sorting.value = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_getActionPlanPatientsSuccessHandler',
    value: function _getActionPlanPatientsSuccessHandler(response) {
      var _this2 = this;

      this.actionPlanPatientsPage.results = [];
      if (_.has(response, 'data.patients')) {
        var responseData = response.data.patients;

        angular.forEach(responseData.content, function (patient) {

          patient.fullName = patient.lastName + ', ' + patient.firstName;
          patient.birthDate = '' + moment(patient.birthDate).format('MM/DD/YYYY');
          patient.appt = _this2._getAppointment(patient);
          patient.results = _this2._getEncounterStatus(patient);
          patient.pendingHCCValue = _this2._resolveHCC(patient.pendingHCCValue);

          _this2.actionPlanPatientsPage.results.push(patient);
        }, this);
        this.actionPlanPatientsPage.results = _.uniq(this.actionPlanPatientsPage.results, 'patient');
        this.actionPlanPatientsPage.totalResultCount = responseData.totalElements;
      }

      return this.actionPlanPatientsPage;
    }
  }, {
    key: '_getActionPlanPatientsErrorHandler',
    value: function _getActionPlanPatientsErrorHandler(err) {
      this.actionPlanPatientsPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return this.actionPlanPatientsPage;
    }
  }, {
    key: '_resolveHCC',
    value: function _resolveHCC(value) {
      if (value) {
        return this.$filter('number')(value, 3);
      } else {
        return 'N/A';
      }
    }
  }, {
    key: '_getAppointment',
    value: function _getAppointment(patient) {
      var appt = '';

      var isCancelled = false;
      _.forEach(patient.actionPlanActivities, function (el) {
        if (el.reminderStatus === 'cancelled') {
          isCancelled = true;
        }
      });

      if (patient.appointment) {
        appt = patient.appointment.displayValue;
      }
      if (isCancelled) {
        appt = 'Cancelled';
      }
      return appt;
    }
  }, {
    key: '_getEncounterStatus',
    value: function _getEncounterStatus(patient) {
      var encounterStatus = {};
      encounterStatus.lightGray = false;
      switch (patient.iconCode) {
        case 0:
          encounterStatus.icon = 'insert_invitation';
          encounterStatus.text = 'Not Seen';
          encounterStatus.lightGray = true;
          break;
        case 2:
          encounterStatus.hideLink = true;
          encounterStatus.icon = 'close';
          encounterStatus.text = 'Cancelled';
          encounterStatus.lightGray = true;
          break;
        case 4:
          encounterStatus.icon = 'event_available';
          encounterStatus.text = 'Results Entered';
          break;
        case 5:
          encounterStatus.icon = 'event_busy';
          encounterStatus.text = 'No-Show';
          encounterStatus.lightGray = true;
          break;
      }

      return encounterStatus;
    }
  }, {
    key: '_stateShouldBeRestored',
    value: function _stateShouldBeRestored() {
      return _.has(this.$state, 'previous.name') && _.includes(this.restoreStateWhenComingFrom, this.$state.previous.name) && !this.stateRestored;
    }
  }]);

  return ApmDetailsGridEncounterController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsGridEncounter', {
  templateUrl: 'app/components/actionPlans/details/grid/encounter/apm.details.grid.encounter.component.html',
  controller: ApmDetailsGridEncounterController,
  bindings: {
    actionPlan: '<',
    hideIneligiblePatients: '<'
  }
});
'use strict';

angular.module('apm.components.actionPlans').component('apmDetailsGridCancelled', {
  templateUrl: 'app/components/actionPlans/details/grid/cancelled/apm.details.grid.cancelled.html',
  bindings: {
    actionPlan: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScheduleCallResultActionsController = function () {

  /** @ngInject */
  function ScheduleCallResultActionsController($scope, $state, $stateParams, $timeout, apmActionPlanService, scNotificationsFactory) {
    _classCallCheck(this, ScheduleCallResultActionsController);

    _.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      $timeout: $timeout,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,

      actionPlanContextId: null,
      dispositionArray: [],
      eventDates: [],
      isPluralDates: false,
      timeSlots: [],
      eventTimes: [],
      saveClicked: false,

      postObj: {
        patientId: null,
        appointment: null,
        appointmentId: null,
        slotId: null,
        appointmentComment: '',
        callResult: {
          callOutcome: '',
          comments: ''
        }
      },

      providerLocation: {},
      actionPlanContext: {},
      template: ''
    });
  }

  _createClass(ScheduleCallResultActionsController, [{
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj.patient.currentValue._id) {
        this._getValueSet();
        this._getActionPlan();
        this._getTimeSlots();
        this.postObj.patientId = this.$stateParams.patientId;
        this._setPatientComment();
        this._getActionPlanContext();
      }
    }
  }, {
    key: 'updateAppointment',
    value: function updateAppointment() {
      this.postObj.slotId = null;
      this.postObj.appointment = null;
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      if (!this.saveClicked) {
        this.saveClicked = !this.saveClicked;
        if (this.$scope.callResultActionsForm.$valid) {
          this._setPostObj();
          var saveType = this.$state.$current.component === 'scheduleActions' ? 'schedule' : 'reminder';
          this._setActionPlanContext(saveType);
          this.apmActionPlanService.saveActionPlanConfig(this.actionPlanContext, 'putActionPlanConfig').then(function () {
            return _this._saveSuccess();
          }).catch(function (err) {
            return _this._saveError(err);
          });
        } else {
          this.saveClicked = !this.saveClicked;
        }
      }
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
    }
  }, {
    key: '_getActionPlanContext',
    value: function _getActionPlanContext() {
      var _this2 = this;

      this.apmActionPlanService.getActionPlanConfig(this.$stateParams.planId).then(function (response) {
        _this2.template = response.template;
        _this2.actionPlanContextId = response._id;
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_setActionPlanContext',
    value: function _setActionPlanContext(saveType) {
      this.actionPlanContext = {
        _id: this.actionPlanContextId,
        template: this.template,
        currentOperation: saveType === 'schedule' ? 'ScheduleAppointment' : 'RemindAppointment',
        patientId: this.$stateParams.patientId,
        actionPlanId: this.$stateParams.planId,
        actionPlanPatientSchedule: {
          patientId: this.$stateParams.patientId,
          slotId: this.postObj.slotId,
          appointmentComment: this.postObj.appointmentComment,
          callResult: {
            callOutcome: this.postObj.callResult.callOutcome,
            comment: this.postObj.callResult.comment,
            comments: this.postObj.callResult.comments
          }
        }
      };
    }
  }, {
    key: '_setPostObj',
    value: function _setPostObj() {
      if (this.postObj.appointment && this.postObj.callResult.callOutcome === 'APPOINTMENT_SCHEDULED') {
        this.postObj.appointment = moment(new Date(this.postObj.appointment)).toISOString();
      }
      if (this.postObj.callResult.callOutcome !== 'REFUSED_OTHER') {
        this.postObj.callResult.comment = false;
      }
      if (this.postObj.callResult.callOutcome !== 'APPOINTMENT_SCHEDULED') {
        this.postObj.slotId = null;
      }
      if (this.postObj.appointment && this.postObj.callResult.callOutcome !== 'APPOINTMENT_SCHEDULED') {
        this.postObj.appointment = null;
      }
    }
  }, {
    key: '_setPatientComment',
    value: function _setPatientComment() {
      var _this3 = this;

      this.$timeout(function () {
        _this3.postObj.appointmentComment = _this3.patient.appointmentComment;
      });
    }
  }, {
    key: '_saveSuccess',
    value: function _saveSuccess() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
      this.scNotificationsFactory.success('Successfully updated appointment status');
    }
  }, {
    key: '_saveError',
    value: function _saveError(err) {
      this.saveClicked = !this.saveClicked;
      this._errorHandler(err);
    }
  }, {
    key: '_getTimeSlots',
    value: function _getTimeSlots() {
      var _this4 = this;

      this.apmActionPlanService.getTimeSlots(this.$stateParams.planId).then(function (res) {
        if (_.has(res, 'data')) {
          _this4._getTimeSlotsSuccess(_.sortBy(res.data, 'start'));
        }
      }).catch(function (err) {
        return _this4._errorHandler(err);
      });
    }
  }, {
    key: '_getTimeSlotsSuccess',
    value: function _getTimeSlotsSuccess(timeSlots) {
      var prevSlot = void 0;
      var tempArr = [];
      _.forEach(timeSlots, function (slot, i) {
        if (slot) {
          var timeDisplay = slot.start.displayValue;
          if (prevSlot && prevSlot.start.displayValue === slot.start.displayValue) {
            timeDisplay += '  (2 slots available)';
            delete tempArr[i - 1];
          }
          tempArr.push({
            label: timeDisplay,
            value: slot.id
          });
          prevSlot = slot;
        }
      });
      this.timeSlots = _.filter(tempArr, Boolean);
      if (!this.isPluralDates) {
        this.postObj.appointment = this.eventDates[0];
        this.eventTimes = this.timeSlots;
      }
    }
  }, {
    key: '_getActionPlan',
    value: function _getActionPlan() {
      var _this5 = this;

      this.apmActionPlanService.getActionPlan(this.$stateParams.planId).then(function (res) {
        return _this5._getActionPlanSuccess(res);
      }).catch(function (err) {
        return _this5._errorHandler(err);
      });
    }
  }, {
    key: '_getActionPlanSuccess',
    value: function _getActionPlanSuccess(res) {
      if (_.has(res, 'data')) {
        this.eventDates = res.data.eventDates && res.data.eventDates.length ? res.data.eventDates : [];
        this.isPluralDates = this.eventDates.length > 1;
      }
      if (_.has(res, 'data.location')) {
        this.providerLocation = res.data.location;
      }
    }
  }, {
    key: '_getValueSet',
    value: function _getValueSet() {
      var _this6 = this;

      this.apmActionPlanService.getValueSetGroup('sc-call-results-group', 'scheduling').then(function (res) {
        return _this6._getValueSetSuccess(res);
      }).catch(function (err) {
        return _this6._errorHandler(err);
      });
    }
  }, {
    key: '_getValueSetSuccess',
    value: function _getValueSetSuccess(res) {
      if (_.has(res, 'data')) {
        this.dispositionArray = _.filter(res.data, function (el) {
          return el.code !== 'CANCELLED';
        }).filter(function (el) {
          return el.code !== 'RESCHEDULED';
        });
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return ScheduleCallResultActionsController;
}();

angular.module('apm.components.actionPlans').component('scheduleCallResultActions', {
  templateUrl: 'app/components/actionPlans/actions/schedule/callResult/apm.actionPlans.actions.schedule.callResult.html',
  controller: ScheduleCallResultActionsController,
  bindings: {
    isReadOnly: '<',
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReminderCallResultActionsController = function () {

  /** @ngInject */
  function ReminderCallResultActionsController($scope, $state, $stateParams, $timeout, apmActionPlanService, scNotificationsFactory) {
    _classCallCheck(this, ReminderCallResultActionsController);

    _.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      $timeout: $timeout,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,

      actionPlanContextId: null,
      appointmentDate: '',
      appointmentDateTimeDisplay: '',
      appointmentTime: '',
      dispositionArray: [],
      eventDates: [],
      eventTimes: [],
      isPluralDates: false,
      postObj: {
        patientId: null,
        appointment: null,
        appointmentId: null,
        slotId: null,
        appointmentComment: '',
        callResult: {
          callOutcome: '',
          comments: ''
        }
      },
      providerLocation: {},
      saveClicked: false,
      template: '',
      timeSlots: []
    });
  }

  _createClass(ReminderCallResultActionsController, [{
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj.patient.currentValue._id) {
        this._setPatientComment();
        if (this.$state.$current.component !== 'encounterActions') {
          this._getValueSet();
          this._getActionPlan();
          this._getTimeSlots();
        }
        this._setAppointmentOnLoad();
        this.postObj.patientId = this.$stateParams.patientId;
        this._getActionPlanContext();
      }
    }
  }, {
    key: 'setDisposition',
    value: function setDisposition() {
      this.hasAppointment = this.postObj.callResult.callOutcome !== 'RESCHEDULED';
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      if (!this.saveClicked) {
        this.saveClicked = !this.saveClicked;
        if (this.$scope.callResultActionsForm.$valid) {
          this._setPostObj();
          var saveType = this.$state.$current.component === 'scheduleActions' ? 'schedule' : 'reminder';
          this._setActionPlanContext(saveType);
          this.apmActionPlanService.saveActionPlanConfig(this.actionPlanContext, 'putActionPlanConfig').then(function () {
            return _this._saveSuccess();
          }).catch(function (err) {
            return _this._saveError(err);
          });
        } else {
          this.saveClicked = !this.saveClicked;
        }
      }
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
    }
  }, {
    key: '_getActionPlanContext',
    value: function _getActionPlanContext() {
      var _this2 = this;

      this.apmActionPlanService.getActionPlanConfig(this.$stateParams.planId).then(function (response) {
        _this2.template = response.template;
        _this2.currentAction = response._id;
        _this2.actionPlanContextId = response._id;
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_setActionPlanContext',
    value: function _setActionPlanContext(saveType) {
      this.actionPlanContext = {
        _id: this.actionPlanContextId,
        template: this.template,
        currentOperation: saveType === 'schedule' ? 'ScheduleAppointment' : 'RemindAppointment',
        patientId: this.$stateParams.patientId,
        actionPlanId: this.$stateParams.planId,
        actionPlanPatientSchedule: {
          patientId: this.$stateParams.patientId,
          slotId: this.postObj.slotId,
          appointmentComment: this.postObj.appointmentComment,
          callResult: {
            callOutcome: this.postObj.callResult.callOutcome,
            comment: this.postObj.callResult.comment,
            comments: this.postObj.callResult.comments
          }
        }
      };
    }
  }, {
    key: '_setPatientComment',
    value: function _setPatientComment() {
      var _this3 = this;

      this.$timeout(function () {
        _this3.postObj.appointmentComment = _this3.patient.appointmentComment;
      });
    }
  }, {
    key: '_setAppointmentOnLoad',
    value: function _setAppointmentOnLoad() {
      var _this4 = this;

      this.$timeout(function () {
        if (_this4.hasAppointment) {
          _this4.appointmentDateTimeDisplay = _this4.patient.appointment.displayValue;
          _this4.appointmentTime = _this4.appointmentDateTimeDisplay.substr(_this4.appointmentDateTimeDisplay.indexOf(' ') + 1).replace(' ', '').toLowerCase();
        }
      });
    }
  }, {
    key: '_saveSuccess',
    value: function _saveSuccess() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
      this.scNotificationsFactory.success('Successfully updated appointment status');
    }
  }, {
    key: '_saveError',
    value: function _saveError(err) {
      this._errorHandler(err);
      this.saveClicked = !this.saveClicked;
    }
  }, {
    key: '_setPostObj',
    value: function _setPostObj() {
      if (this.postObj.appointment && this.postObj.callResult.callOutcome === 'RESCHEDULED') {
        this.postObj.appointment = moment(new Date(this.postObj.appointment)).toISOString();
      }
      if (this.postObj.callResult.callOutcome !== 'CANCELLED') {
        this.postObj.callResult.comments = '';
      }
      if (this.postObj.callResult.callOutcome !== 'RESCHEDULED' && _.has(this.patient, 'slotId')) {
        this.postObj.slotId = this.patient.slotId;
      }
      if (this.postObj.appointment && this.postObj.callResult.callOutcome !== 'RESCHEDULED') {
        this.postObj.appointment = null;
      }
      if (this.postObj.callResult.callOutcome === 'CANCELLED' && !this.postObj.callResult.comments) {
        this.$scope.callResultActionsForm.dispositionComment.$setValidity('required', false);
      }
    }
  }, {
    key: '_getTimeSlots',
    value: function _getTimeSlots() {
      var _this5 = this;

      this.apmActionPlanService.getTimeSlots(this.$stateParams.planId).then(function (res) {
        if (_.has(res, 'data')) {
          _this5._getTimeSlotsSuccess(_.sortBy(res.data, 'start'));
        }
      }).catch(function (err) {
        return _this5._errorHandler(err);
      });
    }
  }, {
    key: '_getTimeSlotsSuccess',
    value: function _getTimeSlotsSuccess(timeSlots) {
      var prevSlot = void 0;
      var tempArr = [];
      _.forEach(timeSlots, function (slot, i) {
        if (slot) {
          var timeDisplay = slot.start.displayValue;
          if (prevSlot && prevSlot.start.displayValue === slot.start.displayValue) {
            timeDisplay += '  (2 slots available)';
            delete tempArr[i - 1];
          }
          tempArr.push({
            label: timeDisplay,
            value: slot.id
          });
          prevSlot = slot;
        }
      });
      this.timeSlots = _.filter(tempArr, Boolean);
      if (!this.isPluralDates) {
        this.postObj.appointment = this.eventDates[0];
        this.eventTimes = this.timeSlots;
      }
    }
  }, {
    key: '_getActionPlan',
    value: function _getActionPlan() {
      var _this6 = this;

      this.apmActionPlanService.getActionPlan(this.$stateParams.planId).then(function (res) {
        return _this6._getActionPlanSuccess(res);
      }).catch(function (err) {
        return _this6._errorHandler(err);
      });
    }
  }, {
    key: '_getActionPlanSuccess',
    value: function _getActionPlanSuccess(res) {
      if (_.has(res, 'data')) {
        this.eventDates = this.eventDates = res.data.eventDates && res.data.eventDates.length ? res.data.eventDates : [];
        this.isPluralDates = this.eventDates.length > 1;
      }
      if (_.has(res, 'data.location')) {
        this.providerLocation = res.data.location;
      }
    }
  }, {
    key: '_getValueSet',
    value: function _getValueSet() {
      var _this7 = this;

      this.apmActionPlanService.getValueSetGroup('sc-call-results-group', 'reminder').then(function (res) {
        return _this7._getValueSetSuccess(res);
      }).catch(function (err) {
        return _this7._errorHandler(err);
      });
    }
  }, {
    key: '_getValueSetSuccess',
    value: function _getValueSetSuccess(res) {
      if (_.has(res, 'data')) {
        this.dispositionArray = _.filter(res.data, function (el) {
          return el.code !== 'APPOINTMENT_SCHEDULED';
        });
        if (this.actionType === 'schedule') {
          this.dispositionArray = _.filter(this.dispositionArray, function (el) {
            return el.code !== 'APPOINTMENT_CONFIRMED';
          });
        }
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return ReminderCallResultActionsController;
}();

angular.module('apm.components.actionPlans').component('reminderCallResultActions', {
  templateUrl: 'app/components/actionPlans/actions/reminder/callResult/apm.actionPlans.actions.reminder.callResult.html',
  controller: ReminderCallResultActionsController,
  bindings: {
    patient: '<',
    hasAppointment: '<',
    actionType: '<',
    isReadOnly: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EncounterUpdateResultsController = function () {

  /** @ngInject */
  function EncounterUpdateResultsController($scope, $state, $stateParams, apmActionPlanService, apmAuthenticationService, scNotificationsFactory) {
    _classCallCheck(this, EncounterUpdateResultsController);

    _.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      apmAuthenticationService: apmAuthenticationService,
      scNotificationsFactory: scNotificationsFactory,

      actionPlanContextId: null,
      actionPlanContext: {},
      encounterPostObj: {
        result: '',
        diagnosticOrderResults: []
      },
      followupDate: {},
      hasAppointment: false,
      minStartDate: {},
      notdoneCodes: [],
      notdoneNoteModel: {},
      notdoneSelectModel: {},
      onLoadResult: '',
      performed: {},
      reasonType: {},
      refusedCodes: [],
      refusedNoteModel: {},
      refusedSelectModel: {},
      saveClicked: false,
      showNotdoneNote: {},
      showRefusedNote: {},
      template: '',
      testList: [],
      viewIsReadOnly: false
    });
  }

  _createClass(EncounterUpdateResultsController, [{
    key: '$onInit',
    value: function $onInit() {
      this._setMinStartDate();
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj.patient.currentValue._id) {
        this.testList = this.patient.qualifiedTestTypes;
        this.hasAppointment = !!this.patient.appointment;
        this._getNotdoneCodes();
        this._getRefusedCodes();
        this._setTestResults();
        this.viewIsReadOnly = !this.apmAuthenticationService.hasAccess('scAPMedical');
        this.onLoadResult = this.encounterPostObj.result;
        this._getActionPlanContext();
      }
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this._goToAPList();
    }
  }, {
    key: 'getCheckboxEvent',
    value: function getCheckboxEvent(testId) {
      var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (testId && (checked || !this.performed[testId])) {
        var eventObj = {
          status: 'performed',
          description: null,
          testId: testId,
          note: null,
          occurrenceDate: this.followupDate[testId] ? {
            type: 'date',
            systemValue: moment(this.followupDate[testId]).format('YYYY-MM-DD')
          } : null
        };
        this.encounterPostObj.diagnosticOrderResults.unshift(eventObj);
        this.encounterPostObj.diagnosticOrderResults = _.uniq(this.encounterPostObj.diagnosticOrderResults, 'testId');
        this._clearDropdowns(testId);
      } else {
        this.followupDate[testId] = null;
        this.encounterPostObj.diagnosticOrderResults = _.remove(this.encounterPostObj.diagnosticOrderResults, function (el) {
          return el.testId !== testId;
        });
      }
    }
  }, {
    key: 'getSelectedEvent',
    value: function getSelectedEvent(data, type, testId) {
      this._setPerformed(testId);
      if (data) {
        if (data === 'OTHER') {
          if (type === 'refused') {
            this.notdoneSelectModel[testId] = undefined;
            this.showRefusedNote[testId] = true;
            this.showNotdoneNote[testId] = false;
          } else {
            this.refusedSelectModel[testId] = undefined;
            this.showNotdoneNote[testId] = true;
            this.showRefusedNote[testId] = false;
          }
          this.reasonType[testId] = type;
        } else {
          this.showRefusedNote[testId] = false;
          this.showNotdoneNote[testId] = false;
          this.refusedNoteModel[testId] = undefined;
          this.notdoneNoteModel[testId] = undefined;
          this._setSelectedObj(data, type, testId);
        }
      } else {
        this._clearDropdowns(testId);
        this.showRefusedNote[testId] = false;
        this.showNotdoneNote[testId] = false;
        this.refusedNoteModel[testId] = undefined;
        this.notdoneNoteModel[testId] = undefined;
        _.remove(this.encounterPostObj.diagnosticOrderResults, function (el) {
          return el.testId === testId;
        });
      }
    }
  }, {
    key: 'save',
    value: function save() {
      this.saveClicked = true;
      this.encounterPostObj.diagnosticOrderResults = _.uniq(this.encounterPostObj.diagnosticOrderResults, 'testId');
      if (this.$scope.updateEncountersForm.$valid) {
        this.encounterPostObj.patient = this.$stateParams.patientId;
        if (this.encounterPostObj.result === 'noshow') {
          if (this.encounterPostObj.resetIcon) {
            delete this.encounterPostObj.resetIcon;
          }
        } else if (this.encounterPostObj.result !== 'noshow') {
          if (!this.encounterPostObj.diagnosticOrderResults.length) {
            this.encounterPostObj.result = '';
            this.encounterPostObj.resetIcon = true;
          }
        }
        this._updateMeasures();
      } else {
        this.saveClicked = false;
      }
    }
  }, {
    key: 'setNote',
    value: function setNote(type, testId) {
      this._setSelectedObj('OTHER', type, testId);
    }
  }, {
    key: 'submitFollowUpDate',
    value: function submitFollowUpDate(test) {
      this.performed[test.testId] = true;
      this.getCheckboxEvent(test.testId, true);
    }
  }, {
    key: '_getActionPlanContext',
    value: function _getActionPlanContext() {
      var _this = this;

      this.apmActionPlanService.getActionPlanConfig(this.$stateParams.planId).then(function (response) {
        _this.template = response.template;
        _this.actionPlanContextId = response._id;
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_goToAPList',
    value: function _goToAPList() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
    }
  }, {
    key: '_clearDropdowns',
    value: function _clearDropdowns(testId) {
      this.refusedSelectModel[testId] = undefined;
      this.notdoneSelectModel[testId] = undefined;
      this.refusedNoteModel[testId] = undefined;
      this.notdoneNoteModel[testId] = undefined;
    }
  }, {
    key: '_getNotdoneCodes',
    value: function _getNotdoneCodes() {
      var _this2 = this;

      this.apmActionPlanService.getValueSetGroup('sc-encounter-results-group', 'notdone').then(function (response) {
        return _this2._getNotdoneCodesSuccess(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_getRefusedCodes',
    value: function _getRefusedCodes() {
      var _this3 = this;

      this.apmActionPlanService.getValueSetGroup('sc-encounter-results-group', 'refused').then(function (response) {
        return _this3._getRefusedCodesSuccess(response);
      }).catch(function (err) {
        return _this3._errorHandler(err);
      });
    }
  }, {
    key: '_getRefusedCodesSuccess',
    value: function _getRefusedCodesSuccess(response) {
      if (_.has(response, 'data') && response.data.length) {
        this.refusedCodes = response.data;
      }
    }
  }, {
    key: '_getNotdoneCodesSuccess',
    value: function _getNotdoneCodesSuccess(response) {
      if (_.has(response, 'data') && response.data.length) {
        this.notdoneCodes = response.data;
      }
    }
  }, {
    key: '_saveSuccess',
    value: function _saveSuccess() {
      this.scNotificationsFactory.success('Encounter Successfully Updated');
      this.saveClicked = false;
      this._goToAPList();
    }
  }, {
    key: '_setFollowupDate',
    value: function _setFollowupDate(occurrenceDate, testId) {
      this.followupDate[testId] = new Date(occurrenceDate);
    }
  }, {
    key: '_setMinStartDate',
    value: function _setMinStartDate() {
      this.minStartDate = moment(new Date()).startOf('day').toDate();
    }
  }, {
    key: '_setNotdone',
    value: function _setNotdone(value, key) {
      this.notdoneSelectModel[key] = value.description;
      this.getSelectedEvent(this.notdoneSelectModel[key], 'notdone', key);
      if (this.notdoneSelectModel[key] === 'OTHER') {
        this.showNotdoneNote[key] = true;
        this.notdoneNoteModel[key] = value.note;
        this.setNote(this.reasonType[key], key);
      }
    }
  }, {
    key: '_setPerformed',
    value: function _setPerformed(testId) {
      if (this.performed[testId]) {
        this.performed[testId] = false;
      }
    }
  }, {
    key: '_setPerformedData',
    value: function _setPerformedData(key) {
      this.getCheckboxEvent(key);
      this.performed[key] = true;
    }
  }, {
    key: '_setRefused',
    value: function _setRefused(value, key) {
      this.refusedSelectModel[key] = value.description;
      this.getSelectedEvent(this.refusedSelectModel[key], 'refused', key);
      if (this.refusedSelectModel[key] === 'OTHER') {
        this.showRefusedNote[key] = true;
        this.refusedNoteModel[key] = value.note;
        this.setNote(this.reasonType[key], key);
      }
    }
  }, {
    key: '_setSelectedObj',
    value: function _setSelectedObj(data, type, testId) {
      var eventObj = {
        status: type,
        description: data,
        testId: testId,
        note: this.notdoneNoteModel[testId] || this.refusedNoteModel[testId] || null,
        occurrenceDate: this.followupDate[testId] ? {
          type: 'date',
          systemValue: moment(this.followupDate[testId]).format('YYYY-MM-DD')
        } : null
      };
      if (type === 'refused') {
        this.notdoneSelectModel[testId] = undefined;
      } else {
        this.refusedSelectModel[testId] = undefined;
      }

      this.encounterPostObj.diagnosticOrderResults.push(eventObj);
      this.encounterPostObj.diagnosticOrderResults.reverse();
      this.encounterPostObj.diagnosticOrderResults = _.uniq(this.encounterPostObj.diagnosticOrderResults, 'testId');
    }
  }, {
    key: '_setTestResults',
    value: function _setTestResults() {
      var _this4 = this;

      if (_.has(this.patient, 'actionPlanActivities') && this.patient.actionPlanActivities.length) {
        var workflowStep3 = _.find(this.patient.actionPlanActivities, { workflowStep: '3' });
        if (workflowStep3 && workflowStep3.resultStatus) {
          this.encounterPostObj.result = workflowStep3.resultStatus;
        }
        if (workflowStep3 && workflowStep3.testResults && !_.isEmpty(workflowStep3.testResults)) {
          _.forOwn(workflowStep3.testResults, function (value, key) {
            if (_.has(value, 'occurrenceDate') && _.has(value.occurrenceDate, 'displayValue')) {
              _this4._setFollowupDate(value.occurrenceDate.displayValue, key);
            }
            if (value.status === 'performed') {
              _this4._setPerformedData(key);
            }
            if (value.status === 'refused') {
              _this4._setRefused(value, key);
            }
            if (value.status === 'notdone') {
              _this4._setNotdone(value, key);
            }
          });
        }
      }
    }
  }, {
    key: '_setActionPlanContext',
    value: function _setActionPlanContext() {
      this.actionPlanContext = {
        _id: this.actionPlanContextId,
        template: this.template,
        currentOperation: 'ReportTestResults',
        patientId: this.$stateParams.patientId,
        actionPlanId: this.$stateParams.planId,
        eventResult: {
          patient: this.$stateParams.patientId,
          result: this.encounterPostObj.result,
          resetIcon: false,
          diagnosticResults: this.encounterPostObj.diagnosticOrderResults
        }
      };
    }
  }, {
    key: '_updateMeasures',
    value: function _updateMeasures() {
      var _this5 = this;

      if (this.onLoadResult !== this.encounterPostObj || this.encounterPostObj.diagnosticOrderResults.length) {
        this._setActionPlanContext();
        this.apmActionPlanService.saveActionPlanConfig(this.actionPlanContext, 'putActionPlanConfig').then(function () {
          return _this5._saveSuccess();
        }).catch(function (err) {
          return _this5._errorHandler(err);
        });
      } else {
        this.scNotificationsFactory.success('There have been no changes to the form.');
        this.saveClicked = false;
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.saveClicked = false;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return EncounterUpdateResultsController;
}();

angular.module('apm.components.actionPlans').component('encounterUpdateResultsActions', {
  templateUrl: 'app/components/actionPlans/actions/encounter/updateResults/apm.actionPlans.actions.encounter.updateResults.html',
  controller: EncounterUpdateResultsController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsLocationsGridController = function () {

  /** @ngInject */
  function ReportsLocationsGridController($mdDialog, $scope, apmResourcesLocationsService, apmGridFactory, scNotificationsFactory) {
    _classCallCheck(this, ReportsLocationsGridController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      apmResourcesLocationsService: apmResourcesLocationsService,
      apmGridFactory: apmGridFactory,
      scNotificationsFactory: scNotificationsFactory,

      columnsSort: ['', 'name', 'address1', 'address2', 'city', 'county', 'state', 'zip'],
      PAGE_SIZES: [10, 20, 30],

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ReportsLocationsGridController, [{
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmResourcesLocationsService.getLocations(this._getApiParams()).then(function (response) {
        return _this._getLocationsSuccessHandler(response);
      }).catch(function (err) {
        return _this._getLocationsErrorHandler(err);
      });
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'onCheckboxClick',
    value: function onCheckboxClick(resource, toggle) {
      if (toggle) {
        _.remove(this.addressesObj.addresses, function (addressesArray_value) {
          return addressesArray_value.locationId === resource.locationId;
        });
      } else {
        this.addressesObj.addresses.push(resource);
      }
    }
  }, {
    key: 'onClickLocationView',
    value: function onClickLocationView(location) {
      var _this2 = this;

      var scope = angular.extend(this.$scope.$new(true), {
        location: location,
        refreshCallback: function refreshCallback() {
          return _this2.getLoadResultsCallback(1);
        }
      });

      this.$mdDialog.show({
        template: '<md-dialog class="resources-locations-list-modal-container" aria-label="modal"><resources-locations-list-modal class="Resources-locations-list-modal" location="location" refresh-callback="refreshCallback"/></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        'page': this.page,
        '_count': this.pageSize
      }, this._getSortingParam());
    }
  }, {
    key: '_getLocationsSuccessHandler',
    value: function _getLocationsSuccessHandler(response) {
      var _this3 = this;

      this.locationsListPage = [];
      var locationsListPage = {
        results: [],
        totalResultCount: 0
      };
      if (_.has(response, 'content')) {
        var responseData = response.content;

        _.forEach(responseData, function (locationsList) {
          _this3.locationsListPage[locationsList.locationId] = locationsList;

          locationsListPage.results.push(locationsList);
        }, this);
        locationsListPage.totalResultCount = response.totalElements;
      }
      this.locationsListPage = locationsListPage.results;
      return locationsListPage;
    }
  }, {
    key: '_getLocationsErrorHandler',
    value: function _getLocationsErrorHandler(err) {
      this.locationsListPage = [];
      var locationsListPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return locationsListPage;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {};
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }]);

  return ReportsLocationsGridController;
}();

angular.module('apm.components.resources').component('apmResourcesLocationsGrid', {
  templateUrl: 'app/components/resources/locations/grid/apm.resources.locations.grid.component.html',
  controller: ReportsLocationsGridController,
  bindings: {
    checkboxObj: '=',
    addressesObj: '='
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsLocationsBucketItemController = function () {

  /** @ngInject */
  function ReportsLocationsBucketItemController() {
    _classCallCheck(this, ReportsLocationsBucketItemController);
  }

  _createClass(ReportsLocationsBucketItemController, [{
    key: 'onClickRemoveAddress',
    value: function onClickRemoveAddress(locationId) {
      this.removeFn({
        resource: { locationId: locationId }
      });
    }
  }]);

  return ReportsLocationsBucketItemController;
}();

angular.module('apm.components.resources').component('apmResourcesLocationsBucketItem', {
  templateUrl: 'app/components/resources/locations/grid/apm.resources.locations.bucket.item.component.html',
  controller: ReportsLocationsBucketItemController,
  bindings: {
    item: '<',
    checkbox: '=',
    removeFn: '&'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsLocationsBucketController = function () {

  /** @ngInject */
  function ReportsLocationsBucketController($state, apmResourcesLocationsService, scNotificationsFactory) {
    _classCallCheck(this, ReportsLocationsBucketController);

    _.assign(this, {
      $state: $state,
      apmResourcesLocationsService: apmResourcesLocationsService,
      scNotificationsFactory: scNotificationsFactory,

      radioModel: null,
      saveClicked: false
    });
  }

  _createClass(ReportsLocationsBucketController, [{
    key: 'cancel',
    value: function cancel() {
      var _this = this;

      var thisAddresses = this.addressesObj.addresses;

      if (thisAddresses.length) {
        _.forEach(thisAddresses, function (thisAddress_value) {
          if (_this.radioModel === thisAddress_value.locationId) {
            _this.radioModel = null;
          }
          _this.checkboxObj[thisAddress_value.locationId] = false;
          _.forEach(_this.addressesObj.addresses, function (addressesArray_value) {
            if (addressesArray_value.locationId === thisAddress_value.locationId) {
              addressesArray_value._delete = true;
            }
          });
        });
        _.remove(this.addressesObj.addresses, function (addressesArray_value) {
          return addressesArray_value._delete === true;
        });
      }
    }
  }, {
    key: 'onClickRemoveAddress',
    value: function onClickRemoveAddress(resource) {
      if (this.radioModel === resource.locationId) {
        this.radioModel = null;
      }
      _.remove(this.addressesObj.addresses, function (addressesArray_value) {
        return addressesArray_value.locationId === resource.locationId;
      });
      this.checkboxObj[resource.locationId] = false;
    }
  }, {
    key: 'save',
    value: function save() {
      var _this2 = this;

      this.saveClicked = true;
      var params = this._resolveParentChildren();

      this.apmResourcesLocationsService.setLocationGroup(params).then(function () {
        return _this2._setLocationGroupSuccessHandler();
      }).catch(function (err) {
        return _this2._setLocationGroupErrorHandler(err);
      });
    }
  }, {
    key: '_resolveParentChildren',
    value: function _resolveParentChildren() {
      var _this3 = this;

      var childrenIds = _.clone(this.addressesObj, true);

      childrenIds = _.pluck(_.filter(childrenIds.addresses, function (address) {
        return address.locationId !== _this3.radioModel;
      }), 'locationId').join(',');

      return {
        parentId: this.radioModel,
        childrenIds: childrenIds
      };
    }
  }, {
    key: '_setLocationGroupErrorHandler',
    value: function _setLocationGroupErrorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
      this.saveClicked = false;
    }
  }, {
    key: '_setLocationGroupSuccessHandler',
    value: function _setLocationGroupSuccessHandler() {
      this.scNotificationsFactory.success('Location(s) Merged Successfully');
      this.$state.reload();
    }
  }]);

  return ReportsLocationsBucketController;
}();

angular.module('apm.components.resources').component('apmResourcesLocationsBucket', {
  templateUrl: 'app/components/resources/locations/grid/apm.resources.locations.bucket.component.html',
  controller: ReportsLocationsBucketController,
  bindings: {
    checkboxObj: '=',
    addressesObj: '='
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeleteLeaveModalController = function () {

  /** @ngInject */
  function DeleteLeaveModalController($mdDialog) {
    _classCallCheck(this, DeleteLeaveModalController);

    _.assign(this, {
      $mdDialog: $mdDialog
    });
  }

  _createClass(DeleteLeaveModalController, [{
    key: 'confirm',
    value: function confirm() {
      this.$mdDialog.hide();
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$mdDialog.cancel();
    }
  }]);

  return DeleteLeaveModalController;
}();

angular.module('apm.components.resources').component('deleteLeaveModal', {
  templateUrl: 'app/components/resources/details/modals/apm.resources.deleteLeaveModal.html',
  controller: DeleteLeaveModalController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddEditLeaveModalController = function () {
  function AddEditLeaveModalController($mdDialog, $window, apmResourcesService, scNotificationsFactory) {
    _classCallCheck(this, AddEditLeaveModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $window: $window,
      apmResourcesService: apmResourcesService,
      scNotificationsFactory: scNotificationsFactory,

      addEventForm: {},
      errorMessage: null,
      eventTypes: [{
        code: 'CLINICAL_COVERAGE',
        display: 'Clinical Coverage'
      }, {
        code: 'PTO',
        display: 'PTO'
      }, {
        code: 'EMBEDDED_RESOURCE',
        display: 'Embedded Resource'
      }],
      filter: {},
      minEndDate: {},
      minStartDate: {},
      newEvent: {},
      saveClicked: false,
      searchText: ''
    });
  }

  _createClass(AddEditLeaveModalController, [{
    key: '$onInit',
    value: function $onInit() {
      this._setDateFilters();
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.event.currentValue && changesObj.event.previousValue !== changesObj.event.currentValue) {
        this._populateEventData(_.clone(changesObj.event.currentValue));
        this._setDateFilters();
      }
    }
  }, {
    key: 'setValidMinEndDate',
    value: function setValidMinEndDate() {
      this.minEndDate = this.newEvent.startDate;
      this.validateEndDate();
    }
  }, {
    key: 'validateAddEventForm',
    value: function validateAddEventForm() {
      this.addEventForm.type.$setValidity('required', !!this.newEvent.type);
    }
  }, {
    key: 'validateEndDate',
    value: function validateEndDate() {
      if (this.newEvent.endDate) {
        this.addEventForm.endDate.$setValidity('isSameOrAfterStartDate', this._isValidEndDate(this.newEvent.endDate));
      }
    }
  }, {
    key: 'saveEvent',
    value: function saveEvent() {
      this._clearValidationErrors();
      this.saveClicked = true;
      if (this.newEvent._id) {
        this.updateEvent();
      } else {
        this.createNewEvent();
      }
    }
  }, {
    key: 'createNewEvent',
    value: function createNewEvent() {
      var _this = this;

      this.apmResourcesService.postResourceEvent(this.userId, this._getPostPutResourceEventApiParams()).then(function () {
        return _this._postResourceEventSuccessHandler();
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: 'updateEvent',
    value: function updateEvent() {
      var _this2 = this;

      this.apmResourcesService.putResourceEvent(this.userId, this.newEvent._id, this._getPostPutResourceEventApiParams()).then(function () {
        return _this2._putResourceEventSuccessHandler();
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'onStartDateChange',
    value: function onStartDateChange() {
      this._clearValidationErrors();
      this.setValidMinEndDate();
    }
  }, {
    key: 'onEndDateChange',
    value: function onEndDateChange() {
      this._clearValidationErrors();
      this.validateEndDate();
    }
  }, {
    key: 'onLeaveTypeChange',
    value: function onLeaveTypeChange() {
      this._clearValidationErrors();
      this.validateAddEventForm();
    }
  }, {
    key: '_clearValidationErrors',
    value: function _clearValidationErrors() {
      this.errorMessage = null;
    }
  }, {
    key: '_postResourceEventSuccessHandler',
    value: function _postResourceEventSuccessHandler() {
      this._clearValidationErrors();
      this.refreshCallback();
      this.scNotificationsFactory.success('Leave Time has been successfully created');
      this.$mdDialog.hide();
    }
  }, {
    key: '_putResourceEventSuccessHandler',
    value: function _putResourceEventSuccessHandler() {
      this._clearValidationErrors();
      this.refreshCallback();
      this.scNotificationsFactory.success('Leave Time has been successfully updated');
      this.$mdDialog.hide();
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
      this.saveClicked = false;
    }
  }, {
    key: '_populateEventData',
    value: function _populateEventData(event) {
      event.startDate = moment(event.startDate).toDate();
      event.endDate = moment(event.endDate).toDate();
      event.type = event.typeCode;

      _.assign(this.newEvent, event);
    }
  }, {
    key: '_setDateFilters',
    value: function _setDateFilters() {
      this.minStartDate = new Date();
      this.minEndDate = this.newEvent.startDate || new Date();
    }
  }, {
    key: '_isValidEndDate',
    value: function _isValidEndDate(date) {
      return moment(date).isSameOrAfter(this.newEvent.startDate);
    }
  }, {
    key: '_getPostPutResourceEventApiParams',
    value: function _getPostPutResourceEventApiParams() {
      return {
        typeCode: this.newEvent.type,
        startDate: moment(this.newEvent.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.newEvent.endDate).format('YYYY-MM-DD')
      };
    }
  }]);

  return AddEditLeaveModalController;
}();

angular.module('apm.components.resources').component('addEditLeaveModal', {
  templateUrl: 'app/components/resources/details/modals/apm.resources.addEditLeaveModal.html',
  controller: AddEditLeaveModalController,
  bindings: {
    event: '<',
    userId: '<',
    refreshCallback: '<'
  }
});
'use strict';

angular.module('apm.components.reports.factories', []);
angular.module('apm.components.reports', ['apm.components.reports.factories']);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsPendingGapsReopenModalController = function () {

  /** @ngInject */
  function ReportsPendingGapsReopenModalController($mdDialog, apmReportMeasureGapsService, scNotificationsFactory) {
    _classCallCheck(this, ReportsPendingGapsReopenModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      apmReportMeasureGapsService: apmReportMeasureGapsService,
      scNotificationsFactory: scNotificationsFactory,

      errorMessage: null,
      isSaving: false,
      measureGap: {}
    });
  }

  _createClass(ReportsPendingGapsReopenModalController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.measureReport.currentValue && changesObj.measureReport.currentValue !== changesObj.measureReport.previousValue) {
        this._getMeasureGapInfo();
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      this.isSaving = true;
      this.apmReportMeasureGapsService.reopenGap(this.measureReport.measureReportId).then(function () {
        return _this._reopenGapSuccessHandler();
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_getMeasureGapInfo',
    value: function _getMeasureGapInfo() {
      var _this2 = this;

      this.apmReportMeasureGapsService.fetchMeasureGaps(this.measureReport.measureReportId).then(function (response) {
        return _this2._fetchMeasureGapsSuccessHandler(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_reopenGapSuccessHandler',
    value: function _reopenGapSuccessHandler() {
      this.errorMessage = null;
      this.scNotificationsFactory.success('Gap reopened successfully');
      this.$mdDialog.hide();
    }
  }, {
    key: '_fetchMeasureGapsSuccessHandler',
    value: function _fetchMeasureGapsSuccessHandler(response) {
      this.errorMessage = null;
      this._extractMeasureGap(response.data.actionPlans);
    }
  }, {
    key: '_extractMeasureGap',
    value: function _extractMeasureGap(actionPlans) {
      var _this3 = this;

      this.measureGap = _.find(actionPlans, function (actionPlan) {
        return actionPlan.id === _this3.measureReport.actionPlanId;
      });
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.isSaving = false;
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return ReportsPendingGapsReopenModalController;
}();

angular.module('apm.components.reports').component('apmReportsPendingGapsReopenModal', {
  templateUrl: 'app/components/reports/pendingGaps/modal/apm.reports.pendingGaps.reopenModal.html',
  controller: ReportsPendingGapsReopenModalController,
  bindings: {
    measureReport: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlanReportHeaderController = function () {

  /** @ngInject */
  function ActionPlanReportHeaderController($scope, apmDetailsHeaderWorkflowService) {
    _classCallCheck(this, ActionPlanReportHeaderController);

    _.assign(this, {
      $scope: $scope,
      apmDetailsHeaderWorkflowService: apmDetailsHeaderWorkflowService,

      headerCalculations: []
    });
  }

  _createClass(ActionPlanReportHeaderController, [{
    key: '$onInit',
    value: function $onInit() {
      this.headerCalculations = [{
        displayOrder: 1,
        label: 'Tested Gaps Closed',
        type: 'percentage',
        value: this.headerData.pendingGapsClosed
      }, {
        displayOrder: 2,
        label: 'Days Since Event',
        type: 'count',
        value: this.headerData.daysSinceEvent
      }];
    }
  }, {
    key: 'openDetailsModal',
    value: function openDetailsModal() {
      this.apmDetailsHeaderWorkflowService.showActionPlanDetailsModal(this.actionPlan, this.$scope);
    }
  }]);

  return ActionPlanReportHeaderController;
}();

angular.module('apm.components.actionPlans').component('actionPlanReportHeader', {
  templateUrl: 'app/components/reports/actionPlans/header/apm.reports.actionPlans.header.component.html',
  controller: ActionPlanReportHeaderController,
  bindings: {
    headerData: '<',
    actionPlan: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlanReportGridController = function () {

  /** @ngInject */
  function ActionPlanReportGridController($document, $log, apmReportService, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ActionPlanReportGridController);

    _.assign(this, {
      $document: $document,
      $log: $log,
      apmReportService: apmReportService,
      scNotificationsFactory: scNotificationsFactory,

      pageSizes: PAGE_SIZES,

      columnsSort: ['patientName', 'patientDateOfBirth', 'gapsTotal', 'gapsSDO', 'gapsRefused', 'gapsNotDone', 'gapsTested', 'gapsPending']
    });
  }

  _createClass(ActionPlanReportGridController, [{
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        actionPlanId: this.actionPlan._id,
        page: this.page,
        '_count': this.pageSize
      }, this._getSortingParam());
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'gapsPending'
      };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmReportService.fetchActionPlanReportPatients(this._getApiParams()).then(function (response) {
        return _this._fetchActionPlanReportSuccessHandler(response);
      }).catch(function (err) {
        return _this._fetchActionPlanReportErrorHandler(err);
      });
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: '_fetchActionPlanReportSuccessHandler',
    value: function _fetchActionPlanReportSuccessHandler(response) {
      return {
        results: response.content,
        totalResultCount: response.totalElements
      };
    }
  }, {
    key: '_fetchActionPlanReportErrorHandler',
    value: function _fetchActionPlanReportErrorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return {
        results: [],
        totalResultCount: 0
      };
    }
  }, {
    key: 'downloadCSV',
    value: function downloadCSV() {
      var reportCSVParams = this._getApiParams();

      delete reportCSVParams['_sort:undefined'];
      this.apmReportService.downloadActionPlanReportCSV(_.omit(reportCSVParams, ['page', '_count'])).then(angular.bind(this, this._downloadActionPlanReportSuccessHandler)).catch(angular.bind(this, this._downloadActionPlanReportErrorHandler));
    }
  }, {
    key: '_downloadActionPlanReportSuccessHandler',
    value: function _downloadActionPlanReportSuccessHandler(response) {
      if (navigator.msSaveBlob) {
        var blob = new Blob([response.report], { type: 'text/csv;charset=utf-8;' });

        navigator.msSaveBlob(blob, response.filename);
      } else {
        var downloadLinkElement = angular.element('<a/>').attr({
          href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.report),
          target: '_blank',
          download: response.filename
        });

        angular.element('body').append(downloadLinkElement);
        (downloadLinkElement[0] || downloadLinkElement).click();
        downloadLinkElement.remove();
      }
    }
  }, {
    key: '_downloadActionPlanReportErrorHandler',
    value: function _downloadActionPlanReportErrorHandler(response) {
      if (_.has(response, 'data.message')) {
        this.$log(response.data.message);
      }
    }
  }]);

  return ActionPlanReportGridController;
}();

angular.module('apm.components.reports').component('actionPlanReportGrid', {
  templateUrl: 'app/components/reports/actionPlans/grid/apm.reports.actionPlans.grid.component.html',
  controller: ActionPlanReportGridController,
  bindings: {
    actionPlan: '<',
    sorting: '<'
  }
});
'use strict';

angular.module('apm.components.patients', ['apm.components.patients.factories']);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientActivityGapMeasuresModalController = function () {

  /** @ngInject */
  function PatientActivityGapMeasuresModalController($mdDialog) {
    _classCallCheck(this, PatientActivityGapMeasuresModalController);

    _.assign(this, {
      $mdDialog: $mdDialog
    });
  }

  _createClass(PatientActivityGapMeasuresModalController, [{
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }]);

  return PatientActivityGapMeasuresModalController;
}();

angular.module('apm.components.patients').component('apmPatientDetailsModal', {

  templateUrl: 'app/components/patients/activity/modal/apm.patients.activity.gap.measuresModal.html',
  controller: PatientActivityGapMeasuresModalController,
  bindings: {
    gap: '<'
  }

});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlanDetailsModalController = function () {

  /** @ngInject */
  function ActionPlanDetailsModalController($window, $state, $mdDialog, reverseDateFormatFilterFilter) {
    _classCallCheck(this, ActionPlanDetailsModalController);

    _.assign(this, {
      $window: $window,
      $state: $state,
      $mdDialog: $mdDialog,
      reverseDateFormatFilterFilter: reverseDateFormatFilterFilter,

      thisActionPlanSortBy: '',
      availableAppointments: [],
      eventStaff: [],
      showEditActionPlanButton: false
    });
  }

  _createClass(ActionPlanDetailsModalController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.actionPlan.currentValue && changesObj.actionPlan.currentValue !== changesObj.actionPlan.previousValue) {
        this.showEditActionPlanButton = _.includes(['DRAFT', 'SCHEDULING', 'REMINDERS', 'ENCOUNTERS', 'PENDING', 'APPROVED', 'ON_HOLD'], this.actionPlan.status);
        this._extractTabGeneral();
        this._extractTabAppointments();
        this._extractTabEvent();
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      this.close();
      this.$state.reload();
    }
  }, {
    key: 'setEdit',
    value: function setEdit(id) {
      this.$window.sessionStorage.setItem('selectedActionPlan', angular.toJson({ id: id, action: 'edit' }));
    }
  }, {
    key: '_extractTabAppointments',
    value: function _extractTabAppointments() {
      this._extractTabAppointmentsSortBy();
      this._extractTabAppointmentsAvailableAppointments();
      this._extractTabAppointmentsExcludedTimeSlots();
    }
  }, {
    key: '_extractTabAppointmentsAvailableAppointments',
    value: function _extractTabAppointmentsAvailableAppointments() {
      if (_.has(this.actionPlan, 'startTimeEndTimeRange') && _.has(this.actionPlan.startTimeEndTimeRange, 'start') && _.has(this.actionPlan.startTimeEndTimeRange, 'end')) {
        this.availableAppointments = moment(this.actionPlan.startTimeEndTimeRange.start, ['HH:mm']).format('h:mmA').toLowerCase() + ' - ' + moment(this.actionPlan.startTimeEndTimeRange.end, ['HH:mm']).format('h:mmA').toLowerCase();
      } else {
        this.availableAppointments = 'N/A';
      }
    }
  }, {
    key: '_extractTabAppointmentsExcludedTimeSlots',
    value: function _extractTabAppointmentsExcludedTimeSlots() {
      this.excludedTimeSlots = _.map(this.actionPlan.excludedTimeSlots, function (timeSlot) {
        return moment(timeSlot.start, ['HH:mm']).format('h:mmA').toLowerCase() + ' - ' + moment(timeSlot.end, ['HH:mm']).format('h:mmA').toLowerCase();
      }).join(', ');
    }
  }, {
    key: '_extractTabAppointmentsSortBy',
    value: function _extractTabAppointmentsSortBy() {
      if (_.has(this.actionPlan, 'sortBy')) {
        switch (this.actionPlan.sortBy) {
          case 'LAST_VISIT':
            this.thisActionPlanSortBy = 'Last Office Visit';
            break;
          case 'MOST_GAPS':
            this.thisActionPlanSortBy = 'Most Total Gaps';
            break;
        }
      }
    }
  }, {
    key: '_extractTabEvent',
    value: function _extractTabEvent() {
      this.eventStaff = _.pluck(this.actionPlan.plannedResources, 'name').join(', ');
    }
  }, {
    key: '_extractTabGeneral',
    value: function _extractTabGeneral() {
      this.population = _.reduce(_.pluck(this.actionPlan.population.groupCharacteristic, 'name'), function (population, group) {
        return population + ', ' + group;
      });
    }
  }]);

  return ActionPlanDetailsModalController;
}();

angular.module('apm.components.actionPlans').component('detailsModalComponent', {
  templateUrl: 'app/components/actionPlans/details/modal/apm.actionPlans.detailsModal.component.html',
  controller: ActionPlanDetailsModalController,
  bindings: {
    actionPlan: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderWorkflowService = function () {

  /** @ngInject */
  function ApmDetailsHeaderWorkflowService($state, $filter, $mdDialog) {
    _classCallCheck(this, ApmDetailsHeaderWorkflowService);

    _.assign(this, {
      $state: $state,
      $filter: $filter,
      $mdDialog: $mdDialog
    });
  }

  _createClass(ApmDetailsHeaderWorkflowService, [{
    key: 'setEventDate',
    value: function setEventDate(actionPlan) {
      return {
        eventDate: actionPlan.eventDates && actionPlan.eventDates.length ? '' + this.$filter('reverseDateFormatFilter')(actionPlan.eventDates[0]) : 'N/A'
      };
    }
  }, {
    key: 'showActionPlanDetailsModal',
    value: function showActionPlanDetailsModal(actionPlan, $scope) {
      var scope = angular.extend($scope.$new(true), {
        actionPlan: actionPlan
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal" class="action-plan-details-modal"><details-modal-component action-plan="actionPlan" /></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }]);

  return ApmDetailsHeaderWorkflowService;
}();

angular.module('apm.components.actionPlans').service('apmDetailsHeaderWorkflowService', ApmDetailsHeaderWorkflowService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderController = function () {

  /** @ngInject */
  function ApmDetailsHeaderController($state, $window, $scope, apmAuthenticationService, apmDetailsHeaderWorkflowService, apmActionPlansFactory) {
    _classCallCheck(this, ApmDetailsHeaderController);

    _.assign(this, {
      $state: $state,
      $window: $window,
      $scope: $scope,
      apmAuthenticationService: apmAuthenticationService,
      apmDetailsHeaderWorkflowService: apmDetailsHeaderWorkflowService,
      apmActionPlansFactory: apmActionPlansFactory,

      firstColumnFlex: null,
      hasEditAccess: false
    });
  }

  _createClass(ApmDetailsHeaderController, [{
    key: '$onInit',
    value: function $onInit() {
      this.hasEditAccess = this.apmAuthenticationService.hasAccess('scAPAdmin');
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (_.has(changesObj, 'actionPlan.currentValue') && changesObj.actionPlan.currentValue._id) {
        this.actionPlan.statusToDisplay = this.actionPlan.status === 'ON_HOLD' ? 'On Hold' : this.actionPlan.status.toLowerCase();
        this.actionPlan.dates = this.apmDetailsHeaderWorkflowService.setEventDate(this.actionPlan);
      }
    }
  }, {
    key: 'isStatusEditable',
    value: function isStatusEditable() {
      return this.apmActionPlansFactory.isLimitedEdit(this.actionPlan, true);
    }
  }, {
    key: 'goToEdit',
    value: function goToEdit(id) {
      this.$window.sessionStorage.setItem('selectedActionPlan', angular.toJson({ id: id, action: 'edit' }));
      this.$state.go('actionPlans.createEdit');
    }
  }, {
    key: 'openDetailsModal',
    value: function openDetailsModal() {
      this.apmDetailsHeaderWorkflowService.showActionPlanDetailsModal(this.actionPlan, this.$scope);
    }
  }]);

  return ApmDetailsHeaderController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeader', {
  templateUrl: 'app/components/actionPlans/details/header/apm.details.header.component.html',
  controller: ApmDetailsHeaderController,
  bindings: {
    actionPlan: '<',
    actionPlanContext: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderCalculationsController = function () {

  /** @ngInject */
  function ApmDetailsHeaderCalculationsController() {
    _classCallCheck(this, ApmDetailsHeaderCalculationsController);

    _.assign(this, {
      calculationTypes: {
        PERCENTAGE: 'percentage',
        COUNT: 'count'
      },
      calculationIndex: 0,
      calculations: [],
      chartOptions: {
        aspectRatio: 1
      },
      data: {}
    });
  }

  _createClass(ApmDetailsHeaderCalculationsController, [{
    key: '$onInit',
    value: function $onInit() {
      this._loadCalculations();
    }
  }, {
    key: 'getChartData',
    value: function getChartData(id) {
      return _.get(this.data, id, []);
    }
  }, {
    key: '_loadCalculations',
    value: function _loadCalculations() {
      var _this = this;

      this.calculations = _.sortBy(_.map(this.headerCalculations, function (calculation) {
        _this.calculationIndex += 1;
        var calculationId = 'chart'.concat(_this.calculationIndex.toString());
        calculation.id = calculationId;

        if (calculation.type === _this.calculationTypes.PERCENTAGE) {
          _this._loadPercentageData(calculation);
        }
        return calculation;
      }, this), function (el) {
        return el.displayOrder;
      });
    }
  }, {
    key: '_loadPercentageData',
    value: function _loadPercentageData(calculation) {
      this.data[calculation.id] = [calculation.value, 100 - calculation.value];
    }
  }]);

  return ApmDetailsHeaderCalculationsController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderCalculations', {
  templateUrl: 'app/components/actionPlans/details/header/apm.details.header.calculations.html',
  controller: ApmDetailsHeaderCalculationsController,
  bindings: {
    headerCalculations: '<'
  }
});
'use strict';

angular.module('apm.components.actionPlans').component('apmDetailsGrid', {
  templateUrl: 'app/components/actionPlans/details/grid/apm.details.grid.html',
  controller: function controller() {},
  bindings: {
    actionPlan: '<',
    hideIneligiblePatients: '<'
  }
});
'use strict';

angular.module('apm.components.actionPlans').component('actionPlanDetailsCard', {
  templateUrl: 'app/components/actionPlans/details/cards/apm.actionPlans.detailsCard.component.html',
  controller: function controller() {},
  bindings: {
    icon: '@',
    label: '@',
    value: '@'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmActionPlanCreatePopulationController = function () {

  /** @ngInject */
  function ApmActionPlanCreatePopulationController($rootScope, $scope, $timeout, $window, apmActionPlanService, apmActionPlansFactory, scNotificationsFactory, reverseDateFormatFilterFilter, scLastNameFirstFilter) {
    _classCallCheck(this, ApmActionPlanCreatePopulationController);

    _.assign(this, {
      $rootScope: $rootScope,
      $scope: $scope,
      scNotificationsFactory: scNotificationsFactory,
      $timeout: $timeout,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      apmActionPlansFactory: apmActionPlansFactory,
      reverseDateFormatFilterFilter: reverseDateFormatFilterFilter,
      scLastNameFirstFilter: scLastNameFirstFilter,

      actionPlan: {
        _id: null,
        population: {
          criteria: '',
          groupCharacteristic: [],
          patientLimit: 500
        },
        template: '',
        sortBy: '',
        measureYear: 0,
        subjectCount: 0,
        doubleBooked: false
      },
      allProviders: [],
      allProvidersOfGroup: [],
      autoCompleteData: [],
      autoCompleteProviderData: [],
      criteriaData: [],
      firstNamePosition: 0,
      isClone: false,
      isLimitedEdit: false,
      lastNamePosition: 1,
      lockTemplate: false,
      originalTitle: '',
      populationData: [],
      populationItem: '',
      providerItem: '',
      providersPlaceHolder: 'Select Provider',
      searchGroupText: '',
      searchProviderText: '',
      selectedIndexEventListener: null,
      suffixPosition: 2,
      templateConfig: {},
      templateData: []
    });
  }

  _createClass(ApmActionPlanCreatePopulationController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this._setTemplateConfig();
      this._getActionPlanTemplates();
      if (this.$window.sessionStorage.getItem('selectedActionPlan')) {
        var selection = angular.fromJson(this.$window.sessionStorage.getItem('selectedActionPlan'));
        this.isClone = _.has(selection, 'action') && selection.action === 'clone';
        this.lockTemplate = true;
        angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(4)').addClass('md-step-complete');
        this.apmActionPlanService.getActionPlanConfig(selection.id).then(function (response) {
          return _this._getActionPlanConfigSuccess(response);
        }).catch(function (err) {
          return _this._errorHandler(err);
        });
      } else {
        if (_.isEmpty(this.apmActionPlanService.getActionPlanTitle())) {
          this.apmActionPlanService.setActionPlanTitle('Create Action Plan');
        }
        this.actionPlan = angular.fromJson(this.$window.sessionStorage.getItem('actionPlan')) || this.actionPlan;
        this.templateConfig = angular.fromJson(this.$window.sessionStorage.getItem('templateConfig')) || this.templateConfig;
        this._getCriteriaData();
        this._setData();
        this.isLimitedEdit = this.apmActionPlansFactory.isLimitedEdit(this.actionPlan);
        if (this.actionPlan.template) {
          this.lockTemplate = true;
        }
      }
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (!_.isNull(this.selectedIndexEventListener)) {
        this.selectedIndexEventListener();
      }
      this.apmActionPlanService.setActionPlanTitle('');
    }
  }, {
    key: 'getGroupMatches',
    value: function getGroupMatches(searchText) {
      searchText = searchText.toLowerCase();
      return _.filter(this.autoCompleteData, function (d) {
        return d.name.toLowerCase().indexOf(searchText) === 0;
      });
    }
  }, {
    key: 'getProviderMatches',
    value: function getProviderMatches(searchText) {
      if (searchText) {
        searchText = searchText.toLowerCase();
        return _.filter(this.autoCompleteProviderData, function (d) {
          return d.firstName.toLowerCase().indexOf(searchText) === 0 || d.lastName.toLowerCase().indexOf(searchText) === 0;
        });
      }
      return this.autoCompleteProviderData;
    }
  }, {
    key: 'onRemoveChip',
    value: function onRemoveChip(chip) {
      if (_.has(chip, 'value') && _.has(chip, 'name')) {
        chip = {
          _id: _.first(chip.value.match(/[^\/]*$/)),
          reference: chip.value,
          firstName: _.trim(_.get(chip.name.split(','), this.firstNamePosition, '')),
          lastName: _.trim(_.get(chip.name.split(','), this.lastNamePosition, '')),
          suffix: _.trim(_.get(chip.name.split(','), this.suffixPosition, '')),
          name: chip.name
        };
      }

      if (this._isOnTheCurrentGroupList(chip)) {
        this.autoCompleteProviderData.push(chip);
        this._setProvidersSelectPlaceHolder();
      }
      this.allProviders.push(chip);
      this._checkChipLength();
    }
  }, {
    key: 'setGroupName',
    value: function setGroupName(data) {
      if (data && data.name) {
        var group = _.find(this.populationData, { name: data.name });
        if (group) {
          this._setProviderDataByGroup(group);
        } else {
          this.scNotificationsFactory.custom('Name must be in list', 'error');
        }
      } else {
        this.autoCompleteProviderData = _.clone(this.allProviders);
        this.allProvidersOfGroup = _.clone(this.allProviders);
        this._setProvidersSelectPlaceHolder();
      }
    }
  }, {
    key: 'setProviderName',
    value: function setProviderName(data) {
      if (data && data._id) {
        var provider = void 0;
        _.forEach(this.populationData, function (el) {
          _.forEach(el.associatedProviders, function (elem) {
            if (elem._id === data._id) {
              elem.type = 'practitioner';
              elem.value = elem.reference;
              provider = elem;
            }
          });
        });
        if (provider) {
          this.actionPlan.population.groupCharacteristic.push(provider);
        } else {
          this.scNotificationsFactory.custom('Name must be in list', 'error');
        }
        this.providerItem = undefined;
        this._removeElementFromProviderLists(data._id);
        this._setProvidersSelectPlaceHolder();
      }
      this._checkChipLength();
    }
  }, {
    key: 'save',
    value: function save() {
      if (!this.$scope.createActionPlanPopulationForm.$dirty && !this.isClone) {
        this.$rootScope.selectedIndex = 1;
      } else {
        this._checkChipLength();
        if (this.$scope.createActionPlanPopulationForm.$valid) {
          this._saveActionPlan();
        }
      }
    }
  }, {
    key: '_getActionPlanTemplates',
    value: function _getActionPlanTemplates() {
      var _this2 = this;

      this.apmActionPlanService.getActionPlanTemplates().then(function (response) {
        return _this2._getActionPlanTemplatesSuccess(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_getActionPlanTemplatesSuccess',
    value: function _getActionPlanTemplatesSuccess(response) {
      this.templateData = response;
      if (this.templateData.length === 1) {
        this.actionPlan.template = this.templateData[0].type;
        this._getCriteriaData();
      }
    }
  }, {
    key: '_setTemplateConfig',
    value: function _setTemplateConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.templateConfig = {
        actionPlanId: null,
        template: config.template,
        currentOperation: 'CreateActionPlan',
        allowableOperations: [],
        processing: false,
        repeatCurrentOperation: false,
        actionPlanConfiguration: config
      };
    }
  }, {
    key: '_getActionPlanConfigSuccess',
    value: function _getActionPlanConfigSuccess(response) {
      var title = void 0;
      this.actionPlan = response.actionPlanConfiguration;
      this.templateConfig = response;
      this.actionPlan.template = response.template;
      title = 'Action Plan Details for ' + this.actionPlan.title + ' ' + (this.actionPlan.eventDates[0] ? ' - ' + this.reverseDateFormatFilterFilter(this.actionPlan.eventDates[0]) : '');
      if (this.isClone) {
        title = 'Cloning ' + this.actionPlan.title;
        this._cloneActionPlan(response.actionPlanConfiguration);
        this._setTemplateConfig(this.actionPlan);
        this.$window.sessionStorage.setItem('actionPlanClone', angular.toJson(this.actionPlan));
      }
      this.apmActionPlanService.setActionPlanTitle(title);
      this.$window.sessionStorage.setItem('actionPlan', angular.toJson(this.actionPlan));
      this.$window.sessionStorage.setItem('templateConfig', angular.toJson(this.templateConfig));
      this.isLimitedEdit = this.apmActionPlansFactory.isLimitedEdit(this.actionPlan);
      this._setActionPlanStep();
      this._getCriteriaData();
      this._setData();
      this.$window.sessionStorage.removeItem('selectedActionPlan');
    }
  }, {
    key: '_saveActionPlan',
    value: function _saveActionPlan() {
      var _this3 = this;

      this.templateConfig = angular.fromJson(this.$window.sessionStorage.getItem('templateConfig')) || this.templateConfig;
      this.templateConfig.template = this.actionPlan.template;
      this.templateConfig.actionPlanId = this.actionPlan._id;
      this.templateConfig.actionPlanConfiguration = this.actionPlan;
      var requestType = this.actionPlan._id ? 'putActionPlanConfig' : 'postActionPlanConfig';
      this.templateConfig.editOnly = requestType === 'putActionPlanConfig';
      this.apmActionPlanService.saveActionPlanConfig(this.templateConfig, requestType).then(function (response) {
        return _this3._saveActionPlanSuccess(response);
      }).catch(function (err) {
        return _this3._errorHandler(err);
      });
    }
  }, {
    key: '_saveActionPlanSuccess',
    value: function _saveActionPlanSuccess(response) {
      var apTitle = _.has(response, 'actionPlanConfiguration') && response.actionPlanConfiguration.title ? response.actionPlanConfiguration.title : '';
      this.isClone = false;

      this.scNotificationsFactory.success('Action Plan ' + apTitle + ' has been successfully created.');
      response.actionPlanConfiguration.template = response.template;
      this.$window.sessionStorage.setItem('templateConfig', angular.toJson(response));
      this.$window.sessionStorage.setItem('actionPlan', angular.toJson(response.actionPlanConfiguration));
      this.apmActionPlanService.setActionPlanTitle('Action Plan Details for ' + apTitle);
      this.$rootScope.selectedIndex = 1;
    }
  }, {
    key: '_checkChipLength',
    value: function _checkChipLength() {
      if (!this.actionPlan.population.groupCharacteristic.length) {
        this.$scope.createActionPlanPopulationForm.provider.$setValidity('required', false);
      } else {
        this.$scope.createActionPlanPopulationForm.provider.$setValidity('required', true);
      }
    }
  }, {
    key: '_cloneActionPlan',
    value: function _cloneActionPlan(actionPlan) {
      if (_.has(actionPlan, '_id')) {
        actionPlan._id = undefined;
      }
      if (_.has(actionPlan, 'title')) {
        this.originalTitle = actionPlan.title;
        actionPlan.title = '';
      }
      if (_.has(actionPlan, 'status')) {
        actionPlan.status = undefined;
      }
      if (_.has(actionPlan, 'statusToDisplay')) {
        actionPlan.statusToDisplay = undefined;
      }
      if (_.has(actionPlan, 'measureYear')) {
        actionPlan.measureYear = undefined;
      }
      if (_.has(actionPlan, 'eventDates') && actionPlan.eventDates.length) {
        actionPlan.eventDates = [];
      }
      if (_.has(actionPlan, 'plannedResources') && actionPlan.plannedResources.length) {
        actionPlan.plannedResources = [];
      }
    }
  }, {
    key: '_setActionPlanStep',
    value: function _setActionPlanStep() {
      var selectedIndex = 0;

      if (this.actionPlan.eventDates && !this.actionPlan.eventDates.length) {
        selectedIndex = 1;
      } else if (!this.actionPlan.startEndTimeRange || !this.actionPlan.startEndTimeRange.start || !this.actionPlan.startEndTimeRange.end) {
        angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(2)').addClass('md-step-complete');
        selectedIndex = 2;
      } else {
        angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(2)').addClass('md-step-complete');
        angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(3)').addClass('md-step-complete');
      }
      if (this.isLimitedEdit) {
        selectedIndex = 1;
      }
      this.$rootScope.selectedIndex = !this.isClone ? selectedIndex : 0;
    }
  }, {
    key: '_setData',
    value: function _setData() {
      var _this4 = this;

      if (!this.populationData.length) {
        this._getPopulationData();
      }
      angular.element('body').addClass('create');
      this._setPopulationCheckMark();
      this._setWatches();
      this.$timeout(function () {
        if (_this4.actionPlan && _this4.actionPlan.population && _this4.actionPlan.population.groupCharacteristic && !_this4.actionPlan.population.groupCharacteristic.length) {
          _this4.$scope.createActionPlanPopulationForm.provider.$setValidity('required', false);
        }
      });
    }
  }, {
    key: '_setPopulationCheckMark',
    value: function _setPopulationCheckMark() {
      var _this5 = this;

      this.$timeout(function () {
        if (_this5.$scope.createActionPlanPopulationForm && _this5.$scope.createActionPlanPopulationForm.$valid) {
          angular.element('apm-action-plan-create-edit .md-tab:first-of-type').addClass('md-step-complete');
        } else {
          angular.element('apm-action-plan-create-edit .md-tab:first-of-type').removeClass('md-step-complete');
        }
      }, 1000);
    }
  }, {
    key: '_setWatches',
    value: function _setWatches() {
      var _this6 = this;

      this.$timeout(function () {
        _this6._selectedIndexWatch();
        _this6.$scope.$watch('createActionPlanPopulationForm.$valid', function () {
          _this6._setPopulationCheckMark();
        }, true);
      });
    }
  }, {
    key: '_selectedIndexWatch',
    value: function _selectedIndexWatch() {
      var _this7 = this;

      if (!_.isNull(this.selectedIndexEventListener)) {
        return false;
      }
      this.selectedIndexEventListener = this.$rootScope.$watch('selectedIndex', function (current, previous) {
        if (current !== previous && current === 0) {
          _this7.$onInit();
        }
      });
    }
  }, {
    key: '_getCriteriaData',
    value: function _getCriteriaData() {
      var _this8 = this;

      this.$timeout(function () {
        if (_this8.actionPlan.template) {
          _.forEach(_this8.templateData, function (el) {
            if (el.type === _this8.actionPlan.template) {
              _this8.criteriaData = el.templateCriterias;
            }
          });
        }
      });
    }
  }, {
    key: '_getPopulationData',
    value: function _getPopulationData() {
      var _this9 = this;

      this.apmActionPlanService.getOrganizationList().then(function (response) {
        return _this9._getPopulationSuccess(response);
      }).catch(function (err) {
        return _this9._errorHandler(err);
      });
    }
  }, {
    key: '_getPopulationSuccess',
    value: function _getPopulationSuccess(response) {
      if (response.length) {
        this.populationData = _.map(response, function (el) {
          return el;
        });
        this._setGroupData();
        this._setProviderData();
        this._removeAllSelectedProvidersFromList();
      }
    }
  }, {
    key: '_setGroupData',
    value: function _setGroupData() {
      this.autoCompleteData = this.populationData;
    }
  }, {
    key: '_setProviderData',
    value: function _setProviderData() {
      var _this10 = this;

      this.autoCompleteProviderData = [];
      _.forEach(this.populationData, function (el) {
        _.forEach(el.associatedProviders, function (elem) {
          elem.name = _this10.scLastNameFirstFilter(elem.lastName, null, elem.firstName, null, elem.suffix);
          _this10.autoCompleteProviderData.push(elem);
        });
      });
      this.allProviders = this.autoCompleteProviderData.slice(0);
      this.allProvidersOfGroup = _.clone(this.allProviders);
    }
  }, {
    key: '_setProviderDataByGroup',
    value: function _setProviderDataByGroup(group) {
      var _this11 = this;

      this.autoCompleteProviderData = [];
      this.allProvidersOfGroup = [];
      _.forEach(group.associatedProviders, function (elem) {
        if (!_.find(_this11.actionPlan.population.groupCharacteristic, { _id: elem._id })) {
          _this11.autoCompleteProviderData.push(elem);
        }
        _this11.allProvidersOfGroup.push(elem);
      });
      this._setProvidersSelectPlaceHolder();
    }
  }, {
    key: '_setProvidersSelectPlaceHolder',
    value: function _setProvidersSelectPlaceHolder() {
      if (this.autoCompleteProviderData.length) {
        this.providersPlaceHolder = 'Select Provider';
      } else {
        this.providersPlaceHolder = 'No providers available for the selected group';
      }
    }
  }, {
    key: '_isOnTheCurrentGroupList',
    value: function _isOnTheCurrentGroupList(chip) {
      var id = _.get(chip, '_id');
      return !_.isUndefined(_.find(this.allProvidersOfGroup, { _id: id }));
    }
  }, {
    key: '_removeElementFromProviderLists',
    value: function _removeElementFromProviderLists(id) {
      this.autoCompleteProviderData = _.map(this.autoCompleteProviderData, function (el) {
        if (el && el._id !== id) {
          return el;
        }
      }).filter(Boolean);
      this.allProviders = _.map(this.allProviders, function (el) {
        if (el && el._id !== id) {
          return el;
        }
      }).filter(Boolean);
    }
  }, {
    key: '_removeAllSelectedProvidersFromList',
    value: function _removeAllSelectedProvidersFromList() {
      var _this12 = this;

      if (this.actionPlan && this.actionPlan.population && this.actionPlan.population.groupCharacteristic) {
        _.forEach(this.actionPlan.population.groupCharacteristic, function (el) {
          var id = _.first(el.value.match(/[^\/]*$/));
          _this12._removeElementFromProviderLists(id);
        });
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return ApmActionPlanCreatePopulationController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlanCreatePopulation', {
  templateUrl: 'app/components/actionPlans/createEdit/population/apm.actionPlans.createPopulation.html',
  controller: ApmActionPlanCreatePopulationController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmActionPlanCreateLocationController = function () {

  /** @ngInject */
  function ApmActionPlanCreateLocationController($rootScope, $scope, $timeout, $window, apmActionPlanService, apmActionPlansFactory, scNotificationsFactory, API_BASE_URL) {
    _classCallCheck(this, ApmActionPlanCreateLocationController);

    _.assign(this, {
      $rootScope: $rootScope,
      $scope: $scope,
      $timeout: $timeout,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      apmActionPlansFactory: apmActionPlansFactory,
      scNotificationsFactory: scNotificationsFactory,
      API_BASE_URL: API_BASE_URL,

      actionPlan: {},
      appointmentLengths: [15, 30, 45],
      appointmentMaxTime: undefined,
      appointmentMinTime: undefined,
      availableLocations: [],
      breakLength: undefined,
      breakMaxTime: undefined,
      breakMinTime: undefined,
      endTime: '',
      event: {
        excludedTimeSlots: [],
        doubleBooked: false,
        startTimeEndTimeRange: {}
      },
      eventTimes: null,
      eventTimesEnd: null,
      excludeArray: [],
      excludeEndArray: [],
      excludedEnd: '',
      excludedStart: '',
      invalidSlotsRemoved: false,
      isLimitedEdit: false,
      lastIndex: 3,
      loadingLocations: false,
      locationsCount: 0,
      locationsToDisplay: [],
      longTimeFormat: 'HH:mm:ss',
      outbound: {},
      selectedLocation: '',
      shortTimeFormat: 'h:mma',
      startIndex: 0,
      startTime: '',
      templateConfig: {},
      timeSlotsLoadedFromClone: false
    });
  }

  _createClass(ApmActionPlanCreateLocationController, [{
    key: '$onInit',
    value: function $onInit() {
      this._loadTimeDefaults();
      this._setWatches();
    }
  }, {
    key: '_loadTimeDefaults',
    value: function _loadTimeDefaults() {
      var applicationProperties = JSON.parse(this.$window.sessionStorage.getItem('applicationProperties'));
      this.appointmentMinTime = this._changeTimeFormat(_.get(applicationProperties, 'firstAppointmentDefault', undefined));
      this.appointmentMaxTime = this._changeTimeFormat(_.get(applicationProperties, 'lastAppointmentDefault', undefined));
      this.breakMinTime = this._changeTimeFormat(_.get(applicationProperties, 'startBreakDefault', undefined));
      this.breakMaxTime = this._changeTimeFormat(_.get(applicationProperties, 'endBreakDefault', undefined));
      this.breakLength = _.get(applicationProperties, 'appointmentLength', undefined);
    }
  }, {
    key: '_changeTimeFormat',
    value: function _changeTimeFormat(time) {
      if (_.isUndefined(time)) {
        return time;
      }
      return moment(time, this.longTimeFormat).format(this.shortTimeFormat);
    }
  }, {
    key: 'save',
    value: function save() {
      if (this.timeSlotsLoadedFromClone || this.invalidSlotsRemoved) {
        this.$scope.createActionPlanLocationForm.$setDirty();
      }

      if (!this.$scope.createActionPlanLocationForm.$dirty) {
        this.$rootScope.selectedIndex = 3;
      } else if (this.$scope.createActionPlanLocationForm.$valid) {
        this._setOutbound();
        this._cleanExcludeTimes();
        this._setActionPlan();
        this._submitActionPlan();
      }
    }
  }, {
    key: 'goToPreviousPage',
    value: function goToPreviousPage() {
      this.$window.history.back();
    }
  }, {
    key: 'resetAppointmentLength',
    value: function resetAppointmentLength(length) {
      this._updateEventTimes(length);
      this.event.excludedTimeSlots = [];
      this.startTime = null;
    }
  }, {
    key: '_updateEventTimes',
    value: function _updateEventTimes(length) {
      this.eventTimes = this.apmActionPlansFactory.getTimes(this.appointmentMinTime, this.appointmentMaxTime, length);
      this.eventTimesEnd = this.apmActionPlansFactory.getTimes(this.appointmentMinTime, this.appointmentMaxTime, length);
    }
  }, {
    key: 'back',
    value: function back() {
      this.$rootScope.selectedIndex = 1;
    }
  }, {
    key: 'setTime',
    value: function setTime(time, type) {
      if (type === 'start' && !time && this.event.startTimeEndTimeRange.end) {
        this.event.startTimeEndTimeRange.end = null;
        this.endTime = null;
        return;
      }

      time = time.replace('am', ' AM').replace('pm', ' PM');

      if (this.event && this.event.startTimeEndTimeRange) {
        this.event.startTimeEndTimeRange[type] = moment(time, ['h:mm A']).format('HH:mm');
      } else {
        this.event.startTimeEndTimeRange = {};
        this.event.startTimeEndTimeRange[type] = moment(time, ['h:mm A']).format('HH:mm');
      }

      if (this.event && this.event.excludedTimeSlots && this.event.excludedTimeSlots.length) {
        this._cleanTimeSlots(moment(time, ['h:mm A']).format('HH:mm'), type);
      }

      if (this.startTime && this.endTime) {
        this.excludeArray = [];
        this._setExcludeArray(moment(this.startTime.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']), moment(this.endTime.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']));
      }

      if (type === 'start') {
        this._cleanEventTimesEnd(this.event.startTimeEndTimeRange.start);
      }
      this.excludedStart = null;
      this.excludedEnd = null;
    }
  }, {
    key: 'setExcludeEndArray',
    value: function setExcludeEndArray(startTime) {
      this.excludedEnd = null;
      this.$scope.createActionPlanLocationForm.excludedEnd.$setValidity('overlapping', true);
      if (startTime) {
        startTime = startTime.replace('am', ' am').replace('pm', ' pm');
        this.excludeEndArray = _.map(this.excludeArray, function (endTime) {
          if (moment(startTime, ['h:mm a']).isBefore(moment(endTime, ['h:mm a']))) {
            return endTime.replace(/\s/g, '');
          }
        }).filter(Boolean);
      }
    }
  }, {
    key: 'setExcluded',
    value: function setExcluded(startTime, endTime) {
      startTime = startTime.replace('am', ' AM').replace('pm', ' PM');
      endTime = endTime.replace('am', ' AM').replace('pm', ' PM');
      if (!this.event.excludedTimeSlots) {
        this.event.excludedTimeSlots = [];
      }
      this.event.excludedTimeSlots.push({
        start: moment(startTime, ['h:mm A']).format('h:mm A').replace(' AM', 'am').replace(' PM', 'pm'),
        end: moment(endTime, ['h:mm A']).format('h:mm A').replace(' AM', 'am').replace(' PM', 'pm')
      });

      this.excludedStart = null;
      this.excludedEnd = null;
    }
  }, {
    key: 'removeExcluded',
    value: function removeExcluded(index) {
      _.pullAt(this.event.excludedTimeSlots, index);
      this.$scope.createActionPlanLocationForm.$setDirty();
    }
  }, {
    key: 'validateRequiredTime',
    value: function validateRequiredTime() {
      if (this.$scope.createActionPlanLocationForm.endTime.$error.required && this.$scope.createActionPlanLocationForm.endTime.$touched || this.$scope.createActionPlanLocationForm.startTime.$error.required && this.$scope.createActionPlanLocationForm.startTime.$touched) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: '_before',
    value: function _before(date1End, date2Start, date2End) {
      return date1End.isSameOrBefore(date2Start) && date1End.isSameOrBefore(date2End);
    }
  }, {
    key: '_exclusiveDates',
    value: function _exclusiveDates(d1Start, d1End, d2Start, d2End) {
      return this._before(d1End, d2Start, d2End) || this._before(d2End, d1Start, d1End);
    }
  }, {
    key: 'validateOverlappingDateTime',
    value: function validateOverlappingDateTime(testObj) {
      var _this = this;

      if (angular.isObject(testObj) && testObj.end) {
        var start = moment(testObj.start, ['h:ma']);
        var end = moment(testObj.end, ['h:ma']);

        var overlappingDates = _.some(this.event.excludedTimeSlots, function (x) {
          var xStart = moment(x.start, ['h:ma']);
          var xEnd = moment(x.end, ['h:ma']);
          return !_this._exclusiveDates(xStart, xEnd, start, end);
        });

        if (overlappingDates) {
          this.$scope.createActionPlanLocationForm.excludedEnd.$setValidity('overlapping', false);
          return true;
        } else {
          this.$scope.createActionPlanLocationForm.excludedEnd.$setValidity('overlapping', true);
          return false;
        }
      }
    }
  }, {
    key: 'validateUniqueDateTime',
    value: function validateUniqueDateTime(testObj) {
      if (angular.isObject(testObj)) {
        if (_.some(this.event.excludedTimeSlots, testObj)) {
          this.$scope.createActionPlanLocationForm.excludedEnd.$setValidity('isunique', false);
          return true;
        } else {
          this.$scope.createActionPlanLocationForm.excludedEnd.$setValidity('isunique', true);
          return false;
        }
      }
    }
  }, {
    key: 'slide',
    value: function slide(way) {
      if (way === 'right') {
        this.startIndex += 1;
        this.lastIndex += 1;
      } else {
        this.startIndex -= 1;
        this.lastIndex -= 1;
      }
      this.locationsToDisplay = _.slice(this.availableLocations, this.startIndex, this.lastIndex);
    }
  }, {
    key: '_setLocationCheckMark',
    value: function _setLocationCheckMark() {
      var _this2 = this;

      this.$timeout(function () {
        _this2.actionPlan = angular.fromJson(_this2.$window.sessionStorage.getItem('actionPlan'));
        if (_this2.$scope.createActionPlanLocationForm && _this2.$scope.createActionPlanLocationForm.$valid || _this2.actionPlan && _this2.actionPlan.startTimeEndTimeRange && !_.isEmpty(_this2.actionPlan.startTimeEndTimeRange)) {
          angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(3)').addClass('md-step-complete');
        } else {
          angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(3)').removeClass('md-step-complete');
        }
      }, 1000);
    }
  }, {
    key: '_setActionPlanWatch',
    value: function _setActionPlanWatch() {
      var _this3 = this;

      this.$scope.$watch(function () {
        return _this3.$window.sessionStorage.getItem('actionPlan');
      }, function (current, previous) {
        return _this3._getActionPlanAvailableLocations(current, previous);
      });
    }
  }, {
    key: '_setWatches',
    value: function _setWatches() {
      var _this4 = this;

      this._selectedIndexWatch();
      this._setActionPlanWatch();
      this.$scope.$watch('createActionPlanLocationForm.$valid', function () {
        _this4._setLocationCheckMark();
      }, true);
    }
  }, {
    key: '_getActionPlanAvailableLocations',
    value: function _getActionPlanAvailableLocations(currentValue, previousValue) {
      var _this5 = this;

      var currentActionPlan = currentValue ? angular.fromJson(currentValue) : null;
      var previousActionPlan = previousValue ? angular.fromJson(previousValue) : null;
      var loadLocations = true;
      var providers = [];

      if (currentActionPlan && _.has(currentActionPlan, 'location.fhir')) {
        this.selectedLocation = _.last(currentActionPlan.location.fhir.split('/'));
      }

      if (currentActionPlan && _.has(currentActionPlan, 'population.groupCharacteristic')) {
        var currentProviders = _.map(currentActionPlan.population.groupCharacteristic, 'value');

        if (previousActionPlan && _.has(previousActionPlan, 'population.groupCharacteristic')) {
          var previousProviders = _.map(previousActionPlan.population.groupCharacteristic, 'value');
          loadLocations = !_.isEqual(previousProviders.sort(), currentProviders.sort()) || _.isEmpty(this.availableLocations);
        }

        if (loadLocations) {
          this.loadingLocations = true;
          providers = _.map(currentProviders, function (provider) {
            return _.last(provider.split('/'));
          });

          this.apmActionPlanService.getLocationsByProviders(providers).then(function (response) {
            return _this5._getActionPlanAvailableLocationsSuccessHandler(response);
          }).catch(function (err) {
            return _this5._getActionPlanAvailableLocationsErrorHandler(err);
          });
        }
      }
    }
  }, {
    key: '_getActionPlanAvailableLocationsSuccessHandler',
    value: function _getActionPlanAvailableLocationsSuccessHandler(response) {
      if (_.has(response, 'data.content')) {
        this.availableLocations = response.data.content;
      }
      this.startIndex = 0;
      this.lastIndex = 3;
      this.locationsCount = _.size(this.availableLocations);
      this.locationsToDisplay = _.clone(this.availableLocations);

      if (this.locationsCount > 3) {
        this.locationsToDisplay = _.slice(this.availableLocations, this.startIndex, this.lastIndex);
      }
      this.loadingLocations = false;
    }
  }, {
    key: '_getActionPlanAvailableLocationsErrorHandler',
    value: function _getActionPlanAvailableLocationsErrorHandler(err) {
      this.loadingLocations = false;
      this._errorHandler(err);
    }
  }, {
    key: '_selectedIndexWatch',
    value: function _selectedIndexWatch() {
      var _this6 = this;

      this.$rootScope.$watch('selectedIndex', function (current, previous) {
        if (current !== previous && current === 2) {
          _this6.actionPlan = angular.fromJson(_this6.$window.sessionStorage.getItem('actionPlan'));
          _this6.actionPlanClone = angular.fromJson(_this6.$window.sessionStorage.getItem('actionPlanClone'));
          _this6.templateConfig = angular.fromJson(_this6.$window.sessionStorage.getItem('templateConfig'));
          angular.element('.main-container').animate({ scrollTop: 0 }, 200);
          _this6._loadActionPlan();
          if (_this6.startTime && _this6.endTime) {
            _this6.eventTimes = _this6.apmActionPlansFactory.getTimes(_this6.appointmentMinTime, _this6.appointmentMaxTime, _this6.appointmentLength);
            _this6.eventTimesEnd = _this6.apmActionPlansFactory.getTimes(_this6.appointmentMinTime, _this6.appointmentMaxTime, _this6.appointmentLength);
            _this6.excludeArray = [];
            _this6._setExcludeArray(moment(_this6.startTime.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']), moment(_this6.endTime.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']));
          }
        }
      });
    }
  }, {
    key: '_loadActionPlan',
    value: function _loadActionPlan() {
      if (this.actionPlan) {
        this.event.excludedTimeSlots = this.actionPlan.excludedTimeSlots || [];
        this.event.doubleBooked = this.actionPlan.doubleBooked || false;
        this.event.startTimeEndTimeRange = this.actionPlan.startTimeEndTimeRange || {};
        this.appointmentLength = this.actionPlan.appointmentLength || '';
        this._updateEventTimes(this.appointmentLength);
        if (_.has(this.event.startTimeEndTimeRange, 'start') && _.has(this.event.startTimeEndTimeRange, 'end')) {
          this.startTime = moment(this.event.startTimeEndTimeRange.start, ['h:mm a']).format('h:mm a').replace(/\s/g, '');
          this.endTime = moment(this.event.startTimeEndTimeRange.end, ['h:mm a']).format('h:mm a').replace(/\s/g, '');
        } else if (this.actionPlanClone && _.has(this.actionPlanClone.startTimeEndTimeRange, 'start') && _.has(this.actionPlanClone.startTimeEndTimeRange, 'end') && !this.startTime && !this.endTime) {
          this.event.startTimeEndTimeRange = this.actionPlanClone.startTimeEndTimeRange;
          this.startTime = moment(this.actionPlanClone.startTimeEndTimeRange.start, ['h:mm a']).format('h:mm a').replace(/\s/g, '');
          this.endTime = moment(this.actionPlanClone.startTimeEndTimeRange.end, ['h:mm a']).format('h:mm a').replace(/\s/g, '');
          this.appointmentLength = this.actionPlanClone.appointmentLength || '';
          this.event.excludedTimeSlots = this.actionPlanClone.excludedTimeSlots;
          this._setExcludeArray(moment(this.startTime.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']), moment(this.endTime.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']));
          this.timeSlotsLoadedFromClone = true;
        }
        this._filterOutOfRangeTimeSlots();

        if (this.event.excludedTimeSlots && this.event.excludedTimeSlots.length) {
          _.forEach(this.event.excludedTimeSlots, function (el) {
            el.start = moment(el.start, ['h:mm a']).format('h:mm a').replace(/\s/g, '');
            el.end = moment(el.end, ['h:mm a']).format('h:mm a').replace(/\s/g, '');
          });
        }
        this.isLimitedEdit = this.apmActionPlansFactory.isLimitedEdit(this.actionPlan);
      }
    }
  }, {
    key: '_filterOutOfRangeTimeSlots',
    value: function _filterOutOfRangeTimeSlots() {
      var _this7 = this;

      var invalidSlots = _.remove(this.event.excludedTimeSlots, function (timeSlot) {
        return moment(timeSlot.start, 'h:mma').isBefore(moment(_this7.breakMinTime, 'h:mma')) || moment(timeSlot.end, 'h:mma').isAfter(moment(_this7.breakMaxTime, 'h:mma'));
      });

      this.invalidSlotsRemoved = !_.isEmpty(invalidSlots);
    }
  }, {
    key: '_setActionPlan',
    value: function _setActionPlan() {
      if ((_.isEmpty(this.event.startTimeEndTimeRange) || !this.event.startTimeEndTimeRange) && this.startTime && this.endTime) {
        this.setTime(this.startTime, 'start');
        this.setTime(this.endTime, 'end');
      }

      if (this.actionPlan) {
        if (!_.isEmpty(this.selectedLocation)) {
          this.actionPlan.location = { fhir: this.API_BASE_URL + '/fhir/Location/' + this.selectedLocation };
        }
        this.actionPlan.excludedTimeSlots = this.outbound.actionPlan.excludedTimeSlots;
        this.actionPlan.doubleBooked = this.event.doubleBooked;
        this.actionPlan.startTimeEndTimeRange = this.event.startTimeEndTimeRange;
        this.actionPlan.appointmentLength = this.appointmentLength;
      }
    }
  }, {
    key: '_submitActionPlan',
    value: function _submitActionPlan() {
      var _this8 = this;

      this.templateConfig.actionPlanConfiguration = this.actionPlan;
      this.templateConfig.editOnly = true;
      this.apmActionPlanService.saveActionPlanConfig(this.templateConfig, 'putActionPlanConfig').then(function (response) {
        return _this8._saveSuccess(response);
      }).catch(function (err) {
        return _this8._errorHandler(err);
      });
    }
  }, {
    key: '_saveSuccess',
    value: function _saveSuccess(response) {
      var actionPlan = void 0;
      if (_.has(response, 'actionPlanConfiguration')) {
        actionPlan = response.actionPlanConfiguration;
      }
      this.$window.sessionStorage.setItem('actionPlan', angular.toJson(actionPlan));
      delete response.actionPlanConfiguration;
      this.$window.sessionStorage.setItem('templateConfig', angular.toJson(response));
      this.$rootScope.selectedIndex = 3;
      this.scNotificationsFactory.success('Event Times have been successfully saved/updated.');
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_cleanTimeSlots',
    value: function _cleanTimeSlots(time, type) {
      var _this9 = this;

      _.forEach(this.event.excludedTimeSlots, function (el, i) {
        if (type === 'start' && moment(time, ['h:mm A']).isAfter(moment(el.start, ['h:mm A']))) {
          delete _this9.event.excludedTimeSlots[i];
        }
        if (type === 'end' && moment(time, ['h:mm A']).isBefore(moment(el.end, ['h:mm A']))) {
          delete _this9.event.excludedTimeSlots[i];
        }
      });
      this.event.excludedTimeSlots = _.filter(this.event.excludedTimeSlots, Boolean);
    }
  }, {
    key: '_cleanExcludeTimes',
    value: function _cleanExcludeTimes() {
      var _this10 = this;

      if (this.event && this.event.excludedTimeSlots && this.event.excludedTimeSlots.length) {
        this.outbound.actionPlan.excludedTimeSlots = [];
        _.forEach(this.event.excludedTimeSlots, function (el) {
          _this10.outbound.actionPlan.excludedTimeSlots.push({
            start: moment(el.start.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']).format('HH:mm'),
            end: moment(el.end.replace('am', ' AM').replace('pm', ' PM'), ['h:mm A']).format('HH:mm')
          });
        });
      }
    }
  }, {
    key: '_setExcludeArray',
    value: function _setExcludeArray(startTime, endTime) {
      this.excludeArray = [];
      if (startTime.isBefore(moment(this.breakMaxTime, this.shortTimeFormat)) && endTime.isAfter(moment(this.breakMinTime, this.shortTimeFormat))) {
        var minTime = startTime.isAfter(moment(this.breakMinTime, this.shortTimeFormat)) ? startTime.format(this.shortTimeFormat) : this.breakMinTime;
        var maxTime = endTime.isBefore(moment(this.breakMaxTime, this.shortTimeFormat)) ? endTime.format(this.shortTimeFormat) : this.breakMaxTime;
        this.excludeArray = this.apmActionPlansFactory.getTimes(minTime, maxTime, this.breakLength);
      }
    }
  }, {
    key: '_cleanEventTimesEnd',
    value: function _cleanEventTimesEnd(startTime) {
      this.eventTimesEnd = this.apmActionPlansFactory.getTimes(this.appointmentMinTime, this.appointmentMaxTime, this.appointmentLength);
      this.eventTimesEnd = _.map(this.eventTimesEnd, function (endTime) {
        if (moment(startTime, ['h:mm A']).isSameOrBefore(moment(endTime, ['h:mm A']))) {
          return endTime;
        }
      }).filter(Boolean);
    }
  }, {
    key: '_setOutbound',
    value: function _setOutbound() {
      this.outbound.actionPlan = {};
    }
  }]);

  return ApmActionPlanCreateLocationController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlanCreateLocation', {
  templateUrl: 'app/components/actionPlans/createEdit/location/apm.actionPlans.createLocation.html',
  controller: ApmActionPlanCreateLocationController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmActionPlanCreateInstructionsController = function () {

  /** @ngInject */
  function ApmActionPlanCreateInstructionsController($rootScope, $scope, $state, $timeout, $window, apmActionPlanService, apmActionPlansFactory, scNotificationsFactory) {
    _classCallCheck(this, ApmActionPlanCreateInstructionsController);

    _.assign(this, {
      $rootScope: $rootScope,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      apmActionPlansFactory: apmActionPlansFactory,
      scNotificationsFactory: scNotificationsFactory,

      actionPlan: {},
      actionPlanClone: {},
      actionPlanComments: [{
        type: 'scheduling',
        comment: ''
      }, {
        type: 'reminders',
        comment: ''
      }, {
        type: 'encounters',
        comment: ''
      }],
      commentsLoadedFromClone: false,
      templateConfig: {},
      schedulingInstructions: '',
      reminderInstructions: '',
      encounterInstructions: '',
      isLimitedEdit: false
    });
  }

  _createClass(ApmActionPlanCreateInstructionsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$watch('selectedIndex', function (current, previous) {
        if (current !== previous && current === 3) {
          _this.actionPlan = angular.fromJson(_this.$window.sessionStorage.getItem('actionPlan'));
          _this.actionPlanClone = angular.fromJson(_this.$window.sessionStorage.getItem('actionPlanClone'));
          if (!_.has(_this.actionPlanClone, 'actionPlanComments') && !_.has(_this.actionPlan, 'actionPlanComments')) {
            _this.actionPlan.actionPlanComments = _this.actionPlanComments;
          } else {
            _this.actionPlan.actionPlanComments = _.get(_this.actionPlanClone, 'actionPlanComments', _.get(_this.actionPlan, 'actionPlanComments'));
            _this.commentsLoadedFromClone = _.has(_this.actionPlanClone, 'actionPlanComments');
          }

          _this.templateConfig = angular.fromJson(_this.$window.sessionStorage.getItem('templateConfig'));
          _this.$timeout(function () {
            angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(4)').addClass('md-step-complete');
          }, 1000);
          _this._loadActionPlan();
        }
      });
    }
  }, {
    key: 'save',
    value: function save() {
      this._setSchedulingInstructions();
      this._setReminderInstructions();
      this._setEncounterInstructions();
      this._updateActionPlan();
    }
  }, {
    key: 'back',
    value: function back() {
      this.$rootScope.selectedIndex = 2;
    }
  }, {
    key: '_loadActionPlan',
    value: function _loadActionPlan() {
      var _this2 = this;

      if (this.actionPlan && this.actionPlan.actionPlanComments && this.actionPlan.actionPlanComments.length) {
        _.forEach(this.actionPlan.actionPlanComments, function (el) {
          if (_.has(el, 'type') && el.comment) {
            switch (el.type) {
              case 'scheduling':
                _this2.schedulingInstructions = el.comment;
                break;
              case 'reminders':
                _this2.reminderInstructions = el.comment;
                break;
              case 'encounters':
                _this2.encounterInstructions = el.comment;
                break;
            }
          }
        });
        this.isLimitedEdit = this.apmActionPlansFactory.isLimitedEdit(this.actionPlan);
      }
    }
  }, {
    key: '_updateActionPlan',
    value: function _updateActionPlan() {
      var _this3 = this;

      if (this.commentsLoadedFromClone) {
        this.$scope.createActionPlanInstructionsForm.$setDirty();
      }

      if (this.$scope.createActionPlanInstructionsForm.$dirty) {
        this.templateConfig.actionPlanConfiguration = this.actionPlan;
        this.templateConfig.editOnly = true;
        this.apmActionPlanService.saveActionPlanConfig(this.templateConfig, 'putActionPlanConfig').then(function (response) {
          return _this3._saveActionPlanSuccessHandler(response);
        }).catch(function (error) {
          return _this3._saveActionPlanErrorHandler(error);
        });
      } else {
        this.$state.go('actionPlans.details', { id: this.actionPlan._id });
      }
    }
  }, {
    key: '_saveActionPlanSuccessHandler',
    value: function _saveActionPlanSuccessHandler(response) {
      var actionPlan = void 0;
      if (_.has(response, 'actionPlanConfiguration')) {
        actionPlan = response.actionPlanConfiguration;
      }
      this.$window.sessionStorage.setItem('actionPlan', angular.toJson(actionPlan));
      delete response.actionPlanConfiguration;
      this.$window.sessionStorage.setItem('templateConfig', angular.toJson(response));

      this.scNotificationsFactory.success('Action Plan Instructions has been successfully created.');
      this.$state.go('actionPlans.details', { id: this.actionPlan._id });
    }
  }, {
    key: '_saveActionPlanErrorHandler',
    value: function _saveActionPlanErrorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_setSchedulingInstructions',
    value: function _setSchedulingInstructions() {
      var _this4 = this;

      if (this.schedulingInstructions) {
        if (this.actionPlan && this.actionPlan.actionPlanComments && this.actionPlan.actionPlanComments.length) {
          _.forEach(this.actionPlan.actionPlanComments, function (el) {
            if (el.type === 'scheduling') {
              el.comment = _this4.schedulingInstructions;
            }
          });
        }
      }
    }
  }, {
    key: '_setReminderInstructions',
    value: function _setReminderInstructions() {
      var _this5 = this;

      if (this.reminderInstructions) {
        if (this.actionPlan && this.actionPlan.actionPlanComments && this.actionPlan.actionPlanComments.length) {
          _.forEach(this.actionPlan.actionPlanComments, function (el) {
            if (el.type === 'reminders') {
              el.comment = _this5.reminderInstructions;
            }
          });
        }
      }
    }
  }, {
    key: '_setEncounterInstructions',
    value: function _setEncounterInstructions() {
      var _this6 = this;

      if (this.encounterInstructions) {
        if (this.actionPlan && this.actionPlan.actionPlanComments && this.actionPlan.actionPlanComments.length) {
          _.forEach(this.actionPlan.actionPlanComments, function (el) {
            if (el.type === 'encounters') {
              el.comment = _this6.encounterInstructions;
            }
          });
        }
      }
    }
  }]);

  return ApmActionPlanCreateInstructionsController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlanCreateInstructions', {
  templateUrl: 'app/components/actionPlans/createEdit/instructions/apm.actionPlans.createInstructions.html',
  controller: ApmActionPlanCreateInstructionsController
});
'use strict';

angular.module('apm.components.actionPlans').component('apmActionPlanHeader', {
  templateUrl: 'app/components/actionPlans/createEdit/header/apm.actionPlans.createEditHeader.component.html',
  controller: function controller() {},
  bindings: {
    title: '<'
  }
});
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckboxResourcesController =

/** @ngInject */
function CheckboxResourcesController(ROLES) {
  _classCallCheck(this, CheckboxResourcesController);

  _.assign(this, {
    ROLES: ROLES
  });
};

angular.module('apm.components.actionPlans').component('apmCalendarCheckboxResources', {
  templateUrl: 'app/components/actionPlans/calendar/checkboxResources/apm.actionPlans.calendar.checkboxResources.component.html',
  controller: CheckboxResourcesController,
  bindings: {
    availableResources: '='
  }
});
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScheduleActionsController = function () {

  /** @ngInject */
  function ScheduleActionsController($q, $scope, $state, $stateParams, apmActionPlanService, apmAuthenticationService, apmPatientsService, scNotificationsFactory, scLastNameFirstFilter) {
    _classCallCheck(this, ScheduleActionsController);

    _.assign(this, {
      $q: $q,
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      apmPatientsService: apmPatientsService,
      apmAuthenticationService: apmAuthenticationService,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,

      actionType: 'schedule',
      apPatient: {},
      disposition: '',
      dispositionArray: [],
      hasAppointment: false,
      patient: {},
      ready: false,
      vendorCardVisibility: false,
      vm: {
        apPatient: {},
        patient: {}
      }
    });
  }

  _createClass(ScheduleActionsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.isReadOnly = !this.apmAuthenticationService.hasAccess('scAPOutreach');
      this._getAllData();
      this.$scope.$on('number-updated', function () {
        _this._getPatientSummary();
      });
    }
  }, {
    key: 'getVendorVisibility',
    value: function getVendorVisibility() {
      return this.vendorCardVisibility;
    }
  }, {
    key: '_determineVendorVisibility',
    value: function _determineVendorVisibility() {
      this.vendorCardVisibility = _.has(this.patient, 'hasVendors') && this.patient.hasVendors;
    }
  }, {
    key: '_getAllData',
    value: function _getAllData() {
      var _this2 = this;

      var getPatientSummary = this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId);
      var getActionPlanPatient = this.apmActionPlanService.getActionPlanPatient(this.$stateParams.planId, this.$stateParams.patientId);

      this.$q.all([getPatientSummary, getActionPlanPatient]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            getPatientSummaryResponse = _ref2[0],
            getActionPlanPatientResponse = _ref2[1];

        _this2._getPatientSummarySuccess(getPatientSummaryResponse);
        _this2._getActionPlanPatientSuccess(getActionPlanPatientResponse);
        _this2._getAllDataSuccessHandler();
      }).catch(function (err) {
        return _this2.errorHandler(err);
      });
    }
  }, {
    key: '_getAllDataSuccessHandler',
    value: function _getAllDataSuccessHandler() {
      this.ready = true;
    }
  }, {
    key: 'goToAPList',
    value: function goToAPList() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
    }
  }, {
    key: '_getActionPlanPatientSuccess',
    value: function _getActionPlanPatientSuccess(res) {
      if (_.has(res, 'data.appointmentId')) {
        this.hasAppointment = true;
      }
      if (_.has(res, 'data')) {
        this.apPatient = res.data;
        this.vm.apPatient = this._translateApPatientVm();
      }
    }
  }, {
    key: '_getPatientSummary',
    value: function _getPatientSummary() {
      var _this3 = this;

      this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId).then(function (res) {
        return _this3._getPatientSummarySuccess(res);
      }).catch(function (err) {
        return _this3.errorHandler(err);
      });
    }
  }, {
    key: '_getPatientSummarySuccess',
    value: function _getPatientSummarySuccess(response) {
      this.patient = response.data;
      this.patient.fullName = this.scLastNameFirstFilter(this.patient.firstName, null, this.patient.lastName, null, null);
      this.vm.patient = this._translatePatientVm();
      this._determineVendorVisibility();
    }
  }, {
    key: 'errorHandler',
    value: function errorHandler(err) {
      this.ready = true;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_translatePatientVm',
    value: function _translatePatientVm() {
      var _patient = this.patient;

      return {
        id: this.$stateParams.patientId,
        activeActionPlansCount: _.get(_patient, 'activeActionPlansCount', 0)
      };
    }
  }, {
    key: '_translateApPatientVm',
    value: function _translateApPatientVm() {
      var _apPatient = this.apPatient;

      return {
        pendingGaps: _.get(_apPatient, 'pendingGaps', []),
        openGaps: _.get(_apPatient, 'openGaps', [])
      };
    }
  }]);

  return ScheduleActionsController;
}();

angular.module('apm.components.actionPlans').component('scheduleActions', {
  templateUrl: 'app/components/actionPlans/actions/schedule/apm.actionPlans.actions.schedule.html',
  controller: ScheduleActionsController
});
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReminderActionsController = function () {

  /** @ngInject */
  function ReminderActionsController($q, $scope, $state, $stateParams, apmActionPlanService, apmAuthenticationService, apmPatientsService, scNotificationsFactory, scLastNameFirstFilter) {
    _classCallCheck(this, ReminderActionsController);

    _.assign(this, {
      $q: $q,
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      apmPatientsService: apmPatientsService,
      apmAuthenticationService: apmAuthenticationService,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,

      apPatient: {},
      hasAppointment: false,
      patient: {},
      ready: false,
      vendorCardVisibility: false,
      vm: {
        apPatient: {}
      }
    });
  }

  _createClass(ReminderActionsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.isReadOnly = !this.apmAuthenticationService.hasAccess('scAPOutreach');
      this._getAllData();
      this.$scope.$on('number-updated', function () {
        _this._getPatientSummary();
      });
    }
  }, {
    key: 'getVendorVisibility',
    value: function getVendorVisibility() {
      return this.vendorCardVisibility;
    }
  }, {
    key: '_determineVendorVisibility',
    value: function _determineVendorVisibility() {
      this.vendorCardVisibility = _.has(this.patient, 'hasVendors') && this.patient.hasVendors;
    }
  }, {
    key: '_getAllData',
    value: function _getAllData() {
      var _this2 = this;

      var getPatientSummary = this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId);
      var getActionPlanPatient = this.apmActionPlanService.getActionPlanPatient(this.$stateParams.planId, this.$stateParams.patientId);

      this.$q.all([getPatientSummary, getActionPlanPatient]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            getPatientSummaryResponse = _ref2[0],
            getActionPlanPatientResponse = _ref2[1];

        _this2._getPatientSummarySuccess(getPatientSummaryResponse);
        _this2._getActionPlanPatientSuccess(getActionPlanPatientResponse);
        _this2._getAllDataSuccessHandler();
      }).catch(function (err) {
        return _this2.errorHandler(err);
      });
    }
  }, {
    key: '_getAllDataSuccessHandler',
    value: function _getAllDataSuccessHandler() {
      this.ready = true;
    }
  }, {
    key: 'goToAPList',
    value: function goToAPList() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
    }
  }, {
    key: '_getActionPlanPatientSuccess',
    value: function _getActionPlanPatientSuccess(res) {
      if (_.has(res, 'data.appointmentId')) {
        this.hasAppointment = true;
      }
      if (_.has(res, 'data')) {
        this.apPatient = res.data;
        this.vm.apPatient = this._translateApPatientVm();
      }
    }
  }, {
    key: '_getPatientSummary',
    value: function _getPatientSummary() {
      var _this3 = this;

      this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId).then(function (res) {
        return _this3._getPatientSummarySuccess(res);
      }).catch(function (err) {
        return _this3.errorHandler(err);
      });
    }
  }, {
    key: '_getPatientSummarySuccess',
    value: function _getPatientSummarySuccess(response) {
      this.patient = response.data;
      this.patient.fullName = this.scLastNameFirstFilter(this.patient.firstName, null, this.patient.lastName, null, null);
      this.vm.patient = this._translatePatientVm();
      this._determineVendorVisibility();
    }
  }, {
    key: 'errorHandler',
    value: function errorHandler(err) {
      this.ready = true;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_translatePatientVm',
    value: function _translatePatientVm() {
      var _patient = this.patient;

      return {
        id: this.$stateParams.patientId,
        activeActionPlansCount: _.get(_patient, 'activeActionPlansCount', 0)
      };
    }
  }, {
    key: '_translateApPatientVm',
    value: function _translateApPatientVm() {
      var _apPatient = this.apPatient;

      return {
        pendingGaps: _.get(_apPatient, 'pendingGaps', []),
        openGaps: _.get(_apPatient, 'openGaps', [])
      };
    }
  }]);

  return ReminderActionsController;
}();

angular.module('apm.components.actionPlans').component('reminderActions', {
  templateUrl: 'app/components/actionPlans/actions/reminder/apm.actionPlans.actions.reminder.html',
  controller: ReminderActionsController
});
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EncounterActionsController = function () {

  /** @ngInject */
  function EncounterActionsController($q, $state, $stateParams, apmActionPlanService, apmPatientsService, scNotificationsFactory, scLastNameFirstFilter) {
    _classCallCheck(this, EncounterActionsController);

    _.assign(this, {
      $q: $q,
      $state: $state,
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      apmPatientsService: apmPatientsService,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,

      apPatient: {},
      hasAppointment: false,
      patient: {},
      ready: false,
      vm: {
        apPatient: {}
      }
    });
  }

  _createClass(EncounterActionsController, [{
    key: '$onInit',
    value: function $onInit() {
      this._getAllData();
    }
  }, {
    key: '_getAllData',
    value: function _getAllData() {
      var _this = this;

      var getPatientSummary = this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId);
      var getActionPlanPatient = this.apmActionPlanService.getActionPlanPatient(this.$stateParams.planId, this.$stateParams.patientId);

      this.$q.all([getPatientSummary, getActionPlanPatient]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            getPatientSummaryResponse = _ref2[0],
            getActionPlanPatientResponse = _ref2[1];

        _this._getPatientSummarySuccess(getPatientSummaryResponse);
        _this._getActionPlanPatientSuccess(getActionPlanPatientResponse);
        _this._getAllDataSuccessHandler();
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_getAllDataSuccessHandler',
    value: function _getAllDataSuccessHandler() {
      this.ready = true;
    }
  }, {
    key: 'goToAPList',
    value: function goToAPList() {
      this.$state.go('actionPlans.details', { id: this.$stateParams.planId });
    }
  }, {
    key: '_getActionPlanPatientSuccess',
    value: function _getActionPlanPatientSuccess(res) {
      if (_.has(res, 'data.appointmentId')) {
        this.hasAppointment = true;
      }
      if (_.has(res, 'data')) {
        this.apPatient = res.data;
        this.vm.apPatient = this._translateApPatientVm();
      }
    }
  }, {
    key: '_getPatientSummary',
    value: function _getPatientSummary() {
      var _this2 = this;

      this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId).then(function (res) {
        return _this2._getPatientSummarySuccess(res);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_getPatientSummarySuccess',
    value: function _getPatientSummarySuccess(response) {
      this.patient = response.data;
      this.patient.fullName = this.scLastNameFirstFilter(this.patient.firstName, null, this.patient.lastName, null, null);
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.ready = true;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_translateApPatientVm',
    value: function _translateApPatientVm() {
      var _apPatient = this.apPatient;

      return {
        pendingGaps: _.get(_apPatient, 'pendingGaps', []),
        openGaps: _.get(_apPatient, 'openGaps', [])
      };
    }
  }]);

  return EncounterActionsController;
}();

angular.module('apm.components.actionPlans').component('encounterActions', {
  templateUrl: 'app/components/actionPlans/actions/encounter/apm.actionPlans.actions.encounter.html',
  controller: EncounterActionsController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmResourcesLocationsService = function () {

  /** @ngInject */
  function ApmResourcesLocationsService($resource, $httpParamSerializer, API_BASE_URL) {
    var _this = this;

    _classCallCheck(this, ApmResourcesLocationsService);

    _.assign(this, {
      $resource: $resource,
      $httpParamSerializer: $httpParamSerializer,
      API_BASE_URL: API_BASE_URL
    });
    var baseUrl = '' + API_BASE_URL;

    this.resourcesLocationsResource = $resource('' + baseUrl, {}, {
      getLocations: {
        method: 'GET',
        url: baseUrl + '/sc/Locations',
        transformResponse: this._extractResponse
      },
      getLocationGroupByParentId: {
        method: 'GET',
        url: baseUrl + '/sc/LocationGroup?parentId=:locationId',
        transformResponse: this._extractResponseLocation
      },
      setLocationGroup: {
        method: 'POST',
        url: baseUrl + '/sc/LocationGroup',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        transformRequest: function transformRequest(params) {
          return _this._transformUrlEncoded(params);
        },
        transformResponse: this._extractResponse
      }
    });
  }

  _createClass(ApmResourcesLocationsService, [{
    key: 'getLocations',
    value: function getLocations(params) {
      return this.resourcesLocationsResource.getLocations(params).$promise;
    }
  }, {
    key: 'setLocationGroup',
    value: function setLocationGroup(params) {
      return this.resourcesLocationsResource.setLocationGroup(params).$promise;
    }
  }, {
    key: 'getLocationGroupByParentId',
    value: function getLocationGroupByParentId(params) {
      return this.resourcesLocationsResource.getLocationGroupByParentId(params).$promise;
    }
  }, {
    key: '_extractResponse',
    value: function _extractResponse(response) {
      var responseJSON = angular.fromJson(response);
      return responseJSON.success ? responseJSON.data : responseJSON;
    }
  }, {
    key: '_extractResponseLocation',
    value: function _extractResponseLocation(response) {
      return angular.fromJson(response);
    }
  }, {
    key: '_transformUrlEncoded',
    value: function _transformUrlEncoded(parameters) {
      return this.$httpParamSerializer(parameters);
    }
  }]);

  return ApmResourcesLocationsService;
}();

angular.module('apm.components.resources').service('apmResourcesLocationsService', ApmResourcesLocationsService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourcesLocationsController = function () {

  /** @ngInject */
  function ResourcesLocationsController($state, apmAuthenticationService) {
    _classCallCheck(this, ResourcesLocationsController);

    _.assign(this, {
      $state: $state,
      apmAuthenticationService: apmAuthenticationService,

      addressesObj: {
        addresses: []
      },
      checkboxObj: {}
    });
  }

  _createClass(ResourcesLocationsController, [{
    key: '$onInit',
    value: function $onInit() {
      if (!this.apmAuthenticationService.hasAccess('duplicateManagement')) {
        this.$state.go('resources.list');
      }
    }
  }]);

  return ResourcesLocationsController;
}();

angular.module('apm.components.resources').component('apmResourcesLocations', {
  templateUrl: 'app/components/resources/locations/apm.resources.locations.component.html',
  controller: ResourcesLocationsController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourcesGridController = function () {

  /** @ngInject */
  function ResourcesGridController($state, $window, apmAuthenticationService, apmResourcesService, apmGridFactory, scNotificationsFactory, scLastNameFirstFilter, PAGE_SIZES, ROLES) {
    _classCallCheck(this, ResourcesGridController);

    _.assign(this, {
      $state: $state,
      $window: $window,
      apmAuthenticationService: apmAuthenticationService,
      apmResourcesService: apmResourcesService,
      apmGridFactory: apmGridFactory,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,
      PAGE_SIZES: PAGE_SIZES,
      ROLES: ROLES,

      enabledRoles: [],
      filter: {},
      resourcesListPage: {},
      rolesLimitedTo: [ROLES.PSU, ROLES.NP].join(),

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ResourcesGridController, [{
    key: '$onInit',
    value: function $onInit() {
      if (!this.apmAuthenticationService.hasAccess('scResourceMgmt')) {
        this.$state.go('home');
      }
      this._initializeFilter();
      this._fetchRoles();
    }
  }, {
    key: 'navigateToUserDetails',
    value: function navigateToUserDetails(userId) {
      this.$window.sessionStorage.setItem('returnState', 'resources.list');
      this.$state.go('resources.details', { userId: userId });
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;

      return this.apmResourcesService.fetchResources(this._getApiParams()).then(function (response) {
        return _this._fetchResourcesSuccessHandler(response);
      }).catch(function (err) {
        return _this._fetchResourcesErrorHandler(err);
      });
    }
  }, {
    key: '_fetchRoles',
    value: function _fetchRoles() {
      var _this2 = this;

      return this.apmResourcesService.fetchResourcesRoles().then(function (response) {
        return _this2._fetchResourcesRolesSuccessHandler(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_fetchResourcesRolesSuccessHandler',
    value: function _fetchResourcesRolesSuccessHandler(response) {
      var _this3 = this;

      if (_.has(response, 'data.results')) {
        var apmRoles = _.filter(response.data.results, { 'application': 'APM Application' })[0].rolesAvailable;
        var rolesLimitedTo = this.rolesLimitedTo.split(',');
        _.forEach(apmRoles, function (role) {
          _.forEach(rolesLimitedTo, function (enabledRole) {
            if (_.isMatch(role, { 'role': enabledRole })) {
              _this3.enabledRoles.push(role);
            }
          });
        });
      }
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.resourcesListPage[rowId];
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty() {
      return this.apmGridFactory.isFilterEmpty(this.filter);
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        '_count': this.pageSize,
        'page': this.page,
        'roles': this.rolesLimitedTo,
        'active': true
      }, this._getFilterParam());
    }
  }, {
    key: '_getFilterParam',
    value: function _getFilterParam() {
      return this.apmGridFactory.resolveFilters(this.filter);
    }
  }, {
    key: '_fetchResourcesSuccessHandler',
    value: function _fetchResourcesSuccessHandler(response) {
      var _this4 = this;

      this.resourcesListPage = {};
      var resourcesListPage = {
        results: [],
        totalResultCount: 0
      };
      if (_.has(response, 'data.content')) {
        _.forEach(response.data.content, function (user) {
          _this4._resolveName(user);
          _this4._resolveRoles(user);
          _this4.resourcesListPage[user._id] = user;

          resourcesListPage.results.push(user);
        }, this);
        resourcesListPage.totalResultCount = response.data.totalElements;
      }
      return resourcesListPage;
    }
  }, {
    key: '_fetchResourcesErrorHandler',
    value: function _fetchResourcesErrorHandler(err) {
      var resourcesListPage = {
        results: [],
        totalResultCount: 0
      };

      this.resourcesListPage = {};
      this._errorHandler(err);

      return resourcesListPage;
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.filter = {};
    }
  }, {
    key: '_resolveName',
    value: function _resolveName(user) {
      user.userFullName = this.scLastNameFirstFilter(user.lName, null, user.fName, null);
    }
  }, {
    key: '_resolveRoles',
    value: function _resolveRoles(user) {
      user.userRoles = '';
      _.forEach(user.roles, function (role, index) {
        if (index === 0) {
          user.userRoles = role.description;
        } else {
          user.userRoles = user.userRoles + ', ' + role.description;
        }
      }, this);
    }
  }]);

  return ResourcesGridController;
}();

angular.module('apm.components.resources').component('apmResourcesGrid', {
  templateUrl: 'app/components/resources/grid/apm.resources.grid.component.html',
  controller: ResourcesGridController,
  bindings: {
    filter: '<',
    sorting: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourcesDetailsController = function () {

  /** @ngInject */
  function ResourcesDetailsController($mdDialog, $q, $scope, $stateParams, apmResourcesService, scNotificationsFactory, scLastNameFirstFilter) {
    _classCallCheck(this, ResourcesDetailsController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $q: $q,
      $scope: $scope,
      $stateParams: $stateParams,
      apmResourcesService: apmResourcesService,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,

      events: [],
      loading: false,
      loadingEvents: false,
      resource: {}
    });
  }

  _createClass(ResourcesDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      this._getAllData();
    }
  }, {
    key: 'createEditLeave',
    value: function createEditLeave() {
      var _this = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var scope = angular.extend(this.$scope.$new(true), {
        userId: this.$stateParams.userId,
        event: event,
        refreshCallback: function refreshCallback() {
          return _this._getResourceEvents();
        }
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal" class="add-edit-leave-modal-dialog"><add-edit-leave-modal event="event" user-id="userId" refresh-callback="refreshCallback"/></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: 'confirmDeleteEvent',
    value: function confirmDeleteEvent(id) {
      var _this2 = this;

      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal" class="message-content"><delete-leave-modal></delete-leave-modal></md-dialog>',
        clickOutsideToClose: true
      }).then(function () {
        _this2.deleteEvent(id);
      });
    }
  }, {
    key: 'deleteEvent',
    value: function deleteEvent(id) {
      var _this3 = this;

      this.apmResourcesService.deleteResourceEvent(this.$stateParams.userId, id).then(function () {
        return _this3._deleteResourceEventSuccessHandler();
      }).catch(function (err) {
        return _this3._errorHandler(err);
      });
    }
  }, {
    key: '_getAllData',
    value: function _getAllData() {
      var _this4 = this;

      this.loading = true;

      var resourcePromise = this._getResourceInfo();
      var eventsPromise = this._getResourceEvents();

      this.$q.all([resourcePromise, eventsPromise]).then(function () {
        _this4.loading = false;
      });
    }
  }, {
    key: '_getResourceInfo',
    value: function _getResourceInfo() {
      var _this5 = this;

      return this.apmResourcesService.fetchResource(this.$stateParams.userId).then(function (response) {
        return _this5._fetchResourceSuccessHandler(response);
      }).catch(function (err) {
        return _this5._errorHandler(err);
      });
    }
  }, {
    key: '_fetchResourceSuccessHandler',
    value: function _fetchResourceSuccessHandler(response) {
      this.resource = response.data;
      this.resource.fullName = this.scLastNameFirstFilter(this.resource.lastName, null, this.resource.firstName);
    }
  }, {
    key: '_getResourceEvents',
    value: function _getResourceEvents() {
      var _this6 = this;

      this.loadingEvents = true;
      return this.apmResourcesService.fetchResourceEvents(this.$stateParams.userId).then(function (response) {
        return _this6._fetchResourceEventsSuccessHandler(response);
      }).catch(function (err) {
        return _this6._errorHandler(err);
      }).finally(function () {
        _this6.loadingEvents = false;
      });
    }
  }, {
    key: '_fetchResourceEventsSuccessHandler',
    value: function _fetchResourceEventsSuccessHandler(response) {
      var _this7 = this;

      angular.forEach(response.data, function (event) {
        _this7._resolveNames(event);
      });

      this.events = response.data;
    }
  }, {
    key: '_deleteResourceEventSuccessHandler',
    value: function _deleteResourceEventSuccessHandler() {
      this._getResourceEvents();
      this.scNotificationsFactory.success('Leave Time has been successfully deleted');
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_resolveNames',
    value: function _resolveNames(event) {
      event.creatorFullName = this.scLastNameFirstFilter(event.creatorLastName, null, event.creatorFirstName);
    }
  }]);

  return ResourcesDetailsController;
}();

angular.module('apm.components.resources').component('apmResourcesDetails', {
  templateUrl: 'app/components/resources/details/apm.resources.details.html',
  controller: ResourcesDetailsController
});
'use strict';

angular.module('apm.components.reports').component('apmReportsPendingGaps', {
  templateUrl: 'app/components/reports/pendingGaps/apm.reports.pendingGaps.html'
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsPendingGapsGridController = function () {

  /** @ngInject */
  function ReportsPendingGapsGridController($mdDialog, $q, $scope, $state, $timeout, apmReportService, apmGridFactory, apmPendingGapsFactory, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ReportsPendingGapsGridController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $q: $q,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      apmReportService: apmReportService,
      apmGridFactory: apmGridFactory,
      apmPendingGapsFactory: apmPendingGapsFactory,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      columns: ['patientFullName', 'patientBirthDate', 'measureName', 'actionPlanTitle', 'datePerformed', 'daysSincePerformed', 'reopen'],
      columnsSort: ['patientLastName', '', 'measureName', 'actionPlanTitle', 'datePerformed', ''],
      currentGridState: {},
      filter: {},
      patientArray: [],

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ReportsPendingGapsGridController, [{
    key: '$onInit',
    value: function $onInit() {
      this._initializeFilter();
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;
      this.currentGridState.page = page;

      return this.apmReportService.fetchPendingGapsReportPage(this._getApiParams()).then(function (response) {
        return _this._getReportsListSuccessHandler(response);
      }).catch(function (err) {
        return _this._getReportsListErrorHandler(err);
      });
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.reportsPendingGapsPage[rowId];
    }
  }, {
    key: 'getMeasureReport',
    value: function getMeasureReport(id) {
      return _.find(this.patientArray.results, function (gapRow) {
        return gapRow.measureReportId === id;
      });
    }
  }, {
    key: 'goToPatient',
    value: function goToPatient(fullName) {
      var elemId = _.uniq(_.map(this.patientArray.results, function (el) {
        if (el.patientFullName === fullName) {
          return el.patientId;
        }
      }).filter(Boolean));
      this.$state.go('patients.profile', { patientId: elemId[0] });
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: 'showReopenGapModal',
    value: function showReopenGapModal(reportId) {
      var _this2 = this;

      var measureReport = this.getMeasureReport(reportId);
      var scope = angular.extend(this.$scope.$new(true), { measureReport: measureReport });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        scope: scope,
        template: '<md-dialog aria-label="Reopen Gap" class="message-content"><apm-reports-pending-gaps-reopen-modal measure-report="measureReport"></apm-reports-pending-gaps-reopen-modal></md-dialog>'
      }).then(function () {
        return _this2._reopenGapSuccessHandler();
      });
    }
  }, {
    key: '_reopenGapSuccessHandler',
    value: function _reopenGapSuccessHandler() {
      var grid = this.currentGridState;
      var page = grid.numberOfElements === 1 && !grid.first ? grid.page - 1 : grid.page;
      this.loadPageCallback(page);
    }
  }, {
    key: '_clearBirthDate',
    value: function _clearBirthDate() {
      var _this3 = this;

      this.$timeout(function () {
        _this3.$scope.pendingGapsFilter.datePerformed.$setValidity('valid', true);
      });
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        'page': this.page,
        '_count': this.pageSize
      }, this._getSortingParam(), this._getFilterParam());
    }
  }, {
    key: '_getFilterParam',
    value: function _getFilterParam() {
      return this.apmPendingGapsFactory.filterToScFilter(this.apmGridFactory.resolveFilters(this.filter));
    }
  }, {
    key: '_getReportsListSuccessHandler',
    value: function _getReportsListSuccessHandler(response) {
      var _this4 = this;

      _.assign(this.currentGridState, _.pick(response, ['last', 'numberOfElements']));
      this.reportsPendingGapsPage = {};
      var reportsPendingGapsPage = {
        results: [],
        totalResultCount: 0
      };

      if (_.has(response, 'content')) {
        var responseData = response.content;

        _.forEach(responseData, function (reportsPendingGaps) {
          _this4._resolveName(reportsPendingGaps);
          _this4._resolveBirthDate(reportsPendingGaps);
          _this4._resolveDatePerformed(reportsPendingGaps);
          _this4._resolveReopenGapId(reportsPendingGaps);
          _this4.reportsPendingGapsPage[reportsPendingGaps.actionPlanId] = reportsPendingGaps;

          reportsPendingGapsPage.results.push(reportsPendingGaps);
        }, this);
        reportsPendingGapsPage.totalResultCount = response.totalElements;
      }
      this.patientArray = reportsPendingGapsPage;
      return reportsPendingGapsPage;
    }
  }, {
    key: '_getReportsListErrorHandler',
    value: function _getReportsListErrorHandler(err) {
      this.reportsPendingGapsPage = {};
      var reportsPendingGapsPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return reportsPendingGapsPage;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'datePerformed'
      };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.filter = {};
      this._clearBirthDate();
    }
  }, {
    key: '_resolveBirthDate',
    value: function _resolveBirthDate(actionPlan) {
      actionPlan.patientBirthDate = this.apmPendingGapsFactory.resolveDate(actionPlan.patientBirthDate);
    }
  }, {
    key: '_resolveDatePerformed',
    value: function _resolveDatePerformed(actionPlan) {
      actionPlan.datePerformed = this.apmPendingGapsFactory.resolveDate(actionPlan.datePerformed);
    }
  }, {
    key: '_resolveReopenGapId',
    value: function _resolveReopenGapId(actionPlan) {
      actionPlan.reopen = actionPlan.measureReportId;
    }
  }, {
    key: '_resolveName',
    value: function _resolveName(actionPlan) {
      actionPlan.patientFullName = this.apmPendingGapsFactory.resolveName(actionPlan);
    }
  }]);

  return ReportsPendingGapsGridController;
}();

angular.module('apm.components.reports').component('apmReportsPendingGapsGrid', {
  templateUrl: 'app/components/reports/pendingGaps/apm.reports.pendingGaps.grid.component.html',
  controller: ReportsPendingGapsGridController,
  bindings: {
    filter: '<',
    sorting: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmPendingGapsFactory = function () {

  /** @ngInject */
  function ApmPendingGapsFactory(scLastNameFirstFilter, reverseDateFormatFilterFilter) {
    _classCallCheck(this, ApmPendingGapsFactory);

    this.scLastNameFirstFilter = scLastNameFirstFilter;
    this.reverseDateFormatFilterFilter = reverseDateFormatFilterFilter;
  }

  _createClass(ApmPendingGapsFactory, [{
    key: 'filterToScFilter',
    value: function filterToScFilter(filter) {
      var newFilter = _.clone(filter);

      _.forOwn(filter, function (value, key) {
        switch (key) {
          case 'datePerformed':
            newFilter['datePerformed'] = moment(new Date(value)).format('YYYY-MM-DD');
            break;
        }
      });
      return newFilter;
    }
  }, {
    key: 'resolveDate',
    value: function resolveDate(oldDate) {
      var newDate = moment(new Date(this.reverseDateFormatFilterFilter(oldDate)));

      return newDate.isValid() ? newDate.format('MM/DD/YYYY') : '';
    }
  }, {
    key: 'resolveName',
    value: function resolveName(actionPlan) {
      var nameObj = {
        prefix: null,
        fName: null,
        mName: null,
        lName: null,
        suffix: null
      };

      if (_.has(actionPlan, 'patientFirstName') && actionPlan.patientFirstName.length) {
        nameObj.fName = actionPlan.patientFirstName;
      }

      if (_.has(actionPlan, 'patientLastName') && actionPlan.patientLastName.length) {
        nameObj.lName = actionPlan.patientLastName;
      }

      return this.scLastNameFirstFilter(nameObj.lName, nameObj.prefix, nameObj.fName, nameObj.mName, nameObj.suffix);
    }
  }]);

  return ApmPendingGapsFactory;
}();

angular.module('apm.components.reports.factories').service('apmPendingGapsFactory', ApmPendingGapsFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsGridController = function () {

  /** @ngInject */
  function ReportsGridController($scope, $timeout, apmReportService, apmActionPlansFactory, apmGridFactory, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ReportsGridController);

    _.assign(this, {
      $scope: $scope,
      $timeout: $timeout,
      apmReportService: apmReportService,
      apmActionPlansFactory: apmActionPlansFactory,
      apmGridFactory: apmGridFactory,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      columnsSort: ['title', '', '', 'lastUpdated'],
      filter: {},

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ReportsGridController, [{
    key: '$onInit',
    value: function $onInit() {
      this._initializeFilter();
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmReportService.fetchReportsList(this._getApiParams()).then(function (response) {
        return _this._getReportsListSuccessHandler(response);
      }).catch(function (err) {
        return _this._getReportsListErrorHandler(err);
      });
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.reportsListPage[rowId];
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty() {
      return this.apmGridFactory.isFilterEmpty(this.filter);
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        'page': this.page,
        '_count': this.pageSize
      }, this._getSortingParam(), this._getFilterParam());
    }
  }, {
    key: '_getFilterParam',
    value: function _getFilterParam() {
      return this.apmGridFactory.resolveFilters(this.filter);
    }
  }, {
    key: '_getReportsListSuccessHandler',
    value: function _getReportsListSuccessHandler(response) {
      var _this2 = this;

      this.reportsListPage = {};
      var reportsListPage = {
        results: [],
        totalResultCount: 0
      };

      if (_.has(response, 'content')) {
        var responseData = response.content;

        _.forEach(responseData, function (reportsList) {
          _this2._resolveEventDates(reportsList);
          _this2._resolveLastUpdated(reportsList);
          _this2.reportsListPage[reportsList._id] = reportsList;

          reportsListPage.results.push(reportsList);
        }, this);
        reportsListPage.totalResultCount = response.totalElements;
      }
      return reportsListPage;
    }
  }, {
    key: '_getReportsListErrorHandler',
    value: function _getReportsListErrorHandler(err) {
      this.reportsListPage = {};
      var reportsListPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return reportsListPage;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'lastUpdated'
      };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.filter = {};
    }
  }, {
    key: '_resolveEventDates',
    value: function _resolveEventDates(actionPlan) {
      actionPlan.eventDates = this.apmActionPlansFactory.setEventDates(actionPlan);
    }
  }, {
    key: '_resolveLastUpdated',
    value: function _resolveLastUpdated(actionPlan) {
      actionPlan.lastUpdated = moment(actionPlan.lastUpdated).format('MM/DD/YYYY') + ' ' + moment(actionPlan.lastUpdated).format('h:mm a').replace(/\s+/g, '');
    }
  }]);

  return ReportsGridController;
}();

angular.module('apm.components.reports').component('apmReportsGrid', {
  templateUrl: 'app/components/reports/grid/apm.reports.grid.component.html',
  controller: ReportsGridController,
  bindings: {
    filter: '<',
    sorting: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmReportsCallLogGridFactory = function () {
  function ApmReportsCallLogGridFactory(scLastNameFirstFilter) {
    _classCallCheck(this, ApmReportsCallLogGridFactory);

    this.scLastNameFirstFilter = scLastNameFirstFilter;
  }

  _createClass(ApmReportsCallLogGridFactory, [{
    key: 'filterToScFilter',
    value: function filterToScFilter(filter) {
      var newFilter = _.clone(filter);

      _.forOwn(filter, function (value, key) {
        switch (key) {
          case 'startDate':
            newFilter['startDate'] = moment(value).format('YYYY-MM-DD');
            break;
          case 'endDate':
            newFilter['endDate'] = moment(value).format('YYYY-MM-DD');
            break;
        }
      });

      return newFilter;
    }
  }, {
    key: 'resolveCallerName',
    value: function resolveCallerName(callLog) {
      var nameObj = {
        prefix: null,
        fName: null,
        mName: null,
        lName: null,
        suffix: null
      };

      if (_.has(callLog, 'callerFirstName')) {
        nameObj.fName = callLog.callerFirstName;
      }

      if (_.has(callLog, 'callerLastName')) {
        nameObj.lName = callLog.callerLastName;
      }

      return this.scLastNameFirstFilter(nameObj.lName, nameObj.prefix, nameObj.fName, nameObj.mName, nameObj.suffix);
    }
  }, {
    key: 'resolvePatientName',
    value: function resolvePatientName(callLog) {
      var nameObj = {
        prefix: null,
        fName: null,
        mName: null,
        lName: null,
        suffix: null
      };

      if (_.has(callLog, 'patientFirstName')) {
        nameObj.fName = callLog.patientFirstName;
      }

      if (_.has(callLog, 'patientLastName')) {
        nameObj.lName = callLog.patientLastName;
      }

      return this.scLastNameFirstFilter(nameObj.lName, nameObj.prefix, nameObj.fName, nameObj.mName, nameObj.suffix);
    }
  }]);

  return ApmReportsCallLogGridFactory;
}();

angular.module('apm.components.reports.factories').service('apmReportsCallLogGridFactory', ApmReportsCallLogGridFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CallLogReportGridController = function () {

  /** @ngInject */
  function CallLogReportGridController($document, $log, $q, $state, apmReportService, apmGridFactory, apmReportsCallLogGridFactory, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, CallLogReportGridController);

    _.assign(this, {
      $document: $document,
      $log: $log,
      $q: $q,
      $state: $state,
      apmReportService: apmReportService,
      apmGridFactory: apmGridFactory,
      apmReportsCallLogGridFactory: apmReportsCallLogGridFactory,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      callResultList: [],
      columnsSort: ['patientLastName', 'actionPlanTitle', 'dispositionDisplayText', 'callerLastName', 'callTime'],
      patientArray: []
    });
  }

  _createClass(CallLogReportGridController, [{
    key: '$onInit',
    value: function $onInit() {
      this._initializeFilter();
      this._getValueSet();
    }
  }, {
    key: 'goToPatient',
    value: function goToPatient(fullName) {
      var elemId = _.uniq(_.map(this.patientArray, function (el) {
        if (el.patientFullName === fullName) {
          return el.patientId;
        }
      }).filter(Boolean));

      this.$state.go('patients.profile', { patientId: elemId[0] });
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.hasFilter = false;
      this.filter = {};
    }
  }, {
    key: '_getValueSet',
    value: function _getValueSet() {
      var _this = this;

      this.apmReportService.getValueSetGroup().then(function (response) {
        return _this._getValueSetSuccess(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_getValueSetSuccess',
    value: function _getValueSetSuccess(response) {
      if (_.has(response, 'data')) {
        this.callResultList = _.uniq(response.data, 'code');
      }
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        page: this.page,
        '_count': this.pageSize,
        'excludeVendor': true
      }, this._getSortingParam(), this._getFilterParam());
    }
  }, {
    key: '_getFilterParam',
    value: function _getFilterParam() {
      return this.apmReportsCallLogGridFactory.filterToScFilter(this.apmGridFactory.resolveFilters(this.filter));
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'callTime'
      };

      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      if (this.isFilterEmpty()) {
        this.hasFilter = false;
        return this._returnEmptyResult();
      } else {
        this.hasFilter = true;
      }

      return this.apmReportService.fetchCallLogReportPage(this._getApiParams()).then(angular.bind(this, this._fetchCallLogReportPageSuccessHandler)).catch(angular.bind(this, this._fetchCallLogReportPageErrorHandler));
    }
  }, {
    key: '_fetchCallLogReportPageSuccessHandler',
    value: function _fetchCallLogReportPageSuccessHandler(response) {
      var _this2 = this;

      this.callLogsPage = {};

      angular.forEach(response.content, function (callLog, index) {

        _this2._resolvePatientName(callLog);
        _this2._resolveCallerName(callLog);

        callLog._id = '' + index;
        _this2.callLogsPage[callLog._id] = callLog;
      }, this);
      this.patientArray = response.content;
      return {
        results: response.content,
        totalResultCount: response.totalElements
      };
    }
  }, {
    key: '_resolvePatientName',
    value: function _resolvePatientName(callLog) {
      callLog.patientFullName = this.apmReportsCallLogGridFactory.resolvePatientName(callLog);
    }
  }, {
    key: '_resolveCallerName',
    value: function _resolveCallerName(callLog) {
      callLog.callerFullName = this.apmReportsCallLogGridFactory.resolveCallerName(callLog);
    }
  }, {
    key: '_fetchCallLogReportPageErrorHandler',
    value: function _fetchCallLogReportPageErrorHandler(err) {
      this._errorHandler(err);
      return this._returnEmptyResult();
    }
  }, {
    key: 'downloadCSV',
    value: function downloadCSV() {
      var reportCSVParams = this._getApiParams();

      this.apmReportService.downloadCallLogReportCSV(_.omit(reportCSVParams, ['page', '_count'])).then(angular.bind(this, this._downloadCallLogReportSuccessHandler)).catch(angular.bind(this, this._downloadCallLogReportErrorHandler));
    }
  }, {
    key: '_downloadCallLogReportSuccessHandler',
    value: function _downloadCallLogReportSuccessHandler(response) {
      if (navigator.msSaveBlob) {
        var blob = new Blob([response.report], { type: 'text/csv;charset=utf-8;' });
        navigator.msSaveBlob(blob, response.filename);
      } else {
        var downloadLinkElement = angular.element('<a/>').attr({
          href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.report),
          target: '_blank',
          download: response.filename
        });
        angular.element('body').append(downloadLinkElement);
        (downloadLinkElement[0] || downloadLinkElement).click();
        downloadLinkElement.remove();
      }
    }
  }, {
    key: '_downloadCallLogReportErrorHandler',
    value: function _downloadCallLogReportErrorHandler(response) {
      if (_.has(response, 'data.message')) {
        this.$log(response.data.message);
      }

      return this._returnEmptyResult();
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.callLogsPage[rowId];
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty() {
      return this.apmGridFactory.isFilterEmpty(this.filter);
    }
  }, {
    key: 'hasResults',
    value: function hasResults() {
      return _.keys(this.callLogsPage).length > 0;
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_returnEmptyResult',
    value: function _returnEmptyResult() {
      var emptyResultDeferred = this.$q.defer();
      emptyResultDeferred.resolve({
        results: [],
        totalResultCount: 0
      });

      return emptyResultDeferred.promise;
    }
  }]);

  return CallLogReportGridController;
}();

angular.module('apm.components.reports').component('apmCallLogReport', {
  templateUrl: 'app/components/reports/callLog/apm.reports.callLog.grid.component.html',
  controller: CallLogReportGridController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlanReportController = function () {

  /** @ngInject */
  function ActionPlanReportController($stateParams, apmActionPlanService, apmReportService, scNotificationsFactory) {
    _classCallCheck(this, ActionPlanReportController);

    _.assign(this, {
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      apmReportService: apmReportService,
      scNotificationsFactory: scNotificationsFactory,

      vm: {
        actionPlan: {}
      }
    });
  }

  _createClass(ActionPlanReportController, [{
    key: '$onInit',
    value: function $onInit() {
      if (angular.isUndefined(this.$stateParams.actionPlan)) {
        this.vm.actionPlan = { _id: this.$stateParams.id };
        this._fetchActionPlan();
      } else {
        this.vm.actionPlan = this._translateActionPlanVm(this.$stateParams.actionPlan);
      }
      this._fetchActionPlanReport();
    }
  }, {
    key: '_fetchActionPlan',
    value: function _fetchActionPlan() {
      var _this = this;

      this.apmActionPlanService.getActionPlan(this.$stateParams.id).then(function (response) {
        return _this._fetchActionPlanSuccessHandler(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_fetchActionPlanSuccessHandler',
    value: function _fetchActionPlanSuccessHandler(response) {
      this.vm.actionPlan = this._translateActionPlanVm(angular.fromJson(response.data));
    }
  }, {
    key: '_fetchActionPlanReport',
    value: function _fetchActionPlanReport() {
      var _this2 = this;

      this.apmReportService.fetchActionPlanReportSummary({ actionPlanId: this.$stateParams.id }).then(function (response) {
        return _this2._fetchActionPlanReportSuccessHandler(response);
      }).catch(function (err) {
        return _this2._fetchActionPlanReportErrorHandler(err);
      });
    }
  }, {
    key: '_fetchActionPlanReportSuccessHandler',
    value: function _fetchActionPlanReportSuccessHandler(response) {
      this.actionPlanReport = response;
      this.patientSummaryConfig = [{
        icon: 'accessibility',
        label: 'Patients Seen',
        value: response.patientSummary.seen
      }, {
        icon: 'content_paste',
        label: 'Chart Audits',
        value: response.patientSummary.chartAudits
      }, {
        icon: 'insert_invitation',
        label: 'Scheduled',
        value: response.patientSummary.scheduled
      }, {
        icon: 'do_not_disturb_alt',
        label: 'No Shows',
        value: response.patientSummary.noShows
      }];
    }
  }, {
    key: '_fetchActionPlanReportErrorHandler',
    value: function _fetchActionPlanReportErrorHandler(err) {
      this.actionPlanReport = {};
      this._errorHandler(err);
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_translateActionPlanVm',
    value: function _translateActionPlanVm(actionPlan) {
      return {
        _id: _.get(actionPlan, '_id'),
        actionPlanComments: _.get(actionPlan, 'actionPlanComments'),
        actionPlanEventType: _.get(actionPlan, 'actionPlanEventType'),
        assigneeId: _.get(actionPlan, 'assigneeId'),
        assigneeName: _.get(actionPlan, 'assigneeName'),
        author: _.get(actionPlan, 'author'),
        doubleBooked: _.get(actionPlan, 'doubleBooked'),
        eventDates: _.get(actionPlan, 'eventDates', []),
        eventType: _.get(actionPlan, 'eventType'),
        excludedTimeSlots: _.get(actionPlan, 'excludedTimeSlots'),
        ownerId: _.get(actionPlan, 'ownerId'),
        ownerName: _.get(actionPlan, 'ownerName'),
        population: _.get(actionPlan, 'population'),
        sortBy: _.get(actionPlan, 'sortBy'),
        startTimeEndTimeRange: _.get(actionPlan, 'startTimeEndTimeRange'),
        status: _.get(actionPlan, 'status', ''),
        statusToDisplay: _.get(actionPlan, 'status', '').toLowerCase(),
        subjectCount: _.get(actionPlan, 'subjectCount'),
        template: _.get(actionPlan, 'template'),
        title: _.get(actionPlan, 'title')
      };
    }
  }]);

  return ActionPlanReportController;
}();

angular.module('apm.components.reports').component('actionPlanReport', {
  templateUrl: 'app/components/reports/actionPlans/apm.reports.actionPlans.component.html',
  controller: ActionPlanReportController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientVendorModalController = function () {

  /** @ngInject */
  function PatientVendorModalController($mdDialog) {
    _classCallCheck(this, PatientVendorModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,

      errorMessage: null
    });
  }

  _createClass(PatientVendorModalController, [{
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'errorHandler',
    value: function errorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return PatientVendorModalController;
}();

angular.module('apm.components.patients').component('apmPatientVendorModal', {
  templateUrl: 'app/components/patients/vendorModal/apm.patients.vendorModal.component.html',
  controller: PatientVendorModalController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientsVendorCardController = function () {

  /** @ngInject */
  function PatientsVendorCardController(apmPatientsService) {
    _classCallCheck(this, PatientsVendorCardController);

    _.assign(this, {
      apmPatientsService: apmPatientsService,

      vendorData: []
    });
  }

  _createClass(PatientsVendorCardController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this._getPatientVendors();
      }
    }
  }, {
    key: '_getPatientVendors',
    value: function _getPatientVendors() {
      var _this = this;

      this.apmPatientsService.getPatientVendors(this.patient).then(function (response) {
        return _this._getPatientVendorsSuccess(response);
      }).catch(function (err) {
        return _this.onError({ err: err });
      });
    }
  }, {
    key: '_getPatientVendorsSuccess',
    value: function _getPatientVendorsSuccess(response) {
      this.vendorData = response;
    }
  }]);

  return PatientsVendorCardController;
}();

angular.module('apm.components.patients').component('patientsVendorCard', {
  templateUrl: 'app/components/patients/vendor/apm.patients.vendor.component.html',
  controller: PatientsVendorCardController,
  bindings: {
    patient: '<',
    actionType: '<',
    onError: '&'
  }
});
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientTestResultsModalController = function () {
  function PatientTestResultsModalController() {
    _classCallCheck(this, PatientTestResultsModalController);
  }

  _createClass(PatientTestResultsModalController, null, [{
    key: "dialogController",


    /** @ngInject */
    value: function dialogController($scope, $mdDialog) {
      $scope.close = function () {
        $mdDialog.cancel();
      };
    }
  }]);

  return PatientTestResultsModalController;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientTestResultsGridController = function () {

  /** @ngInject */
  function PatientTestResultsGridController($q, apmPatientsService) {
    _classCallCheck(this, PatientTestResultsGridController);

    _.assign(this, {
      $q: $q,
      apmPatientsService: apmPatientsService,

      columnsSort: ['name', '', 'date', '', ''],
      errorMessage: null,

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(PatientTestResultsGridController, [{
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj && changeObj.patient && changeObj.patient.currentValue.patient !== changeObj.patient.previousValue.patient) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;
      var apiParams = this._getApiParams();

      if (!apiParams.patientId) {
        return this._getEmptyPromise();
      }

      return this.apmPatientsService.getPatientTestResults(apiParams).then(function (response) {
        return _this._getPatientTestResultsSuccessHandler(response);
      }).catch(function (err) {
        return _this._getPatientTestResultsErrorHandler(err);
      });
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.testResultsPage[rowId];
    }
  }, {
    key: 'getMeasuresTooltipTemplate',
    value: function getMeasuresTooltipTemplate(measures) {
      return _.map(measures, function (measure, i) {
        return i + 1 + '. ' + measure;
      }).join('\n');
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        patientId: this.patient.patient || this.patient.id,
        page: this.page,
        '_count': this.pageSize
      }, this._getSortingParam());
    }
  }, {
    key: '_getEmptyPromise',
    value: function _getEmptyPromise() {
      return this.$q.defer().promise;
    }
  }, {
    key: '_getPatientTestResultsSuccessHandler',
    value: function _getPatientTestResultsSuccessHandler(response) {
      var _this2 = this;

      this.testResultsPage = {};
      this.errorMessage = null;

      _.forEach(response.content, function (testResult, index) {

        testResult.id = '' + index;
        testResult.associatedActionPlan = testResult.associatedActionPlan || 'N/A';
        _this2.testResultsPage[testResult.id] = testResult;
      }, this);

      return {
        results: _.values(this.testResultsPage),
        totalResultCount: response.totalElements
      };
    }
  }, {
    key: '_getPatientTestResultsErrorHandler',
    value: function _getPatientTestResultsErrorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));

      return {
        results: [],
        totalResultCount: 0
      };
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'date'
      };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }]);

  return PatientTestResultsGridController;
}();

angular.module('apm.components.patients').component('apmPatientTestResultsGrid', {
  templateUrl: 'app/components/patients/testResults/apm.patients.testResultsGrid.component.html',
  controller: PatientTestResultsGridController,
  bindings: {
    patient: '<',
    pageSizes: '<',
    onActionPlanLink: '&'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientProviderInfoModalController = function () {

  /** @ngInject */
  function PatientProviderInfoModalController($mdDialog, apmResourcesLocationsService, scNotificationsFactory) {
    _classCallCheck(this, PatientProviderInfoModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      apmResourcesLocationsService: apmResourcesLocationsService,
      scNotificationsFactory: scNotificationsFactory,

      vm: {
        patient: {}
      },
      location: {}
    });
  }

  _createClass(PatientProviderInfoModalController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient && changesObj.patient.currentValue && changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this.vm.patient = this.patient;
        this._prepProviderLocation();
      }
    }
  }, {
    key: '_prepProviderLocation',
    value: function _prepProviderLocation() {
      this.location = {
        name: _.get(this.vm.patient, 'clinic', 'N/A'),
        address1: _.get(this.vm.patient, 'providerInfo.providerAddresses[0].addressLine1', 'N/A'),
        address2: _.get(this.vm.patient, 'providerInfo.providerAddresses[0].addressLine2', null),
        city: _.get(this.vm.patient, 'providerInfo.providerAddresses[0].addressCity', null),
        state: _.get(this.vm.patient, 'providerInfo.providerAddresses[0].addressState', 'N/A'),
        zip: _.get(this.vm.patient, 'providerInfo.providerAddresses[0].addressPostalCode', 'N/A')
      };
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }]);

  return PatientProviderInfoModalController;
}();

angular.module('apm.components.patients').component('patientProviderInfoModal', {
  templateUrl: 'app/components/patients/providerInfo/apm.patients.providerInfoModal.html',
  controller: PatientProviderInfoModalController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientProfileController = function () {

  /** @ngInject */
  function PatientProfileController($rootScope, $q, $stateParams, $window, apmPatientsService, scNotificationsFactory) {
    _classCallCheck(this, PatientProfileController);

    _.assign(this, {
      $rootScope: $rootScope,
      $q: $q,
      $stateParams: $stateParams,
      $window: $window,
      apmPatientsService: apmPatientsService,
      scNotificationsFactory: scNotificationsFactory,

      tabPatient: {
        value: undefined,
        information: undefined,
        clinical: undefined
      }
    });
  }

  _createClass(PatientProfileController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this._fetchPatient();
      this.$rootScope.$on('number-updated', function () {
        _this._fetchPatient();
      });
    }
  }, {
    key: 'loadTab',
    value: function loadTab(tab) {
      if (_.has(this.tabPatient, tab)) {
        this.tabPatient[tab] = this.patient;
      }
    }
  }, {
    key: '_fetchPatient',
    value: function _fetchPatient() {
      var _this2 = this;

      this.apmPatientsService.fetchPatientSummary(this.$stateParams.patientId).then(function (response) {
        return _this2._fetchPatientSuccessHandler(response);
      }).catch(function (err) {
        return _this2._fetchPatientErrorHandler(err);
      });
    }
  }, {
    key: '_fetchPatientSuccessHandler',
    value: function _fetchPatientSuccessHandler(response) {
      this.patient = response.data;
      this.patient.id = this.$stateParams.patientId;
    }
  }, {
    key: '_fetchPatientErrorHandler',
    value: function _fetchPatientErrorHandler(err) {
      this.patient = {};
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return PatientProfileController;
}();

angular.module('apm.components.patients').component('apmPatientProfile', {
  templateUrl: 'app/components/patients/profile/apm.patients.profile.component.html',
  controller: PatientProfileController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientInformationController = function () {
  function PatientInformationController() {
    _classCallCheck(this, PatientInformationController);

    _.assign(this, {
      showVendorCard: false
    });
  }

  _createClass(PatientInformationController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient.currentValue && changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this._determineVendorCardVisibility();
      }
    }
  }, {
    key: '_determineVendorCardVisibility',
    value: function _determineVendorCardVisibility() {
      this.showVendorCard = _.has(this.patient, 'hasVendors') && this.patient.hasVendors;
    }
  }]);

  return PatientInformationController;
}();

angular.module('apm.components.patients').component('apmPatientInformation', {
  templateUrl: 'app/components/patients/information/apm.patient.information.html',
  controller: PatientInformationController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientHeaderController = function () {
  function PatientHeaderController($state, $window, scLastNameFirstFilter) {
    _classCallCheck(this, PatientHeaderController);

    _.assign(this, {
      $state: $state,
      $window: $window,
      scLastNameFirstFilter: scLastNameFirstFilter,

      showQualityMeasure: true,
      showReturnButton: true,
      returnButtonLabel: '',
      returnButtonState: ''
    });
  }

  _createClass(PatientHeaderController, [{
    key: '$onInit',
    value: function $onInit() {
      this._resolvePatientName();
      this.showQualityMeasure = this._showQualityMeasure();
      this.showReturnButton = this._showReturnButton();

      if (this.showReturnButton) {
        this.returnButtonState = this.$window.sessionStorage.getItem('returnState');
        this.returnButtonLabel = this.returnButtonState === 'patients.list' ? 'RETURN TO PATIENT LIST' : 'RETURN TO ACTION PLAN';
      }
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.$window.sessionStorage.getItem('returnState')) {
        this.$window.sessionStorage.removeItem('returnState');
      }
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient.currentValue.phone !== changesObj.patient.previousValue.phone) {
        this._resolvePatientName();
      }
    }
  }, {
    key: 'navigateToPreviousState',
    value: function navigateToPreviousState() {
      if (this.returnButtonState === 'patients.list') {
        this.$state.go(this.returnButtonState);
      } else {
        this.$state.go('actionPlans.details', { id: this.returnButtonState });
      }
    }
  }, {
    key: 'getGapsTooltipTemplate',
    value: function getGapsTooltipTemplate(status) {
      var gaps = _.get(this.apPatient, status + 'Gaps');
      return _.map(gaps, function (gap, i) {
        return i + 1 + '. ' + gap;
      }).join('\n');
    }
  }, {
    key: '_showQualityMeasure',
    value: function _showQualityMeasure() {
      return !(this.$state.$current.component === 'scheduleActions' || this.$state.$current.component === 'reminderActions' || this.$state.$current.component === 'apmPatientProfile');
    }
  }, {
    key: '_showReturnButton',
    value: function _showReturnButton() {
      return !(this.$state.$current.component === 'scheduleActions' || this.$state.$current.component === 'reminderActions' || this.$state.$current.component === 'encounterActions') && this.$window.sessionStorage.getItem('returnState');
    }
  }, {
    key: '_resolvePatientName',
    value: function _resolvePatientName() {
      this.patient.fullName = this.scLastNameFirstFilter(this.patient.lastName, null, this.patient.firstName, null, null);
    }
  }]);

  return PatientHeaderController;
}();

angular.module('apm.components.patients').component('apmPatientHeader', {

  templateUrl: 'app/components/patients/header/apm.patients.header.component.html',
  controller: PatientHeaderController,
  bindings: {
    patient: '<',
    apPatient: '<'
  }

});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmPatientsListFactory = function () {

  /** @ngInject */
  function ApmPatientsListFactory(scLastNameFirstFilter, reverseDateFormatFilterFilter) {
    _classCallCheck(this, ApmPatientsListFactory);

    _.assign(this, {
      scLastNameFirstFilter: scLastNameFirstFilter,
      reverseDateFormatFilterFilter: reverseDateFormatFilterFilter
    });
  }

  _createClass(ApmPatientsListFactory, [{
    key: 'filterToScFilter',
    value: function filterToScFilter(filter) {
      var newFilter = _.clone(filter);

      _.forOwn(filter, function (value, key) {
        if (key === 'birthDate') {
          newFilter['birthDate'] = moment(value).format('YYYY-MM-DD');
        }
      });

      return newFilter;
    }
  }, {
    key: 'resolveDate',
    value: function resolveDate(oldDate) {
      var newDate = moment(new Date(this.reverseDateFormatFilterFilter(oldDate)));

      return newDate.isValid() ? newDate.format('MM/DD/YYYY') : '';
    }
  }, {
    key: 'resolveName',
    value: function resolveName(providerList) {
      var nameObj = {
        prefix: null,
        fName: null,
        mName: null,
        lName: null,
        suffix: null
      };

      if (_.has(providerList, 'firstName') && providerList.firstName.length) {
        nameObj.fName = providerList.firstName;
      }
      if (_.has(providerList, 'lastName') && providerList.lastName.length) {
        nameObj.lName = providerList.lastName;
      }
      return this.scLastNameFirstFilter(nameObj.lName, nameObj.prefix, nameObj.fName, nameObj.mName, nameObj.suffix);
    }
  }, {
    key: 'resolvePhone',
    value: function resolvePhone(oldPhone) {
      var display = oldPhone;
      var phoneRegEx = /^\d{10}$/;

      if (oldPhone && oldPhone.length === 10 && phoneRegEx.test(oldPhone)) {
        display = '(' + oldPhone.substr(0, 3) + ') ' + oldPhone.substr(3, 3) + '-' + oldPhone.substr(6, 4);
      }
      return display;
    }
  }]);

  return ApmPatientsListFactory;
}();

angular.module('apm.components.patients.factories', []).service('apmPatientsListFactory', ApmPatientsListFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientsGridController = function () {

  /** @ngInject */
  function PatientsGridController($filter, $scope, $state, $timeout, $window, apmPatientsService, apmGridFactory, apmPatientsListFactory, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, PatientsGridController);

    _.assign(this, {
      $filter: $filter,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      $window: $window,
      apmPatientsService: apmPatientsService,
      apmGridFactory: apmGridFactory,
      apmPatientsListFactory: apmPatientsListFactory,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      columnsSort: ['lastName', 'birthDate', '', 'phone', 'lastVisit'],
      filter: {},
      hideIneligiblePatients: true,

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(PatientsGridController, [{
    key: '$onInit',
    value: function $onInit() {
      this._initializeFilter();
    }
  }, {
    key: 'setPatients',
    value: function setPatients() {
      this.loadPageCallback(1);
    }
  }, {
    key: 'navigateToPatientDetails',
    value: function navigateToPatientDetails(patientId) {
      this.$window.sessionStorage.setItem('returnState', 'patients.list');
      this.$state.go('patients.profile', { patientId: patientId });
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmPatientsService.fetchPatientsList(this._getApiParams()).then(function (response) {
        return _this._getPatientsListSuccessHandler(response);
      }).catch(function (err) {
        return _this._getPatientsListErrorHandler(err);
      });
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.patientsListPage[rowId];
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty() {
      return this.apmGridFactory.isFilterEmpty(this.filter);
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: '_clearBirthDate',
    value: function _clearBirthDate() {
      var _this2 = this;

      this.$timeout(function () {
        _this2.$scope.PatientsListFilters.birthDate.$setValidity('valid', true);
      });
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      var params = _.assign({
        'page': this.page,
        '_count': this.pageSize
      }, this._getSortingParam(), this._getFilterParam());

      if (this.hideIneligiblePatients) {
        params.active = this.hideIneligiblePatients;
      }

      return params;
    }
  }, {
    key: '_getFilterParam',
    value: function _getFilterParam() {
      return this.apmPatientsListFactory.filterToScFilter(this.apmGridFactory.resolveFilters(this.filter));
    }
  }, {
    key: '_getPatientsListSuccessHandler',
    value: function _getPatientsListSuccessHandler(response) {
      var _this3 = this;

      this.patientsListPage = {};
      var patientsListPage = {
        results: [],
        totalResultCount: 0
      };

      if (_.has(response, 'data.content')) {
        var responseData = response.data.content;

        _.forEach(responseData, function (patientsList) {
          _this3._resolveBirthDate(patientsList);
          _this3._resolveLastPCPVisit(patientsList);
          _this3._resolveName(patientsList);
          _this3._resolvePhone(patientsList);
          _this3.patientsListPage[patientsList.fhirId] = patientsList;
          patientsListPage.results.push(patientsList);
        }, this);
        patientsListPage.totalResultCount = response.data.totalElements;
      }
      return patientsListPage;
    }
  }, {
    key: '_getPatientsListErrorHandler',
    value: function _getPatientsListErrorHandler(err) {
      var patientsListPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return patientsListPage;
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:asc': 'lastName'
      };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });
      return sorting;
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.filter = {};
      this._clearBirthDate();
    }
  }, {
    key: '_resolveBirthDate',
    value: function _resolveBirthDate(patientsList) {
      patientsList.birthDate = this.apmPatientsListFactory.resolveDate(patientsList.birthDate);
    }
  }, {
    key: '_resolveLastPCPVisit',
    value: function _resolveLastPCPVisit(patientsList) {
      patientsList.lastVisit = this.apmPatientsListFactory.resolveDate(patientsList.lastVisit);
    }
  }, {
    key: '_resolveName',
    value: function _resolveName(patientsList) {
      patientsList.patientFullName = this.apmPatientsListFactory.resolveName(patientsList);
    }
  }, {
    key: '_resolvePhone',
    value: function _resolvePhone(patientsList) {
      patientsList.phone = this.apmPatientsListFactory.resolvePhone(patientsList.phone);
    }
  }]);

  return PatientsGridController;
}();

angular.module('apm.components.patients').component('apmPatientsGrid', {
  templateUrl: 'app/components/patients/grid/apm.patients.grid.component.html',
  controller: PatientsGridController,
  bindings: {
    filter: '<',
    sorting: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientHealthPlanController = function () {

  /** @ngInject */
  function PatientHealthPlanController() {
    _classCallCheck(this, PatientHealthPlanController);

    _.assign(this, {
      healthPlan: ''
    });
  }

  _createClass(PatientHealthPlanController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient.currentValue.healthPlan !== changesObj.patient.previousValue.healthPlan) {
        this.healthPlan = changesObj.patient.currentValue.healthPlan;
      }
    }
  }]);

  return PatientHealthPlanController;
}();

angular.module('apm.components.patients').component('apmPatientHealthPlan', {
  templateUrl: 'app/components/patients/contactInfo/apm.patients.healthPlan.html',
  controller: PatientHealthPlanController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientContactInfoModalController = function () {

  /** @ngInject */
  function PatientContactInfoModalController($mdDialog) {
    _classCallCheck(this, PatientContactInfoModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,

      contactInfo: {},
      errorMessage: null,
      vm: {
        patient: {}
      }
    });
  }

  _createClass(PatientContactInfoModalController, [{
    key: '$onInit',
    value: function $onInit() {
      this.vm.patient = this.patient;
      this._prepContactInfo();
    }
  }, {
    key: 'onError',
    value: function onError(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }, {
    key: '_prepContactInfo',
    value: function _prepContactInfo() {
      this.contactInfo = {
        eligibility: _.get(this.vm.patient, 'active', null) ? 'Eligible' : 'Not Eligible',
        status: _.get(this.vm.patient, 'patientStatus', 'N/A'),
        address: {
          line1: _.get(this.vm.patient, 'addressLine1', 'N/A'),
          city: _.get(this.vm.patient, 'addressCity', null),
          state: _.get(this.vm.patient, 'addressState', 'N/A'),
          zip: _.get(this.vm.patient, 'addressPostalCode', 'N/A')
        }
      };
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }]);

  return PatientContactInfoModalController;
}();

angular.module('apm.components.patients').component('patientContactInfoModal', {
  templateUrl: 'app/components/patients/contactInfo/apm.patients.contactInfoModal.html',
  controller: PatientContactInfoModalController,
  bindings: {
    patient: '<'
  }
});
'use strict';

angular.module('apm.components.patients').component('apmPatientClinical', {
  templateUrl: 'app/components/patients/clinical/apm.patient.clinical.html',
  controller: function controller() {},
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientVendorCardController = function () {

  /** @ngInject */
  function PatientVendorCardController($scope, $mdDialog) {
    _classCallCheck(this, PatientVendorCardController);

    _.assign(this, {
      $scope: $scope,
      $mdDialog: $mdDialog
    });
  }

  _createClass(PatientVendorCardController, [{
    key: 'showPatientVendorModal',
    value: function showPatientVendorModal() {
      var scope = angular.extend(this.$scope.$new(true), {
        patient: this.patient
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="Vendor"><apm-patient-vendor-modal patient="patient" /></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }]);

  return PatientVendorCardController;
}();

angular.module('apm.components.patients').component('apmPatientVendorCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.vendorCard.component.html',
  controller: PatientVendorCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientTestResultsCardController = function () {

  /** @ngInject */
  function PatientTestResultsCardController($mdDialog) {
    _classCallCheck(this, PatientTestResultsCardController);

    this.$mdDialog = $mdDialog;
  }

  _createClass(PatientTestResultsCardController, [{
    key: 'showTestResultsModal',
    value: function showTestResultsModal() {
      this.$mdDialog.show({
        templateUrl: 'app/components/patients/testResults/apm.patients.testResultsModal.html',
        // eslint-disable-next-line no-undef
        controller: PatientTestResultsModalController.dialogController,
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          patient: this.patient
        },
        clickOutsideToClose: true
      });
    }
  }]);

  return PatientTestResultsCardController;
}();

angular.module('apm.components.patients').component('apmPatientTestResultsCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.testResultsCard.component.html',
  controller: PatientTestResultsCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientProviderInfoCardController = function () {

  /** @ngInject */
  function PatientProviderInfoCardController($scope, $mdDialog, reverseDateFormatFilterFilter) {
    _classCallCheck(this, PatientProviderInfoCardController);

    _.assign(this, {
      $scope: $scope,
      $mdDialog: $mdDialog,
      reverseDateFormatFilterFilter: reverseDateFormatFilterFilter,

      vm: {
        patient: {}
      }
    });
  }

  _createClass(PatientProviderInfoCardController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient && changesObj.patient.currentValue && changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this._resolvePCPData(changesObj.patient.currentValue);
      }
    }
  }, {
    key: 'showProviderInfoModal',
    value: function showProviderInfoModal() {
      var scope = angular.extend(this.$scope.$new(true), {
        patient: this.vm.patient
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="Provider Info"><patient-provider-info-modal patient="patient"></patient-provider-info-modal></md-dialog>',
        // eslint-disable-next-line no-undef
        controller: PatientContactInfoModalController,
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: '_resolvePCPData',
    value: function _resolvePCPData(patient) {
      this.vm.patient = _.clone(patient);
      this.vm.patient.lastVisit = patient.lastVisit ? this.reverseDateFormatFilterFilter(patient.lastVisit) : 'N/A';
      this.vm.patient.providerInfo = _.get(patient, 'providerInfo', {});
      this.vm.patient.providerInfo.name = _.get(patient, 'providerInfo.name', 'N/A');
    }
  }]);

  return PatientProviderInfoCardController;
}();

angular.module('apm.components.patients').component('apmPatientProviderInfoCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.providerInfoCard.component.html',
  controller: PatientProviderInfoCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientHccCardController = function () {
  function PatientHccCardController() {
    _classCallCheck(this, PatientHccCardController);
  }

  _createClass(PatientHccCardController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient.currentValue && changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this._extractHCCData();
      }
    }
  }, {
    key: '_extractHCCData',
    value: function _extractHCCData() {
      var riskSection = _.find(this.patient.qualityMeasures.sections, { name: 'RISK' });

      if (riskSection && riskSection.groups.length > 0 && riskSection.groups[0].qualityMeasures.length > 0) {
        this.pendingValue = riskSection.groups[0].qualityMeasures[0].pendingValue;
        this.pendingCount = riskSection.groups[0].qualityMeasures[0].pendingCount;
      }
    }
  }]);

  return PatientHccCardController;
}();

angular.module('apm.components.patients').component('apmPatientHccCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.hccCard.component.html',
  controller: PatientHccCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientGapsCardController = function () {
  function PatientGapsCardController() {
    _classCallCheck(this, PatientGapsCardController);

    _.assign(this, {
      vm: {}
    });
  }

  _createClass(PatientGapsCardController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient && changesObj.patient.currentValue && changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this._extractGapsData();
      }
    }
  }, {
    key: '_extractGapsData',
    value: function _extractGapsData() {
      this.vm.open = _.get(this.patient, 'qualityMeasures.headerScores.' + this.group + '.open', 0);
      this.vm.pending = _.get(this.patient, 'qualityMeasures.headerScores.' + this.group + '.pending', 0);
    }
  }]);

  return PatientGapsCardController;
}();

angular.module('apm.components.patients').component('apmPatientGapsCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.gapsCard.component.html',
  controller: PatientGapsCardController,
  bindings: {
    patient: '<',
    group: '@'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientContactInfoCardController = function () {

  /** @ngInject */
  function PatientContactInfoCardController($scope, $mdDialog) {
    _classCallCheck(this, PatientContactInfoCardController);

    _.assign(this, {
      $scope: $scope,
      $mdDialog: $mdDialog
    });
  }

  _createClass(PatientContactInfoCardController, [{
    key: '$onInit',
    value: function $onInit() {
      this._setPhoneNumberUpdateWatch();
    }
  }, {
    key: 'showPatientContactInfoModal',
    value: function showPatientContactInfoModal() {
      var scope = angular.extend(this.$scope.$new(true), {
        patient: this.patient
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="Contact Info" class="patient-contact-modal"><patient-contact-info-modal patient="patient"/></md-dialog>',
        // eslint-disable-next-line no-undef
        controller: PatientContactInfoModalController,
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: '_setPhoneNumberUpdateWatch',
    value: function _setPhoneNumberUpdateWatch() {
      var _this = this;

      this.$scope.$on('number-updated', function (event, telecom) {
        if (telecom && telecom.length && telecom[0].value) {
          _this.patient = _.assign({}, _this.patient, {
            phone: telecom[0].value
          });
        }
      });
    }
  }]);

  return PatientContactInfoCardController;
}();

angular.module('apm.components.patients').component('apmPatientContactInfoCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.contactInfoCard.component.html',
  controller: PatientContactInfoCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientCallHistoryCardController = function () {

  /** @ngInject */
  function PatientCallHistoryCardController($mdDialog, $document) {
    _classCallCheck(this, PatientCallHistoryCardController);

    this.$mdDialog = $mdDialog;
    this.$document = $document;
  }

  _createClass(PatientCallHistoryCardController, [{
    key: 'showPatientsCallLogModal',
    value: function showPatientsCallLogModal(event) {
      this.$mdDialog.show({
        templateUrl: 'app/components/patients/callLog/apm.patients.callLogModal.html',
        // eslint-disable-next-line no-undef
        controller: PatientCallLogModalController.dialogController,
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          patient: this.patient
        },
        parent: angular.element(this.$document.body),
        targetEvent: event,
        clickOutsideToClose: true
      });
    }
  }]);

  return PatientCallHistoryCardController;
}();

angular.module('apm.components.patients').component('apmPatientCallHistoryCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.callHistoryCard.component.html',
  controller: PatientCallHistoryCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientApptHistoryCardController = function () {

  /** @ngInject */
  function PatientApptHistoryCardController($mdDialog) {
    _classCallCheck(this, PatientApptHistoryCardController);

    this.$mdDialog = $mdDialog;
  }

  _createClass(PatientApptHistoryCardController, [{
    key: 'showPatientAppointmentsModal',
    value: function showPatientAppointmentsModal() {
      this.$mdDialog.show({
        templateUrl: 'app/components/patients/appointments/apm.patients.appointmentsModal.html',
        // eslint-disable-next-line no-undef
        controller: PatientAppointmentsModalController.dialogController,
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          patient: this.patient
        },
        clickOutsideToClose: true
      });
    }
  }]);

  return PatientApptHistoryCardController;
}();

angular.module('apm.components.patients').component('apmPatientApptHistoryCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.apptHistoryCard.component.html',
  controller: PatientApptHistoryCardController,
  bindings: {
    patient: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientActivePlansCardController = function () {
  function PatientActivePlansCardController($scope, $mdDialog) {
    _classCallCheck(this, PatientActivePlansCardController);

    _.assign(this, {
      $scope: $scope,
      $mdDialog: $mdDialog
    });
  }

  _createClass(PatientActivePlansCardController, [{
    key: 'showActiveActionPlansInfoModal',
    value: function showActiveActionPlansInfoModal() {
      var scope = angular.extend(this.$scope.$new(true), {
        patient: this.patient
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal" class="action-plan-details-modal grid-content"><apm-patient-active-plans patient="patient" title="Active Action Plans" page-sizes="[5, 10, 20, 30]"></apm-patient-active-plans></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }]);

  return PatientActivePlansCardController;
}();

angular.module('apm.components.patients').component('apmPatientActivePlansCard', {
  templateUrl: 'app/components/patients/cards/apm.patients.activePlansCard.component.html',
  controller: PatientActivePlansCardController,
  bindings: {
    patient: '<'
  }
});
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientAppointmentsModalController = function () {
  function PatientAppointmentsModalController() {
    _classCallCheck(this, PatientAppointmentsModalController);
  }

  _createClass(PatientAppointmentsModalController, null, [{
    key: "dialogController",


    /** @ngInject */
    value: function dialogController($scope, $mdDialog) {
      $scope.close = function () {
        $mdDialog.cancel();
      };
    }
  }]);

  return PatientAppointmentsModalController;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientAppointmentsGridController = function () {

  /** @ngInject */
  function PatientAppointmentsGridController($q, apmPatientsService) {
    _classCallCheck(this, PatientAppointmentsGridController);

    _.assign(this, {
      $q: $q,
      apmPatientsService: apmPatientsService,

      columnsSort: ['fhirResource.start', 'actionPlanTitle', 'fhirResource.status'],
      errorMessage: null,

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(PatientAppointmentsGridController, [{
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj && changeObj.patient && changeObj.patient.currentValue.patient !== changeObj.patient.previousValue.patient) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;
      var apiParams = this._getApiParams();

      if (!apiParams.patientId) {
        return this._getEmptyPromise();
      }

      return this.apmPatientsService.fetchPatientAppointmentsPage(apiParams).then(function (response) {
        return _this._fetchPatientAppointmentsSuccessHandler(response);
      }).catch(function (err) {
        return _this._fetchPatientAppointmentsErrorHandler(err);
      });
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.appointmentsPage[rowId];
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        patientId: this.patient.patient || this.patient.id,
        page: this.page,
        '_count': this.pageSize
      }, this._getSortingParam());
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'fhirResource.start'
      };

      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_getEmptyPromise',
    value: function _getEmptyPromise() {
      return this.$q.defer().promise;
    }
  }, {
    key: '_fetchPatientAppointmentsSuccessHandler',
    value: function _fetchPatientAppointmentsSuccessHandler(response) {
      var _this2 = this;

      this.appointmentsPage = {};
      this.errorMessage = null;

      angular.forEach(response.content, function (appointment, index) {

        appointment.id = '' + index;
        appointment.actionPlanTitle = appointment.actionPlanTitle || 'N/A';
        _this2.appointmentsPage[appointment.id] = appointment;
      }, this);

      return {
        results: _.values(this.appointmentsPage),
        totalResultCount: response.totalElements
      };
    }
  }, {
    key: '_fetchPatientAppointmentsErrorHandler',
    value: function _fetchPatientAppointmentsErrorHandler(err) {
      this.appointmentsPage = {};
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));

      return {
        results: [],
        totalResultCount: 0
      };
    }
  }]);

  return PatientAppointmentsGridController;
}();

angular.module('apm.components.patients').component('apmPatientAppointmentsGrid', {
  templateUrl: 'app/components/patients/appointments/apm.patients.appointmentsGrid.component.html',
  controller: PatientAppointmentsGridController,
  bindings: {
    patient: '<',
    pageSizes: '<',
    onActionPlanLink: '&',
    title: '@'
  }
});
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientCallLogModalController = function () {
  function PatientCallLogModalController() {
    _classCallCheck(this, PatientCallLogModalController);
  }

  _createClass(PatientCallLogModalController, null, [{
    key: "dialogController",


    /** @ngInject */
    value: function dialogController($scope, $mdDialog) {
      $scope.close = function () {
        $mdDialog.cancel();
      };
    }
  }]);

  return PatientCallLogModalController;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientCallLogGridController = function () {

  /** @ngInject */
  function PatientCallLogGridController(apmReportService, scLastNameFirstFilter) {
    _classCallCheck(this, PatientCallLogGridController);

    _.assign(this, {
      apmReportService: apmReportService,
      scLastNameFirstFilter: scLastNameFirstFilter,

      columnDisplay: ['callTime', 'actionPlanTitle', 'fullName', 'dispositionDisplayText'],
      columnsSort: ['callTime', 'actionPlanTitle', 'callerLastName', 'dispositionDisplayText'],
      errorMessage: null,
      filter: {},
      isActionPage: false
    });
  }

  _createClass(PatientCallLogGridController, [{
    key: '$onInit',
    value: function $onInit() {
      if (_.has(this, 'patient.patient')) {
        this.isActionPage = true;
        this.columnDisplay = _.without(this.columnDisplay, 'actionPlanTitle');
        this.columnsSort = _.without(this.columnsSort, 'actionPlanTitle');
      }
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmReportService.fetchCallLogReportPage(this._getApiParams()).then(function (response) {
        return _this._getPatientCallLogSuccessHandler(response);
      }).catch(function (err) {
        return _this._getPatientCallLogErrorHandler(err);
      });
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        patientIds: [this.patient.patient || this.patient.id],
        page: this.page,
        '_count': this.pageSize
      }, this._getSortingParam());
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'callTime'
      };
      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });
      return sorting;
    }
  }, {
    key: '_getPatientCallLogSuccessHandler',
    value: function _getPatientCallLogSuccessHandler(response) {
      var _this2 = this;

      var callLogs = [];
      this.errorMessage = null;

      angular.forEach(response.content, function (callLog) {
        _this2._resolveCallerName(callLog);
        callLogs.push(callLog);
      });
      return {
        results: callLogs,
        totalResultCount: response.totalElements
      };
    }
  }, {
    key: '_getPatientCallLogErrorHandler',
    value: function _getPatientCallLogErrorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));

      return {
        results: [],
        totalResultCount: 0
      };
    }
  }, {
    key: '_resolveCallerName',
    value: function _resolveCallerName(callLog) {
      callLog.fullName = this.scLastNameFirstFilter(callLog.callerLastName, null, callLog.callerFirstName, null, null);
    }
  }]);

  return PatientCallLogGridController;
}();

angular.module('apm.components.patients').component('apmPatientCallLogGrid', {
  templateUrl: 'app/components/patients/callLog/apm.patients.callLogGrid.component.html',
  controller: PatientCallLogGridController,
  bindings: {
    patient: '<',
    pageSizes: '<',
    title: '@'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientGapModalController = function () {

  /** @ngInject */
  function PatientGapModalController($mdDialog, apmPatientsService) {
    _classCallCheck(this, PatientGapModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      apmPatientsService: apmPatientsService,

      errorMessage: null,
      followUpDate: null,
      ready: false
    });
  }

  _createClass(PatientGapModalController, [{
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      var _this = this;

      if (changeObj.gap.currentValue.name) {
        this._getRelatedActionPlans();
      }
      this.processMeasures.forEach(function (measure) {
        if (measure.name === _this.gap.name) {
          _this.followUpDate = measure.occurrenceDates[0].displayValue;
        }
      });
    }
  }, {
    key: '_getRelatedActionPlans',
    value: function _getRelatedActionPlans() {
      var _this2 = this;

      this.apmPatientsService.fetchPatientGapRelatedActionPlans(this.patientId, this.measureReportId).then(function (response) {
        return _this2._fetchPatientGapRelatedActionPlansSuccessHandler(response);
      }).catch(function (err) {
        return _this2._fetchPatientGapRelatedActionPlansErrorHandler(err);
      });
    }
  }, {
    key: '_fetchPatientGapRelatedActionPlansSuccessHandler',
    value: function _fetchPatientGapRelatedActionPlansSuccessHandler(response) {
      this.gap.relatedActionPlans = response.data;
      this.errorMessage = null;
      this._parseRelatedActionPlans();
      this.ready = true;
    }
  }, {
    key: '_parseRelatedActionPlans',
    value: function _parseRelatedActionPlans() {
      this.relatedActionPlans = _.map(this.gap.relatedActionPlans, function (actionPlan) {
        return {
          title: actionPlan.actionPlanTitle,
          id: _.last(actionPlan.actionPlanRef.split('/'))
        };
      });
    }
  }, {
    key: '_fetchPatientGapRelatedActionPlansErrorHandler',
    value: function _fetchPatientGapRelatedActionPlansErrorHandler(err) {
      this.ready = true;
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }]);

  return PatientGapModalController;
}();

angular.module('apm.components.patients').component('patientGapModal', {
  templateUrl: 'app/components/patients/activity/apm.patients.activity.gapModal.component.html',
  controller: PatientGapModalController,
  bindings: {
    gap: '<',
    statusMapping: '<',
    processMeasures: '<',
    measureReportId: '<',
    patientId: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientActivityGapCardController = function () {

  /** @ngInject */
  function PatientActivityGapCardController($mdDialog, $scope) {
    _classCallCheck(this, PatientActivityGapCardController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,

      statusMapping: {
        NOT_MET: {
          text: 'Open Gap',
          icon: 'highlight_off'
        },
        MET: {
          text: 'Closed Gap',
          icon: 'check_circle'
        },
        PERFORMED: {
          text: 'Pending',
          icon: 'hourglass_empty'
        },
        INELIGIBLE: {
          text: 'Not Eligible',
          icon: 'not_interested'
        }
      }
    });
  }

  _createClass(PatientActivityGapCardController, [{
    key: 'showGapDetailsDialog',
    value: function showGapDetailsDialog() {
      var scope = angular.extend(this.$scope.$new(true), {
        gap: this.gap,
        processMeasures: this.processMeasures,
        statusMapping: this.statusMapping,
        measureReportId: this.measureReportId,
        patientId: this.patientId
      });
      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal" class="patient-gap-modal"><patient-gap-modal gap="gap" measure-report-id="measureReportId" patient-id="patientId" process-measures="processMeasures" status-mapping="statusMapping" /></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }]);

  return PatientActivityGapCardController;
}();

angular.module('apm.components.patients').component('apmPatientActivityGapCard', {
  templateUrl: 'app/components/patients/activity/apm.patients.activity.gapCard.component.html',
  controller: PatientActivityGapCardController,
  bindings: {
    gap: '<',
    measureReportId: '<',
    patientId: '<',
    processMeasures: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientActivityController = function () {

  /** @ngInject */
  function PatientActivityController($window, apmPatientsService, scFhirApi, scNotificationsFactory) {
    _classCallCheck(this, PatientActivityController);

    _.assign(this, {
      $window: $window,
      apmPatientsService: apmPatientsService,
      scFhirApi: scFhirApi,
      scNotificationsFactory: scNotificationsFactory,

      ready: false,
      showGaps: true
    });
  }

  _createClass(PatientActivityController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.patient.currentValue && changesObj.patient.currentValue !== changesObj.patient.previousValue) {
        this._getPatientQualityMeasures();
      }
    }
  }, {
    key: 'setGaps',
    value: function setGaps() {
      this.gaps = this.showGaps ? _.filter(this.extractedGaps, this._gapFilter, this) : this.extractedGaps;
    }
  }, {
    key: '_getPatientQualityMeasures',
    value: function _getPatientQualityMeasures() {
      var _this = this;

      var measureYear = this.$window.sessionStorage.getItem('measureYear');
      this.apmPatientsService.fetchPatientQualityMeasures(this.patient.id, measureYear).then(function (response) {
        return _this._fetchPatientQualityMeasuresSuccessHandler(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_fetchPatientQualityMeasuresSuccessHandler',
    value: function _fetchPatientQualityMeasuresSuccessHandler(response) {
      var _this2 = this;

      this._extractPatientQualityMeasuresData(response).then(function () {
        _this2.ready = true;
      });
    }
  }, {
    key: '_extractPatientQualityMeasuresData',
    value: function _extractPatientQualityMeasuresData(response) {
      var _this3 = this;

      if (_.has(response, 'data')) {
        this.patient.qualityMeasures = response.data;

        response.data.sections.forEach(function (section) {
          if (section.name === 'QUALITY') {
            section.groups.forEach(function (group) {
              if (group.name === 'Process Measures') {
                _this3.patient.processMeasures = group.qualityMeasures;
              }
            });
          }
        });
        this._extractGaps();

        return this._extractMeasureInfo().then(function () {
          return _this3.setGaps();
        });
      }
    }
  }, {
    key: '_flattenGaps',
    value: function _flattenGaps() {
      return _.map(_.flatten(this.patient.qualityMeasures.sections), function (section) {
        return {
          name: section.name.toLowerCase(),
          gaps: _.flatten(_.map(_.flatten(section.groups), 'qualityMeasures'))
        };
      });
    }
  }, {
    key: '_extractGaps',
    value: function _extractGaps() {
      var sections = _.remove(this.patient.qualityMeasures.sections, function (section) {
        return section.name !== 'RISK';
      });

      var gaps = _.map(sections, this._extractGroups, this);

      this.extractedGaps = _.flatten(gaps);
    }
  }, {
    key: '_extractMeasureInfo',
    value: function _extractMeasureInfo() {
      var _this4 = this;

      return this.scFhirApi.getMeasures().then(function (measures) {
        return _this4._extractMeasureInfoSuccess(measures);
      }).catch(function (err) {
        return _this4._errorHandler(err);
      });
    }
  }, {
    key: '_extractMeasureInfoSuccess',
    value: function _extractMeasureInfoSuccess(measures) {
      var _this5 = this;

      if (_.has(measures, 'data.entry')) {
        _.forEach(measures.data.entry, function (gapInfo) {
          var gapName = _.isArray(gapInfo.resource.identifier) && gapInfo.resource.identifier.length ? gapInfo.resource.identifier[0].value : '';
          var properties = _this5._filterProperties(gapInfo.resource);
          _this5._parseData(gapName, properties);
        });
      }
    }
  }, {
    key: '_parseData',
    value: function _parseData(gapName, properties) {
      if (properties.definition) {
        properties.definition = angular.fromJson(properties.definition);
      }
      if (properties.type) {
        properties.type = _.capitalize(properties.type[0]);
      }
      _.assign(_.find(this.extractedGaps, { identifier: gapName }), { measures: properties });
    }
  }, {
    key: '_filterProperties',
    value: function _filterProperties(fields) {
      var properties = ['title', 'type', 'rateAggregation', 'guidance', 'description', 'definition'];
      return _.pick(fields, function (value, key) {
        return _.includes(properties, key);
      });
    }
  }, {
    key: '_extractGroups',
    value: function _extractGroups(section) {
      var groups = _.map(section.groups, this._extractGroupQualityMeasures);

      return _.flatten(groups);
    }
  }, {
    key: '_extractGroupQualityMeasures',
    value: function _extractGroupQualityMeasures(group) {
      return _.map(group.qualityMeasures, function (qualityMeasure) {
        return {
          group: group.name,
          name: qualityMeasure.name,
          identifier: qualityMeasure.identifier,
          status: qualityMeasure.status,
          statusText: qualityMeasure.statusText,
          updateText: qualityMeasure.updateText,
          lastUpdated: qualityMeasure.lastUpdated,
          relatedActionPlans: qualityMeasure.relatedActionPlans,
          explanationsSections: _.get(qualityMeasure, 'modal.sections', []),
          measureReportId: _.get(qualityMeasure, 'measureReportId')
        };
      });
    }
  }, {
    key: '_gapFilter',
    value: function _gapFilter(gap) {
      return _.includes(['NOT_MET', 'PERFORMED'], gap.status);
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.ready = true;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return PatientActivityController;
}();

angular.module('apm.components.patients').component('apmPatientActivity', {

  templateUrl: 'app/components/patients/activity/apm.patients.activity.component.html',
  controller: PatientActivityController,
  bindings: {
    patient: '<'
  }

});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientActivePlansModalController = function () {
  function PatientActivePlansModalController($mdDialog, $q, $stateParams, apmActionPlanService, apmPatientsService) {
    _classCallCheck(this, PatientActivePlansModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $q: $q,
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      apmPatientsService: apmPatientsService,

      actionPlanPage: {},
      currentActionPlan: {},
      errorMessage: null,
      hasCurrentActionPlan: false,

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(PatientActivePlansModalController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.hasCurrentActionPlan = _.has(this.$stateParams, 'planId');
      if (this.hasCurrentActionPlan) {
        this.apmActionPlanService.getActionPlan(this.$stateParams.planId).then(function (response) {
          return _this._getCurrentActionPlanSuccessHandler(response);
        }).catch(function (err) {
          return _this._errorHandler(err);
        });
      }
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changeObj) {
      if (changeObj && changeObj.patient && changeObj.patient.currentValue.patient !== changeObj.patient.previousValue.patient) {
        this.loadPageCallback(1);
      }
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this2 = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;
      var apiParams = this._getApiParams();

      if (!apiParams.patientId) {
        return this._getEmptyPromise();
      }

      return this.apmPatientsService.fetchPatientActionPlans(apiParams).then(function (response) {
        return _this2._getPatientActionPlansSuccessHandler(response);
      }).catch(function (err) {
        return _this2._getPatientActionPlansErrorHandler(err);
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'setLoadResultsCallback',
    value: function setLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      var patientId = this.patient.patient || this.patient.id;

      return {
        patientId: patientId,
        page: this.page,
        '_count': this.pageSize,
        '_sort:asc': 'eventDate',
        status: 'SCHEDULING,REMINDERS,ENCOUNTERS'
      };
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return _.get(this, 'actionPlanPage[' + rowId + '].actionPlanId') !== this.currentActionPlan._id ? this.actionPlanPage[rowId] : null;
    }
  }, {
    key: '_getEmptyPromise',
    value: function _getEmptyPromise() {
      return this.$q.defer().promise;
    }
  }, {
    key: '_getCurrentActionPlanSuccessHandler',
    value: function _getCurrentActionPlanSuccessHandler(response) {
      this.currentActionPlan = response.data;
    }
  }, {
    key: '_getPatientActionPlansSuccessHandler',
    value: function _getPatientActionPlansSuccessHandler(response) {
      var _this3 = this;

      this.actionPlanPage = {};

      angular.forEach(response.content, function (appointment, index) {
        appointment.id = '' + index;
        appointment.actionPlanTitle = appointment.actionPlanTitle || 'N/A';
        _this3.actionPlanPage[appointment.id] = appointment;
      }, this);

      return {
        results: _.values(this.actionPlanPage),
        totalResultCount: response.totalElements
      };
    }
  }, {
    key: '_getPatientActionPlansErrorHandler',
    value: function _getPatientActionPlansErrorHandler(err) {
      this.actionPlanPage = {};
      this._errorHandler(err);

      return {
        results: [],
        totalResultCount: 0
      };
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return PatientActivePlansModalController;
}();

angular.module('apm.components.patients').component('apmPatientActivePlans', {
  templateUrl: 'app/components/patients/activePlans/apm.patients.activePlansModal.html',
  controller: PatientActivePlansModalController,
  bindings: {
    patient: '<',
    pageSizes: '<',
    onActionPlanLink: '&',
    title: '@'
  }
});
'use strict';

angular.module('apm.components.providers.factories', []);
angular.module('apm.components.providers', ['apm.components.providers.factories']);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProviderHeaderController = function () {
  /** @ngInject */
  function ProviderHeaderController() {
    _classCallCheck(this, ProviderHeaderController);

    _.assign(this, {
      providerName: ''
    });
  }

  _createClass(ProviderHeaderController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (changesObj.provider.currentValue.providerName !== changesObj.provider.previousValue.providerName) {
        this._resolveProviderHeader();
      }
    }
  }, {
    key: '_resolveProviderHeader',
    value: function _resolveProviderHeader() {
      if (this.provider) {
        if (_.has(this.provider, 'providerName')) {
          this.providerName = this.provider.providerName;
        }
      }
    }
  }]);

  return ProviderHeaderController;
}();

angular.module('apm.components.providers').component('apmProviderHeader', {
  templateUrl: 'app/components/providers/header/apm.providers.header.component.html',
  controller: ProviderHeaderController,
  bindings: {
    provider: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmProviderDetailsService = function () {

  /** @ngInject */
  function ApmProviderDetailsService($resource, API_BASE_URL) {
    _classCallCheck(this, ApmProviderDetailsService);

    this.providerDetailsResource = $resource(API_BASE_URL + '/ap/provider', { id: '@id', year: '@year' }, {
      fetchProviderSettings: {
        method: 'GET',
        isArray: true,
        url: API_BASE_URL + '/ap/provider/:id/SDO/:year',
        transformResponse: this._extractResponse,
        cache: false
      },
      postProviderSettings: {
        method: 'POST',
        url: API_BASE_URL + '/ap/provider/SDO',
        transformRequest: function transformRequest(data) {
          return angular.toJson(data);
        },
        transformResponse: this._extractResponse,
        cache: false
      }
    });
  }

  _createClass(ApmProviderDetailsService, [{
    key: 'getProviderDetails',
    value: function getProviderDetails(thisID, thisYear) {
      return this.providerDetailsResource.fetchProviderSettings({ id: thisID, year: thisYear }).$promise;
    }
  }, {
    key: 'setProviderDetails',
    value: function setProviderDetails(data) {
      return this.providerDetailsResource.postProviderSettings(data).$promise;
    }
  }, {
    key: '_extractResponse',
    value: function _extractResponse(response) {
      var responseJSON = angular.fromJson(response);
      return responseJSON.success ? responseJSON.data : responseJSON;
    }
  }]);

  return ApmProviderDetailsService;
}();

angular.module('apm.components.providers').service('apmProviderDetailsService', ApmProviderDetailsService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmProviderDetailsFactory = function () {

  /** @ngInject */
  function ApmProviderDetailsFactory(scLastNameFirstFilter, reverseDateFormatFilterFilter) {
    _classCallCheck(this, ApmProviderDetailsFactory);

    _.assign(this, {
      scLastNameFirstFilter: scLastNameFirstFilter,
      reverseDateFormatFilterFilter: reverseDateFormatFilterFilter
    });
  }

  _createClass(ApmProviderDetailsFactory, [{
    key: 'resolveCheckboxData',
    value: function resolveCheckboxData(data) {
      var orderByMap = ['SDS/HEDIS Screenings', 'Laboratory', 'Referrals'];

      if (_.has(data, 'groups') && data.groups.length) {
        _.forEach(data.groups, function (groups_value) {
          groups_value.name = groups_value.group;
          groups_value.orderBy = orderByMap.indexOf(groups_value.name);
          if (_.has(groups_value, 'qualifications')) {
            var thisChecked = false;
            groups_value.children = groups_value.qualifications;
            delete groups_value.qualifications;
            _.forEach(groups_value.children, function (children_value) {
              if (_.has(children_value, 'measureTest') && _.has(children_value.measureTest, 'name')) {
                children_value.name = children_value.measureTest.name;
              }
              if (_.has(children_value, 'approved') && children_value.approved) {
                thisChecked = true;
                children_value.checked = children_value.approved;
              }
              delete children_value.approved;
            });
            groups_value.checked = thisChecked;
          }
        });
        data.groups = _.sortBy(data.groups, 'orderBy');

        return data;
      }

      return false;
    }
  }, {
    key: 'setCheckboxDisabled',
    value: function setCheckboxDisabled(data) {
      if (_.has(data, 'groups') && data.groups.length) {
        _.forEach(data.groups, function (groups_value) {
          groups_value.disabled = true;
          if (_.has(groups_value, 'children')) {
            _.forEach(groups_value.children, function (children_value) {
              children_value.disabled = true;
            });
          }
        });
      }

      return data;
    }
  }, {
    key: 'setPostQueryData',
    value: function setPostQueryData(dataRaw, comments) {
      var request = {
        'providerId': dataRaw.providerId,
        'measureYear': dataRaw.measureYear,
        'groups': []
      };

      if (comments) {
        request.comments = [{ text: comments }];
      }
      if (_.has(dataRaw, 'groups')) {
        _.forEach(dataRaw.groups, function (groups_value) {
          var thisGroup = groups_value;
          var compiledGroup = {
            'group': thisGroup.group,
            'qualifications': []
          };
          _.forEach(thisGroup.children, function (children_value) {
            compiledGroup.qualifications.push({
              'approved': children_value.checked ? children_value.checked : false,
              'measureTest': {
                'code': children_value.measureTest.code,
                'group': children_value.measureTest.group,
                'name': children_value.measureTest.name,
                'relatedMeasures': children_value.measureTest.relatedMeasures
              }
            });
          });
          request.groups.push(compiledGroup);
        });
      }
      return request;
    }
  }, {
    key: 'resolveName',
    value: function resolveName(properties) {
      var nameObj = {
        prefix: null,
        fName: null,
        mName: null,
        lName: null,
        suffix: null
      };

      if (_.has(properties, 'firstName') && properties.firstName.length) {
        nameObj.fName = properties.firstName;
      }
      if (_.has(properties, 'lastName') && properties.lastName.length) {
        nameObj.lName = properties.lastName;
      }
      return this.scLastNameFirstFilter(nameObj.lName, nameObj.prefix, nameObj.fName, nameObj.mName, nameObj.suffix);
    }
  }]);

  return ApmProviderDetailsFactory;
}();

angular.module('apm.components.providers.factories').service('apmProviderDetailsFactory', ApmProviderDetailsFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProviderDetailsController = function () {

  /** @ngInject */
  function ProviderDetailsController($scope, $state, $stateParams, $window, apmAuthenticationService, apmProviderDetailsService, apmProviderDetailsFactory, scNotificationsFactory) {
    _classCallCheck(this, ProviderDetailsController);

    _.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      $window: $window,
      apmAuthenticationService: apmAuthenticationService,
      apmProviderDetailsService: apmProviderDetailsService,
      scNotificationsFactory: scNotificationsFactory,
      apmProviderDetailsFactory: apmProviderDetailsFactory,

      comments: null,
      isLoading: false,
      lastUpdated: null,
      providerDetailsDataCheckBoxes: {},
      providerDetailsDataRaw: {},
      saveReadOnly: true,
      selectedProvider: undefined
    });
  }

  _createClass(ProviderDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      this.saveReadOnly = !this.apmAuthenticationService.hasAccess('scProviderMgmt');
      this._getProviderDetails(this.$stateParams.id, this.$window.sessionStorage.getItem('measureYear'));
    }
  }, {
    key: 'onCheckboxChanged',
    value: function onCheckboxChanged() {
      this._setProviderDetailsFormDirty();
    }
  }, {
    key: 'isSelectedProvider',
    value: function isSelectedProvider() {
      return _.isObject(this.selectedProvider);
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      this._setCommentsTouched();
      if (this.$scope.providerDetailsForm.$valid) {
        this.isLoading = true;
        var request = this.apmProviderDetailsFactory.setPostQueryData(this.providerDetailsDataCheckBoxes, this.comments);
        this.apmProviderDetailsService.setProviderDetails(request).then(function (res) {
          return _this._setProviderDetailsSuccess(res);
        }).catch(function (err) {
          return _this._errorHandler(err);
        });
      }
    }
  }, {
    key: '_setProviderDetailsFormDirty',
    value: function _setProviderDetailsFormDirty() {
      this.$scope.providerDetailsForm.$setDirty();
    }
  }, {
    key: '_setCommentsTouched',
    value: function _setCommentsTouched() {
      if (this.$scope.providerDetailsForm.comments) {
        this.$scope.providerDetailsForm.comments.$setTouched();
      }
    }
  }, {
    key: '_getProviderDetails',
    value: function _getProviderDetails(thisID, thisYear) {
      var _this2 = this;

      this.isLoading = true;
      this.apmProviderDetailsService.getProviderDetails(thisID, thisYear).then(function (response) {
        return _this2._getProviderDetailsSuccess(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_getProviderDetailsSuccess',
    value: function _getProviderDetailsSuccess(response) {
      var _this3 = this;

      if (response.length) {
        this.providerDetailsDataRaw = response[0];
        this.selectedProvider = _.clone(response[0]);
        this.providerDetailsDataCheckBoxes = this.apmProviderDetailsFactory.resolveCheckboxData(this.providerDetailsDataRaw);
        if (this.saveReadOnly) {
          this.apmProviderDetailsFactory.setCheckboxDisabled(this.providerDetailsDataCheckBoxes);
        }
        _.forEach(this.selectedProvider.comments, function (comment_value) {
          _this3._resolveName(comment_value);
        });
      }
      this.isLoading = false;
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.isLoading = false;
      this.selectedProvider = {};
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_setProviderDetailsSuccess',
    value: function _setProviderDetailsSuccess(res) {
      this.lastUpdated = res.lastUpdated;
      this.scNotificationsFactory.success('Settings saved successfully');
      this.$state.go('providers.list');
    }
  }, {
    key: '_resolveName',
    value: function _resolveName(comment) {
      comment.fullName = this.apmProviderDetailsFactory.resolveName(comment);
    }
  }]);

  return ProviderDetailsController;
}();

angular.module('apm.components.providers').component('apmProviderDetails', {
  templateUrl: 'app/components/providers/details/apm.providers.details.html',
  controller: ProviderDetailsController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmProviderListFactory = function () {

  /** @ngInject */
  function ApmProviderListFactory(scLastNameFirstFilter) {
    _classCallCheck(this, ApmProviderListFactory);

    this.scLastNameFirstFilter = scLastNameFirstFilter;
  }

  _createClass(ApmProviderListFactory, [{
    key: 'filterToFhirFilter',
    value: function filterToFhirFilter(filter) {
      var newFilter = {};

      _.forOwn(filter, function (value, key) {
        if (value) {
          switch (key) {
            case 'fName':
              newFilter['fhirResource.name.given:inexact'] = value;
              break;
            case 'lName':
              newFilter['fhirResource.name.family:inexact'] = value;
              break;
            case 'market':
              newFilter['fhirResource.market:inexact'] = value;
              break;
          }
        }
      });
      return newFilter;
    }
  }, {
    key: 'setName',
    value: function setName(providerList) {
      var display = 'N/A';
      var nameObj = {
        prefix: null,
        fName: null,
        mName: null,
        lName: null,
        suffix: null
      };
      if (_.has(providerList, 'resource.name') && providerList.resource.name.length > 0) {
        var resourceName = providerList.resource.name[0];

        if (_.has(resourceName, 'prefix') && resourceName.prefix.length) {
          nameObj.prefix = resourceName.prefix[0];
        }
        if (_.has(resourceName, 'given') && resourceName.given.length) {
          if (resourceName.given[0]) {
            nameObj.fName = resourceName.given[0];
          }
          if (resourceName.given[1]) {
            nameObj.mName = resourceName.given[1];
          }
        }
        if (_.has(resourceName, 'family')) {
          nameObj.lName = resourceName.family;
        }
        if (_.has(resourceName, 'suffix') && resourceName.suffix.length) {
          nameObj.suffix = resourceName.suffix[0];
        }

        display = this.scLastNameFirstFilter(nameObj.lName, nameObj.prefix, nameObj.fName, nameObj.mName, nameObj.suffix);
      }
      return display;
    }
  }, {
    key: 'sortingToFhirFilter',
    value: function sortingToFhirFilter(sortValue) {
      var newSorting = void 0;

      switch (sortValue) {
        case 'fName':
          newSorting = 'fhirResource.name.given';
          break;
        case 'lName':
          newSorting = 'fhirResource.name.family';
          break;
        case 'market':
          newSorting = 'fhirResource.market';
          break;
      }
      return newSorting;
    }
  }]);

  return ApmProviderListFactory;
}();

angular.module('apm.components.providers.factories').service('apmProviderListFactory', ApmProviderListFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProvidersGridController = function () {

  /** @ngInject */
  function ProvidersGridController(apmProvidersService, apmGridFactory, apmProviderListFactory, scNotificationsFactory, PAGE_SIZES) {
    _classCallCheck(this, ProvidersGridController);

    _.assign(this, {
      apmProvidersService: apmProvidersService,
      apmGridFactory: apmGridFactory,
      apmProviderListFactory: apmProviderListFactory,
      scNotificationsFactory: scNotificationsFactory,
      PAGE_SIZES: PAGE_SIZES,

      filter: {},
      providerListPage: {},

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ProvidersGridController, [{
    key: '$onInit',
    value: function $onInit() {
      this._initializeFilter();
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;

      return this.apmProvidersService.fetchProviderListPage(this._getApiParams()).then(function (response) {
        return _this._getProviderListSuccessHandler(response);
      }).catch(function (err) {
        return _this._getProviderListErrorHandler(err);
      });
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'getRow',
    value: function getRow(rowId) {
      return this.providerListPage[rowId];
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty() {
      return this.apmGridFactory.isFilterEmpty(this.filter);
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      var newParams = {
        '_count': this.pageSize,
        '_filter': this.filter,
        'page': this.page
      };

      if (_.has(this.sorting[0], 'key')) {
        newParams[this.sorting[0].key] = this.apmProviderListFactory.sortingToFhirFilter(this.sorting[0].value);
      }

      if (_.has(newParams, '_filter')) {
        _.merge(newParams, this.apmProviderListFactory.filterToFhirFilter(newParams._filter));
        delete newParams._filter;
      }
      return newParams;
    }
  }, {
    key: '_getProviderListSuccessHandler',
    value: function _getProviderListSuccessHandler(response) {
      var _this2 = this;

      this.providerListPage = {};
      var providerListPage = {
        results: [],
        totalResultCount: 0
      };

      if (_.has(response, 'entry')) {
        angular.forEach(response.entry, function (providerList) {
          _this2._resolveName(providerList);
          _this2.providerListPage[providerList.resource.id] = providerList;

          providerListPage.results.push(providerList);
        }, this);
        providerListPage.totalResultCount = response.total;
      }
      return providerListPage;
    }
  }, {
    key: '_getProviderListErrorHandler',
    value: function _getProviderListErrorHandler(err) {
      this.providerListPage = {};
      var providerListPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return providerListPage;
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.filter = {};
    }
  }, {
    key: '_resolveName',
    value: function _resolveName(providerList) {
      providerList.providerFullName = this.apmProviderListFactory.setName(providerList);
    }
  }]);

  return ProvidersGridController;
}();

angular.module('apm.components.providers').component('apmProvidersGrid', {
  templateUrl: 'app/components/providers/grid/apm.providers.grid.component.html',
  controller: ProvidersGridController,
  bindings: {
    filter: '<',
    sorting: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScNavHeaderController = function () {

  /** @ngInject */
  function ScNavHeaderController($rootScope, $scope, $state, $mdDialog, $window, authenticationService, scNotificationsFactory) {
    _classCallCheck(this, ScNavHeaderController);

    _.assign(this, {
      $rootScope: $rootScope,
      $scope: $scope,
      $state: $state,
      $mdDialog: $mdDialog,
      $window: $window,
      authenticationService: authenticationService,
      scNotificationsFactory: scNotificationsFactory,

      tenantLogo: '',
      tenantName: ''
    });
  }

  _createClass(ScNavHeaderController, [{
    key: '$onInit',
    value: function $onInit() {
      this.userName = this.$window.sessionStorage.getItem('lastName') + ', ' + this.$window.sessionStorage.getItem('userName').substring(0, 1).toUpperCase();
      this._setTenantInfo();
    }
  }, {
    key: 'logout',
    value: function logout() {
      var _this = this;

      this.authenticationService.logout().then(function () {
        return _this._logoutSuccessHandler();
      }).catch(function (err) {
        return _this._logoutErrorHandler(err);
      });
    }
  }, {
    key: 'openUpdatePasswordModal',
    value: function openUpdatePasswordModal() {
      this.$mdDialog.show({
        template: '\n        <md-dialog aria-label="Update Password" class="update-password-modal-dialog">\n            <sc-update-password-modal class="Update-password-modal"></sc-update-password-modal>\n        </md-dialog>',
        clickOutsideToClose: true
      });
    }
  }, {
    key: '_logoutSuccessHandler',
    value: function _logoutSuccessHandler() {
      this.$rootScope.navContext = '';
      this.$state.go('login');
    }
  }, {
    key: '_logoutErrorHandler',
    value: function _logoutErrorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
      this.$rootScope.navContext = '';
      this.$state.go('login');
    }
  }, {
    key: '_setTenantInfo',
    value: function _setTenantInfo() {
      var filePath = 'assets/images/branding/';
      var imageName = null;
      this.tenantName = this.authenticationService.getTenant();

      // if (this.tenantName === 'Social Care Test Tenant') {
      //   imageName = 'biodatai-logo-inapp.png';
      // } else if (this.tenantName === 'Elite Medical') {
      //   imageName = 'elite-small-logo.png';
      // } else if (this.tenantName === 'Wellmed') {
      //   imageName = 'wellmed-logo-inapp-desktop.png';
      // } else {
      //   imageName = 'biodatai-logo-inapp.png';
      // }
      imageName = 'biodatai-logo-inapp.png';
      this.tenantLogo = filePath + imageName;
    }
  }]);

  return ScNavHeaderController;
}();

angular.module('sc.common.components.layout').component('scNavHeader', {
  templateUrl: 'app/components/layout/siteNav/sc.nav.header.component.html',
  controller: ScNavHeaderController,
  bindings: {
    isOpen: '<',
    toggleFn: '&'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScNavController = function () {

  /** @ngInject */
  function ScNavController($rootScope, $state, $cookies) {
    _classCallCheck(this, ScNavController);

    _.assign(this, {
      $rootScope: $rootScope,
      $state: $state,
      $cookies: $cookies,

      isLoaded: false,
      isOpen: false
    });
  }

  _createClass(ScNavController, [{
    key: '$onInit',
    value: function $onInit() {
      this._getScNavState();
      this.isLoaded = true;
    }
  }, {
    key: 'isParentActive',
    value: function isParentActive(menuItem) {
      var thisStateParent = _.head(menuItem.split('.'));

      return thisStateParent && this.$state.includes(thisStateParent);
    }
  }, {
    key: 'navigate',
    value: function navigate(state) {
      this.$state.go(state);
      this.$rootScope.$broadcast('sc-navClicked', state);
    }
  }, {
    key: 'onClickMenuItem',
    value: function onClickMenuItem(e, $mdOpenMenu, menuItem) {
      if (_.get(menuItem, 'children.length', 0) > 0) {
        $mdOpenMenu(e);
      } else {
        this.$state.go(menuItem.state);
      }
    }
  }, {
    key: 'onClickToggleNav',
    value: function onClickToggleNav() {
      this.isOpen = !this.isOpen;
      this._setScNavCookie(this.isOpen);
    }
  }, {
    key: '_getScNavCookie',
    value: function _getScNavCookie() {
      var scNavCookie = this.$cookies.get('sc-nav');
      var result = void 0;

      switch (scNavCookie) {
        case '1':
          result = true;
          break;
        case '0':
          result = false;
          break;
        default:
          result = undefined;
          break;
      }

      return result;
    }
  }, {
    key: '_getScNavState',
    value: function _getScNavState() {
      var thisState = this._getScNavCookie();
      if (_.isUndefined(thisState)) {
        this._setScNavCookie(true);
        thisState = true;
      }
      this.isOpen = thisState;
    }
  }, {
    key: '_setScNavCookie',
    value: function _setScNavCookie(value) {
      this.$cookies.put('sc-nav', value ? '1' : '0', { expires: moment().add(30, 'days').toDate() });
    }
  }]);

  return ScNavController;
}();

angular.module('sc.common.components.layout').component('scNav', {
  templateUrl: 'app/components/layout/siteNav/sc.nav.component.html',
  controller: ScNavController,
  bindings: {
    menuItems: '<'
  }
});
'use strict';

angular.module('apm.components.layout', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APMSiteNavController = function () {

  /** @ngInject */
  function APMSiteNavController($state, $scope, apmAuthenticationService) {
    _classCallCheck(this, APMSiteNavController);

    _.assign(this, {
      $state: $state,
      $scope: $scope,
      apmAuthenticationService: apmAuthenticationService,

      hasReportsItem: false,
      hasResourcesItem: false,
      hideNavBar: false,
      menuItems: []
    });
  }

  _createClass(APMSiteNavController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.menuItems = this._generateDefaultMenuItems();

      this.$scope.$watch('$ctrl.$state.current.name', function () {
        _this.hideNavBar = _this.$state.current.name === 'login';
        if (_this.apmAuthenticationService.hasAccess('scResourceMgmt') && !_this.hasResourcesItem) {
          var resourcesMenu = {
            icon: 'person',
            text: 'Resources',
            state: 'resources.list',
            enabled: true
          };

          if (_this.apmAuthenticationService.hasAccess('duplicateManagement')) {
            resourcesMenu.children = [{
              text: 'Resources',
              state: 'resources.list'
            }, {
              text: 'Locations',
              state: 'resources.locations'
            }];
          }
          _this.menuItems.push(resourcesMenu);
          _this.hasResourcesItem = true;
        } else if (!_this.apmAuthenticationService.hasAccess('scResourceMgmt') && _this.hasResourcesItem) {
          _this.menuItems.pop();
          _this.hasResourcesItem = false;
        }
        if (_this.apmAuthenticationService.hasAccess('scAPReport') && !_this.hasReportsItem) {
          _this.menuItems.push({
            icon: 'poll',
            text: 'Reports',
            state: 'reports.list',
            enabled: true,
            children: [{
              text: 'Completed Action Plans',
              state: 'reports.list'
            }, {
              text: 'Action Plan Call Log Report',
              state: 'reports.callLog'
            }, {
              text: 'Pending Gaps Report',
              state: 'reports.pendingGaps'
            }]
          });
          _this.hasReportsItem = true;
        } else if (!_this.apmAuthenticationService.hasAccess('scAPReport') && _this.hasReportsItem) {
          _this.menuItems.pop();
          _this.hasReportsItem = false;
        }
      });
    }
  }, {
    key: '_generateDefaultMenuItems',
    value: function _generateDefaultMenuItems() {
      return [{
        icon: 'home',
        text: 'Home',
        state: 'home',
        enabled: true
      }, {
        icon: 'accessibility',
        text: 'Patients',
        state: 'patients.list',
        enabled: true
      }, {
        icon: 'assignment',
        text: 'Action Plans',
        state: 'actionPlans.list',
        enabled: true,
        children: [{
          text: 'List',
          state: 'actionPlans.list'
        }, {
          text: 'Calendar',
          state: 'actionPlans.calendar'
        }]
      }, {
        icon: 'account_box',
        text: 'Providers',
        state: 'providers.list',
        enabled: true
      }];
    }
  }]);

  return APMSiteNavController;
}();

angular.module('apm.components.layout').component('apmSiteNav', {
  templateUrl: 'app/components/layout/siteNav/apm.layout.siteNav.component.html',
  controller: APMSiteNavController
});
'use strict';

angular.module('apm.components.home', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UpdatePasswordAdviceModalController = function () {

  /** @ngInject */
  function UpdatePasswordAdviceModalController($mdDialog) {
    _classCallCheck(this, UpdatePasswordAdviceModalController);

    _.assign(this, {
      $mdDialog: $mdDialog
    });
  }

  _createClass(UpdatePasswordAdviceModalController, [{
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'openUpdatePasswordModal',
    value: function openUpdatePasswordModal() {
      this.$mdDialog.show({
        template: '\n        <md-dialog aria-label="Update Password" class="update-password-modal">\n            <sc-update-password-modal class="Update-password-modal"></sc-update-password-modal>\n        </md-dialog>',
        clickOutsideToClose: true
      });
    }
  }]);

  return UpdatePasswordAdviceModalController;
}();

angular.module('apm.components.home').component('updatePasswordAdviceModal', {
  templateUrl: 'app/components/home/modal/apm.home.updatePasswordAdviceModal.component.html',
  controller: UpdatePasswordAdviceModalController,
  bindings: {
    daysForPasswordExpiration: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlanSimpleGridController = function () {

  /** @ngInject */
  function ActionPlanSimpleGridController(apmActionPlanService, PAGE_SIZES, apmActionPlansFactory, scNotificationsFactory) {
    _classCallCheck(this, ActionPlanSimpleGridController);

    _.assign(this, {
      apmActionPlanService: apmActionPlanService,
      PAGE_SIZES: PAGE_SIZES,
      apmActionPlansFactory: apmActionPlansFactory,
      scNotificationsFactory: scNotificationsFactory,

      columnsSort: ['title', 'actionPlanEventType.display', 'statusToDisplay', 'eventDates', 'progress']
    });
  }

  _createClass(ActionPlanSimpleGridController, [{
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        page: this.page,
        '_count': this.pageSize
      }, this._getSortingParam(), { status: 'SCHEDULING,REMINDERS,APPROVED,ENCOUNTERS' });
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'lastUpdated'
      };

      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmActionPlanService.fetchActionPlansPage(this._getApiParams()).then(function (response) {
        return _this._getActionPlansSuccessHandler(response);
      }).catch(function (err) {
        return _this._getActionPlansErrorHandler(err);
      });
    }
  }, {
    key: '_getActionPlansSuccessHandler',
    value: function _getActionPlansSuccessHandler(response) {
      var _this2 = this;

      var actionPlansPage = {
        results: [],
        totalResultCount: 0
      };

      if (_.has(response, 'content')) {
        angular.forEach(response.content, function (actionPlan) {
          _this2._resolveStatus(actionPlan);
          _this2._resolveProgress(actionPlan);
          _this2._resolveEventDates(actionPlan);
          actionPlansPage.results.push(actionPlan);
        }, this);
        actionPlansPage.totalResultCount = response.totalElements;
      }

      return actionPlansPage;
    }
  }, {
    key: '_getActionPlansErrorHandler',
    value: function _getActionPlansErrorHandler(err) {
      var actionPlansPage = {
        results: [],
        totalResultCount: 0
      };
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));

      return actionPlansPage;
    }
  }, {
    key: '_resolveStatus',
    value: function _resolveStatus(actionPlan) {
      actionPlan.statusToDisplay = actionPlan.status.toLowerCase();
    }
  }, {
    key: '_resolveProgress',
    value: function _resolveProgress(actionPlan) {
      actionPlan.progress = this.apmActionPlansFactory.setProgress(actionPlan);
    }
  }, {
    key: '_resolveEventDates',
    value: function _resolveEventDates(actionPlan) {
      actionPlan.eventDates = this.apmActionPlansFactory.setEventDates(actionPlan);
    }
  }]);

  return ActionPlanSimpleGridController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlanSimpleGrid', {
  templateUrl: 'app/components/actionPlans/simpleGrid/apm.actionPlans.simpleGrid.component.html',
  controller: ActionPlanSimpleGridController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderOwnerModalController = function () {

  /** @ngInject */
  function ApmDetailsHeaderOwnerModalController($mdDialog, apmActionPlanService, scNotificationsFactory, scLastNameFirstFilter, ROLES) {
    _classCallCheck(this, ApmDetailsHeaderOwnerModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,
      ROLES: ROLES,

      errorMessage: null,
      lsaRoles: [ROLES.LSA],
      saveEnabled: false,
      saving: false
    });
  }

  _createClass(ApmDetailsHeaderOwnerModalController, [{
    key: '$onInit',
    value: function $onInit() {
      this._fetchActionPlanUsers();
    }
  }, {
    key: 'getMatches',
    value: function getMatches(searchText) {
      searchText = searchText.toLowerCase();
      return _.filter(this.autoCompleteData, function (d) {
        return d.fullName.toLowerCase().indexOf(searchText) === 0;
      });
    }
  }, {
    key: 'saveOwner',
    value: function saveOwner(name) {
      if (name && name.fullName) {
        var currentOwner = _.find(this.autoCompleteData, function (d) {
          return d.fullName === name.fullName;
        });
        this._saveOwnerActionPlan(currentOwner.oid);
      }
    }
  }, {
    key: 'clearOwner',
    value: function clearOwner() {
      this._saveOwnerActionPlan(null);
    }
  }, {
    key: 'getOwnerName',
    value: function getOwnerName() {
      return _.has(this.currentOwner, 'fullName') ? this.currentOwner.fullName : this.currentOwner;
    }
  }, {
    key: 'selectedItemChange',
    value: function selectedItemChange() {
      this.saveEnabled = !!this.selectedOwner;
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: '_fetchActionPlanUsers',
    value: function _fetchActionPlanUsers() {
      var _this = this;

      this.apmActionPlanService.getActionPlanUsers(this.actionPlan._id, this.lsaRoles).then(function (response) {
        return _this._getActionPlanUsersSuccessHandler(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_getActionPlanUsersSuccessHandler',
    value: function _getActionPlanUsersSuccessHandler(response) {
      this.errorMessage = null;
      this._resolveAutocompleteData(response);
      this._setCurrentOwner();
    }
  }, {
    key: '_resolveAutocompleteData',
    value: function _resolveAutocompleteData(data) {
      var _this2 = this;

      this.autoCompleteData = _.map(data.data, function (el) {
        el.fullName = _this2.scLastNameFirstFilter(el.lastName, null, el.firstName);
        return el;
      });
    }
  }, {
    key: '_saveOwnerActionPlan',
    value: function _saveOwnerActionPlan(ownerId) {
      var _this3 = this;

      this.saving = true;
      this.apmActionPlanService.setOwnerActionPlan(this.actionPlan._id, ownerId).then(function (response) {
        return _this3._setOwnerSuccessHandler(response);
      }).catch(function (err) {
        return _this3._errorHandler(err);
      });
    }
  }, {
    key: '_setOwnerSuccessHandler',
    value: function _setOwnerSuccessHandler(response) {
      this.saving = false;
      this.errorMessage = null;
      this.actionPlan.ownerId = response.data.ownerId;
      this.actionPlan.ownerName = response.data.ownerName;
      this.scNotificationsFactory.success('Action Plan updated successfully');

      if (this.onOwner) {
        this.onOwner();
      }

      this.$mdDialog.hide();
    }
  }, {
    key: '_setCurrentOwner',
    value: function _setCurrentOwner() {
      var _this4 = this;

      if (this.actionPlan.ownerId) {
        var owner = _.find(this.autoCompleteData, function (d) {
          return d.oid === _this4.actionPlan.ownerId;
        });
        if (owner) {
          this.currentOwner = owner.fullName;
        }
      }
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.saving = false;
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return ApmDetailsHeaderOwnerModalController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderOwnerModal', {
  templateUrl: 'app/components/actionPlans/owner/apm.owner.ownerModal.component.html',
  controller: ApmDetailsHeaderOwnerModalController,
  bindings: {
    actionPlan: '<',
    onOwner: '&?'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderOwnerModalButtonController = function () {

  /** @ngInject */
  function ApmDetailsHeaderOwnerModalButtonController($mdDialog, $scope, apmActionPlansFactory) {
    _classCallCheck(this, ApmDetailsHeaderOwnerModalButtonController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      apmActionPlansFactory: apmActionPlansFactory
    });
  }

  _createClass(ApmDetailsHeaderOwnerModalButtonController, [{
    key: 'showOwnerModal',
    value: function showOwnerModal() {
      var scope = angular.extend(this.$scope.$new(true), {
        actionPlan: this.actionPlan,
        onOwner: this.onOwner
      });

      var template = this.onOwner ? '<md-dialog aria-label="modal" class="message-content header-owner-modal"><apm-details-header-owner-modal action-plan="actionPlan" on-owner="onOwner()" /></md-dialog>' : '<md-dialog aria-label="modal" class="message-content header-owner-modal"><apm-details-header-owner-modal action-plan="actionPlan"/></md-dialog>';

      this.$mdDialog.show({
        template: template,
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: 'isStatusEditable',
    value: function isStatusEditable() {
      return this.apmActionPlansFactory.isLimitedEdit(this.actionPlan, true);
    }
  }]);

  return ApmDetailsHeaderOwnerModalButtonController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderOwnerModalButton', {
  templateUrl: 'app/components/actionPlans/owner/apm.owner.ownerModal.button.component.html',
  controller: ApmDetailsHeaderOwnerModalButtonController,
  bindings: {
    actionPlan: '<',
    onOwner: '&?'
  }

});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlanListController = function () {
  function ActionPlanListController() {
    _classCallCheck(this, ActionPlanListController);
  }

  _createClass(ActionPlanListController, [{
    key: '$onInit',
    value: function $onInit() {
      // hack for IE flex display: table fix
      angular.element('body').addClass('action-plan-list');
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      angular.element('body').removeClass('action-plan-list');
    }
  }]);

  return ActionPlanListController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlanList', {
  templateUrl: 'app/components/actionPlans/list/apm.actionPlans.list.component.html',
  controller: ActionPlanListController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlansGridController = function () {
  function ActionPlansGridController($mdDialog, $state, $window, apmActionPlanService, apmAuthenticationService, apmActionPlansFactory, scNotificationsFactory, scLastNameFirstFilter, PAGE_SIZES) {
    _classCallCheck(this, ActionPlansGridController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $state: $state,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      apmAuthenticationService: apmAuthenticationService,
      apmActionPlansFactory: apmActionPlansFactory,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,
      PAGE_SIZES: PAGE_SIZES,

      columnsSort: ['title', 'actionPlanEventType.display', 'population.groupCharacteristic.name', 'status', 'eventDates', 'progress'],
      columnsToDisplay: ['title', 'actionPlanEventType.display', 'population.groupCharacteristic.name', 'statusToDisplay', 'eventDates', 'progress', '_id', '_apOwnerId', '_cloneId'],
      filter: {},
      hasEditAccess: false,
      hasReportAccess: false,
      searchAssigneeText: '',
      searchOwnerText: '',
      statuses: [],

      loadPageCallback: function loadPageCallback() {}
    });
  }

  _createClass(ActionPlansGridController, [{
    key: '$onInit',
    value: function $onInit() {
      this._initializeFilter();
      this._getAutoCompleteData();
      this.statuses = this.apmActionPlansFactory.getStatuses();
      this.hasEditAccess = this.apmAuthenticationService.hasAccess('scAPAdmin');
      this.hasCloneAccess = this.apmAuthenticationService.hasAccess('scAPWorkflowCreate');
      this.hasReportAccess = this.apmAuthenticationService.hasAccess('scAPReport');

      if (!this.hasEditAccess || !this.hasCloneAccess) {
        this.columnsToDisplay = _.without(this.columnsToDisplay, '_cloneId');
      }
    }
  }, {
    key: '_getAutoCompleteData',
    value: function _getAutoCompleteData() {
      var _this = this;

      this._fetchAssigneeAutoCompleteData().then(function (data) {
        return _this._assigneeAutoCompleteHandler(data);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });

      this._fetchOwnerAutoCompleteData().then(function (data) {
        return _this._ownerAutoCompleteHandler(data);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: 'goToDetails',
    value: function goToDetails(event, id) {
      if (!this.hasReportAccess) {
        var ap = this.findActionPlan(id);
        if (ap.status === 'COMPLETED') {
          this.scNotificationsFactory.custom('You do not have permissions to view the Report for this Action Plan.', 'error');
          event.preventDefault();
        }
      }
    }
  }, {
    key: 'goToEdit',
    value: function goToEdit(id) {
      this.$window.sessionStorage.setItem('selectedActionPlan', angular.toJson({ id: id, action: 'edit' }));
      this.$state.go('actionPlans.createEdit');
    }
  }, {
    key: 'goToClone',
    value: function goToClone(id) {
      if (this.hasEditAccess) {
        this.$window.sessionStorage.setItem('selectedActionPlan', angular.toJson({ id: id, action: 'clone' }));
        this.$state.go('actionPlans.createEdit');
      }
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this._initializeFilter();
      this.submitFilter();
    }
  }, {
    key: 'submitFilter',
    value: function submitFilter() {
      this.loadPageCallback(1);
    }
  }, {
    key: 'fetchPage',
    value: function fetchPage(page, pageSize, options) {
      var _this2 = this;

      this.page = page;
      this.pageSize = pageSize;
      this.sorting = options.columnSort;

      return this.apmActionPlanService.fetchActionPlansPage(this._getApiParams()).then(function (response) {
        return _this2._getActionPlansSuccessHandler(response);
      }).catch(function (err) {
        return _this2._getActionPlansErrorHandler(err);
      });
    }
  }, {
    key: 'getLoadResultsCallback',
    value: function getLoadResultsCallback(loadPageCallback) {
      this.loadPageCallback = loadPageCallback;
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty() {
      return this.apmActionPlansFactory.isFilterEmpty(this.filter);
    }
  }, {
    key: 'getAssigneeMatches',
    value: function getAssigneeMatches(searchText) {
      searchText = searchText.toLowerCase();
      return _.filter(this.assigneeAutoCompleteData, function (d) {
        return d.lName ? d.lName.toLowerCase().indexOf(searchText) === 0 : '' || d.fName ? d.fName.toLowerCase().indexOf(searchText) === 0 : '';
      });
    }
  }, {
    key: 'getOwnerMatches',
    value: function getOwnerMatches(searchText) {
      searchText = searchText.toLowerCase();
      return _.filter(this.ownerAutoCompleteData, function (d) {
        return d.lName ? d.lName.toLowerCase().indexOf(searchText) === 0 : '' || d.fName ? d.fName.toLowerCase().indexOf(searchText) === 0 : '';
      });
    }
  }, {
    key: 'findActionPlan',
    value: function findActionPlan(id) {
      return _.find(this.actionPlans, function (el) {
        return el._id === id;
      });
    }
  }, {
    key: 'setAssigneeName',
    value: function setAssigneeName(name) {
      var _this3 = this;

      if (name) {
        this.selectedAssignee = _.find(this.assigneeAutoCompleteData, function (aName) {
          return _this3._getUserDisplayName(aName) === _this3._getUserDisplayName(name);
        });
        if (this.selectedAssignee) {
          this.selectedAssigneeId = this.selectedAssignee._id;
          this.filter.assigneeId = this.selectedAssigneeId;
        } else {
          this.scNotificationsFactory.custom('Name must be in assignees list', 'error');
        }
      }
    }
  }, {
    key: 'setOwnerName',
    value: function setOwnerName(name) {
      var _this4 = this;

      if (name) {
        this.selectedOwner = _.find(this.ownerAutoCompleteData, function (aName) {
          return _this4._getUserDisplayName(aName) === _this4._getUserDisplayName(name);
        });
        if (this.selectedOwner) {
          this.selectedOwnerId = this.selectedOwner._id;
          this.filter.ownerId = this.selectedOwnerId;
        } else {
          this.scNotificationsFactory.custom('Name must be in owner list', 'error');
        }
      }
    }
  }, {
    key: 'isStatusEditable',
    value: function isStatusEditable(id) {
      var actionPlan = this.findActionPlan(id);
      return this.apmActionPlansFactory.isLimitedEdit(actionPlan, true);
    }
  }, {
    key: 'onAssigneeCallback',
    value: function onAssigneeCallback() {
      var _this5 = this;

      this._fetchAssigneeAutoCompleteData().then(function (data) {
        return _this5._assigneeAutoCompleteHandler(data);
      }).catch(function (err) {
        return _this5._errorHandler(err);
      });
    }
  }, {
    key: 'onOwnerCallback',
    value: function onOwnerCallback() {
      var _this6 = this;

      this._fetchOwnerAutoCompleteData().then(function (data) {
        return _this6._ownerAutoCompleteHandler(data);
      }).catch(function (err) {
        return _this6._errorHandler(err);
      });
    }
  }, {
    key: '_fetchAssigneeAutoCompleteData',
    value: function _fetchAssigneeAutoCompleteData() {
      return this.apmActionPlanService.fetchActionPlanUsers({ assignedActionPlan: true });
    }
  }, {
    key: '_fetchOwnerAutoCompleteData',
    value: function _fetchOwnerAutoCompleteData() {
      return this.apmActionPlanService.fetchActionPlanUsers({ ownsActionPlan: true });
    }
  }, {
    key: '_getActionPlansSuccessHandler',
    value: function _getActionPlansSuccessHandler(response) {
      var _this7 = this;

      var actionPlansPage = {
        results: [],
        totalResultCount: 0
      };

      if (_.has(response, 'content')) {
        var responseData = response;
        this.actionPlans = response.content;
        _.forEach(responseData.content, function (actionPlan) {
          _this7._resolveGroupCharacteristic(actionPlan);
          _this7._resolveStatus(actionPlan);
          _this7._resolveProgress(actionPlan);
          _this7._resolveEventDates(actionPlan);
          _this7._resolveExtraIds(actionPlan);
          actionPlansPage.results.push(actionPlan);
        }, this);
        actionPlansPage.totalResultCount = responseData.totalElements;
      }

      return actionPlansPage;
    }
  }, {
    key: '_getActionPlansErrorHandler',
    value: function _getActionPlansErrorHandler(err) {
      var actionPlansPage = {
        results: [],
        totalResultCount: 0
      };

      this._errorHandler(err);
      return actionPlansPage;
    }
  }, {
    key: '_getApiParams',
    value: function _getApiParams() {
      return _.assign({
        page: this.page,
        '_count': this.pageSize
      }, this._getSortingParam(), this._getFilterParam());
    }
  }, {
    key: '_getFilterParam',
    value: function _getFilterParam() {
      return this.apmActionPlansFactory.resolveFilters(this.filter);
    }
  }, {
    key: '_getSortingParam',
    value: function _getSortingParam() {
      var sorting = {
        '_sort:desc': 'lastUpdated'
      };

      var columnSortMapping = this.columnsSort;

      _.forEach(this.sorting, function (value, index) {
        if (value.sort !== false) {
          sorting = {};
          sorting['_sort:' + value.sort] = columnSortMapping[index];

          return false;
        }
      });

      return sorting;
    }
  }, {
    key: '_initializeFilter',
    value: function _initializeFilter() {
      this.filter = {};
    }
  }, {
    key: '_resolveEventDates',
    value: function _resolveEventDates(actionPlan) {
      actionPlan.eventDates = this.apmActionPlansFactory.setEventDates(actionPlan);
    }
  }, {
    key: '_resolveGroupCharacteristic',
    value: function _resolveGroupCharacteristic(actionPlan) {

      var groupCharacteristic = actionPlan.population.groupCharacteristic;

      if (groupCharacteristic.length === 0) {
        return;
      }

      var newGroupCharacteristic = {};

      var thisGroupCharacteristicType = groupCharacteristic[0].type;

      if (thisGroupCharacteristicType === 'clinic') {
        newGroupCharacteristic.name = 'Multiple Clinics';
      }

      if (thisGroupCharacteristicType === 'practitioner') {
        newGroupCharacteristic.name = 'Multiple Providers';
      }

      if (groupCharacteristic.length === 1) {
        newGroupCharacteristic.name = groupCharacteristic[0].name;
      }

      if (thisGroupCharacteristicType !== 'practitioner' && thisGroupCharacteristicType !== 'clinic') {
        newGroupCharacteristic.name = 'N/A';
      }

      actionPlan.population.groupCharacteristic = newGroupCharacteristic;
    }
  }, {
    key: '_resolveProgress',
    value: function _resolveProgress(actionPlan) {
      actionPlan.progress = this.apmActionPlansFactory.setProgress(actionPlan);
    }
  }, {
    key: '_resolveStatus',
    value: function _resolveStatus(actionPlan) {
      actionPlan.statusToDisplay = actionPlan.status === 'ON_HOLD' ? 'On Hold' : actionPlan.status.toLowerCase();
    }
  }, {
    key: '_resolveExtraIds',
    value: function _resolveExtraIds(actionPlan) {
      actionPlan._cloneId = actionPlan._id;
      actionPlan._apOwnerId = actionPlan._id;
    }
  }, {
    key: '_assigneeAutoCompleteHandler',
    value: function _assigneeAutoCompleteHandler(data) {
      this.assigneeAutoCompleteData = data.content;
    }
  }, {
    key: '_ownerAutoCompleteHandler',
    value: function _ownerAutoCompleteHandler(data) {
      this.ownerAutoCompleteData = data.content;
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_getUserDisplayName',
    value: function _getUserDisplayName(user) {
      if (!user) {
        return '';
      }
      return this.scLastNameFirstFilter(user.lName, user.mName, user.fName, null, null);
    }
  }]);

  return ActionPlansGridController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlansGrid', {
  templateUrl: 'app/components/actionPlans/grid/apm.actionPlans.grid.component.html',
  controller: ActionPlansGridController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsController = function () {

  /** @ngInject */
  function ApmDetailsController($scope, $state, $stateParams, apmActionPlanService, scNotificationsFactory) {
    _classCallCheck(this, ApmDetailsController);

    _.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,

      actionPlan: null,
      actionPlanStatus: {},
      hideIneligiblePatients: true
    });
  }

  _createClass(ApmDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      this._fetchActionPlan();
      this._setHideIneligiblePatientWatch();
    }
  }, {
    key: '_setHideIneligiblePatientWatch',
    value: function _setHideIneligiblePatientWatch() {
      var _this = this;

      this.$scope.$on('hideIneligiblePatientsChanged', function (event, value) {
        _this.hideIneligiblePatients = value;
      });
    }
  }, {
    key: '_fetchActionPlan',
    value: function _fetchActionPlan() {
      var _this2 = this;

      this.apmActionPlanService.getActionPlanConfig(this.$stateParams.id).then(function (response) {
        return _this2._fetchActionPlanSuccessHandler(response);
      }).catch(function (err) {
        return _this2._fetchActionPlanErrorHandler(err);
      });
    }
  }, {
    key: '_fetchActionPlanSuccessHandler',
    value: function _fetchActionPlanSuccessHandler(response) {
      var actionPlan = response.actionPlanConfiguration;
      if (actionPlan.status === 'COMPLETED') {
        this.$state.go('reports.actionPlans', { actionPlan: actionPlan, id: actionPlan._id });
      } else {
        this.actionPlan = actionPlan;
        this.actionPlanContext = response;
      }
    }
  }, {
    key: '_fetchActionPlanErrorHandler',
    value: function _fetchActionPlanErrorHandler(err) {
      this.actionPlan = {};
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }]);

  return ApmDetailsController;
}();

angular.module('apm.components.actionPlans').component('apmDetails', {
  templateUrl: 'app/components/actionPlans/details/apm.details.component.html',
  controller: ApmDetailsController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateActionPlanModalController = function () {

  /** @ngInject */
  function CreateActionPlanModalController($mdDialog, $scope, $window, apmActionPlanService, apmActionPlansFactory, scNotificationsFactory, reverseDateFormatFilterFilter, ROLES) {
    _classCallCheck(this, CreateActionPlanModalController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      apmActionPlansFactory: apmActionPlansFactory,
      scNotificationsFactory: scNotificationsFactory,
      reverseDateFormatFilterFilter: reverseDateFormatFilterFilter,
      ROLES: ROLES,

      actionPlan: {},
      displayDate: '',
      errorMessage: null,
      eventTypeData: [],
      isLoad: false,
      ma: '',
      maList: [],
      maListStatus: 'loading',
      maPlaceholder: '',
      np: '',
      npList: [],
      npListStatus: 'loading',
      npPlaceholder: '',
      onLoadResources: [],
      plannedMAs: [],
      plannedNPs: [],
      templateConfig: {}
    });
  }

  _createClass(CreateActionPlanModalController, [{
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      if (_.has(changesObj, 'date.currentValue._d')) {
        this.displayDate = moment(this.date).format('MM/DD/YYYY');
        this.actionPlan = angular.fromJson(this.$window.sessionStorage.getItem('actionPlan'));
        this.actionPlanClone = angular.fromJson(this.$window.sessionStorage.getItem('actionPlanClone'));
        this.templateConfig = angular.fromJson(this.$window.sessionStorage.getItem('templateConfig'));
        if (this.actionPlan.template !== 'SCH') {
          this._getEventTypeData();
          this._getResources();
        }
      }
    }
  }, {
    key: 'setEventType',
    value: function setEventType(value) {
      if (!_.isUndefined(value)) {
        this.actionPlan.actionPlanEventType = {
          display: _.find(this.eventTypeData, { code: value }).display
        };
      }
    }
  }, {
    key: 'setResource',
    value: function setResource(resource, type) {
      if (type === 'ma') {
        this.plannedMAs = resource;
      } else {
        this.plannedNPs = resource;
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'save',
    value: function save() {
      if (this._isDataDirty() && this.actionPlan.template !== 'SCH') {
        this.actionPlan.plannedResources = _.union(this.plannedMAs, this.plannedNPs);
        this._updateActionPlan();
      } else if (this.actionPlan.template === 'SCH') {
        this.actionPlan.actionPlanEventType = {
          value: 'EMBEDDED_RESOURCE_SCHEDULING',
          display: 'Embedded resource Scheduling'
        };
        this._setDates();
        this._updateActionPlan();
      } else {
        this.$mdDialog.cancel();
      }
    }
  }, {
    key: '_setDates',
    value: function _setDates() {
      this.actionPlan.eventDates.length = 0;
      this.actionPlan.eventDates.push(moment(this.date).format('YYYY-MM-DD'));
    }
  }, {
    key: '_isDataDirty',
    value: function _isDataDirty() {
      return this.$scope.createActionPlan.$dirty || !this.actionPlan.eventDates.length && this.date || this.actionPlan.eventDates && this.actionPlan.eventDates.length && moment(this.date).format('YYYY-MM-DD') !== moment(this.actionPlan.eventDates[0]).format('YYYY-MM-DD');
    }
  }, {
    key: '_updateActionPlan',
    value: function _updateActionPlan() {
      var _this = this;

      this.templateConfig.actionPlanConfiguration = this.actionPlan;
      this.templateConfig.editOnly = true;

      this.apmActionPlanService.saveActionPlanConfig(this.templateConfig, 'putActionPlanConfig').then(function (response) {
        return _this._updateActionPlanSuccess(response);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: '_updateActionPlanSuccess',
    value: function _updateActionPlanSuccess(response) {
      var actionPlan = void 0;
      this.errorMessage = null;
      if (_.has(response, 'actionPlanConfiguration')) {
        actionPlan = response.actionPlanConfiguration;
      }
      var message = this.actionPlan.template !== 'SCH' ? 'Event Date and Population successfully updated.' : 'Event Date successfully updated.';
      this._resetListStatus();
      this.scNotificationsFactory.success(message);
      this.apmActionPlanService.setActionPlanTitle('Action Plan Details for ' + actionPlan.title + ' - ' + this.reverseDateFormatFilterFilter(actionPlan.eventDates[0]));
      this.$mdDialog.hide(response);
    }
  }, {
    key: '_getEventTypeData',
    value: function _getEventTypeData() {
      var _this2 = this;

      this.apmActionPlanService.getValueSetGroup('sc-actionplan-message-group', 'event').then(function (response) {
        return _this2._getEventTypeSuccess(response);
      }).catch(function (err) {
        return _this2._errorHandler(err);
      });
    }
  }, {
    key: '_getEventTypeSuccess',
    value: function _getEventTypeSuccess(response) {
      if (_.has(response, 'data')) {
        this.eventTypeData = response.data;
        if (this.actionPlanClone && _.has(this.actionPlanClone, 'actionPlanEventType.value')) {
          this.actionPlan.actionPlanEventType = {
            value: this.actionPlanClone.actionPlanEventType.value
          };
        }
      }
    }
  }, {
    key: '_getResources',
    value: function _getResources() {
      var _this3 = this;

      this.apmActionPlanService.getActionPlanCalendar(moment(this.date).format('YYYY-MM-DD'), moment(this.date).format('YYYY-MM-DD')).then(function (response) {
        return _this3._getCalendarSuccess(response);
      }).catch(function (err) {
        return _this3._errorHandler(err);
      });
    }
  }, {
    key: '_getCalendarSuccess',
    value: function _getCalendarSuccess(response) {
      var _this4 = this;

      if (angular.isArray(response) && response.length && _.has(response[0], 'availableResources') && response[0].availableResources.length) {
        this.maList = _.map(response[0].availableResources, function (el) {
          if (el.roleName === _this4.ROLES.PSU) {
            return el;
          }
        }).filter(Boolean);

        this.npList = _.map(response[0].availableResources, function (el) {
          if (el.roleName === _this4.ROLES.NP) {
            return el;
          }
        }).filter(Boolean);
      }
      this._setOnLoadResources();
      this._setDates();
    }
  }, {
    key: '_setOnLoadResources',
    value: function _setOnLoadResources() {
      var _this5 = this;

      if (this.actionPlan.eventDates.length && moment(this.date).format('YYYY-MM-DD') === this.actionPlan.eventDates[0]) {
        _.forEach(this.actionPlan.plannedResources, function (el) {
          el.checked = true;
          el.resourceName = el.name;
          el.id = el.oid;
          if (el.roleName === _this5.ROLES.PSU) {
            _this5.maList.push(el);
          }
          if (el.roleName === _this5.ROLES.NP) {
            _this5.npList.push(el);
          }
        });
      }

      this.maListStatus = _.isEmpty(this.maList) ? 'no-resources' : 'ready';
      this.maPlaceholder = _.get(_.first(this.maList), 'roleDescription', 'resource');
      this.npListStatus = _.isEmpty(this.npList) ? 'no-resources' : 'ready';
      this.npPlaceholder = _.get(_.first(this.npList), 'roleDescription', 'resource');
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this._resetListStatus();
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }, {
    key: '_resetListStatus',
    value: function _resetListStatus() {
      this.maListStatus = 'no-resources';
      this.npListStatus = 'no-resources';
    }
  }]);

  return CreateActionPlanModalController;
}();

angular.module('apm.components.actionPlans').component('createActionPlanModal', {
  templateUrl: 'app/components/actionPlans/createEdit/apm.actionPlans.createModal.html',
  controller: CreateActionPlanModalController,
  bindings: {
    date: '<',
    isLimitedEdit: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmActionPlanCreateEditController = function () {

  /** @ngInject */
  function ApmActionPlanCreateEditController($compile, $element, $mdDialog, $rootScope, $scope, $state, $timeout, $window, apmActionPlanService, apmAuthenticationService, apmActionPlansFactory, scNotificationsFactory, ROLES) {
    _classCallCheck(this, ApmActionPlanCreateEditController);

    _.assign(this, {
      $compile: $compile,
      $element: $element,
      $mdDialog: $mdDialog,
      $rootScope: $rootScope,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      $window: $window,
      apmActionPlanService: apmActionPlanService,
      apmAuthenticationService: apmAuthenticationService,
      apmActionPlansFactory: apmActionPlansFactory,
      scNotificationsFactory: scNotificationsFactory,
      ROLES: ROLES,

      actionPlan: {},
      availableResources: [],
      availableResourcesRaw: [],
      calendarConfig: {},
      calendarCurrentDayCount: 0,
      calendarCurrentStartDay: {},
      calendarData: [[]],
      calendarDataRaw: [],
      exclusions: {
        excludeUser: '',
        excludeRole: ''
      },
      isLimitedEdit: false,
      isLoading: false,
      refreshAvailableResources: true,
      resourcesRendered: {},
      selectedIndex: 0,
      setEventSuccess: false,
      templateConfig: {},
      title: ''
    });
  }

  _createClass(ApmActionPlanCreateEditController, [{
    key: '$onInit',
    value: function $onInit() {
      if (this.apmAuthenticationService.hasAccess('scAPAdmin')) {
        this.actionPlan = angular.fromJson(this.$window.sessionStorage.getItem('actionPlan'));
        this.templateConfig = angular.fromJson(this.$window.sessionStorage.getItem('templateConfig'));
        this._setWatches();
        this._setEventCheckMark();
      } else {
        this.$state.go('home');
      }
    }
  }, {
    key: 'next',
    value: function next() {
      this.$rootScope.selectedIndex = 2;
    }
  }, {
    key: 'back',
    value: function back() {
      this.$rootScope.selectedIndex = 0;
    }
  }, {
    key: 'goToPreviousPage',
    value: function goToPreviousPage() {
      this.$window.history.back();
    }
  }, {
    key: 'onCheckboxFilter',
    value: function onCheckboxFilter(availableResources) {
      this.refreshAvailableResources = false;
      this.exclusions = this._extractAvailableResourcesExclusions(availableResources);
      this.resourcesState = this._extractCheckboxesState();
      this.resourcesRendered = false;
      this._getCalendar(this.calendarCurrentStartDay, this.calendarCurrentDayCount, this.exclusions.excludeUser, this.exclusions.excludeRole);
    }
  }, {
    key: '_extractAvailableResourcesExclusions',
    value: function _extractAvailableResourcesExclusions(availableResources) {
      var exclusions = {
        excludeUser: [],
        excludeRole: []
      };

      _.forEach(availableResources, function (availableResources_value) {
        if (_.has(availableResources_value, 'children') && availableResources_value.children.length) {
          var thisUnchecked = _.pluck(_.filter(availableResources_value.children, { checked: false }), 'id');
          if (thisUnchecked.length === availableResources_value.children.length) {
            exclusions.excludeRole.push(availableResources_value.id);
          } else {
            exclusions.excludeUser.push(thisUnchecked);
          }
        }
      });
      exclusions.excludeUser = _.flatten(exclusions.excludeUser).join(',');
      exclusions.excludeRole = _.flatten(exclusions.excludeRole).join(',');

      return exclusions;
    }
  }, {
    key: '_extractCheckboxesState',
    value: function _extractCheckboxesState() {
      return _.map(this.availableResources, function (role) {
        return {
          id: _.get(role, 'id'),
          name: _.get(role, 'name'),
          checked: _.get(role, 'checked'),
          children: _.map(role.children, function (user) {
            return _.pick(user, 'id', 'name', 'initial', 'role', 'checked');
          })
        };
      });
    }
  }, {
    key: '_setWatches',
    value: function _setWatches() {
      var _this = this;

      this.$rootScope.selectedIndex = 0;
      this.$rootScope.$watch('selectedIndex', function (current, previous) {
        if (current !== previous) {
          _this.selectedIndex = current;
          if (_this.selectedIndex === 1) {
            _this.isLoading = true;
            _this.actionPlan = angular.fromJson(_this.$window.sessionStorage.getItem('actionPlan'));
            _this.templateConfig = angular.fromJson(_this.$window.sessionStorage.getItem('templateConfig'));
            _this.actionPlan.template = _this.templateConfig.template;
            _this._generateAvailableResources();
            _this.isLimitedEdit = _this.apmActionPlansFactory.isLimitedEdit(_this.actionPlan);
            _this._setCalendarView();
            if (_.isFunction(_this.calendarConfig.viewRender)) {
              _this.isLoading = false;
            }
          }
        }
      });
    }
  }, {
    key: '_setEventCheckMark',
    value: function _setEventCheckMark() {
      var _this2 = this;

      this.$timeout(function () {
        _this2.actionPlan = angular.fromJson(_this2.$window.sessionStorage.getItem('actionPlan'));
        if (_this2.actionPlan && _this2.actionPlan.eventDates && _this2.actionPlan.eventDates.length) {
          angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(2)').addClass('md-step-complete');
        } else {
          angular.element('apm-action-plan-create-edit .md-tab:nth-of-type(2)').removeClass('md-step-complete');
        }
      }, 500);
    }
  }, {
    key: '_setCalendarView',
    value: function _setCalendarView() {
      var _this3 = this;

      this.$timeout(function () {
        _this3.calendarConfig = {
          eventOrder: '-title',
          header: {
            right: 'agendaWeek month',
            left: 'prev, title, next'
          },
          views: {
            month: {
              eventLimit: 1,
              eventLimitText: 'Events'
            }
          },
          viewRender: function viewRender(view) {
            return _this3._viewRender(view);
          },
          eventAfterAllRender: function eventAfterAllRender(view) {
            return _this3._eventAfterAllRender(view);
          },
          dayClick: function dayClick(date) {
            return _this3._dayClick(date);
          }
        };
      }, 500);
    }
  }, {
    key: '_dayClick',
    value: function _dayClick(date) {
      var _this4 = this;

      var momentDate = moment(date);

      if (momentDate.isoWeekday() >= 6 || momentDate.isBefore(moment().subtract(1, 'days')) || !this._hasResourcesAvailable(momentDate)) {
        return false;
      }
      var scope = angular.extend(this.$scope.$new(true), {
        date: date,
        isLimitedEdit: this.isLimitedEdit
      });
      this._toggleClickDateHighlight(momentDate, true);
      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal"><create-action-plan-modal class="create-modal" date="date" is-limited-edit="isLimitedEdit"/></md-dialog>',
        scope: scope,
        clickOutsideToClose: true,
        onRemoving: function onRemoving() {
          _this4._toggleClickDateHighlight(momentDate, false);
        }
      }).then(function (response) {
        return _this4._setEventSuccess(response);
      });
    }
  }, {
    key: '_setEventSuccess',
    value: function _setEventSuccess(response) {
      var actionPlan = void 0;

      if (_.has(response, 'actionPlanConfiguration')) {
        actionPlan = response.actionPlanConfiguration;
      }
      this.startDate = actionPlan.eventDates && actionPlan.eventDates.length ? actionPlan.eventDates[0] : '';
      this.setEventSuccess = true;
      this.$window.sessionStorage.setItem('actionPlan', angular.toJson(actionPlan));
      delete response.actionPlanConfiguration;
      this.$window.sessionStorage.setItem('templateConfig', angular.toJson(response));
      this.actionPlan = angular.fromJson(this.$window.sessionStorage.getItem('actionPlan'));
      this.calendarConfig.viewRender();
      this._setEventCheckMark();
    }
  }, {
    key: '_toggleClickDateHighlight',
    value: function _toggleClickDateHighlight(date, selected) {
      var thisFcCell = this.$element.find('.fc-bg .fc-day[data-date=\'' + date.format('YYYY-MM-DD') + '\']');

      if (thisFcCell) {
        thisFcCell.toggleClass('fc-selected', selected);
      }

      return true;
    }
  }, {
    key: '_eventAfterAllRender',
    value: function _eventAfterAllRender(view) {
      if ((view.type === 'month' || view.type === 'agendaWeek') && this.calendarDataRaw.length && this.calendarDataRaw !== this.resourcesRendered) {
        this.resourcesRendered = this.calendarDataRaw;
        this._generateAvailableResources();
      }
    }
  }, {
    key: '_viewRender',
    value: function _viewRender() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: 'month' };

      var dayCount = void 0;

      if (view.start && view.start._d && view.type !== 'agendaWeek') {
        this.title = view.title;
      }

      if (view.type === 'month') {
        dayCount = 30;
        this.calendarCurrentStartDay = moment(new Date(this.title.replace(/ /g, ' 1 '))).format();
      } else if (view.type === 'agendaWeek') {
        this.calendarCurrentStartDay = moment(new Date(view.start._d)).format();
        angular.element('.main-container').animate({ scrollTop: 0 }, 200);
        dayCount = 8;
      }

      this.refreshAvailableResources = true;
      this.calendarCurrentDayCount = dayCount;
      this._getCalendar(this.calendarCurrentStartDay, this.calendarCurrentDayCount, this.exclusions.excludeUser, this.exclusions.excludeRole);
      this._setDisabledPrev(this.calendarCurrentStartDay);
    }
  }, {
    key: '_setDisabledPrev',
    value: function _setDisabledPrev(date) {
      var $prevButton = this.$element.find('.fc-prev-button');

      if (moment(new Date(date)).isBefore(moment(new Date('2017-01-01')))) {
        $prevButton.attr('disabled', 'disabled');
      } else {
        $prevButton.removeAttr('disabled');
      }
    }
  }, {
    key: '_generateAvailableResources',
    value: function _generateAvailableResources() {
      var _this5 = this;

      var roleColors = {};
      roleColors[this.ROLES.PSU] = '#9012fe';
      roleColors[this.ROLES.NP] = '#4990e2';
      var thisCalendar = this.$element.find('#calendar');

      this._clearResources();
      _.forEach(this.calendarDataRaw, function (calendarDataRaw_value) {
        var thisDate = calendarDataRaw_value.date;
        var thisDateCell = thisCalendar.find('.fc-day[data-date="' + thisDate + '"]');
        var thisDateNumberCell = thisCalendar.find('.fc-day-number[data-date="' + thisDate + '"]');
        var thisAvailableResourcesCell = void 0;

        if (thisDateCell.length) {
          if (calendarDataRaw_value.availableResources.length) {
            _this5._setAvailableResourcesClasses(thisDateNumberCell, thisDateCell);
            thisAvailableResourcesCell = thisDateCell.find('.available-resources');
            _.forEach(calendarDataRaw_value.availableResources, function (availableResources_value, availableResources_key) {
              if (availableResources_key === 3) {
                return false;
              }

              if (moment(thisDate).isSameOrAfter(moment(), 'day')) {
                _this5._generateSingleResource(thisAvailableResourcesCell, availableResources_value, availableResources_key, roleColors);
              }
            });
            if (calendarDataRaw_value.availableResources.length > 3) {
              thisAvailableResourcesCell.append('<div class="resources-more"></div>');
            }
            _this5.$compile(thisAvailableResourcesCell.find('div[tooltips]'))(_this5.$scope);
          } else {
            thisDateNumberCell = thisCalendar.find('.fc-day-number[data-date="' + thisDate + '"]');
            if (thisDateNumberCell.length) {
              thisDateNumberCell.addClass('no-resources');
            }
          }
        }

        if (calendarDataRaw_value.availableResources.length) {
          _this5._setAvailableResourcesRaw(calendarDataRaw_value.availableResources);
        }
      });
      this._setCalendarRowHeight(thisCalendar);
      if (this.refreshAvailableResources) {
        this._mergePreviousResourcesState(this._extractAvailableResources());
        this.availableResourcesRaw = [];
      }
    }
  }, {
    key: '_extractAvailableResources',
    value: function _extractAvailableResources() {
      this.refreshAvailableResources = false;

      var availableResources = [];
      if (this.availableResourcesRaw.length) {
        var roles = _.groupBy(this.availableResourcesRaw, 'roleName');

        _.forIn(roles, function (roles_value, roles_key) {
          availableResources.push({
            name: _.get(_.first(roles_value), 'roleDescription') + ' Calendar',
            id: roles_key,
            checked: true,
            children: _.sortBy(_.uniq(roles_value, 'id'), 'name')
          });
        });
      }
      return availableResources;
    }
  }, {
    key: '_mergePreviousResourcesState',
    value: function _mergePreviousResourcesState(availableResources) {
      _.forEach(this.resourcesState, function (role) {
        var existingRole = _.find(availableResources, { id: role.id });
        if (existingRole) {
          if (role.children) {
            _.forEach(role.children, function (user) {
              var existingUser = _.find(existingRole.children, { id: user.id });
              if (!existingUser) {
                existingRole.children.push(user);
              }
            });
            existingRole.children = _.sortBy(existingRole.children, 'name');
          }
        } else {
          availableResources.push(role);
        }
      });

      this.availableResources = _.sortBy(availableResources, 'id');
    }
  }, {
    key: '_generateSingleResource',
    value: function _generateSingleResource(cell, value, key, colors) {
      if (this.actionPlan.template === 'SCH') {
        return;
      }
      cell.append('<div class="single-resource"\n                      style="z-index: ' + (key + 300) + '; left: ' + (key * 16 + 8) + 'px; background-color: ' + colors[value.roleName] + ';"\n                      data-resource-id="' + value.id + '">\n                   <span class="tooltip-top" data-tooltip="' + value.resourceName + '">' + value.initial + '</span>\n                 </div>');
    }
  }, {
    key: '_getCalendar',
    value: function _getCalendar(startDate) {
      var dayCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _this6 = this;

      var excludeUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var excludeRole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this.isLoading = true;
      this.apmActionPlanService.getActionPlanCalendar(moment(startDate).format('YYYY-MM-DD'), moment(startDate).add(dayCount, 'days').format('YYYY-MM-DD'), excludeUser, excludeRole).then(function (res) {
        return _this6._getCalendarSuccess(res);
      }).catch(function (err) {
        return _this6._getCalendarError(err);
      });
    }
  }, {
    key: '_getCalendarSuccess',
    value: function _getCalendarSuccess(res) {
      var _this7 = this;

      this.calendarData[0] = [];

      if (!_.isEmpty(res)) {
        this.calendarDataRaw = res;
        _.forEach(res, function (el) {
          if (el.date && !_.isEmpty(el.actionPlans)) {
            _.forEach(el.actionPlans, function (elem) {
              _this7.calendarData[0].push(_this7._generateCalendarData(el, elem));
            });
          }
        });
      }
      this.isLoading = false;
    }
  }, {
    key: '_getCalendarError',
    value: function _getCalendarError(err) {
      this.isLoading = false;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_generateCalendarData',
    value: function _generateCalendarData(dayData, actionPlanData) {
      return {
        start: dayData.date,
        title: actionPlanData.actionPlanTitle,
        id: actionPlanData.id,
        color: actionPlanData.id === this.actionPlan._id ? '#e7c03b' : '#d7d7d7',
        textColor: '#515050',
        className: actionPlanData.id === this.actionPlan._id ? 'create-screen active' : 'create-screen'
      };
    }
  }, {
    key: '_setAvailableResourcesClasses',
    value: function _setAvailableResourcesClasses(thisDateNumberCell, thisDateCell) {
      if (this.actionPlan && this.actionPlan.eventDates && this.actionPlan.eventDates.length && this.actionPlan.eventDates[0]) {
        this.$element.find('.fc-bg .fc-day[data-date=\'' + moment(this.actionPlan.eventDates[0]).format('YYYY-MM-DD') + '\']').addClass('has-resources');
      }

      if (!this.isLimitedEdit) {
        thisDateNumberCell.addClass('has-resources');
        thisDateCell.addClass('has-resources');
      }
      thisDateCell.append('<div class="available-resources"></div>');
    }
  }, {
    key: '_setAvailableResourcesRaw',
    value: function _setAvailableResourcesRaw(availableResources) {
      var _this8 = this;

      _.forEach(availableResources, function (availableResources_value) {
        var thisAvailableResource = _.clone(availableResources_value);
        thisAvailableResource['name'] = thisAvailableResource['resourceName'];
        thisAvailableResource['checked'] = true;
        delete thisAvailableResource['resourceName'];

        _this8.availableResourcesRaw.push(thisAvailableResource);
      });
    }
  }, {
    key: '_clearResources',
    value: function _clearResources() {
      this.$element.find('.has-resources').removeClass('has-resources').end().find('.available-resources').remove();
    }
  }, {
    key: '_hasResourcesAvailable',
    value: function _hasResourcesAvailable(momentDate) {
      return this.$element.find('.fc-bg .fc-day[data-date=\'' + momentDate.format('YYYY-MM-DD') + '\']').hasClass('has-resources');
    }
  }, {
    key: '_setCalendarRowHeight',
    value: function _setCalendarRowHeight(thisCalendar) {
      var _this9 = this;

      this.$timeout(function () {
        var thisCalendarWeekRow = thisCalendar.find('.fc-row.fc-week.fc-widget-content');
        var thisFCBG = thisCalendarWeekRow.find('.fc-bg');
        var thisFCBGHeight = thisFCBG.height();
        var thisFCSkeleton = thisCalendarWeekRow.find('.fc-content-skeleton');
        if (thisFCBGHeight > 120 && thisFCBGHeight <= thisFCSkeleton.outerHeight()) {
          thisCalendarWeekRow.height(thisFCBGHeight + 20);
          thisFCBG.height(thisFCBGHeight + 20);
        }
        thisFCBG.find('.available-resources').css({
          visibility: 'visible',
          top: thisFCBGHeight - 22
        });

        _this9._setSingleActionPlan();
      });
    }
  }, {
    key: '_setSingleActionPlan',
    value: function _setSingleActionPlan() {
      var $editCell = void 0;

      if (this.actionPlan.eventDates && this.actionPlan.eventDates[0]) {
        $editCell = this.$element.find('.fc-bg .fc-day[data-date=\'' + moment(this.actionPlan.eventDates[0]).format('YYYY-MM-DD') + '\']');

        $editCell.find('.create-screen').remove();
        this.$element.find('.create-screen.active').remove();
        this.$element.find('.fc-day-number[data-date=\'' + moment(this.actionPlan.eventDates[0]).format('YYYY-MM-DD') + '\']').css('cursor', 'pointer');
        $editCell.append('<a class="fc-day-grid-event fc-h-event fc-event fc-start fc-end create-screen active">\n                        <div class="fc-content"> <span class="fc-title">' + this.actionPlan.title + '</span></div>\n                      </a>');
      }

      this.$element.find('.fc-month-view .fc-event-container').css({
        backgroundColor: 'transparent',
        border: 'none'
      }).find('.create-screen').css({
        backgroundColor: 'transparent',
        border: 'none'
      }).html('<a class="single-plan">1 Event</a>');
    }
  }]);

  return ApmActionPlanCreateEditController;
}();

angular.module('apm.components.actionPlans').component('apmActionPlanCreateEdit', {
  templateUrl: 'app/components/actionPlans/createEdit/apm.actionPlans.createEdit.html',
  controller: ApmActionPlanCreateEditController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CalendarController = function () {

  /** @ngInject */
  function CalendarController($compile, $element, $mdDialog, $scope, $state, $timeout, apmActionPlanService, apmAuthenticationService, scNotificationsFactory, ROLES) {
    _classCallCheck(this, CalendarController);

    _.assign(this, {
      $compile: $compile,
      $element: $element,
      $mdDialog: $mdDialog,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      apmActionPlanService: apmActionPlanService,
      apmAuthenticationService: apmAuthenticationService,
      scNotificationsFactory: scNotificationsFactory,
      ROLES: ROLES,

      availableResources: [],
      availableResourcesRaw: [],
      calendarConfig: {},
      calendarCurrentDayCount: 0,
      calendarCurrentStartDay: {},
      calendarData: [[]],
      calendarDataRaw: [],
      exclusions: {
        excludeUser: '',
        excludeRole: ''
      },
      isLoading: false,
      refreshAvailableResources: true,
      resourcesRendered: {},
      actionPlans: {}
    });
  }

  _createClass(CalendarController, [{
    key: '$onInit',
    value: function $onInit() {
      this.hasReportAccess = this.apmAuthenticationService.hasAccess('scAPReport');
    }
  }, {
    key: '$postLink',
    value: function $postLink() {
      var _this = this;

      this.$timeout(function () {
        _this.calendarConfig = {
          header: {
            right: 'agendaWeek month',
            left: 'prev, title, next'
          },
          views: {
            month: {
              eventLimit: 2
            }
          },
          eventLimitClick: function eventLimitClick(data) {
            return _this._eventLimitClick(data);
          },
          viewRender: function viewRender(view) {
            return _this._viewRender(view);
          },
          eventAfterAllRender: function eventAfterAllRender(view) {
            return _this._eventAfterAllRender(view);
          },
          eventClick: function eventClick(el) {
            return _this._setState(el);
          }
        };
        angular.element('body').addClass('calendar');
      }, 500);
    }
  }, {
    key: 'onCheckboxFilter',
    value: function onCheckboxFilter(availableResources) {
      this.refreshAvailableResources = false;
      this.exclusions = this._extractAvailableResourcesExclusions(availableResources);
      this.resourcesRendered = false;

      this._clearResources();
      this._getActionPlanCalendar(this.calendarCurrentStartDay, this.calendarCurrentDayCount, this.exclusions['excludeUser'], this.exclusions['excludeRole']);
    }
  }, {
    key: '_eventLimitClick',
    value: function _eventLimitClick(data) {
      var $calendar = this.$element.find('#calendar');
      $calendar.fullCalendar('gotoDate', data.date._d);
      $calendar.fullCalendar('changeView', 'agendaWeek');
    }
  }, {
    key: '_viewRender',
    value: function _viewRender() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: 'month' };

      var dayCount = void 0;

      if (view.start && view.start._d && view.type !== 'agendaWeek') {
        this.title = view.title;
      }

      if (view.type === 'month') {
        dayCount = 30;
        this.calendarCurrentStartDay = moment(new Date(this.title.replace(/ /g, ' 1 '))).format();
      } else if (view.type === 'agendaWeek') {
        this.calendarCurrentStartDay = moment(new Date(view.start._d)).format();
        angular.element('.main-container').animate({ scrollTop: 0 }, 200);
        dayCount = 8;
      }

      this.refreshAvailableResources = true;
      this.calendarCurrentDayCount = dayCount;
      this._getActionPlanCalendar(this.calendarCurrentStartDay, this.calendarCurrentDayCount, null, null);
      this._setDisabledPrev(this.calendarCurrentStartDay);
    }
  }, {
    key: '_eventAfterAllRender',
    value: function _eventAfterAllRender(view) {
      if ((view.type === 'month' || view.type === 'agendaWeek') && this.calendarDataRaw.length && this.calendarDataRaw !== this.resourcesRendered) {
        this.resourcesRendered = this.calendarDataRaw;
        this._generateAvailableResources();
      }
    }
  }, {
    key: '_setState',
    value: function _setState(el) {
      var ap = this.actionPlans[el.id];
      if (!this.hasReportAccess && ap.status === 'COMPLETED') {
        this.scNotificationsFactory.custom('You do not have permissions to view the Report for this Action Plan.', 'error');
      } else {
        this.$state.go('actionPlans.details', { id: el.id });
      }
    }
  }, {
    key: '_setDisabledPrev',
    value: function _setDisabledPrev(date) {
      var $prevButton = this.$element.find('.fc-prev-button');

      if (moment(new Date(date)).isBefore(moment(new Date('2017-01-01')))) {
        $prevButton.attr('disabled', 'disabled');
      } else {
        $prevButton.removeAttr('disabled');
      }
    }
  }, {
    key: '_generateAvailableResources',
    value: function _generateAvailableResources() {
      var _this2 = this;

      var roleColors = {};
      roleColors[this.ROLES.PSU] = '#9012fe';
      roleColors[this.ROLES.NP] = '#4990e2';

      var thisCalendar = this.$element.find('#calendar');

      _.forEach(this.calendarDataRaw, function (calendarDataRaw_value) {
        var thisDate = calendarDataRaw_value.date;
        var thisDateCell = thisCalendar.find('.fc-day[data-date="' + thisDate + '"]');
        var thisDateNumberCell = thisCalendar.find('.fc-day-number[data-date="' + thisDate + '"]');
        var thisAvailableResourcesCell = void 0;

        if (thisDateCell.length) {
          if (calendarDataRaw_value.availableResources.length) {
            _this2._setAvailableResourcesClasses(thisDateNumberCell, thisDateCell);
            thisAvailableResourcesCell = thisDateCell.find('.available-resources');
            _.forEach(calendarDataRaw_value.availableResources, function (availableResources_value, availableResources_key) {
              if (availableResources_key === 3) {
                return false;
              }
              _this2._generateSingleResource(thisAvailableResourcesCell, availableResources_value, availableResources_key, roleColors);
            });
            if (calendarDataRaw_value.availableResources.length > 3) {
              thisAvailableResourcesCell.append('<div class="resources-more"></div>');
            }
            _this2.$compile(thisAvailableResourcesCell.find('div[tooltips]'))(_this2.$scope);
          } else {
            thisDateNumberCell = thisCalendar.find('.fc-day-number[data-date="' + thisDate + '"]');
            if (thisDateNumberCell.length) {
              thisDateNumberCell.addClass('no-resources');
            }
          }
        }
        if (calendarDataRaw_value.availableResources.length) {
          _this2._setAvailableResourcesRaw(calendarDataRaw_value.availableResources);
        }
      });
      this._setCalendarRowHeight(thisCalendar);
      if (this.refreshAvailableResources) {
        this._transformAvailableResources();
      }
    }
  }, {
    key: '_setAvailableResourcesRaw',
    value: function _setAvailableResourcesRaw(availableResources) {
      var _this3 = this;

      _.forEach(availableResources, function (availableResources_value) {
        var thisAvailableResource = _.clone(availableResources_value);
        thisAvailableResource['name'] = thisAvailableResource['resourceName'];
        thisAvailableResource['checked'] = true;
        delete thisAvailableResource['resourceName'];

        _this3.availableResourcesRaw.push(thisAvailableResource);
      });
    }
  }, {
    key: '_generateSingleResource',
    value: function _generateSingleResource(cell, value, key, colors) {
      cell.append('<div class="single-resource"\n                      style="z-index: ' + (key + 300) + '; left: ' + (key * 16 + 8) + 'px; background-color: ' + colors[value.roleName] + ';"\n                      data-resource-id="' + value.id + '">\n                   <span class="tooltip-top" data-tooltip="' + value.resourceName + '">' + value.initial + '</span>\n                 </div>');
    }
  }, {
    key: '_getActionPlanCalendar',
    value: function _getActionPlanCalendar(startDate) {
      var dayCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _this4 = this;

      var excludeUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var excludeRole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this.isLoading = true;
      this.apmActionPlanService.getActionPlanCalendar(moment(startDate).format('YYYY-MM-DD'), moment(startDate).add(dayCount, 'days').format('YYYY-MM-DD'), excludeUser, excludeRole).then(function (res) {
        return _this4._getActionPlanCalendarSuccess(res);
      }).catch(function (err) {
        return _this4._getActionPlanCalendarError(err);
      });
    }
  }, {
    key: '_getActionPlanCalendarSuccess',
    value: function _getActionPlanCalendarSuccess(res) {
      var _this5 = this;

      this.calendarData[0] = [];

      if (!_.isEmpty(res)) {
        this.calendarDataRaw = res;
        _.forEach(res, function (el) {
          if (el.date && !_.isEmpty(el.actionPlans)) {
            _.forEach(el.actionPlans, function (elem) {
              _this5.actionPlans[elem.id] = {
                status: elem.status
              };
              _this5.calendarData[0].push({
                start: el.date,
                title: elem.actionPlanTitle,
                id: elem.id,
                color: '#f4c06a',
                textColor: '#525050'
              });
            });
          }
        });
      }
      this.isLoading = false;
    }
  }, {
    key: '_getActionPlanCalendarError',
    value: function _getActionPlanCalendarError(err) {
      this.isLoading = false;
      this.scNotificationsFactory.error(_.get(err, 'message', _.get(err, 'data.message', '')));
    }
  }, {
    key: '_transformAvailableResources',
    value: function _transformAvailableResources() {
      this.refreshAvailableResources = false;

      if (this.availableResourcesRaw.length) {
        var availableResources = [];
        var roles = _.groupBy(this.availableResourcesRaw, 'roleName');

        _.forIn(roles, function (roles_value, roles_key) {
          availableResources.push({
            name: _.get(_.first(roles_value), 'roleDescription') + ' Calendar',
            id: roles_key,
            checked: true,
            children: _.uniq(roles_value, 'id')
          });
        });

        this.availableResources = _.sortBy(availableResources, 'id');
        this.availableResourcesRaw = [];
      }
    }
  }, {
    key: '_setAvailableResourcesClasses',
    value: function _setAvailableResourcesClasses(thisDateNumberCell, thisDateCell) {
      thisDateNumberCell.addClass('has-resources');
      thisDateCell.addClass('has-resources');
      thisDateCell.append('<div class="available-resources"></div>');
    }
  }, {
    key: '_extractAvailableResourcesExclusions',
    value: function _extractAvailableResourcesExclusions(availableResources) {
      var exclusions = {
        excludeUser: [],
        excludeRole: []
      };

      _.forEach(availableResources, function (availableResources_value) {
        if (_.has(availableResources_value, 'children') && availableResources_value.children.length) {
          var thisUnchecked = _.pluck(_.filter(availableResources_value.children, { checked: false }), 'id');
          if (thisUnchecked.length === availableResources_value.children.length) {
            exclusions.excludeRole.push(availableResources_value.id);
          } else {
            exclusions.excludeUser.push(thisUnchecked);
          }
        }
      });
      exclusions.excludeUser = _.flatten(exclusions.excludeUser).join(',');
      exclusions.excludeRole = _.flatten(exclusions.excludeRole).join(',');

      return exclusions;
    }
  }, {
    key: '_clearResources',
    value: function _clearResources() {
      this.$element.find('.has-resources').removeClass('has-resources').end().find('.available-resources').remove();
    }
  }, {
    key: '_setCalendarRowHeight',
    value: function _setCalendarRowHeight(thisCalendar) {
      var _this6 = this;

      this.$timeout(function () {
        var thisCalendarWeekRow = thisCalendar.find('.fc-row.fc-week.fc-widget-content');
        var thisFCBG = thisCalendarWeekRow.find('.fc-bg');
        var thisFCBGHeight = thisFCBG.height();
        var thisFCSkeleton = thisCalendarWeekRow.find('.fc-content-skeleton');
        if (thisFCBGHeight > 120 && thisFCBGHeight <= thisFCSkeleton.outerHeight()) {
          thisCalendarWeekRow.height(thisFCBGHeight + 20);
          thisFCBG.height(thisFCBGHeight + 20);
          thisFCBG.find('.available-resources').css({
            visibility: 'visible'
          });
        } else {
          thisFCBG.find('.available-resources').css({
            visibility: 'visible'
          });
        }
        _this6._setAgendaWeekHeight(thisCalendar);
      });
    }
  }, {
    key: '_setAgendaWeekHeight',
    value: function _setAgendaWeekHeight(thisCalendar) {
      var thisAgendaWeekRow = thisCalendar.find('.fc-agendaWeek-view .fc-row.fc-week.fc-widget-content');
      if (thisAgendaWeekRow.outerHeight()) {
        thisAgendaWeekRow.animate({
          height: '+=20'
        }, 10);

        thisCalendar.find('.available-resources').animate({
          marginTop: '+=15'
        }, 10);
      }
    }
  }]);

  return CalendarController;
}();

angular.module('apm.components.actionPlans').component('apmCalendar', {
  templateUrl: 'app/components/actionPlans/calendar/apm.actionPlans.calendar.html',
  controller: CalendarController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderAssigneeModalController = function () {

  /** @ngInject */
  function ApmDetailsHeaderAssigneeModalController($attrs, $mdDialog, apmActionPlanService, scNotificationsFactory, scLastNameFirstFilter, ROLES) {
    _classCallCheck(this, ApmDetailsHeaderAssigneeModalController);

    _.assign(this, {
      $attrs: $attrs,
      $mdDialog: $mdDialog,
      apmActionPlanService: apmActionPlanService,
      scNotificationsFactory: scNotificationsFactory,
      scLastNameFirstFilter: scLastNameFirstFilter,
      ROLES: ROLES,

      assigneeRoles: [ROLES.LSA, ROLES.PSR, ROLES.MANAGEMENT, ROLES.PSU],
      currentAssignee: null,
      errorMessage: null,
      saveEnabled: false,
      saving: false
    });
  }

  _createClass(ApmDetailsHeaderAssigneeModalController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (_.has(this, 'actionPlan.assigneeName') && this.actionPlan.assigneeName) {
        this.currentAssignee = this.actionPlan.assigneeName.trim();
      }

      this.apmActionPlanService.getActionPlanUsers(this.actionPlan._id, this.assigneeRoles).then(function (data) {
        return _this._autocompleteHandler(data);
      }).catch(function (err) {
        return _this._errorHandler(err);
      });
    }
  }, {
    key: 'getMatches',
    value: function getMatches(searchText) {
      searchText = searchText.toLowerCase();
      return _.filter(this.autoCompleteData, function (d) {
        return d.firstName.toLowerCase().indexOf(searchText) === 0 || d.lastName.toLowerCase().indexOf(searchText) === 0;
      });
    }
  }, {
    key: 'selectedItemChange',
    value: function selectedItemChange() {
      this.saveEnabled = !!this.selectedItem;
    }
  }, {
    key: 'setName',
    value: function setName(name) {
      var _this2 = this;

      var selectedItem = null;
      if (name) {
        selectedItem = _.find(this.autoCompleteData, function (x) {
          return _this2.getUserDisplayName(x) === _this2.getUserDisplayName(name);
        });
      }
      this._handleAssignee(selectedItem);
    }
  }, {
    key: 'getAssignee',
    value: function getAssignee() {
      if (_.isObject(this.currentAssignee)) {
        return this.currentAssignee.fullName;
      }
      return this.currentAssignee;
    }
  }, {
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'getUserDisplayName',
    value: function getUserDisplayName(user) {
      if (_.isEmpty(user)) {
        return '';
      }
      return user.fullName;
    }
  }, {
    key: '_autocompleteHandler',
    value: function _autocompleteHandler(data) {
      var _this3 = this;

      this.errorMessage = null;
      this.autoCompleteData = _.map(data.data, function (el) {
        el.fullName = _this3.scLastNameFirstFilter(el.lastName, null, el.firstName, null, null);
        return el;
      });
    }
  }, {
    key: '_handleAssignee',
    value: function _handleAssignee(assignee) {
      var _this4 = this;

      if (!_.isEmpty(assignee)) {
        this.saving = true;
        this.apmActionPlanService.assignActionPlan(this.actionPlan._id, assignee.oid).then(function (data) {
          return _this4._assignSuccessHandler(data);
        }).catch(function (err) {
          return _this4._errorHandler(err);
        });
      } else {
        this.saveEnabled = false;
      }
    }
  }, {
    key: 'clearAssignee',
    value: function clearAssignee() {
      var _this5 = this;

      this.saving = true;
      this.apmActionPlanService.unassignActionPlan(this.actionPlan._id).then(function (data) {
        return _this5._unassignSuccessHandler(data);
      }).catch(function (err) {
        return _this5.errorHandler(err);
      });
    }
  }, {
    key: '_assignSuccessHandler',
    value: function _assignSuccessHandler(response) {
      this.errorMessage = null;
      this.actionPlan.assigneeId = response.data.assigneeId;
      this.actionPlan.assigneeName = response.data.assigneeName;
      this.scNotificationsFactory.success('Action Plan assigned successfully');

      if (this.onAssignee) {
        this.onAssignee();
      }

      this.$mdDialog.hide();
    }
  }, {
    key: '_unassignSuccessHandler',
    value: function _unassignSuccessHandler(response) {
      this.errorMessage = null;
      this.actionPlan.assigneeId = response.data.assigneeId;
      this.actionPlan.assigneeName = response.data.assigneeName;
      this.scNotificationsFactory.success('Assignee cleared successfully');

      if (this.onAssignee) {
        this.onAssignee();
      }

      this.$mdDialog.hide();
    }
  }, {
    key: '_errorHandler',
    value: function _errorHandler(err) {
      this.saving = false;
      this.errorMessage = _.get(err, 'message', _.get(err, 'data.message', ''));
    }
  }]);

  return ApmDetailsHeaderAssigneeModalController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderAssigneeModal', {
  templateUrl: 'app/components/actionPlans/assignee/apm.assignee.assigneeModal.component.html',
  controller: ApmDetailsHeaderAssigneeModalController,
  bindings: {
    actionPlan: '<',
    onAssignee: '&?'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmDetailsHeaderAssigneeModalButtonController = function () {

  /** @ngInject */
  function ApmDetailsHeaderAssigneeModalButtonController($attrs, $mdDialog, $scope, apmActionPlansFactory) {
    _classCallCheck(this, ApmDetailsHeaderAssigneeModalButtonController);

    _.assign(this, {
      $attrs: $attrs,
      $mdDialog: $mdDialog,
      $scope: $scope,
      apmActionPlansFactory: apmActionPlansFactory
    });
  }

  _createClass(ApmDetailsHeaderAssigneeModalButtonController, [{
    key: 'showAssigneeModal',
    value: function showAssigneeModal() {
      var scope = angular.extend(this.$scope.$new(true), {
        actionPlan: this.actionPlan,
        onAssignee: this.onAssignee
      });

      var template = this.$attrs.onAssignee ? '<md-dialog aria-label="modal" class="message-content"><apm-details-header-assignee-modal action-plan="actionPlan" class="assignee-modal" on-assignee="onAssignee()" /></md-dialog>' : '<md-dialog aria-label="modal" class="message-content"><apm-details-header-assignee-modal action-plan="actionPlan" class="assignee-modal" /></md-dialog>';

      this.$mdDialog.show({
        template: template,
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: 'isStatusEditable',
    value: function isStatusEditable() {
      return this.apmActionPlansFactory.isLimitedEdit(this.actionPlan, true);
    }
  }]);

  return ApmDetailsHeaderAssigneeModalButtonController;
}();

angular.module('apm.components.actionPlans').component('apmDetailsHeaderAssigneeModalButton', {
  templateUrl: 'app/components/actionPlans/assignee/apm.assignee.assigneeModal.button.component.html',
  controller: ApmDetailsHeaderAssigneeModalButtonController,
  bindings: {
    actionPlan: '<',
    onAssignee: '&?'
  }
});
'use strict';

angular.module('apm.components.sessionTimeout', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmShowSessionTimeoutService = function () {

  /** @ngInject */
  function ApmShowSessionTimeoutService($mdDialog) {
    _classCallCheck(this, ApmShowSessionTimeoutService);

    _.assign(this, {
      $mdDialog: $mdDialog
    });
  }

  _createClass(ApmShowSessionTimeoutService, [{
    key: 'openSessionTimeoutModal',
    value: function openSessionTimeoutModal() {
      this.$mdDialog.show({
        template: '<md-dialog aria-label="Session Timeout" class="session-timeout-modal"><apm-session-timeout-modal /></md-dialog>',
        clickOutsideToClose: false
      });
    }
  }]);

  return ApmShowSessionTimeoutService;
}();

angular.module('apm.components.sessionTimeout').service('apmShowSessionTimeoutService', ApmShowSessionTimeoutService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmSessionTimeoutModalController = function () {

  /** @ngInject */
  function ApmSessionTimeoutModalController($rootScope, $state, $interval, $mdDialog, apmSessionService, authenticationService) {
    _classCallCheck(this, ApmSessionTimeoutModalController);

    _.assign(this, {
      $rootScope: $rootScope,
      $state: $state,
      $interval: $interval,
      $mdDialog: $mdDialog,
      apmSessionService: apmSessionService,
      authenticationService: authenticationService,

      countdownHandler: null,
      minutes: '3',
      seconds: '00'
    });

    this.countdownHandler = this.$interval(angular.bind(this, this._countdown), 1000);
  }

  _createClass(ApmSessionTimeoutModalController, [{
    key: 'close',
    value: function close() {
      this.$mdDialog.cancel();
    }
  }, {
    key: 'continue',
    value: function _continue() {
      var _this = this;

      this.$interval.cancel(this.countdownHandler);
      this.apmSessionService.getPing().then(function (response) {
        return _this._getPingSuccessHandler(response);
      }).catch(function () {
        return _this.logout();
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.$interval.cancel(this.countdownHandler);
      this.authenticationService.logout();
      this._redirectToLogin();
    }
  }, {
    key: '_countdown',
    value: function _countdown() {
      var currentMinute = parseInt(this.minutes);
      var currentSecond = parseInt(this.seconds);

      if (currentSecond === 0 && currentMinute > 0) {
        currentMinute -= 1;
        currentSecond = 59;
      } else if (currentSecond > 0) {
        currentSecond -= 1;

        if (currentSecond === 0 && currentMinute === 0) {
          this.close();
          this.logout();
          return;
        }
      }

      this.minutes = currentMinute;
      this.seconds = currentSecond >= 10 ? currentSecond : '0' + currentSecond;
    }
  }, {
    key: '_getPingSuccessHandler',
    value: function _getPingSuccessHandler() {
      this.apmSessionService.keepSessionAlive();
    }
  }, {
    key: '_redirectToLogin',
    value: function _redirectToLogin() {
      this.$rootScope.navContext = '';
      this.$state.go('login');
    }
  }]);

  return ApmSessionTimeoutModalController;
}();

angular.module('apm.components.sessionTimeout').component('apmSessionTimeoutModal', {
  templateUrl: 'app/components/sessionTimeoutModal/apm.sessionTimeoutModal.component.html',
  controller: ApmSessionTimeoutModalController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmResourcesService = function () {

  /** @ngInject */
  function ApmResourcesService($resource, API_BASE_URL) {
    _classCallCheck(this, ApmResourcesService);

    var baseUrl = API_BASE_URL + '/ap';
    this.resourcesResource = $resource(baseUrl + '/resources', { id: '@id' }, {
      fetchResource: {
        method: 'GET',
        url: baseUrl + '/resources/:id'
      },
      fetchResources: {
        method: 'GET',
        url: API_BASE_URL + '/admin/UserAdmin?first_name=:fName&last_name=:lName&role_name=:roles&active=:active',
        transformResponse: this._extractResponse
      },
      postResourceEvent: {
        method: 'POST',
        url: baseUrl + '/resources/:id/events',
        transformRequest: function transformRequest(data) {
          return angular.toJson(data);
        },
        transformResponse: this._extractResponse
      },
      putResourceEvent: {
        method: 'PUT',
        url: baseUrl + '/resources/:id/events/:eventId',
        transformRequest: function transformRequest(data) {
          return angular.toJson(data);
        },
        transformResponse: this._extractResponse
      },
      deleteResourceEvent: {
        method: 'DELETE',
        url: baseUrl + '/resources/:id/events/:eventId',
        transformResponse: this._extractResponse
      },
      fetchResourceEvents: {
        method: 'GET',
        url: baseUrl + '/resources/:id/events',
        transformResponse: this._extractResponse
      },
      fetchResourcesRoles: {
        method: 'GET',
        url: API_BASE_URL + '/admin/TenantSecurity',
        transformResponse: this._extractResponse
      }
    });
  }

  _createClass(ApmResourcesService, [{
    key: '_extractResponse',
    value: function _extractResponse(response) {
      return angular.fromJson(response);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource(id) {
      return this.resourcesResource.fetchResource({ id: id }).$promise;
    }
  }, {
    key: 'fetchResources',
    value: function fetchResources(params) {
      return this.resourcesResource.fetchResources(params).$promise;
    }
  }, {
    key: 'fetchResourceEvents',
    value: function fetchResourceEvents(id) {
      return this.resourcesResource.fetchResourceEvents({ id: id }).$promise;
    }
  }, {
    key: 'postResourceEvent',
    value: function postResourceEvent(id, event) {
      return this.resourcesResource.postResourceEvent({ id: id }, event).$promise;
    }
  }, {
    key: 'putResourceEvent',
    value: function putResourceEvent(id, eventId, event) {
      return this.resourcesResource.putResourceEvent({ id: id, eventId: eventId }, event).$promise;
    }
  }, {
    key: 'deleteResourceEvent',
    value: function deleteResourceEvent(id, eventId) {
      return this.resourcesResource.deleteResourceEvent({ id: id, eventId: eventId }).$promise;
    }
  }, {
    key: 'fetchResourcesRoles',
    value: function fetchResourcesRoles() {
      return this.resourcesResource.fetchResourcesRoles().$promise;
    }
  }]);

  return ApmResourcesService;
}();

angular.module('apm.components.resources').service('apmResourcesService', ApmResourcesService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourcesRoutes = function () {
  function ResourcesRoutes() {
    _classCallCheck(this, ResourcesRoutes);
  }

  _createClass(ResourcesRoutes, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($stateProvider) {
      $stateProvider.state('resources', {
        url: '/resources',
        template: '<ui-view></ui-view>',
        abstract: true
      }).state('resources.list', {
        url: '/list',
        templateUrl: 'app/components/resources/apm.resources.html',
        data: { pageTitle: 'Resources List' }
      }).state('resources.details', {
        url: '/:userId/details',
        component: 'apmResourcesDetails'
      }).state('resources.locations', {
        url: '/locations',
        component: 'apmResourcesLocations'
      });
    }
  }]);

  return ResourcesRoutes;
}();

angular.module('apm.components.resources').config(ResourcesRoutes.config);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmReportService = function () {

  /** @ngInject */
  function ApmReportService($resource, API_BASE_URL) {
    _classCallCheck(this, ApmReportService);

    this.reportsResource = $resource(API_BASE_URL + '/actionplans', {
      status: 'COMPLETED'
    }, {
      fetchReports: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      }
    });
    this.callLogReportResource = $resource(API_BASE_URL + '/ap/callReport', {}, {
      fetchReports: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      },
      downloadCSV: {
        method: 'GET',
        url: API_BASE_URL + '/ap/callReport/csv',
        headers: {
          'Accept': 'text/csv'
        },
        responseType: 'text',
        transformResponse: [this._transformReportCSVSuccessfulResponse, this._transformReportCSVErrorResponse]
      }
    });
    this.actionPlanReportResource = $resource(API_BASE_URL + '/ap/apReport/:actionPlanId', {}, {
      getValueSetGroup: {
        method: 'GET',
        url: API_BASE_URL + '/sc/valueset/sc-call-results-group',
        transformResponse: function transformResponse(response) {
          return angular.fromJson(response);
        }
      },
      summary: {
        method: 'GET',
        url: API_BASE_URL + '/ap/apReport/:actionPlanId/summary',
        transformResponse: this._extractDataFromResponse
      },
      patients: {
        method: 'GET',
        url: API_BASE_URL + '/ap/apReport/:actionPlanId/patients',
        transformResponse: this._extractDataFromResponse
      },
      downloadCSV: {
        method: 'GET',
        url: API_BASE_URL + '/ap/apReport/:actionPlanId/csv',
        headers: {
          'Accept': 'text/csv'
        },
        responseType: 'text',
        transformResponse: [this._transformReportCSVSuccessfulResponse, this._transformReportCSVErrorResponse]
      }
    });
    this.pendingGapsReportResource = $resource(API_BASE_URL + '/ap/pendingGaps', {}, {
      fetchReports: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      }
    });
  }

  _createClass(ApmReportService, [{
    key: '_extractDataFromResponse',
    value: function _extractDataFromResponse(response) {
      return angular.fromJson(response).data;
    }
  }, {
    key: '_transformReportCSVSuccessfulResponse',
    value: function _transformReportCSVSuccessfulResponse(response, headers, status) {
      if (200 !== status) {
        return response;
      }

      var contentDispositionHeader = headers()['content-disposition'];
      var filename = 'report.csv';

      if (angular.isDefined(contentDispositionHeader)) {
        var groups = contentDispositionHeader.match(/.*filename=(.*)/);
        filename = angular.isArray(groups) && groups.length === 2 ? groups[1] : filename;
      }

      return { report: response, filename: filename };
    }
  }, {
    key: '_transformReportCSVErrorResponse',
    value: function _transformReportCSVErrorResponse(response, headers, status) {
      if (200 === status) {
        return response;
      }

      return angular.fromJson(response);
    }
  }, {
    key: 'fetchCallLogReportPage',
    value: function fetchCallLogReportPage(pageRequestData) {
      return this.callLogReportResource.fetchReports(pageRequestData).$promise;
    }
  }, {
    key: 'fetchPendingGapsReportPage',
    value: function fetchPendingGapsReportPage(pageRequestData) {
      return this.pendingGapsReportResource.fetchReports(pageRequestData).$promise;
    }
  }, {
    key: 'downloadCallLogReportCSV',
    value: function downloadCallLogReportCSV(requestData) {
      return this.callLogReportResource.downloadCSV(requestData).$promise;
    }
  }, {
    key: 'fetchActionPlanReportPatients',
    value: function fetchActionPlanReportPatients(pageRequestData) {
      return this.actionPlanReportResource.patients(pageRequestData).$promise;
    }
  }, {
    key: 'fetchActionPlanReportSummary',
    value: function fetchActionPlanReportSummary(pageRequestData) {
      return this.actionPlanReportResource.summary(pageRequestData).$promise;
    }
  }, {
    key: 'downloadActionPlanReportCSV',
    value: function downloadActionPlanReportCSV(requestData) {
      return this.actionPlanReportResource.downloadCSV(requestData).$promise;
    }
  }, {
    key: 'fetchReportsList',
    value: function fetchReportsList(requestData) {
      return this.reportsResource.fetchReports(requestData).$promise;
    }
  }, {
    key: 'getValueSetGroup',
    value: function getValueSetGroup() {
      return this.actionPlanReportResource.getValueSetGroup().$promise;
    }
  }]);

  return ApmReportService;
}();

angular.module('apm.components.reports').service('apmReportService', ApmReportService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsRoutes = function () {
  function ReportsRoutes() {
    _classCallCheck(this, ReportsRoutes);
  }

  _createClass(ReportsRoutes, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.when('/reports', '/reports/list');
      $stateProvider.state('reports', {
        abstract: true,
        url: '/reports',
        template: '<ui-view></ui-view>'
      }).state('reports.list', {
        url: '/list',
        component: 'apmReportsList',
        data: { pageTitle: 'Reports' }
      }).state('reports.actionPlans', {
        url: '/actionPlan/:id',
        component: 'actionPlanReport',
        params: {
          actionPlan: undefined
        },
        data: { pageTitle: 'Action Plan Report' }
      }).state('reports.callLog', {
        url: '/callLog',
        templateUrl: 'app/components/reports/apm.reports.callLog.html',
        data: { pageTitle: 'Action Plan Call Log Report' }
      }).state('reports.pendingGaps', {
        url: '/pendingGaps',
        component: 'apmReportsPendingGaps',
        data: { pageTitle: 'Pending Gaps Report' }
      });
    }
  }]);

  return ReportsRoutes;
}();

angular.module('apm.components.reports').config(ReportsRoutes.config);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmReportMeasureGapsService = function () {

  /** @ngInject */
  function ApmReportMeasureGapsService($resource, API_BASE_URL) {
    _classCallCheck(this, ApmReportMeasureGapsService);

    this.measureGapsResource = $resource(API_BASE_URL + '/ap/measuregaps/:measureReportId', {}, {
      fetchMeasureGaps: {
        method: 'GET'
      },
      reopenGap: {
        method: 'PUT',
        url: API_BASE_URL + '/ap/measuregaps/:measureReportId/status'
      }
    });
  }

  _createClass(ApmReportMeasureGapsService, [{
    key: 'fetchMeasureGaps',
    value: function fetchMeasureGaps(measureReportId) {
      return this.measureGapsResource.fetchMeasureGaps({ measureReportId: measureReportId }).$promise;
    }
  }, {
    key: 'reopenGap',
    value: function reopenGap(measureReportId) {
      return this.measureGapsResource.reopenGap({ measureReportId: measureReportId }, { status: 'open' }).$promise;
    }
  }]);

  return ApmReportMeasureGapsService;
}();

angular.module('apm.components.reports').service('apmReportMeasureGapsService', ApmReportMeasureGapsService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsListController = function () {

  /** @ngInject */
  function ReportsListController($state, apmAuthenticationService) {
    _classCallCheck(this, ReportsListController);

    _.assign(this, {
      $state: $state,

      apmAuthenticationService: apmAuthenticationService
    });
  }

  _createClass(ReportsListController, [{
    key: '$onInit',
    value: function $onInit() {
      if (!this.apmAuthenticationService.hasAccess('scAPReport')) {
        this.$state.go('home');
      }
    }
  }]);

  return ReportsListController;
}();

angular.module('apm.components.reports').component('apmReportsList', {
  templateUrl: 'app/components/reports/apm.reports.list.html',
  controller: ReportsListController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmPatientsService = function () {

  /** @ngInject */
  function ApmPatientsService($resource, API_BASE_URL) {
    _classCallCheck(this, ApmPatientsService);

    this.patientsResource = $resource(API_BASE_URL + '/sc/Patients', { uc: 'APM_PATIENT_LIST' }, {
      getPatientsList: {
        method: 'GET',
        transformResponse: this._extractPatientsFromResponse,
        isArray: false
      }
    });
    this.patientSummaryResource = $resource(API_BASE_URL + '/sc/PatientSummaryHeader/:patientId', {}, {});
    this.patientFhirResource = $resource(API_BASE_URL + '/fhir/Patient/:patientId', {}, {});
    this.patientQualityMeasuresResource = $resource(API_BASE_URL + '/sc/PatientQuality/:patientId/year/:year', {}, {
      fetchQualityMeasures: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      },
      fetchRelatedActionPlans: {
        method: 'GET',
        url: API_BASE_URL + '/sc/PatientQuality/:patientId/measureReport/:measureReportId'
      }
    });
    this.patientActionPlansResource = $resource(API_BASE_URL + '/sc/Patient/:patientId/ActionPlans', {}, {
      fetchActionPlansPage: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      }
    });
    this.patientAppointmentResource = $resource(API_BASE_URL + '/sc/Patient/:patientId/Appointments', { uc: 'APM' }, {
      fetchAppointmentsPage: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      }
    });
    this.patientTestResultsResource = $resource(API_BASE_URL + '/ap/patients/:patientId/tests', {}, {
      fetchPatientTestResults: {
        method: 'GET',
        transformResponse: this._extractDataFromResponse
      }
    });
    this.patientVendorResource = $resource(API_BASE_URL + '/sc/Patient/:patientId/vendors', {}, {
      fetchPatientVendors: {
        method: 'GET',
        isArray: true,
        transformResponse: this._extractDataFromResponse
      }
    });
  }

  _createClass(ApmPatientsService, [{
    key: 'fetchPatientSummary',
    value: function fetchPatientSummary(patientId) {
      return this.patientSummaryResource.get({ patientId: patientId }).$promise;
    }
  }, {
    key: 'fetchFhirPatient',
    value: function fetchFhirPatient(patientId) {
      return this.patientFhirResource.get({ patientId: patientId }).$promise;
    }
  }, {
    key: 'fetchPatientsList',
    value: function fetchPatientsList(pageRequestData) {
      return this.patientsResource.getPatientsList(pageRequestData).$promise;
    }
  }, {
    key: 'fetchPatientQualityMeasures',
    value: function fetchPatientQualityMeasures(patientId, year) {
      return this.patientQualityMeasuresResource.fetchQualityMeasures({ patientId: patientId, year: year }).$promise;
    }
  }, {
    key: 'fetchPatientGapRelatedActionPlans',
    value: function fetchPatientGapRelatedActionPlans(patientId, measureReportId) {
      return this.patientQualityMeasuresResource.fetchRelatedActionPlans({ patientId: patientId, measureReportId: measureReportId }).$promise;
    }
  }, {
    key: 'fetchPatientActionPlans',
    value: function fetchPatientActionPlans(pageRequestData) {
      return this.patientActionPlansResource.fetchActionPlansPage(pageRequestData).$promise;
    }
  }, {
    key: 'fetchPatientAppointmentsPage',
    value: function fetchPatientAppointmentsPage(pageRequestData) {
      return this.patientAppointmentResource.fetchAppointmentsPage(pageRequestData).$promise;
    }
  }, {
    key: 'getPatientTestResults',
    value: function getPatientTestResults(pageRequestData) {
      return this.patientTestResultsResource.fetchPatientTestResults(pageRequestData).$promise;
    }
  }, {
    key: 'getPatientVendors',
    value: function getPatientVendors(patientId) {
      return this.patientVendorResource.fetchPatientVendors({ patientId: patientId }).$promise;
    }
  }, {
    key: '_extractPatientsFromResponse',
    value: function _extractPatientsFromResponse(response) {
      return angular.fromJson(response);
    }
  }, {
    key: '_extractDataFromResponse',
    value: function _extractDataFromResponse(response) {
      var jsonResponse = angular.fromJson(response);
      return _.has(jsonResponse, 'data') ? jsonResponse.data : jsonResponse;
    }
  }]);

  return ApmPatientsService;
}();

angular.module('apm.components.patients').service('apmPatientsService', ApmPatientsService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientsRoutes = function () {
  function PatientsRoutes() {
    _classCallCheck(this, PatientsRoutes);
  }

  _createClass(PatientsRoutes, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($stateProvider) {

      $stateProvider.state('patients', {
        url: '/patients',
        abstract: true,
        template: '<ui-view></ui-view>'

      }).state('patients.list', {
        url: '/list',
        component: 'apmPatientsList',
        data: { pageTitle: 'Patients' }
      }).state('patients.profile', {
        url: '/:patientId/profile',
        component: 'apmPatientProfile',
        data: { pageTitle: 'Patient Profile' }
      });
    }
  }]);

  return PatientsRoutes;
}();

angular.module('apm.components.patients').config(PatientsRoutes.config);
'use strict';

angular.module('apm.components.patients').component('apmPatientsList', {
  templateUrl: 'app/components/patients/apm.patients.list.html'
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmProvidersService = function () {

  /** @ngInject */
  function ApmProvidersService($resource, API_BASE_URL) {
    _classCallCheck(this, ApmProvidersService);

    this.providerListResource = $resource(API_BASE_URL + '/fhir/Practitioner', {}, {
      fetchProviderList: {
        method: 'GET',
        transformResponse: this._extractResponse,
        isArray: false
      }
    });
  }

  _createClass(ApmProvidersService, [{
    key: '_extractResponse',
    value: function _extractResponse(response) {
      return angular.fromJson(response);
    }
  }, {
    key: 'fetchProviderListPage',
    value: function fetchProviderListPage(pageRequestData) {
      return this.providerListResource.fetchProviderList(pageRequestData).$promise;
    }
  }]);

  return ApmProvidersService;
}();

angular.module('apm.components.providers').service('apmProvidersService', ApmProvidersService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProvidersRoutes = function () {
  function ProvidersRoutes() {
    _classCallCheck(this, ProvidersRoutes);
  }

  _createClass(ProvidersRoutes, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($stateProvider, $urlRouterProvider) {

      $urlRouterProvider.when('/providers', '/providers/list');

      $stateProvider.state('providers', {
        url: '/providers',
        template: '<ui-view></ui-view>',
        abstract: true
      }).state('providers.list', {
        url: '/list',
        templateUrl: 'app/components/providers/apm.providers.list.html',
        data: { pageTitle: 'Provider List' }
      }).state('providers.details', {
        url: '/:id',
        component: 'apmProviderDetails',
        data: { pageTitle: 'Provider Details' }
      });
    }
  }]);

  return ProvidersRoutes;
}();

angular.module('apm.components.providers').config(ProvidersRoutes.config);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeRoutes = function () {
  function HomeRoutes() {
    _classCallCheck(this, HomeRoutes);
  }

  _createClass(HomeRoutes, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($stateProvider) {
      $stateProvider.state('home', {
        url: '/',
        component: 'home',

        data: { pageTitle: 'Home' }
      });
    }
  }]);

  return HomeRoutes;
}();

angular.module('apm.components.home').config(HomeRoutes.config);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeController = function () {

  /** @ngInject */
  function HomeController($mdDialog, $scope, apmAuthenticationService, authenticationService) {
    _classCallCheck(this, HomeController);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      apmAuthenticationService: apmAuthenticationService,
      authenticationService: authenticationService,

      canViewReports: false
    });
  }

  _createClass(HomeController, [{
    key: '$onInit',
    value: function $onInit() {
      this._setAccess();

      var daysForPasswordExpiration = this.authenticationService.getDaysForPasswordExpiration();
      if (daysForPasswordExpiration > 0) {
        this.authenticationService.setDaysForPasswordExpiration(0);
        this._openExpirePasswordAdviceDialog(daysForPasswordExpiration);
      }
    }
  }, {
    key: '_openExpirePasswordAdviceDialog',
    value: function _openExpirePasswordAdviceDialog(daysForPasswordExpiration) {
      var scope = angular.extend(this.$scope.$new(true), {
        daysForPasswordExpiration: daysForPasswordExpiration
      });
      this.$mdDialog.show({
        template: '<md-dialog aria-label="modal"><update-password-advice-modal class="Update-password-advice-modal" days-for-password-expiration="daysForPasswordExpiration" /></md-dialog>',
        scope: scope,
        clickOutsideToClose: true
      });
    }
  }, {
    key: '_setAccess',
    value: function _setAccess() {
      this.canViewReports = this.apmAuthenticationService.hasAccess('scAPReport');
    }
  }]);

  return HomeController;
}();

angular.module('apm.components.home').component('home', {
  templateUrl: 'app/components/home/apm.home.html',
  controller: HomeController
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmEditPhoneNumberController = function () {
  function ApmEditPhoneNumberController($scope, $state, $stateParams, scFhirApi) {
    _classCallCheck(this, ApmEditPhoneNumberController);

    _.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      scFhirApi: scFhirApi,

      label: '',
      loading: false,
      newNumber: '',
      patientId: '',
      patientObj: {},
      telecom: []
    });
  }

  _createClass(ApmEditPhoneNumberController, [{
    key: '$onInit',
    value: function $onInit() {
      this.patientId = this.patientInfo || this.$stateParams.patientId;
      this.label = this.$state.current.name === 'patients.profile' ? '(###) ###-####' : 'Add New';
      this._getPatient();
    }
  }, {
    key: 'addNewNumber',
    value: function addNewNumber(number) {
      if (number) {
        if (_.has(this.patientObj, 'telecom') && _.isArray(this.patientObj.telecom)) {
          this.patientObj.telecom = _.forEach(this.patientObj.telecom, this._setRank);
        } else {
          this.patientObj.telecom = [];
        }
        this.patientObj.telecom.push({
          rank: 1,
          use: 'home',
          system: 'phone',
          value: number.toString()
        });
        this._savePatient();
      }
    }
  }, {
    key: 'setPreferred',
    value: function setPreferred(number) {
      var _this = this;

      if (number) {
        number = number.toString();
        this.telecom = _.forEach(this.patientObj.telecom, function (el) {
          _this._setRank(el);
          if (el.value === number) {
            el.rank = 1;
          }
        });
        this._savePatient();
      }
    }
  }, {
    key: '_getPatient',
    value: function _getPatient() {
      var _this2 = this;

      this.scFhirApi.getPatient(this.patientId).then(function (response) {
        return _this2._getPatientSuccess(response);
      }).catch(function (err) {
        return _this2.onError({ err: err });
      });
    }
  }, {
    key: '_getPatientSuccess',
    value: function _getPatientSuccess(response) {
      this.patientObj = response.data;
      this.telecom = this._setViewValues(response);
    }
  }, {
    key: '_savePatient',
    value: function _savePatient() {
      var _this3 = this;

      this.loading = true;
      this.scFhirApi.savePatient(this.patientObj, true).then(function (response) {
        return _this3._savePatientSuccess(response);
      }).catch(function (err) {
        return _this3._savePatientError(err);
      });
    }
  }, {
    key: '_savePatientSuccess',
    value: function _savePatientSuccess(response) {
      this.loading = false;
      this.telecom = this._setViewValues(response);
      this.newNumber = '';
      this.$scope.$emit('number-updated', this.telecom);
    }
  }, {
    key: '_savePatientError',
    value: function _savePatientError(err) {
      this.loading = false;
      this.onError({ err: err });
    }
  }, {
    key: '_setRank',
    value: function _setRank(el) {
      if (el.rank === 1) {
        delete el.rank;
      }
      if (el.use === 'mobile') {
        el.rank = 2;
      }
      if (el.use === 'home') {
        el.rank = 3;
      }
      if (el.use === 'work') {
        el.rank = 4;
      }
      if (el.use === 'other') {
        el.rank = 5;
      }
      if (el.use === 'temp') {
        el.rank = 6;
      }
    }
  }, {
    key: '_setViewValues',
    value: function _setViewValues(response) {
      if (_.has(response, 'data.telecom') && response.data.telecom.length) {
        response.data.telecom = _.uniq(_.sortBy(response.data.telecom, 'rank'), function (el) {
          return el.value;
        });
        return response.data.telecom;
      }
      return [];
    }
  }]);

  return ApmEditPhoneNumberController;
}();

angular.module('apm.components.editPhoneNumber', []).component('apmEditPhoneNumber', {
  templateUrl: 'app/components/editPhoneNumber/apm.editPhoneNumber.html',
  controller: ApmEditPhoneNumberController,
  bindings: {
    patientInfo: '<',
    onError: '&'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmActionPlanService = function () {

  /** @ngInject */
  function ApmActionPlanService($resource, $q, API_BASE_URL) {
    _classCallCheck(this, ApmActionPlanService);

    var baseUrl = API_BASE_URL + '/ap';
    this.$q = $q;
    this.actionPlanOperationToPermission = {
      SubmitActionPlanForApproval: 'scAPWorkflowSubmit',
      ApproveActionPlan: 'scAPWorkflowApprove',
      StartActionPlan: 'scAPWorkflowStart',
      RemindAppointment: 'scAPWorkflowReminders',
      ReportTestResults: 'scAPWorkflowEncounters',
      CompleteActionPlan: 'scAPWorkflowComplete',
      CancelActionPlan: 'scAPWorkflowCancel',
      PutActionPlanOnHold: 'scAPWorkflowOnHold'
    };

    this.actionPlanResource = $resource(null, {}, {
      getActionPlanProperties: {
        method: 'GET',
        url: baseUrl + '/ActionPlanProperties'
      },
      getLocationsByProviders: {
        method: 'GET',
        url: API_BASE_URL + '/sc/Locations'
      },
      getActionPlan: {
        method: 'GET',
        url: '/v1/actionplans/:apId'
      },
      getActionPlans: {
        method: 'GET',
        url: '/v1/actionplans',
        transformResponse: this._extractResponse
      },
      getActionPlanTemplates: {
        method: 'GET',
        url: '/v1/actionplans/templates',
        isArray: true,
        transformResponse: this._extractResponse
      },
      postActionPlanConfig: {
        method: 'POST',
        url: '/v1/actionplans/context',
        transformRequest: function transformRequest(data) {
          return angular.toJson(data);
        },
        transformResponse: this._extractResponse
      },
      putActionPlanConfig: {
        method: 'PUT',
        url: '/v1/actionplans/:apId/context',
        transformRequest: function transformRequest(data) {
          return angular.toJson(data);
        },
        transformResponse: this._extractResponse
      },
      getActionPlanConfig: {
        method: 'GET',
        url: '/v1/actionplans/:apId/context',
        transformResponse: this._extractResponse
      },
      fetchOrganizationList: {
        method: 'GET',
        isArray: true,
        url: API_BASE_URL + '/admin/OrganizationList?type=clinic',
        transformResponse: this._extractResponse
      },
      getActionPlanCalendar: {
        method: 'GET',
        url: '/v1/actionplans/calendar',
        isArray: true,
        transformResponse: this._extractResponse
      },
      setOwnerActionPlan: {
        method: 'PUT',
        url: '/v1/actionplans/:apId/owner'
      },
      assignActionPlan: {
        method: 'PUT',
        url: '/v1/actionplans/:apId/assign/:userId'
      },
      unassignActionPlan: {
        method: 'DELETE',
        url: '/v1/actionplans/:apId/assign'
      },
      getActionPlanPatients: {
        method: 'GET',
        url: '/v1/actionplans/:apId/patients'
      },
      getActionPlanUsers: {
        method: 'GET',
        url: '/v1/actionplans/:apId/users'
      },
      getOpenSlots: {
        method: 'GET',
        url: '/v1/actionplans/:apId/openslots'
      },
      getActionPlanPatient: {
        method: 'GET',
        url: '/v1/actionplans/:apId/patient/:patientId'
      },
      fetchUsers: {
        method: 'GET',
        isArray: false,
        transformResponse: this._extractResponse,
        params: {
          '_sort:asc': 'lName',
          'active': true
        }
      },
      fetchActionPlanUsers: {
        method: 'GET',
        isArray: false,
        transformResponse: this._extractResponse,
        url: API_BASE_URL + '/admin/UserAdmin/actionplanusers'
      },
      getValueSetGroup: {
        method: 'GET',
        url: API_BASE_URL + '/sc/valueset/:group/:path',
        transformResponse: function transformResponse(response) {
          return angular.fromJson(response);
        }
      }
    });
    this.actionPlanTitle = '';
  }

  _createClass(ApmActionPlanService, [{
    key: 'setActionPlanTitle',
    value: function setActionPlanTitle(title) {
      this.actionPlanTitle = title;
    }
  }, {
    key: 'getActionPlanTitle',
    value: function getActionPlanTitle() {
      return this.actionPlanTitle;
    }
  }, {
    key: 'getActionPlan',
    value: function getActionPlan(apId) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = {};
      resourceParams.apId = apId;
      return this.actionPlanResource.getActionPlan(resourceParams).$promise;
    }
  }, {
    key: 'fetchActionPlansPage',
    value: function fetchActionPlansPage(pageRequest) {
      return this.actionPlanResource.getActionPlans(pageRequest).$promise;
    }
  }, {
    key: 'getActionPlanPatients',
    value: function getActionPlanPatients(apId, queryParameters) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = queryParameters ? this._normalizeQueryParams(queryParameters) : {};
      resourceParams.apId = apId;
      return this.actionPlanResource.getActionPlanPatients(resourceParams).$promise;
    }
  }, {
    key: 'getActionPlanPatient',
    value: function getActionPlanPatient(apId, patientId, queryParameters) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = queryParameters ? this._normalizeQueryParams(queryParameters) : {};
      resourceParams.apId = apId;
      resourceParams.patientId = patientId;
      return this.actionPlanResource.getActionPlanPatient(resourceParams).$promise;
    }
  }, {
    key: 'getTimeSlots',
    value: function getTimeSlots(apId) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = {};
      resourceParams.apId = apId;
      return this.actionPlanResource.getOpenSlots(resourceParams).$promise;
    }
  }, {
    key: 'assignActionPlan',
    value: function assignActionPlan(apId, userId) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      if (!userId) {
        return this.$q.reject({ message: 'No User ID found.' });
      }
      var resourceParams = {};
      resourceParams.apId = apId;
      resourceParams.userId = userId;
      return this.actionPlanResource.assignActionPlan(resourceParams, resourceParams).$promise;
    }
  }, {
    key: 'unassignActionPlan',
    value: function unassignActionPlan(apId) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = {};
      resourceParams.apId = apId;
      return this.actionPlanResource.unassignActionPlan(resourceParams).$promise;
    }
  }, {
    key: 'setOwnerActionPlan',
    value: function setOwnerActionPlan(apId, ownerId) {
      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = {
        apId: apId
      };
      var resourceData = { ownerId: ownerId };
      return this.actionPlanResource.setOwnerActionPlan(resourceParams, resourceData).$promise;
    }
  }, {
    key: 'getActionPlanUsers',
    value: function getActionPlanUsers(apId, roles) {
      var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!apId) {
        return this.$q.reject({ message: 'No Action Plan ID found.' });
      }
      var resourceParams = {};
      resourceParams.apId = apId;
      resourceParams['_sort:asc'] = 'lName';
      resourceParams['active'] = active;
      if (roles) {
        resourceParams.role = roles.join(',');
      }
      return this.actionPlanResource.getActionPlanUsers(resourceParams).$promise;
    }
  }, {
    key: 'getActionPlanCalendar',
    value: function getActionPlanCalendar(startDate, endDate, excludeUser, excludeRole) {
      if (!startDate && !endDate) {
        return this.$q.reject({ message: 'Must have a start and end date' });
      }
      var resourceParams = {};
      resourceParams.startDate = startDate;
      resourceParams.endDate = endDate;
      if (excludeUser) {
        resourceParams.excludeUser = excludeUser;
      }
      if (excludeRole) {
        resourceParams.excludeRole = excludeRole;
      }
      return this.actionPlanResource.getActionPlanCalendar(resourceParams).$promise;
    }
  }, {
    key: 'getLocationsByProviders',
    value: function getLocationsByProviders(providers) {
      var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var county = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var zip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      if (!providers || _.size(providers) === 0) {
        return this.$q.reject({ message: 'No providers found.' });
      }

      var resourceParams = {};
      resourceParams.providerId = providers.join(',');
      if (address) {
        resourceParams.address = address;
      }
      if (county) {
        resourceParams.county = county;
      }
      if (zip) {
        resourceParams.zip = zip;
      }

      return this.actionPlanResource.getLocationsByProviders(resourceParams).$promise;
    }
  }, {
    key: '_extractResponse',
    value: function _extractResponse(response) {
      var responseJSON = angular.fromJson(response);
      return responseJSON.success ? responseJSON.data : responseJSON;
    }
  }, {
    key: '_normalizeQueryParams',
    value: function _normalizeQueryParams(queryParameters) {
      var normalizedParams = {};
      _.forEach(queryParameters, function (param, key) {
        if (angular.isObject(param)) {
          if (key === 'sorting') {
            normalizedParams[param[0].key] = param[0].value;
          } else {
            _.forEach(param, function (propertyValue, propertyKey) {
              normalizedParams[propertyKey] = propertyValue;
            });
          }
        } else {
          /*flat property*/
          normalizedParams[key] = param;
        }
      });

      return normalizedParams;
    }
  }, {
    key: 'getActionPlanProperties',
    value: function getActionPlanProperties() {
      return this.actionPlanResource.getActionPlanProperties().$promise;
    }
  }, {
    key: 'getActionPlanTemplates',
    value: function getActionPlanTemplates() {
      return this.actionPlanResource.getActionPlanTemplates().$promise;
    }
  }, {
    key: 'saveActionPlanConfig',
    value: function saveActionPlanConfig(postObj, type) {
      if (type === 'putActionPlanConfig') {
        var resourceParams = { apId: postObj.actionPlanId };
        return this.actionPlanResource[type](resourceParams, postObj).$promise;
      }
      return this.actionPlanResource[type](postObj).$promise;
    }
  }, {
    key: 'getActionPlanConfig',
    value: function getActionPlanConfig(apId) {
      var resourceParams = {};
      resourceParams.apId = apId;
      return this.actionPlanResource.getActionPlanConfig(resourceParams).$promise;
    }
  }, {
    key: 'getOrganizationList',
    value: function getOrganizationList() {
      return this.actionPlanResource.fetchOrganizationList().$promise;
    }
  }, {
    key: 'getUsers',
    value: function getUsers() {
      return this.actionPlanResource.fetchUsers().$promise;
    }
  }, {
    key: 'fetchActionPlanUsers',
    value: function fetchActionPlanUsers(params) {
      return this.actionPlanResource.fetchActionPlanUsers(params).$promise;
    }
  }, {
    key: 'getValueSetGroup',
    value: function getValueSetGroup(group, path) {
      var resourceParams = {};
      resourceParams.group = group;
      resourceParams.path = path;
      return this.actionPlanResource.getValueSetGroup(resourceParams).$promise;
    }
  }, {
    key: 'getPermissionsByOperation',
    value: function getPermissionsByOperation(operationName) {
      return _.get(this.actionPlanOperationToPermission, operationName);
    }
  }]);

  return ApmActionPlanService;
}();

angular.module('apm.components.actionPlans').service('apmActionPlanService', ApmActionPlanService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionPlansRoutes = function () {
  function ActionPlansRoutes() {
    _classCallCheck(this, ActionPlansRoutes);
  }

  _createClass(ActionPlansRoutes, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.when('/actionPlans', '/actionPlans/list');
      $stateProvider.state('actionPlans', {
        url: '/actionPlans',
        abstract: true,
        template: '<ui-view></ui-view>'
      }).state('actionPlans.details', {
        url: '/{id:[0-9a-fA-F]+}',
        component: 'apmDetails'
      }).state('actionPlans.schedule', {
        url: '/:planId/schedule/:patientId',
        component: 'scheduleActions'
      }).state('actionPlans.reminder', {
        url: '/:planId/reminder/:patientId',
        component: 'reminderActions'
      }).state('actionPlans.encounter', {
        url: '/:planId/encounter/:patientId',
        component: 'encounterActions'
      }).state('actionPlans.list', {
        url: '/list',
        component: 'apmActionPlanList',
        data: { pageTitle: 'Action Plans' }
      }).state('actionPlans.calendar', {
        url: '/calendar',
        component: 'apmCalendar',
        data: { pageTitle: 'Action Plans Calendar' }
      }).state('actionPlans.createEdit', {
        url: '/createEdit',
        component: 'apmActionPlanCreateEdit',
        data: { pageTitle: 'Create/Edit Action Plan' }
      }).state('actionPlans.edit', {
        url: '/:id/edit',
        component: 'apmCreateEditActionPlan',
        data: { pageTitle: 'Edit' }
      }).state('actionPlans.configure', {
        url: '/:id/configure',
        component: 'configureActionPlan',
        data: { pageTitle: 'Configure' }
      });
    }
  }]);

  return ActionPlansRoutes;
}();

angular.module('apm.components.actionPlans').config(ActionPlansRoutes.config);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmActionPlansFactory = function () {
  function ApmActionPlansFactory() {
    _classCallCheck(this, ApmActionPlansFactory);
  }

  _createClass(ApmActionPlansFactory, [{
    key: 'isEdit',
    value: function isEdit(APObject) {
      var editOnlyStatuses = ['DRAFT', 'PENDING', 'ON_HOLD'];

      if (APObject && APObject.actionPlanStatus) {
        return _.findIndex(editOnlyStatuses, function (el) {
          return el === APObject.actionPlanStatus;
        }) >= 0;
      }

      return false;
    }
  }, {
    key: 'isLimitedEdit',
    value: function isLimitedEdit(configObject) {
      var extendedStatusList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var enabledStatuses = !extendedStatusList ? ['SCHEDULING', 'REMINDERS', 'ENCOUNTERS', 'APPROVED'] : ['DRAFT', 'SCHEDULING', 'REMINDERS', 'ENCOUNTERS', 'PENDING', 'APPROVED', 'ON_HOLD'];

      if (configObject && configObject.status) {
        return _.findIndex(enabledStatuses, function (el) {
          return el === configObject.status;
        }) >= 0;
      }

      return false;
    }
  }, {
    key: 'getTimes',
    value: function getTimes() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '6:00am';
      var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '8:00pm';
      var appointmentLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

      if (appointmentLength === '') {
        return [];
      }
      var time = moment(startTime, 'h:mma').add(-appointmentLength, 'minutes');
      var times = [];
      while (time.isBefore(moment(endTime, 'h:mma'), 'hour')) {
        time = time.add(appointmentLength, 'minutes');
        times.push(time.format('h:mma'));
      }
      return times;
    }
  }, {
    key: 'getStatuses',
    value: function getStatuses() {
      return [{
        code: 'DRAFT',
        display: 'Draft'
      }, {
        code: 'PENDING',
        display: 'Pending'
      }, {
        code: 'APPROVED',
        display: 'Approved'
      }, {
        code: 'ON_HOLD',
        display: 'On Hold'
      }, {
        code: 'SCHEDULING',
        display: 'Scheduling'
      }, {
        code: 'REMINDERS',
        display: 'Reminders'
      }, {
        code: 'ENCOUNTERS',
        display: 'Encounters'
      }, {
        code: 'COMPLETED',
        display: 'Completed'
      }, {
        code: 'CANCELLED',
        display: 'Cancelled'
      }];
    }
  }, {
    key: 'showActionPlan',
    value: function showActionPlan(status) {
      return status === 'APPROVED' || status === 'SCHEDULING' || status === 'REMINDERS' || status === 'ENCOUNTERS';
    }
  }, {
    key: 'setProgress',
    value: function setProgress(actionPlan) {
      var appointments = void 0;
      if (actionPlan.status) {
        switch (actionPlan.status) {
          case 'SCHEDULING':
            appointments = _.find(actionPlan.headerCalculations, { 'label': 'Appts Filled' });
            actionPlan.progress = (appointments && appointments.value ? appointments.value : 0) + ' % Scheduled';
            break;
          case 'REMINDERS':
            appointments = _.find(actionPlan.headerCalculations, { 'label': 'Appts Confirmed' });
            actionPlan.progress = (appointments && appointments.value ? appointments.value : 0) + ' % Confirmed';
            break;
          case 'ENCOUNTERS':
            appointments = _.find(actionPlan.headerCalculations, { 'label': 'No Shows' });
            actionPlan.progress = (appointments && appointments.value ? appointments.value : 0) + ' No Shows';
            break;
        }
      }
      if (!this.showActionPlan(actionPlan.status)) {
        actionPlan.progress = 'N/A';
      }

      return actionPlan.progress;
    }
  }, {
    key: 'setEventDates',
    value: function setEventDates(actionPlan) {
      if (actionPlan.eventDates.length) {
        return moment(actionPlan.eventDates[0]).format('MM/DD/YYYY').replace(/,/g, ', ');
      }
    }
  }, {
    key: 'isFilterEmpty',
    value: function isFilterEmpty(filter) {
      var filterEmptyBool = true;

      _.forIn(filter, function (filter_value) {
        if (filter_value !== '' && filter_value !== null) {
          filterEmptyBool = false;
          return false;
        }
      });

      return filterEmptyBool;
    }
  }, {
    key: 'resolveFilters',
    value: function resolveFilters(filter) {
      var newFilters = _.clone(filter);

      _.forIn(newFilters, function (value, key) {
        switch (key) {
          case 'selectedAssignee':
          case 'selectedOwner':
            delete newFilters[key];
            break;
        }
        switch (value) {
          case null:
          case '':
            delete newFilters[key];
            break;
        }
      });

      return newFilters;
    }
  }]);

  return ApmActionPlansFactory;
}();

angular.module('apm.components.actionPlans.factories', []).service('apmActionPlansFactory', ApmActionPlansFactory);
'use strict';

/* eslint-disable */
var seconds = 0;
var intervalHandler = null;

function countdown() {
  if (seconds === 0) {
    clearInterval(intervalHandler);
    self.postMessage('promptTimeoutModal');
  } else {
    seconds -= 1;
  }
}

self.addEventListener('message', function () {
  seconds = 720; // 60 * 12 (minutes) before "3 minutes left" dialog be prompted
  if (intervalHandler) {
    clearInterval(intervalHandler);
  }
  intervalHandler = setInterval(countdown, 1000);
}, false);
'use strict';

angular.module('apm.services', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmSessionService = function () {

  /** @ngInject */
  function ApmSessionService($rootScope, $resource, API_BASE_URL, $location) {
    _classCallCheck(this, ApmSessionService);

    _.assign(this, {
      $rootScope: $rootScope,
      $resource: $resource,
      $location: $location,

      sessionResource: {},
      sessionTimeoutWorker: null
    });

    this.sessionResource = this.$resource(API_BASE_URL, {}, {
      getPing: {
        method: 'GET',
        url: API_BASE_URL + '/ping'
      }
    });
  }

  _createClass(ApmSessionService, [{
    key: '$onDestroy',
    value: function $onDestroy() {
      this.terminateSessionTimeoutWorker();
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      this._initializeSessionTimeoutWorker();
    }
  }, {
    key: 'getPing',
    value: function getPing() {
      return this.sessionResource.getPing().$promise;
    }
  }, {
    key: 'keepSessionAlive',
    value: function keepSessionAlive() {
      if (this.$location.host() !== 'localhost') {
        this._initializeSessionTimeoutWorker();
        this.sessionTimeoutWorker.postMessage('keepSessionAlive');
      }
    }
  }, {
    key: 'terminateSessionTimeoutWorker',
    value: function terminateSessionTimeoutWorker() {
      if (this.sessionTimeoutWorker && this.$location.host() !== 'localhost') {
        this.sessionTimeoutWorker.terminate();
        this.sessionTimeoutWorker = null;
      }
    }
  }, {
    key: '_initializeSessionTimeoutWorker',
    value: function _initializeSessionTimeoutWorker() {
      if (!this.sessionTimeoutWorker && this.$location.host() !== 'localhost') {
        this.sessionTimeoutWorker = new Worker('apm.sessionTimeout.js');
        this.sessionTimeoutWorker.addEventListener('message', angular.bind(this, this._promptTimeoutModal), false);
      }
    }
  }, {
    key: '_promptTimeoutModal',
    value: function _promptTimeoutModal() {
      this.$rootScope.$emit('sc-sessionTimeout');
    }
  }]);

  return ApmSessionService;
}();

angular.module('apm.services').service('apmSessionService', ApmSessionService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmAuthenticationService = function () {

  /** @ngInject */
  function ApmAuthenticationService($window) {
    _classCallCheck(this, ApmAuthenticationService);

    _.assign(this, {
      $window: $window
    });
  }

  _createClass(ApmAuthenticationService, [{
    key: 'hasAccess',
    value: function hasAccess(permissionString) {
      var userPermissions = angular.fromJson(this.$window.sessionStorage.getItem('permissions'));
      return _.includes(userPermissions, permissionString);
    }
  }]);

  return ApmAuthenticationService;
}();

angular.module('apm.services').service('apmAuthenticationService', ApmAuthenticationService);
'use strict';

angular.module('apm.filters.phoneNumber', []).filter('phoneNumber', function () {
  return function (tel) {
    if (!tel) {
      return '';
    }
    var value = tel.toString().trim().replace(/^\+/, '');
    if (value.match(/[^0-9]/)) {
      return tel;
    }

    var city = void 0;
    var number = void 0;

    switch (value.length) {
      case 1:
      case 2:
      case 3:
        city = value;
        break;
      default:
        city = value.slice(0, 3);
        number = value.slice(3);
    }

    if (number) {
      if (number.length > 3) {
        number = number.slice(0, 3) + '-' + number.slice(3, 7);
      }
      return ('(' + city + ') ' + number).trim();
    } else {
      return '(' + city;
    }
  };
});
'use strict';

angular.module('apm.filters', ['apm.filters.phoneNumber']);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmNotificationsFactory = function () {

  /** @ngInject */
  function ApmNotificationsFactory($mdDialog, $mdToast, $rootScope) {
    _classCallCheck(this, ApmNotificationsFactory);

    _.assign(this, {
      $mdDialog: $mdDialog,
      $mdToast: $mdToast,
      $rootScope: $rootScope
    });
  }

  _createClass(ApmNotificationsFactory, [{
    key: 'success',
    value: function success(message) {
      this._showNotification(message, 'success');
    }
  }, {
    key: 'error',
    value: function error(message) {
      this._showError(message);
    }
  }, {
    key: 'custom',
    value: function custom(message, type) {
      this._showNotification(message, type);
    }
  }, {
    key: '_showError',
    value: function _showError(message) {
      var scope = angular.extend(this.$rootScope.$new(true), {
        message: message
      });

      this.$mdDialog.show({
        template: '<md-dialog aria-label="Error Message" class="Apm-notify-error-modal"><apm-notify-error-modal error-message="message" /></md-dialog>',
        scope: scope,
        clickOutsideToClose: false
      });
    }
  }, {
    key: '_showNotification',
    value: function _showNotification(message, type) {
      this.$mdToast.show(this.$mdToast.simple().textContent(message).toastClass('md-toast-' + type).position('top right').hideDelay(5000));
    }
  }]);

  return ApmNotificationsFactory;
}();

angular.module('apm.factories.notifications', ['apm.components.notifyError']).service('apmNotificationsFactory', ApmNotificationsFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApmGridFactory = function () {
  function ApmGridFactory() {
    _classCallCheck(this, ApmGridFactory);
  }

  _createClass(ApmGridFactory, [{
    key: 'isFilterEmpty',
    value: function isFilterEmpty(filter) {
      var filterEmptyBool = true;

      _.forIn(filter, function (filter_value) {
        if (filter_value !== '' && filter_value !== null) {
          filterEmptyBool = false;
          return false;
        }
      });

      return filterEmptyBool;
    }
  }, {
    key: 'resolveFilters',
    value: function resolveFilters(filter) {
      var newFilters = _.clone(filter);

      _.forIn(newFilters, function (value, key) {
        switch (key) {
          case 'selectedAssignee':
          case 'selectedOwner':
            delete newFilters[key];
            break;
        }
        switch (value) {
          case null:
          case '':
            delete newFilters[key];
            break;
        }
      });

      return newFilters;
    }
  }]);

  return ApmGridFactory;
}();

angular.module('apm.factories.grid', []).service('apmGridFactory', ApmGridFactory);
'use strict';

angular.module('apm.factories', ['apm.factories.grid']);
'use strict';

angular.module('apm.directives.phoneFormat', []).directive('phoneInput', function ($filter, $browser) {
  return {
    require: 'ngModel',
    link: function link($scope, $element, $attrs, ngModelCtrl) {
      var listener = function listener() {
        var value = $element.val().replace(/[^0-9]/g, '');
        $element.val($filter('phoneNumber')(value, false));
      };

      ngModelCtrl.$parsers.push(function (viewValue) {
        return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
      });

      ngModelCtrl.$render = function () {
        return $element.val($filter('phoneNumber')(ngModelCtrl.$viewValue, false));
      };

      $element.bind('change', listener);
      $element.bind('keydown', function (event) {
        var key = event.keyCode;
        if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) {
          return;
        }
        $browser.defer(listener);
      });

      $element.bind('paste cut', function () {
        return $browser.defer(listener);
      });
    }
  };
});
'use strict';

angular.module('apm.directives.cellButton', []).directive('mdtCustomCellButton', function () {
  return {
    template: '<md-icon class="material-icons edit-pencil no-select">mode_edit</md-icon>'
  };
});
'use strict';

angular.module('apm.directives.enterPress', []).directive('enterPress', function () {
  return function (scope, element, attrs) {
    var bindings = attrs.eventToBind ? attrs.eventToBind : 'keydown keypress';
    element.bind(bindings, function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.enterPress);
        });

        event.preventDefault();
      }
    });
  };
});
'use strict';

angular.module('apm.directives', ['apm.directives.enterPress', 'apm.directives.phoneFormat', 'apm.directives.cellButton']);
'use strict';

angular.module('apm', ['ngCookies', 'mdDataTable', 'scApp', 'apm.components', 'apm.directives', 'apm.factories', 'apm.filters', 'apm.services']).run(function ($rootScope, $mdDialog, $state, $transitions, $window, apmSessionService, apmShowSessionTimeoutService, authenticationService) {
  $transitions.onSuccess({}, function () {
    if ($state.previous.name === 'actionPlans.createEdit' && $window.sessionStorage.getItem('selectedActionPlan')) {
      $window.sessionStorage.removeItem('selectedActionPlan');
    }

    if ($state.current.name !== 'actionPlans.createEdit') {
      $window.sessionStorage.removeItem('actionPlan');
      $window.sessionStorage.removeItem('actionPlanClone');
      $window.sessionStorage.removeItem('templateConfig');
      angular.element('body').removeClass('create');
    }

    if ($state.current.name !== 'actionPlans.calendar') {
      angular.element('body').removeClass('calendar');
    }

    if ($state.current.name === 'login') {
      if (authenticationService.isSessionTimeout()) {
        authenticationService.logout();
      }
    } else {
      $mdDialog.cancel();
      angular.element('.main-container').animate({ scrollTop: 0 }, 200);
    }
  });

  $rootScope.$on('sc-sessionTimeout', function () {
    apmShowSessionTimeoutService.openSessionTimeoutModal();
  });

  $rootScope.$on('sc-loginRequest', function () {
    apmSessionService.terminateSessionTimeoutWorker();
  });

  $rootScope.$on('sc-apiRequest', function () {
    apmSessionService.keepSessionAlive();
  });
});
'use strict';

angular.module('apm').config(function ($mdThemingProvider) {
  $mdThemingProvider.theme('default').primaryPalette('blue-grey', {
    'default': '700',
    'hue-1': '100',
    'hue-2': '300',
    'hue-3': '500'
  }).accentPalette('cyan', {
    'default': '500',
    'hue-1': '100',
    'hue-2': '300',
    'hue-3': '500'
  });
});
'use strict';

angular.module('sc.common.components.login').value('showForgetPasswordLink', false);
'use strict';

angular.module('apm.components.actionPlans').config(['ChartJsProvider', function (ChartJsProvider) {
  ChartJsProvider.setOptions({
    cutoutPercentage: 80,
    elements: {
      arc: {
        borderWidth: 0
      }
    },
    maintainAspectRatio: true,
    chartColors: ['#455a64', '#d3d4e8'],
    responsive: true,
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    }
  });
}]);
'use strict';

angular.module('scApp').constant('scAppConfig', { name: 'apm', displayName: 'APM' }).value('COMPANY_NAME', 'WellMed').value('COMPANY_LOGO', 'assets/images/branding/biodatai-logo.png').constant('PAGE_SIZES', [10, 20]).constant('ROLES', { LSA: 'ROLE_APM_LSA', PSR: 'ROLE_APM_PSR', PSU: 'ROLE_APM_PSU', NP: 'ROLE_APM_NP', MANAGEMENT: 'ROLE_APM_Management' });
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionInterceptorConfig = function () {
  function SessionInterceptorConfig() {
    _classCallCheck(this, SessionInterceptorConfig);
  }

  _createClass(SessionInterceptorConfig, null, [{
    key: 'config',


    /** @ngInject */
    value: function config($httpProvider) {
      $httpProvider.interceptors.push(SessionInterceptorConfig.sessionInterceptor);
    }

    /** @ngInject */

  }, {
    key: 'sessionInterceptor',
    value: function sessionInterceptor($q, $rootScope, API_BASE_URL) {
      return {
        request: function request(config) {
          var loginURL = API_BASE_URL + '/Login';
          var statusURL = API_BASE_URL + '/Status';

          if (config.url && _.includes(config.url, API_BASE_URL)) {
            // is an API request
            if (_.includes(config.url, loginURL)) {
              // is Login page request then stop session timeout countdown
              $rootScope.$emit('sc-loginRequest');
            } else if (!_.includes(config.url, statusURL)) {
              $rootScope.$emit('sc-apiRequest');
            }
          }
          return config;
        },

        responseError: function responseError(rejection) {
          if (401 === rejection.status) {
            // we want to do a logout which will redirect to the login page
            // for all api calls
            if (rejection.config.url.indexOf(API_BASE_URL + '/Login') === -1) {
              // this is a timeout on an api call other than login or logout
              // we are sending a message this is a timeout.
              $rootScope.$emit('sc-apiNotAuthorized', {
                isTimeout: true
              });
            } else if (rejection.config.method === 'DELETE') {
              // this is a logout
              $rootScope.$emit('sc-apiNotAuthorized', {
                isTimeout: false
              });
            }
          }
          return $q.reject(rejection);
        }
      };
    }
  }]);

  return SessionInterceptorConfig;
}();

angular.module('apm').config(SessionInterceptorConfig.config);
'use strict';

angular.module('apm').constant('API_BASE_URL', '/v1');
'use strict';

angular.module('apm.components', ['ngResource', 'material.components.expansionPanels', 'ui.calendar', 'apm.components.layout', 'apm.components.home', 'apm.components.actionPlans', 'apm.components.patients', 'apm.components.providers', 'apm.components.reports', 'apm.components.resources', 'apm.components.editPhoneNumber', 'apm.components.sessionTimeout']);
'use strict';

angular.module('apm').config(function ($urlRouterProvider) {
  $urlRouterProvider.when('', '/');
});
angular.module("scApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/editPhoneNumber/apm.editPhoneNumber.html","<form class=\"edit-phone-container\" name=\"apmPreferredPhoneForm\" layout-gt-sm=\"row\" layout=\"column\">\n    <div>\n        <label>Preferred Phone Number: &nbsp;</label>\n    </div>\n    <div>\n        <span ng-repeat=\"contact in $ctrl.telecom\" ng-if=\"!$ctrl.loading\">\n            <p ng-if=\"$first\" class=\"preferred-phone-number\">{{contact.value | phoneNumber}}</p>\n            <p ng-if=\"!$first\">{{contact.value | phoneNumber}} <a href=\"\" class=\"preferred-link\" ng-click=\"$ctrl.setPreferred(contact.value)\"> MAKE PREFERRED</a></p>\n        </span>\n        <sc-loading-spinner ng-if=\"$ctrl.loading\" diameter=\"25\"></sc-loading-spinner>\n        <md-input-container>\n            <label>{{ $ctrl.label }}</label>\n            <input type=\"text\" ng-model=\"$ctrl.newNumber\" enter-press=\"$ctrl.addNewNumber($ctrl.newNumber)\" name=\"newNumber\" class=\"new-number-input\" phone-input minlength=\"14\">\n            <a href=\"\" class=\"preferred-link add\" ng-click=\"$ctrl.addNewNumber($ctrl.newNumber)\"> ADD PREFERRED</a>\n        </md-input-container>\n    </div>\n</form>\n");
$templateCache.put("app/components/home/apm.home.html","<div layout=\"row\" flex=\"grow\">\n    <h3 flex=\"grow\" class=\"page-title\">Active Action Plans</h3>\n    <span flex=\"grow\" layout=\"row\" layout-align=\"end center\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"actionPlans.createEdit\" access-type=\"PERMISSION\" access-control=\"scAPAdmin,scAPWorkflowCreate\">\n            Create Action Plan\n        </md-button>\n    </span>\n</div>\n<div layout-gt-md=\"row\" layout=\"row\" ng-cloak>\n    <apm-action-plan-simple-grid class=\"ap-grid\" ng-cloak></apm-action-plan-simple-grid>\n</div>\n\n\n");
$templateCache.put("app/components/patients/apm.patients.list.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Patients</h3>\n</div>\n\n<apm-patients-grid flex=\"grow\" sorting=\"[{key: \'_sort:desc\', value: \'lastName\' }]\"></apm-patients-grid>\n");
$templateCache.put("app/components/providers/apm.providers.list.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Providers</h3>\n</div>\n\n<apm-providers-grid sorting=\"[{key: \'_sort:asc\', value: \'lName\' }]\" ng-cloak></apm-providers-grid>\n");
$templateCache.put("app/components/reports/apm.reports.callLog.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Action Plan Call Log Report</h3>\n</div>\n\n<apm-call-log-report></apm-call-log-report>\n");
$templateCache.put("app/components/reports/apm.reports.list.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Completed Action Plans</h3>\n</div>\n\n<div layout-gt-sm=\"row\" layout=\"column\">\n    <apm-reports-grid flex=\"grow\" sorting=\"[{key: \'_sort:desc\', value: \'lastUpdated\' }]\"></apm-reports-grid>\n</div>\n");
$templateCache.put("app/components/resources/apm.resources.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Resources</h3>\n</div>\n\n<apm-resources-grid sorting=\"[{key: \'_sort:asc\', value: \'lName\' }]\" ng-cloak></apm-resources-grid>");
$templateCache.put("app/components/sessionTimeoutModal/apm.sessionTimeoutModal.component.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Session Timeout</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close(); $ctrl.logout();\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-content class=\"session-timeout-modal-content\">\n    <audio autoplay>\n        <source src=\"assets/sounds/alert.mp3\">\n    </audio>\n    <div layout=\"column\" layout-align=\"center center\">\n        <div layout=\"row\" class=\"message-container\">\n            <div>\n                <md-icon>schedule</md-icon>\n            </div>\n            <div>\n                <p>Your online session will expire in</p>\n            </div>\n        </div>\n\n        <div layout=\"row\" class=\"countdown-container\">\n            <span>{{$ctrl.minutes}} min {{$ctrl.seconds}} secs</span>\n        </div>\n\n        <div layout=\"row\" class=\"instructions-container\">\n            <p>Please click \"Continue\" to keep working;<br>or click \"Logout\" to end your session</p>\n        </div>\n    </div>\n\n    <div layout=\"row\" layout-align=\"end end\" class=\"buttons-container\">\n        <md-button class=\"md-accent\" ng-click=\"$ctrl.close(); $ctrl.logout();\">Logout\n        </md-button>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.close(); $ctrl.continue();\">Continue\n        </md-button>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/actionPlans/assignee/apm.assignee.assigneeModal.button.component.html","<div class=\"assignee\">\n    <md-icon ng-if=\"!$ctrl.actionPlan.assigneeName && $ctrl.isStatusEditable()\" ng-click=\"$ctrl.showAssigneeModal()\" class=\"no-select\">person_add</md-icon>\n    <span ng-if=\"$ctrl.actionPlan.assigneeName\" ng-class=\"{ \'enabled-link\' : $ctrl.isStatusEditable() }\" ng-click=\"!$ctrl.isStatusEditable() || $ctrl.showAssigneeModal()\" class=\"no-select\">{{$ctrl.actionPlan.assigneeName}}</span>\n</div>");
$templateCache.put("app/components/actionPlans/assignee/apm.assignee.assigneeModal.component.html","<md-toolbar class=\"_md _md-toolbar-transitions\">\n    <div class=\"md-toolbar-tools\">\n        <h2>Assignee</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content class=\"dialog-content\" layout-margin>\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n    <md-input-container>\n        <md-autocomplete class=\"md-autocomplete\" md-floating-label=\"Enter Assignee Name\" md-items=\"item in $ctrl.getMatches($ctrl.searchText)\" md-selected-item=\"$ctrl.selectedItem\" md-selected-item-change=\"$ctrl.selectedItemChange()\" md-search-text=\"$ctrl.searchText\" md-search-text-change=\"$ctrl.getMatches($ctrl.searchText)\" enter-press=\"$ctrl.setName($ctrl.filter.selectedItem)\" md-item-text=\"item.fullName\" md-min-length=\"0\">\n            <md-item-template>\n                <span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{item.fullName}}</span>\n            </md-item-template>\n        </md-autocomplete>\n        <div ng-if=\"$ctrl.getAssignee()\">\n            <h3 class=\"inner-label\">Current Assignee</h3>\n            <p>{{$ctrl.getAssignee()}}<md-icon title=\"Clear Assignee\" ng-click=\"$ctrl.clearAssignee()\">delete</md-icon></p>\n        </div>\n    </md-input-container>\n</md-dialog-content>\n<md-dialog-actions class=\"dialog-actions\">\n    <md-button class=\"md-accent\" ng-click=\"$ctrl.close()\" aria-label=\"button\" ng-disabled=\"$ctrl.saving\">CANCEL</md-button>\n    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.setName($ctrl.selectedItem)\" ng-disabled=\"!$ctrl.saveEnabled || $ctrl.saving\" aria-label=\"button\">\n        <span ng-if=\"!$ctrl.saving\">SAVE</span>\n        <sc-loading-spinner class=\"assignee-modal\" ng-if=\"$ctrl.saving\"></sc-loading-spinner>\n    </md-button>\n</md-dialog-actions>\n");
$templateCache.put("app/components/actionPlans/calendar/apm.actionPlans.calendar.html","<div class=\"action-plan-calendar-sidebar\" layout=\"row\" layout-fill>\n    <div class=\"calendar-wrapper\" flex=\"66\">\n        <div layout-gt-sm=\"row\" layout=\"column\">\n            <div class=\"calendar-container\">\n                <div class=\"mdtTableContainer\">\n                    <md-progress-linear md-mode=\"indeterminate\" class=\"loading-indicator loading-indicator-calendar\" ng-class=\"{\'loading-is-active\': $ctrl.isLoading}\"></md-progress-linear>\n                </div>\n                <div ui-calendar=\"$ctrl.calendarConfig\" ng-model=\"$ctrl.calendarData\" id=\"calendar\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"md-sidebar\" layout=\"column\" flex=\"33\">\n        <apm-calendar-checkbox-resources available-resources=\"$ctrl.availableResources\"></apm-calendar-checkbox-resources>\n        <div class=\"button-container\">\n            <md-button ng-click=\"$ctrl.onCheckboxFilter($ctrl.availableResources)\" class=\"md-accent md-raised\">Filter</md-button>\n        </div>\n    </div>\n</div>\n\n");
$templateCache.put("app/components/actionPlans/createEdit/apm.actionPlans.createEdit.html","<md-tabs class=\"tab-steps\" md-selected=\"$ctrl.selectedIndex\" md-dynamic-height md-border-bottom md-center-tabs md-no-ink-bar md-no-ink>\n    <md-tab label=\"Population\">\n        <md-content class=\"md-padding\">\n            <apm-action-plan-create-population>\n        </apm-action-plan-create-population></md-content>\n    </md-tab>\n    <md-tab label=\"Assign Event\">\n        <div class=\"assign-event\">\n            <md-content layout=\"row\" layout-align=\"start stretch\">\n                <div class=\"calendar-wrapper\" flex=\"66\">\n                    <div class=\"title-wrapper\">\n                        <apm-action-plan-header class=\"Apm-action-plan-header\" title=\"$ctrl.apmActionPlanService.getActionPlanTitle()\"></apm-action-plan-header>\n                    </div>\n                    <div layout-gt-sm=\"row\" layout=\"column\">\n                        <div flex=\"100\" class=\"calendar-container\">\n                            <div class=\"mdtTableContainer\">\n                                <md-progress-linear md-mode=\"indeterminate\" class=\"loading-indicator loading-indicator-calendar\" ng-class=\"{\'loading-is-active\': $ctrl.isLoading}\"></md-progress-linear>\n                            </div>\n                            <div ui-calendar=\"$ctrl.calendarConfig\" ng-model=\"$ctrl.calendarData\" id=\"calendar\"></div>\n                            <div class=\"button-container\">\n                                <md-button ng-click=\"$ctrl.goToPreviousPage()\" class=\"md-primary step-cancel\">CANCEL</md-button>\n                                <md-button ng-click=\"$ctrl.back()\" class=\"md-accent md-raised\">BACK</md-button>\n                                <md-button ng-click=\"$ctrl.next()\" class=\"md-accent md-raised\" ng-disabled=\"!$ctrl.actionPlan.eventDates.length || $ctrl.isLoading\">NEXT</md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"md-sidebar\" layout=\"column\" flex=\"33\">\n                    <span ng-if=\"$ctrl.actionPlan.template === \'SCH\'\">No resources necessary for scheduling only template.</span>\n                    <apm-calendar-checkbox-resources available-resources=\"$ctrl.availableResources\" ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\"></apm-calendar-checkbox-resources>\n                    <div class=\"button-container\" ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\">\n                        <md-button ng-click=\"$ctrl.onCheckboxFilter($ctrl.availableResources)\" class=\"md-accent md-raised\">Filter</md-button>\n                    </div>\n                </div>\n            </md-content>\n        </div>\n    </md-tab>\n    <md-tab label=\"Location\">\n        <md-content class=\"md-padding\">\n            <apm-action-plan-create-location>\n        </apm-action-plan-create-location></md-content>\n    </md-tab>\n    <md-tab label=\"Instructions\">\n        <md-content class=\"md-padding\">\n            <apm-action-plan-create-instructions>\n        </apm-action-plan-create-instructions></md-content>\n    </md-tab>\n</md-tabs>\n");
$templateCache.put("app/components/actionPlans/createEdit/apm.actionPlans.createModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Create/Edit Action Plan - {{$ctrl.displayDate}}</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content layout-padding>\n    <div ng-if=\"$ctrl.actionPlan.template === \'SCH\'\">\n        <h4>Event</h4>\n        <span>Embedded resource Scheduling</span>\n        <p>No Event staff necessary for Scheduling Only template. Please confirm event date as {{$ctrl.displayDate}}.</p>\n    </div>\n\n    <form ng-class=\"{\'create-ap-mo\': $ctrl.actionPlan.template !== \'SCH\'}\" name=\"createActionPlan\">\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n        <span ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\">\n            <h4>Event</h4>\n            <md-input-container class=\"no-input md-block\">\n                <md-select placeholder=\"Event Type\" ng-model=\"$ctrl.actionPlan.actionPlanEventType.value\" name=\"event\" required ng-disabled=\"$ctrl.isLimitedEdit\" ng-change=\"$ctrl.setEventType($ctrl.actionPlan.eventType.value)\">\n                    <md-option ng-value=\"event.code\" ng-repeat=\"event in $ctrl.eventTypeData\">{{event.display}}</md-option>\n                </md-select>\n            </md-input-container>\n\n            <h4>Assign Event Staff <span class=\"required-marker\">*</span></h4>\n            <p class=\"event-staff-description\">The Event requires at least one staff member.</p>\n            <md-input-container ng-if=\"$ctrl.maListStatus === \'ready\'\" class=\"no-input md-block\" md-no-float>\n                <md-select md-container-class=\"select-popup\" multiple=\"multiple\" placeholder=\"Select {{$ctrl.maPlaceholder}}\" ng-model=\"$ctrl.ma\" ng-change=\"$ctrl.setResource($ctrl.ma, \'ma\')\">\n                    <md-option ng-selected=\"ma.checked\" ng-value=\"{oid: ma.id, name: ma.resourceName, role: ma.roleName}\" ng-repeat=\"ma in $ctrl.maList\">{{ma.resourceName}}</md-option>\n                </md-select>\n            </md-input-container>\n            <p class=\"no-resources\" ng-if=\"$ctrl.maListStatus === \'no-resources\'\">No resources available.</p>\n\n            <md-input-container ng-if=\"$ctrl.npListStatus === \'ready\'\" class=\"no-input md-block\" md-no-float>\n                <md-select md-container-class=\"select-popup\" multiple=\"multiple\" placeholder=\"Select {{$ctrl.npPlaceholder}}\" ng-model=\"$ctrl.np\" ng-change=\"$ctrl.setResource($ctrl.np, \'np\')\">\n                    <md-option ng-selected=\"np.checked\" ng-value=\"{oid: np.id, name: np.resourceName, role: np.roleName}\" ng-repeat=\"np in $ctrl.npList\">{{np.resourceName}}</md-option>\n                </md-select>\n            </md-input-container>\n            <p class=\"no-resources\" ng-if=\"$ctrl.npListStatus === \'no-resources\'\">No resources available.</p>\n        </span>\n    </form>\n\n    <md-dialog-actions>\n        <md-button ng-click=\"$ctrl.close()\" class=\"md-primary\" aria-label=\"button\">CANCEL</md-button>\n        <md-button ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\" ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" ng-disabled=\"!$ctrl.ma.length && !$ctrl.np.length || createActionPlan.$invalid && !$ctrl.isLimitedEdit\" aria-label=\"button\">SAVE</md-button>\n        <md-button ng-if=\"$ctrl.actionPlan.template === \'SCH\'\" ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" aria-label=\"button\">SAVE</md-button>\n    </md-dialog-actions>\n</md-dialog-content>");
$templateCache.put("app/components/actionPlans/details/apm.details.component.html","<div class=\"action-plan-details\" ng-if=\"$ctrl.actionPlan\">\n    <div layout=\"column\" flex=\"grow\">\n        <apm-details-header action-plan=\"$ctrl.actionPlan\" action-plan-context=\"$ctrl.actionPlanContext\"></apm-details-header>\n    </div>\n\n    <div layout=\"column\" flex=\"grow\">\n        <apm-details-grid action-plan=\"$ctrl.actionPlan\" hide-ineligible-patients=\"$ctrl.hideIneligiblePatients\" ng-cloak></apm-details-grid>\n    </div>\n</div>\n<sc-loading-spinner ng-if=\"!$ctrl.actionPlan\" class=\"action-plan-details\"></sc-loading-spinner>\n");
$templateCache.put("app/components/actionPlans/grid/apm.actionPlans.grid.component.html","<md-card class=\"actionPlan-grid-filter-container top-filter-container\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form id=\"ActionPlanGridFilters\" name=\"actionPlanGridFilters\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"grow\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"25\">\n                    <label>Action Plan Title</label>\n                    <input type=\"text\" name=\"title\" autofocus=\"autofocus\" tabindex=\"1\" ng-model=\"$ctrl.filter.title\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"25\">\n                    <label>Provider</label>\n                    <input type=\"text\" name=\"practitioner\" ng-model=\"$ctrl.filter.practitioner\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"15\">\n                    <md-select placeholder=\"Status\" class=\"status-select\" ng-model=\"$ctrl.filter.status\">\n                        <md-option selected=\"selected\" value=\"\"></md-option>\n                        <md-option class=\"status-select-option\" ng-value=\"status.code\" ng-repeat=\"status in $ctrl.statuses\">{{ status.display }}\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"25\">\n                    <md-autocomplete ng-disabled=\"!$ctrl.assigneeAutoCompleteData.length\" class=\"md-autocomplete\" md-floating-label=\"Assigned To\" md-items=\"item in $ctrl.getAssigneeMatches($ctrl.searchAssigneeText)\" md-selected-item=\"$ctrl.filter.selectedAssignee\" md-selected-item-change=\"$ctrl.setAssigneeName($ctrl.filter.selectedAssignee)\" md-search-text=\"$ctrl.searchAssigneeText\" md-search-text-change=\"$ctrl.getAssigneeMatches($ctrl.searchAssigneeText)\" enter-press=\"$ctrl.setAssigneeName($ctrl.filter.selectedAssignee)\" md-item-text=\"$ctrl._getUserDisplayName(item)\" ng-blur=\"$ctrl.setAssigneeName($ctrl.filter.selectedAssignee)\" md-min-length=\"0\" md-no-cache=\"true\">\n                        <md-item-template>\n                            <span md-highlight-text=\"$ctrl.searchAssigneeText\" md-highlight-flags=\"^i\">{{$ctrl._getUserDisplayName(item)}}</span>\n                        </md-item-template>\n                    </md-autocomplete>\n                </md-input-container>\n            </div>\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"25\">\n                    <md-autocomplete ng-disabled=\"!$ctrl.ownerAutoCompleteData.length\" class=\"md-autocomplete\" md-floating-label=\"Owner\" md-items=\"item in $ctrl.getOwnerMatches($ctrl.searchOwnerText)\" md-selected-item=\"$ctrl.filter.selectedOwner\" md-selected-item-change=\"$ctrl.setOwnerName($ctrl.filter.selectedOwner)\" md-search-text=\"$ctrl.searchOwnerText\" md-search-text-change=\"$ctrl.getOwnerMatches($ctrl.searchOwnerText)\" enter-press=\"$ctrl.setOwnerName($ctrl.filter.selectedOwner)\" md-item-text=\"$ctrl._getUserDisplayName(item)\" ng-blur=\"$ctrl.setOwnerName($ctrl.filter.selectedOwner)\" md-min-length=\"0\" md-no-cache=\"true\">\n                        <md-item-template>\n                            <span md-highlight-text=\"$ctrl.searchOwnerText\" md-highlight-flags=\"^i\">{{$ctrl._getUserDisplayName(item)}}</span>\n                        </md-item-template>\n                    </md-autocomplete>\n                </md-input-container>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons sc-filter-buttons-single-line\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"4\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter\n            </md-button>\n            <md-button class=\"md-accent\" tabindex=\"5\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n<md-card layout-margin layout=\"column\" class=\"actionPlans-grid\">\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.getLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading action plans.\" mdt-row=\"{\n                    \'table-row-id-key\': \'_id\',\n                    \'column-keys\': $ctrl.columnsToDisplay\n                }\" ng-cloak>\n        <mdt-header-row ng-if=\"$ctrl.hasEditAccess && $ctrl.hasCloneAccess\">\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Title</mdt-column>\n            <mdt-column align-rule=\"left\">Event Type</mdt-column>\n            <mdt-column align-rule=\"left\">Population</mdt-column>\n            <mdt-column align-rule=\"left\">Status</mdt-column>\n            <mdt-column align-rule=\"left\">Event Date</mdt-column>\n            <mdt-column align-rule=\"left\">Progress</mdt-column>\n            <mdt-column align-rule=\"left\">Assigned To</mdt-column>\n            <mdt-column align-rule=\"left\">Owner</mdt-column>\n            <mdt-column align-rule=\"left\">Clone</mdt-column>\n        </mdt-header-row>\n\n        <mdt-header-row ng-if=\"!$ctrl.hasEditAccess || !$ctrl.hasCloneAccess\">\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Title</mdt-column>\n            <mdt-column align-rule=\"left\">Event Type</mdt-column>\n            <mdt-column align-rule=\"left\">Population</mdt-column>\n            <mdt-column align-rule=\"left\">Status</mdt-column>\n            <mdt-column align-rule=\"left\">Event Date</mdt-column>\n            <mdt-column align-rule=\"left\">Progress</mdt-column>\n            <mdt-column align-rule=\"left\">Assigned To</mdt-column>\n            <mdt-column align-rule=\"left\">Owner</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"title\">\n            <div class=\"title-cell\">\n                <a ng-click=\"clientScope.$ctrl.goToDetails($event, rowId)\" ui-sref=\"actionPlans.details({ id: rowId })\">{{value}} </a>\n                <span ng-class=\"{ \'hidden\' : !clientScope.$ctrl.isStatusEditable(rowId) || !clientScope.$ctrl.hasEditAccess }\">\n                    <mdt-custom-cell-button ng-click=\"clientScope.$ctrl.goToEdit(rowId)\" class=\"no-select\"></mdt-custom-cell-button>\n                </span>\n            </div>\n\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"actionPlanEventType\">\n            <span>{{value || \'N/A\'}}</span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"statusToDisplay\">\n            <span class=\"capitalize\">{{value}}</span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"eventDates\">\n            <div class=\"event-column\">{{value || \'\'}}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"_id\">\n            <div class=\"assignee-cell\">\n                <apm-details-header-assignee-modal-button action-plan=\"clientScope.$ctrl.findActionPlan(value)\" on-assignee=\"clientScope.$ctrl.onAssigneeCallback()\"></apm-details-header-assignee-modal-button>\n            </div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"_apOwnerId\">\n            <div class=\"owner-cell\">\n                <apm-details-header-owner-modal-button action-plan=\"clientScope.$ctrl.findActionPlan(value)\" on-owner=\"clientScope.$ctrl.onOwnerCallback()\"></apm-details-header-owner-modal-button>\n            </div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"_cloneId\">\n            <div class=\"clone-cell\">\n                <md-icon ng-click=\"clientScope.$ctrl.goToClone(value)\">content_copy</md-icon>\n            </div>\n        </mdt-custom-cell>\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/list/apm.actionPlans.list.component.html","<div layout=\"row\" class=\"list-container\">\n    <h3 flex=\"none\" class=\"page-title\">Action Plan List</h3>\n    <span flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-align-sm=\"start center\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"actionPlans.createEdit\" access-type=\"PERMISSION\" access-control=\"scAPAdmin,scAPWorkflowCreate\">\n            Create Action Plan\n        </md-button>\n    </span>\n</div>\n\n<apm-action-plans-grid></apm-action-plans-grid>\n");
$templateCache.put("app/components/actionPlans/owner/apm.owner.ownerModal.button.component.html","<div class=\"owner\">\n    <md-icon ng-if=\"!$ctrl.actionPlan.ownerName && $ctrl.isStatusEditable()\" ng-click=\"$ctrl.showOwnerModal()\" class=\"no-select\">person_add</md-icon>\n    <span ng-if=\"$ctrl.actionPlan.ownerName\" ng-class=\"{ \'enabled-link\' : $ctrl.isStatusEditable() }\" ng-click=\"!$ctrl.isStatusEditable() || $ctrl.showOwnerModal()\" class=\"no-select\">{{$ctrl.actionPlan.ownerName}}</span>\n</div>\n");
$templateCache.put("app/components/actionPlans/owner/apm.owner.ownerModal.component.html","<md-toolbar class=\"_md _md-toolbar-transitions\">\n    <div class=\"md-toolbar-tools\">\n        <h2>Owner</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content class=\"dialog-content\" layout-margin>\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n    <md-input-container>\n        <md-autocomplete class=\"md-autocomplete\" md-floating-label=\"Enter Owner Name\" md-items=\"item in $ctrl.getMatches($ctrl.searchText)\" md-selected-item=\"$ctrl.selectedOwner\" md-search-text=\"$ctrl.searchText\" md-search-text-change=\"$ctrl.getMatches($ctrl.searchText)\" md-selected-item-change=\"$ctrl.selectedItemChange()\" enter-press=\"$ctrl.saveOwner($ctrl.selectedOwner)\" md-item-text=\"item.fullName\" md-min-length=\"0\">\n            <md-item-template>\n                <span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{ item.fullName }}</span>\n            </md-item-template>\n        </md-autocomplete>\n        <div ng-if=\"$ctrl.getOwnerName()\">\n            <h3 class=\"inner-label\">Current Owner</h3>\n            <span>{{ $ctrl.getOwnerName() }}</span>\n            <md-icon title=\"Clear Owner\" ng-click=\"$ctrl.clearOwner()\">delete</md-icon>\n        </div>\n    </md-input-container>\n</md-dialog-content>\n<md-dialog-actions class=\"dialog-actions\">\n    <md-button class=\"md-accent\" ng-click=\"$ctrl.close()\" aria-label=\"button\" ng-disabled=\"$ctrl.saving\">CANCEL</md-button>\n    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.saveOwner($ctrl.selectedOwner)\" ng-disabled=\"!$ctrl.saveEnabled || $ctrl.saving\" aria-label=\"button\">\n        <span ng-if=\"!$ctrl.saving\">SAVE</span>\n        <sc-loading-spinner class=\"header-owner-modal\" ng-if=\"$ctrl.saving\"></sc-loading-spinner>\n    </md-button>\n</md-dialog-actions>");
$templateCache.put("app/components/actionPlans/simpleGrid/apm.actionPlans.simpleGrid.component.html","<md-card layout-margin>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-row-paginator-error-message=\"Error happened while loading action plans.\" mdt-row=\"{\n                \'table-row-id-key\': \'_id\',\n                \'column-keys\': [\n                    \'title\',\n                    \'actionPlanEventType.display\',\n                    \'statusToDisplay\',\n                    \'eventDates\',\n                    \'progress\'\n                ]\n            }\" ng-cloak>\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Title</mdt-column>\n            <mdt-column align-rule=\"left\">Event Type</mdt-column>\n            <mdt-column align-rule=\"left\">Status</mdt-column>\n            <mdt-column align-rule=\"left\">Event Date</mdt-column>\n            <mdt-column align-rule=\"left\">Progress</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"title\">\n            <a ui-sref=\"actionPlans.details({ id: rowId })\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"actionPlanEventType\">\n            <span>{{value || \'N/A\'}}</span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"statusToDisplay\">\n            <span class=\"capitalize\">{{value}}</span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"eventDates\">\n            <div class=\"event-column\">{{value}}</div>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/home/modal/apm.home.updatePasswordAdviceModal.component.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2 flex=\"90\">Update Password</h2>\n        <md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content layout=\"column\" layout-align=\"center center\" layout-padding class=\"update-password-advice-dialog-content md-dialog-content\">\n    <div layout=\"row\">\n        Your password will expire in {{ ::$ctrl.daysForPasswordExpiration }} days. Would you like to update your password now?\n    </div>\n</md-dialog-content>\n<md-dialog-actions>\n    <md-button class=\"md-accent\" ng-click=\"$ctrl.close()\" aria-label=\"button\">DISMISS</md-button>\n    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.openUpdatePasswordModal()\" aria-label=\"button\">UPDATE</md-button>\n</md-dialog-actions>");
$templateCache.put("app/components/layout/siteNav/apm.layout.siteNav.component.html","<sc-nav ng-hide=\"$ctrl.hideNavBar\" class=\"Sc-nav\" menu-items=\"$ctrl.menuItems\"></sc-nav>\n");
$templateCache.put("app/components/layout/siteNav/sc.nav.component.html","<md-sidenav class=\"sc-nav ng-hide\" md-component-id=\"sc-nav\" md-is-locked-open=\"$ctrl.isLoaded\" md-whiteframe=\"4\" layout=\"column\" ng-if=\"$root.user.loggedIn\" md-colors=\"{background: \'primary\'}\" ng-show=\"$ctrl.isLoaded\" ng-class=\"{\'sc-nav--open\':   $ctrl.isOpen,\n                       \'sc-nav--closed\': !$ctrl.isOpen}\">\n\n    <sc-nav-header class=\"Sc-nav-header\" is-open=\"$ctrl.isOpen\" toggle-fn=\"::$ctrl.onClickToggleNav()\"></sc-nav-header>\n\n    <md-list flex>\n        <md-list-item class=\"sc-nav-list-items\" ng-class=\"{\'md-active\': $ctrl.isParentActive(menuItem.state)}\" ng-repeat=\"menuItem in $ctrl.menuItems\" alt=\"{{ menuItem.text }}\" title=\"{{ menuItem.text }}\">\n            <md-menu class=\"sc-nav-menu\" flex=\"100\" layout=\"row\" layout-align=\"end stretch\" md-position-mode=\"target-left target\" md-offset=\"15 0\">\n                <md-button class=\"sc-nav-menu__link md-no-style md-button md-ink-ripple\" layout=\"row\" layout-align=\"start center\" ng-click=\"$ctrl.onClickMenuItem($event, $mdOpenMenu, menuItem)\" tabindex=\"-1\">\n                    <div class=\"sc-nav-list-items__icon-wrapper\" layout layout-align=\"center center\" flex=\"initial\">\n                        <md-icon class=\"sc-nav-list-items__icon md-icon\">\n                            {{ menuItem.icon }}\n                        </md-icon>\n                    </div>\n                    <div class=\"sc-nav-list-items__text-wrapper\" flex layout layout-align=\"start center\">\n                        <span class=\"sc-nav-list-items__text\">{{ menuItem.text }}</span>\n                    </div>\n                    <div class=\"sc-nav-list-items__arrow-wrapper\" layout layout-align=\"center center\" flex=\"initial\" md-menu-origin ng-if=\"menuItem.children && menuItem.children.length > 0\">\n                        <svg class=\"sc-nav-list-items__arrow\" viewBox=\"0 0 50 100\" xmlns=\"http://www.w3.org/2000/svg\">\n                            <polygon points=\"0 0, 50 50, 0 100\"></polygon>\n                        </svg>\n                    </div>\n                </md-button>\n                <md-menu-content width=\"2\">\n                    <md-menu-item ng-repeat=\"child in menuItem.children\">\n                        <md-button ng-click=\"$ctrl.navigate(child.state)\" md-ink-ripple=\"false\">{{ child.text }}</md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </md-list-item>\n    </md-list>\n</md-sidenav>\n");
$templateCache.put("app/components/layout/siteNav/sc.nav.header.component.html","<header class=\"sc-nav-header\" layout=\"column\" ng-class=\"{\'sc-nav-header--open\':   $ctrl.isOpen,\n                   \'sc-nav-header--closed\': !$ctrl.isOpen}\">\n    <div class=\"sc-nav-toggle-wrapper\">\n            <span class=\"sc-nav-toggle\" ng-click=\"$ctrl.toggleFn({\'$event\': $event})\">\n                <md-icon class=\"ng-hide sc-nav-branding__md-icon\" alt=\"Minimize Side Nav\" ng-show=\"$ctrl.isOpen\">keyboard_arrow_left\n                </md-icon>\n                <md-icon class=\"ng-hide sc-nav-branding__md-icon\" alt=\"Maximize Side Nav\" ng-show=\"!$ctrl.isOpen\">keyboard_arrow_right\n                </md-icon>\n            </span>\n    </div>\n    <div class=\"sc-nav-branding\">\n        <div class=\"sc-nav-tenant-logo-wrapper\" flex=\"grow\">\n            <img ng-show=\"::$ctrl.tenantLogo\" ng-src=\"{{ ::$ctrl.tenantLogo }}\" class=\"sc-nav-tenant-logo-wrapper__logo md-avatar\">\n        </div>\n    </div>\n    <div class=\"sc-nav-header-menu-wrapper\">\n        <md-menu class=\"sc-nav-header-menu\" md-position-mode=\"target-left target\" md-offset=\"25 0\">\n            <md-button class=\"sc-nav-header-menu-btn\" ng-click=\"$mdOpenMenu($event)\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div class=\"sc-nav-tenant-user-name\">\n                        {{ ::$ctrl.userName }}\n                    </div>\n                    <md-icon class=\"sc-nav-tenant-icon\" alt=\"Open user menu\">\n                        account_circle\n                    </md-icon>\n                    <md-icon class=\"sc-nav-tenant-arrow\" md-menu-origin alt=\"Open user menu\">\n                        arrow_drop_down\n                    </md-icon>\n                </div>\n            </md-button>\n            <md-menu-content width=\"2\">\n                <md-menu-item ng-show=\"::$ctrl.$state.get(\'profile\')\">\n                    <md-button ui-sref=\"profile\">\n                        <div layout=\"row\" layout-align=\"end center\" flex>User Profile</div>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button ng-click=\"$ctrl.openUpdatePasswordModal()\">\n                        <div layout=\"row\" layout-align=\"end center\" flex>Update Password</div>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button ng-click=\"$ctrl.logout()\">\n                        <div layout=\"row\" layout-align=\"end center\" flex>Logout</div>\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n    </div>\n</header>\n");
$templateCache.put("app/components/patients/activePlans/apm.patients.activePlansModal.html","<md-toolbar>\n  <div class=\"md-toolbar-tools\">\n    <h2>{{ $ctrl.title }}</h2>\n    <span flex></span>\n    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n      <md-icon alt=\"Close dialog\">close</md-icon>\n    </md-button>\n  </div>\n</md-toolbar>\n\n<md-dialog-content class=\"patient-action-plans-modal-content\">\n  <div class=\"error-message\">\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n  </div>\n  <md-card layout-margin>  \n    <div class=\"patient-action-plans-card\">\n      <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.pageSizes}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading action plans.\" mdt-row-paginator-no-results-message=\"No active action plans for this patient.\" mdt-row=\"{\n          \'table-row-id-key\': \'id\',\n          \'column-keys\': [\n          \'actionPlanTitle\',\n          \'status\',\n          \'eventDates\'\n          ]\n        }\">\n\n        <mdt-header-row>\n          <mdt-column align-rule=\"left\">Title </mdt-column>\n          <mdt-column align-rule=\"left\">Status</mdt-column>\n          <mdt-column align-rule=\"left\">Event Date</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"actionPlanTitle\">\n          <a class=\"action-plan-title\" ui-sref=\"actionPlans.details({ id: clientScope.$ctrl.getRow(rowId).actionPlanId })\" ng-click=\"clientScope.$ctrl.onActionPlanLink()\" ng-show=\"clientScope.$ctrl.getRow(rowId).actionPlanId\">{{value}}</a>\n          <span ng-show=\"!clientScope.$ctrl.getRow(rowId).actionPlanId\">{{value}}</span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"status\">\n          <div class=\"appointment-status\">{{ value | lowercase }}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"eventDates\">\n          <div>{{ value[0] | reverseDateFormatFilter }}</div>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n      </mdt-table>\n    </div>\n  </md-card>\n</md-dialog-content>");
$templateCache.put("app/components/patients/activity/apm.patients.activity.component.html","<div ng-if=\"$ctrl.ready\">\n    <div class=\"activity-top-cards\" layout=\"row\" layout-align=\"start center\">\n        <apm-patient-hcc-card patient=\"$ctrl.patient\" flex=\"nogrow\"></apm-patient-hcc-card>\n        <apm-patient-gaps-card class=\"Apm-patient-gaps-card\" group=\"foc\" patient=\"$ctrl.patient\" flex=\"nogrow\">\n        </apm-patient-gaps-card>\n        <apm-patient-gaps-card class=\"Apm-patient-gaps-card\" group=\"quality\" patient=\"$ctrl.patient\" flex=\"nogrow\">\n        </apm-patient-gaps-card>\n    </div>\n  <div class=\"activity-header\" layout=\"row\" layout-align=\"space-between center\">\n    <span class=\"md-title\">Measures</span>\n    <span class=\"md-title\" layout=\"row\" layout-align=\"end center\">\n      Show gaps\n      <md-switch ng-model=\"$ctrl.showGaps\" ng-change=\"$ctrl.setGaps()\" aria-label=\"Show gaps\" class=\"md-primary patient-activity-gaps-switch\"></md-switch>\n    </span>\n  </div>\n\n  <div layout=\"row\" layout-align=\"start center\" layout-wrap ng-if=\"$ctrl.gaps.length\">\n    <apm-patient-activity-gap-card ng-repeat=\"gap in $ctrl.gaps\" gap=\"gap\" measure-report-id=\"gap.measureReportId\" patient-id=\"$ctrl.patient.id\" process-measures=\"$ctrl.patient.processMeasures\"></apm-patient-activity-gap-card>\n  </div>\n  <div layout=\"row\" layout-align=\"center center\" layout-wrap ng-if=\"!$ctrl.gaps.length\" class=\"md-headline\">\n    There are no gaps for this patient.\n  </div>\n</div>\n<sc-loading-spinner ng-if=\"!$ctrl.ready\" class=\"patient-activity\"></sc-loading-spinner>\n");
$templateCache.put("app/components/patients/activity/apm.patients.activity.gapCard.component.html","<md-card layout=\"column\" flex class=\"patient-gap-card\">\n\n    <md-card-content class=\"patient-gap-card-content\" layout=\"column\">\n        <div layout=\"row\" layout-align=\"start center\" class=\"gap-status\">\n            <span flex=\"none\" class=\"gap-status-icon\">\n                <md-icon>{{ $ctrl.statusMapping[$ctrl.gap.status].icon }}</md-icon>\n            </span>\n            <span class=\"gap-status-name {{$ctrl.gap.status}}\">{{ $ctrl.statusMapping[$ctrl.gap.status].text }}</span>\n        </div>\n        <div layout=\"row\">\n            <div layout=\"column\" class=\"gap-name\">\n                <span class=\"md-headline\">{{$ctrl.gap.name}}</span>\n                <span class=\"md-subhead\" md-colors=\"{color: \'primary-hue-3\'}\">{{$ctrl.gap.group}}</span>\n            </div>\n            <div layout=\"column\" layout-align=\"end end\" flex>\n                <a class=\"gap-link\" href=\"\" ng-click=\"$ctrl.showGapDetailsDialog()\">View Details</a>\n            </div>\n        </div>\n    </md-card-content>\n\n</md-card>\n");
$templateCache.put("app/components/patients/activity/apm.patients.activity.gapModal.component.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>{{ $ctrl.gap.name }}</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content ng-if=\"$ctrl.ready\" class=\"patient-gap-modal-content\">\n    <div class=\"error-message\">\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n    </div>\n    <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\">\n\n        <md-tab label=\"status\">\n            <md-content layout=\"column\" layout-margin layout-padding>\n\n                <div layout=\"row\" layout-align=\"start center\">\n                    <span class=\"icon\">\n                        <md-icon alt=\"Measure Status\">{{ $ctrl.statusMapping[$ctrl.gap.status].icon }}</md-icon>\n                    </span>\n                    <span flex>{{ $ctrl.gap.statusText }}</span>\n                </div>\n\n                <div layout=\"row\" layout-align=\"start center\">\n                    <span class=\"icon\">\n                        <md-icon alt=\"Last update\">history</md-icon>\n                    </span>\n                    <span flex>Last Update: {{ $ctrl.gap.updateText }} {{ $ctrl.gap.lastUpdated }}</span>\n                </div>\n\n                <div layout=\"row\" layout-align=\"start center\">\n                    <span class=\"icon\">\n                        <md-icon alt=\"Follow-up date\">date_range</md-icon>\n                    </span>\n                    <span flex>Follow-up Date: {{ $ctrl.followUpDate || \"N/A\" }}</span>\n                </div>\n\n                <div layout=\"row\" layout-align=\"start start\">\n                    <span class=\"icon\">\n                        <md-icon alt=\"Related Action Plans\">assignment</md-icon>\n                    </span>\n                    <span>Related Action Plans:</span>\n                    <span layout=\"column\">\n                        <a class=\"action-plan-title action-plan-link\" ui-sref=\"actionPlans.details({ id: actionPlan.id })\" ng-click=\"$ctrl.close()\" ng-repeat=\"actionPlan in $ctrl.relatedActionPlans\">{{ actionPlan.title }}</a>\n                    </span>\n                </div>\n\n            </md-content>\n        </md-tab>\n\n        <md-tab label=\"explanation\">\n            <md-content layout=\"column\" layout-margin layout-padding>\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"!$ctrl.gap.explanationsSections.length\">\n                    <span>Measure explanation not available</span>\n                </div>\n                <div layout=\"column\" ng-repeat=\"section in $ctrl.gap.explanationsSections\">\n                    <p>{{ section.header }}</p>\n                    <p ng-if=\"section.description\">{{ section.description }}</p>\n                    <ul ng-if=\"section.list\">\n                        <li ng-repeat=\"item in section.list\">{{ item }}</li>\n                    </ul>\n                </div>\n            </md-content>\n        </md-tab>\n\n        <md-tab label=\"metrics\">\n            <md-content layout=\"column\" layout-margin layout-padding class=\"patient-process-measure-tab\">\n                <div layout=\"row\">\n                    <span>Patient {{ $ctrl.gap.measures.type }} Measure </span>\n                    <div ng-if=\"$ctrl.gap.measures.rateAggregation\">\n                        <span>&nbsp;- Weight: {{ $ctrl.gap.measures.rateAggregation }} {{ $ctrl.gap.measures.rateAggregation > 1 ? \'pts\' : \'pt\' }}</span>\n                    </div>\n                </div>\n                <div layout=\"column\">\n                    <span>Metric</span>\n                    <div ng-if=\"$ctrl.gap.measures.guidance\">{{ $ctrl.gap.measures.guidance }}</div>\n                    <div ng-if=\"$ctrl.gap.measures.description\">{{ $ctrl.gap.measures.description }}</div>\n                </div>\n                <div ng-if=\"$ctrl.gap.measures && $ctrl.gap.measures.definition\" layout=\"column\">\n                    <span>WellMed Quality Metrics</span>\n                    <div>\n                        <ul>\n                            <li ng-repeat=\"rating in $ctrl.gap.measures.definition\">\n                                Level {{ rating.level }}: {{ rating.Value }}%\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </md-content>\n        </md-tab>\n\n    </md-tabs>\n</md-dialog-content>\n\n<sc-loading-spinner ng-if=\"!$ctrl.ready\" class=\"patient-activity\"></sc-loading-spinner>\n");
$templateCache.put("app/components/patients/appointments/apm.patients.appointmentsGrid.component.html","<div class=\"error-message\">\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n</div>\n<md-card layout-margin class=\"patient-appointments-grid\">\n    <div ng-if=\"$ctrl.title\">\n        <label>{{$ctrl.title}}</label>\n    </div>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.pageSizes}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading appointment history.\" mdt-row-paginator-no-results-message=\"No appointments for this patient.\" mdt-row=\"{\n                    \'table-row-id-key\': \'id\',\n                    \'column-keys\': [\n                        \'startTime\',\n                        \'actionPlanTitle\',\n                        \'apptStatus\'\n                    ]\n                }\">\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Appt Time</mdt-column>\n            <mdt-column align-rule=\"left\">Action Plan</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Appointment Status</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"startTime\">\n            <div>{{ value.displayValue }}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"actionPlanTitle\">\n            <a class=\"action-plan-title\" ui-sref=\"actionPlans.details({ id: clientScope.$ctrl.getRow(rowId).actionPlanId })\" ng-click=\"clientScope.$ctrl.onActionPlanLink()\" ng-show=\"clientScope.$ctrl.getRow(rowId).actionPlanId\">{{value}}</a>\n            <span ng-show=\"!clientScope.$ctrl.getRow(rowId).actionPlanId\">{{value}}</span>\n\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"apptStatus\">\n            <div class=\"appointment-status\">{{ value }}</div>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n    <div ng-if=\"$ctrl.appointments.length === 0\">No appointments for this patient</div>\n</md-card>\n");
$templateCache.put("app/components/patients/appointments/apm.patients.appointmentsModal.html","<md-dialog aria-label=\"Appointment History\" class=\"grid-content\">\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <h2>Appointment History</h2>\n            <span flex></span>\n            <md-button class=\"md-icon-button\" ng-click=\"close()\">\n                <md-icon alt=\"Close dialog\">close</md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-dialog-content class=\"appointments-dialog-content\">\n        <apm-patient-appointments-grid patient=\"$ctrl.patient\" page-sizes=\"[5, 10, 20, 30]\" on-action-plan-link=\"close()\"></apm-patient-appointments-grid>\n    </md-dialog-content>\n</md-dialog>");
$templateCache.put("app/components/patients/callLog/apm.patients.callLogGrid.component.html","<div class=\"error-message\">\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n</div>\n<md-card layout-margin class=\"patients-callLog-container\" ng-class=\"{\'action-page\': $ctrl.isActionPage}\">\n    <div ng-if=\"$ctrl.title\">\n        <label>{{$ctrl.title}}</label>\n    </div>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.pageSizes}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading call history.\" mdt-row-paginator-no-results-message=\"No calls for this patient.\" mdt-row=\"{\n                    \'table-row-id-key\': \'actionPlanId\',\n                    \'column-keys\': $ctrl.columnDisplay\n                }\">\n        <mdt-header-row ng-if=\"!$ctrl.isActionPage\">\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Date/Time</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Related To</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Caller</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Disposition</mdt-column>\n        </mdt-header-row>\n\n        <mdt-header-row ng-if=\"$ctrl.isActionPage\">\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Date/Time</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Caller</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Disposition</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"callTime\">\n            <div class=\"time-container\">{{value | date:\'short\' | lowercase}}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"actionPlanTitle\">\n            <a class=\"action-plan-title\" ui-sref=\"actionPlans.details({ id: rowId })\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell ng-if=\"$ctrl.isActionPage\" column-key=\"fullName\">\n            <div class=\"caller-column\">{{value}}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"dispositionDisplayText\">\n            <div class=\"disposition-column\">{{value}}</div>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n    <div ng-if=\"$ctrl.callLogs.length === 0\">No calls for this patient</div>\n</md-card>\n");
$templateCache.put("app/components/patients/callLog/apm.patients.callLogModal.html","<md-dialog aria-label=\"Call Log\" class=\"grid-content\">\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <h2>Call History</h2>\n            <span flex></span>\n            <md-button class=\"md-icon-button\" ng-click=\"close()\">\n                <md-icon alt=\"Close dialog\">close</md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-dialog-content>\n        <apm-patient-call-log-grid patient=\"$ctrl.patient\" page-sizes=\"[5, 10, 20, 30]\"></apm-patient-call-log-grid>\n    </md-dialog-content>\n</md-dialog>");
$templateCache.put("app/components/patients/cards/apm.patients.activePlansCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n\n    <md-card-content class=\"card-content\" flex>\n        <span class=\"md-headline card-title\">Active Action Plans</span>\n        <div class=\"card-content__plans-count\">\n            <span>Plans: {{ ::$ctrl.patient.activeActionPlansCount }}</span>\n        </div>\n    </md-card-content>\n\n    <md-divider></md-divider>\n\n    <md-card-actions>\n        <md-button ng-click=\"$ctrl.showActiveActionPlansInfoModal()\" class=\"md-accent\" aria-label=\"button\">View Details</md-button>\n    </md-card-actions>\n\n</md-card>");
$templateCache.put("app/components/patients/cards/apm.patients.apptHistoryCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n\n\n    <md-card-content flex>\n        <span class=\"md-headline card-title\">Appt History</span>\n\n    </md-card-content>\n\n    <md-divider></md-divider>\n\n    <md-card-actions>\n        <md-button class=\"md-accent\" ng-click=\"$ctrl.showPatientAppointmentsModal()\">View Details</md-button>\n    </md-card-actions>\n\n</md-card>");
$templateCache.put("app/components/patients/cards/apm.patients.callHistoryCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n    <md-card-content class=\"card-content\" flex>\n        <span class=\"md-headline card-title\">Call History</span>\n    </md-card-content>\n    <md-divider></md-divider>\n    <md-card-actions>\n        <md-button class=\"md-accent\" ng-click=\"$ctrl.showPatientsCallLogModal()\">View Details</md-button>\n    </md-card-actions>\n</md-card>");
$templateCache.put("app/components/patients/cards/apm.patients.contactInfoCard.component.html","<md-card layout=\"column\" flex=\"auto\" class=\"patient-card\">\n\n    <md-card-content class=\"card-content\" flex=\"auto\">\n        <span class=\"md-headline card-title\">Patient Info</span>\n        <div ng-if=\"$ctrl.patient.phone\" class=\"preferred-phone-number\">\n            <md-icon>phone</md-icon>\n            <span>{{ $ctrl.patient.phone | phoneNumber }}</span>\n        </div>\n        <div class=\"address-container\">\n            <md-icon>location_on</md-icon>\n            <div ng-if=\"::$ctrl.patient.addressLine1\">\n                <p>{{ ::$ctrl.patient.addressLine1 }}</p>\n                <p>{{ ::$ctrl.patient.addressCity }}, {{ ::$ctrl.patient.addressState }} {{ ::$ctrl.patient.addressPostalCode }}</p>\n            </div>\n            <div ng-if=\"!$ctrl.patient.addressLine1\">\n                <span>N/A</span>\n            </div>\n        </div>\n    </md-card-content>\n\n    <md-divider></md-divider>\n\n    <md-card-actions>\n        <md-button ng-click=\"$ctrl.showPatientContactInfoModal()\" class=\"md-accent\">View Details</md-button>\n    </md-card-actions>\n\n</md-card>");
$templateCache.put("app/components/patients/cards/apm.patients.gapsCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n\n    <md-card-content layout=\"row\" layout-align=\"space-between center\" layout-fill class=\"card-content md-subhead no-padding\">\n        <div class=\"patient-card-title\" layout=\"column\" flex=\"40\">\n            <span>{{ ::$ctrl.group }}</span>\n            <span class=\"card-content__gaps\">gaps</span>\n        </div>\n        <md-divider class=\"vertical-divider\"></md-divider>\n        <div class=\"patient-card-content\" flex=\"auto\" layout=\"column\" layout-align=\"center none\">\n            <div>\n                <table class=\"patient-card-bullets\" flex=\"grow\">\n                    <tr>\n                        <td><label>Open</label></td>\n                        <td><span>{{ ::$ctrl.vm.open }}</span></td>\n                    </tr>\n                    <tr>\n                        <td><label>Pending</label></td>\n                        <td><span>{{ ::$ctrl.vm.pending }}</span></td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n    </md-card-content>\n\n</md-card>\n");
$templateCache.put("app/components/patients/cards/apm.patients.hccCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\" ng-if=\"$ctrl.pendingValue || $ctrl.pendingCount\">\n\n    <md-card-content layout=\"row\" layout-align=\"space-between center\" layout-fill class=\"md-subhead no-padding\">\n        <div class=\"patient-card-title\" flex=\"initial\">\n            <span class=\"md-headline\">HCC</span>\n        </div>\n        <md-divider class=\"vertical-divider\"></md-divider>\n        <div flex=\"grow\" class=\"patient-card-content\">\n            <table class=\"patient-card-bullets\" flex=\"grow\">\n                <tr>\n                    <td><label>Pending Weight</label></td>\n                    <td><span>{{ $ctrl.pendingValue ? ($ctrl.pendingValue | number:3) : \'N/A\'}}</span></td>\n                </tr>\n                <tr>\n                    <td><label>Pending Count</label></td>\n                    <td><span>{{ $ctrl.pendingCount || \'N/A\'}}</span></td>\n                </tr>\n            </table>\n        </div>\n    </md-card-content>\n\n</md-card>\n");
$templateCache.put("app/components/patients/cards/apm.patients.providerInfoCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n\n    <md-card-content flex>\n        <span class=\"md-headline card-title\">Provider Info</span>\n        <div layout=\"column\">\n            <div class=\"last-pcp-visit\">\n                <span>Last PCP Visit: </span>\n                <span>{{ ::$ctrl.vm.patient.lastVisit }}</span>\n            </div>\n            <div class=\"pcp\">\n                <span>PCP: </span>\n                <span>{{ ::$ctrl.vm.patient.providerInfo.name }}</span>\n            </div>\n        </div>\n    </md-card-content>\n\n    <md-divider></md-divider>\n\n    <md-card-actions>\n        <md-button ng-click=\"$ctrl.showProviderInfoModal()\" class=\"md-accent\">View Details</md-button>\n    </md-card-actions>\n\n</md-card>");
$templateCache.put("app/components/patients/cards/apm.patients.testResultsCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n\n    <md-card-content flex>\n        <span class=\"md-headline card-title\">Test Results</span>\n    </md-card-content>\n\n    <md-divider></md-divider>\n\n    <md-card-actions>\n        <md-button ng-click=\"$ctrl.showTestResultsModal()\" class=\"md-accent\">View Details</md-button>\n    </md-card-actions>\n\n</md-card>\n");
$templateCache.put("app/components/patients/cards/apm.patients.vendorCard.component.html","<md-card layout=\"column\" flex class=\"patient-card\">\n\n    <md-card-content flex>\n        <span class=\"md-headline card-title\">Vendor</span>\n    </md-card-content>\n\n    <md-divider></md-divider>\n\n    <md-card-actions>\n        <md-button ng-click=\"$ctrl.showPatientVendorModal()\" aria-label=\"button\" class=\"md-accent\">View Details</md-button>\n    </md-card-actions>\n\n</md-card>\n");
$templateCache.put("app/components/patients/clinical/apm.patient.clinical.html","<div layout=\"row\" layout-wrap layout-align=\"start center\">\n  <apm-patient-test-results-card patient=\"$ctrl.patient\" flex-gt-md=\"25\"></apm-patient-test-results-card>\n</div>\n");
$templateCache.put("app/components/patients/contactInfo/apm.patients.contactInfoModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Patient Info</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content class=\"patient-contact-modal-content\">\n    <div class=\"error-label\">\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n    </div>\n    <md-card class=\"patient-contact-modal-status\">\n        <div layout=\"row\">\n            <div layout=\"column\" flex layout-margin>\n                <span>Status: {{ ::$ctrl.contactInfo.eligibility }}, {{ ::$ctrl.contactInfo.status }}</span>\n            </div>\n        </div>\n        <div layout=\"row\">\n            <div ng-if=\"$ctrl.vm.patient.healthPlan\" layout=\"column\" flex layout-margin>\n                <apm-patient-health-plan patient=\"$ctrl.vm.patient\"></apm-patient-health-plan>\n            </div>\n        </div>\n    </md-card>\n    <md-card layout-padding layout-margin>\n        <apm-edit-phone-number on-error=\"$ctrl.onError(err)\"></apm-edit-phone-number>\n    </md-card>\n    <md-card layout-padding layout-margin>\n        <div layout=\"row\">\n            <div>\n                <span>Patient Address:</span>\n            </div>\n            <div class=\"address\" ng-if=\"::$ctrl.contactInfo.address.line1\">\n                <p>{{ ::$ctrl.contactInfo.address.line1 }}</p>\n                <p>{{ ::$ctrl.contactInfo.address.city }}, {{ ::$ctrl.contactInfo.address.state }} {{ ::$ctrl.contactInfo.address.zip }}</p>\n            </div>\n            <div class=\"address\" ng-if=\"!::$ctrl.contactInfo.address.line1\">\n                <p>N/A</p>\n            </div>\n        </div>\n    </md-card>\n</md-dialog-content>");
$templateCache.put("app/components/patients/contactInfo/apm.patients.healthPlan.html","<div layout=\"row\" layout-align=\"start center\">\n    <span>Health Plan: {{$ctrl.healthPlan}}</span>\n</div>\n");
$templateCache.put("app/components/patients/grid/apm.patients.grid.component.html","<md-card class=\"patients-list-filter-container top-filter-container\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form id=\"PatientsListFilters\" name=\"PatientsListFilters\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"grow\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Last Name</label>\n                    <input type=\"text\" name=\"lastName\" autofocus=\"autofocus\" tabindex=\"1\" ng-model=\"$ctrl.filter.lastName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>First Name</label>\n                    <input type=\"text\" name=\"firstName\" tabindex=\"2\" ng-model=\"$ctrl.filter.firstName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Member ID</label>\n                    <input type=\"text\" name=\"memberId\" tabindex=\"3\" ng-model=\"$ctrl.filter.memberId\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n            </div>\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"date-picker-container md-block\" flex-gt-sm=\"30\">\n                    <label>DOB</label>\n                    <md-datepicker name=\"birthDate\" tabindex=\"4\" ng-model=\"$ctrl.filter.birthDate\" enter-press=\"$ctrl.submitFilter()\">\n                    </md-datepicker>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Phone Number</label>\n                    <input type=\"text\" name=\"phone\" tabindex=\"5\" ng-model=\"$ctrl.filter.phone\" phone-input enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <span class=\"md-title hide-ineligible-patients-switch\" layout=\"row\" layout-align=\"start center\">\n                        Hide Ineligible Patients\n                        <md-switch ng-model=\"$ctrl.hideIneligiblePatients\" ng-change=\"$ctrl.setPatients()\" aria-label=\"Hide Ineligible Patients\" class=\"md-primary\"></md-switch>\n                    </span>\n                </md-input-container>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"8\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter</md-button>\n            <md-button class=\"md-accent\" tabindex=\"9\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n\n<md-card layout=\"column\" layout-margin>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.getLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading the patients.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                    \'table-row-id-key\': \'fhirId\',\n                    \'column-keys\': [\n                      \'patientFullName\',\n                      \'birthDate\',\n                      \'memberId\',\n                      \'phone\',\n                      \'lastVisit\'\n                    ]\n                }\" ng-cloak>\n\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\">DOB</mdt-column>\n            <mdt-column align-rule=\"left\">Member ID</mdt-column>\n            <mdt-column align-rule=\"left\">Preferred Phone #</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Last PCP Visit</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"patientFullName\">\n            <a ng-click=\"clientScope.$ctrl.navigateToPatientDetails(rowId)\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/patients/header/apm.patients.header.component.html","<md-card layout=\"column\" class=\"patient-header\">\n    <md-card-content>\n        <div layout=\"row\" flex class=\"patient-header-row\">\n            <div flex>\n                <h2 class=\"patient-summary-title\">Patient Profile</h2>\n            </div>\n            <div layout-align=\"space-around start\" flex class=\"md-subhead patient-ineligible-wrapper\">\n                <div ng-if=\"!$ctrl.patient.active\">\n                    <h4 class=\"patient-inactive\">THIS PATIENT IS INELIGIBLE</h4>\n                </div>\n            </div>\n            <div layout-align=\"end center\" flex class=\"md-subhead return-button-wrapper\" ng-if=\"$ctrl.showReturnButton\">\n                <md-input-container class=\"return-button\">\n                    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.navigateToPreviousState()\">{{ $ctrl.returnButtonLabel }}</md-button>\n                </md-input-container>\n            </div>\n        </div>\n        <div layout-gt-sm=\"row\" layout-align-gt-sm=\"start start\" layout-padding class=\"patient-info-row\">\n            <div layout=\"row\" flex>\n                <h3 class=\"md-headline name\">{{ $ctrl.patient.fullName }} <span class=\"age-gender\"> {{ $ctrl.patient.age }}, {{ $ctrl.patient.gender | limitTo: 1 | uppercase }}</span></h3>\n            </div>\n            <div layout-align=\"space-around start\" flex class=\"md-subhead patient-ineligible-wrapper\">\n                <div ng-if=\"!$ctrl.patient.active\">\n                    <h4 class=\"patient-inactive\">THIS PATIENT IS INELIGIBLE</h4>\n                </div>\n            </div>\n            <div layout-align=\"space-around start\" flex class=\"md-subhead return-button-wrapper\" ng-if=\"$ctrl.showReturnButton\">\n                <md-input-container class=\"return-button\">\n                    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.navigateToPreviousState()\">{{ $ctrl.returnButtonLabel }}</md-button>\n                </md-input-container>\n            </div>\n        </div>\n\n        <div layout-gt-sm=\"row\" layout-align-gt-sm=\"start start\" layout-padding>\n            <div layout=\"row\" flex>\n                <div class=\"patient-phone-icon patient-header-phone\">\n                    <md-icon>call</md-icon>\n                </div>\n                <div layout-align=\"space-around start\" class=\"md-subhead\" flex>\n                    <p class=\"patient-header-phone\">\n                        {{ $ctrl.patient.phone | phoneNumber }}\n                    </p>\n                    <p class=\"patient-header-dob\">\n                        DOB: {{ ($ctrl.patient.birthDate || \'N/A\') | date : \'MM/dd/yyyy\' }}\n                    </p>\n                     <p class=\"patient-header-member-id\">\n                        Member ID: <span>{{ ($ctrl.patient.memberId || \'N/A\')}}</span>\n                    </p>\n                </div>\n            </div>\n\n            <div layout-align=\"space-around start\" flex class=\"md-subhead\">\n                <p class=\"patient-header-last-pcp\">\n                    Last PCP Visit: {{ ($ctrl.patient.lastVisit || \'N/A\') | date : \'MM/dd/yyyy\' }}\n                </p>\n                <p class=\"patient-header-pcp\">\n                    PCP: {{ $ctrl.patient.pcp || \'N/A\' }}\n                </p>\n                <p class=\"patient-header-group\">\n                    Group: {{ $ctrl.patient.clinic || \'N/A\' }}\n                </p>\n            </div>\n\n            <div layout-align=\"space-around start\" flex class=\"md-subhead\" ng-if=\"$ctrl.showQualityMeasure\">\n                <p class=\"patient-header-hcc\">\n                    HCC Weight: {{ ($ctrl.patient.qualityMeasures.headerScores.risk.hccValue | number:3) || \'N/A\' }}\n                </p>\n            </div>\n\n            <div layout-align=\"space-around start\" flex=\"25\" class=\"md-subhead\">\n                <p class=\"patient-header-open-gaps\">\n                    <span>Open Gaps:</span>\n                    <span data-tooltip=\"{{ ::$ctrl.getGapsTooltipTemplate(\'open\') }}\" ng-class=\"::$ctrl.apPatient.openGaps.length ? \'tooltip-right\' : \'tooltip-hidden\'\">\n                        {{ ::$ctrl.apPatient.openGaps.length }}\n                    </span>\n                </p>\n                <p class=\"patient-header-pending-gaps\">\n                    <span>Pending Gaps:</span>\n                    <span data-tooltip=\"{{ ::$ctrl.getGapsTooltipTemplate(\'pending\') }}\" ng-class=\"::$ctrl.apPatient.pendingGaps.length ? \'tooltip-right\' : \'tooltip-hidden\'\">\n                        {{ ::$ctrl.apPatient.pendingGaps.length }}\n                    </span>\n                </p>\n            </div>\n        </div>\n    </md-card-content>\n</md-card>\n");
$templateCache.put("app/components/patients/information/apm.patient.information.html","<div layout=\"row\" layout-wrap layout-align=\"start start\">\n    <apm-patient-contact-info-card class=\"Apm-patient-contact-info-card\" patient=\"$ctrl.patient\" flex-gt-md=\"25\">\n    </apm-patient-contact-info-card>\n    <apm-patient-provider-info-card patient=\"$ctrl.patient\" flex-gt-md=\"25\"></apm-patient-provider-info-card>\n    <apm-patient-appt-history-card patient=\"$ctrl.patient\" flex-gt-md=\"25\"></apm-patient-appt-history-card>\n    <apm-patient-call-history-card class=\"Apm-patient-call-history-card\" patient=\"$ctrl.patient\" flex-gt-md=\"25\">\n    </apm-patient-call-history-card>\n    <apm-patient-vendor-card ng-if=\"$ctrl.showVendorCard\" patient=\"$ctrl.patient\" flex-gt-md=\"25\"></apm-patient-vendor-card>\n    <apm-patient-active-plans-card class=\"Apm-patient-active-plans-card\" patient=\"$ctrl.patient\" flex-gt-md=\"25\">\n    </apm-patient-active-plans-card>\n</div>");
$templateCache.put("app/components/patients/profile/apm.patients.profile.component.html","<div layout=\"column\" layout-margin ng-if=\"$ctrl.patient\" class=\"patient-summary\">\n    <apm-patient-header patient=\"$ctrl.patient\" class=\"header-card no-card patient-summary-header\"></apm-patient-header>\n    <md-tabs md-dynamic-height=\"true\">\n        <md-tab label=\"Value\" md-on-select=\"$ctrl.loadTab(\'value\')\">\n            <apm-patient-activity patient=\"$ctrl.tabPatient.value\"></apm-patient-activity>\n        </md-tab>\n        <md-tab label=\"Information\" md-on-select=\"$ctrl.loadTab(\'information\')\">\n            <apm-patient-information patient=\"$ctrl.tabPatient.information\"></apm-patient-information>\n        </md-tab>\n        <md-tab label=\"Clinical\" md-on-select=\"$ctrl.loadTab(\'clinical\')\">\n            <apm-patient-clinical patient=\"$ctrl.tabPatient.clinical\"></apm-patient-clinical>\n        </md-tab>\n    </md-tabs>\n</div>\n<sc-loading-spinner ng-if=\"!$ctrl.patient\" class=\"patient-summary\"></sc-loading-spinner>\n");
$templateCache.put("app/components/patients/providerInfo/apm.patients.providerInfoModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Provider Information</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content>\n    <md-card flex layout-margin layout-padding>\n        <span>Provider: {{ ::$ctrl.vm.patient.providerInfo.name }}</span>\n    </md-card>\n    <md-card flex layout-margin layout-padding>\n        <span>Last Provider Visit: {{ ::$ctrl.vm.patient.lastVisit }}</span>\n    </md-card>\n    <md-card layout=\"row\" class=\"address-card\" flex layout-margin layout-padding>\n        <div class=\"address-card__label\">\n            <span>Provider Location:</span>\n        </div>\n        <div layout=\"column\" class=\"address-card__value\">\n            <span>{{ ::$ctrl.location.name }}</span>\n            <span>{{ ::$ctrl.location.address1 }}</span>\n            <span ng-if=\"$ctrl.location.address2\">{{ ::$ctrl.location.address2 }}</span>\n            <span ng-if=\"$ctrl.location.city\">{{ ::$ctrl.location.city }}, {{ ::$ctrl.location.state }} {{ ::$ctrl.location.zip }}</span>\n\n            <span ng-if=\"!$ctrl.location\">N/A</span>\n        </div>\n    </md-card>\n    <md-card flex layout-margin layout-padding ng-if=\"$ctrl.vm.patient.clinic\">\n        <span>Group: {{ ::$ctrl.vm.patient.clinic }}</span>\n    </md-card>\n</md-dialog-content>");
$templateCache.put("app/components/patients/testResults/apm.patients.testResultsGrid.component.html","<div class=\"error-message\">\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n</div>\n<md-card layout-margin class=\"patient-test-results-grid\">\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.pageSizes}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading test results.\" mdt-row-paginator-no-results-message=\"No test results for this patient.\" mdt-row=\"{\n                   \'table-row-id-key\': \'id\',\n                   \'column-keys\': [\n                       \'name\',\n                       \'relatedMeasures\',\n                       \'date\',\n                       \'associatedActionPlan\',\n                       \'result\'\n                   ]\n               }\">\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Test</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Measure(s)</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Date</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Action Plan</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Results</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"relatedMeasures\">\n            <span data-tooltip=\"{{::clientScope.$ctrl.getMeasuresTooltipTemplate(value)}}\" ng-class=\"::(value && value.length) ? \'tooltip-right\' : \'tooltip-hidden\'\">\n                {{::value.length}}\n            </span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"date\">\n            <span>{{value.displayValue}}</span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"associatedActionPlan\">\n            <a class=\"action-plan-title\" ui-sref=\"actionPlans.details({ id: clientScope.$ctrl.getRow(rowId).associatedActionPlanId })\" ng-click=\"clientScope.$ctrl.onActionPlanLink()\" ng-show=\"clientScope.$ctrl.getRow(rowId).associatedActionPlanId\">{{value}}</a>\n            <span ng-show=\"!clientScope.$ctrl.getRow(rowId).associatedActionPlanId\">{{value}}</span>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n    <div ng-if=\"$ctrl.testResults.length === 0\">No test results for this patient</div>\n</md-card>\n");
$templateCache.put("app/components/patients/testResults/apm.patients.testResultsModal.html","<md-dialog aria-label=\"Test Results\" class=\"grid-content\">\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <h2>Test Results</h2>\n            <span flex></span>\n            <md-button class=\"md-icon-button\" ng-click=\"close()\">\n                <md-icon alt=\"Close dialog\">close</md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-dialog-content class=\"appointments-dialog-content\">\n        <apm-patient-test-results-grid patient=\"$ctrl.patient\" page-sizes=\"[5, 10, 20, 30]\" on-action-plan-link=\"close()\"></apm-patient-test-results-grid>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/patients/vendor/apm.patients.vendor.component.html","<md-card>\n    <div ng-repeat=\"vendor in $ctrl.vendorData\">\n        <md-card-content layout=\"column\">\n            <div class=\"vendor-header\">\n                <div layout=\"row\">\n                    <div flex=\"50\">\n                        <md-icon alt=\"{{vendor.name}}\" ng-if=\"vendor.status === \'active\'\">check_circle</md-icon>\n                        <md-icon alt=\"{{vendor.name}}\" ng-if=\"vendor.status === \'inactive\'\">not_interested</md-icon>\n                         <span>{{vendor.name}}</span></div>\n                    <div flex=\"50\" class=\"first-letter-capitalize\">\n                        <span>{{vendor.status}} since </span>\n                        <time ng-if=\"vendor.statusEffectiveDate\">{{vendor.statusEffectiveDate | reverseDateFormatFilter}}</time>\n                        <span class=\"vendor-time\" ng-if=\"!vendor.statusEffectiveDate\">N/A</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"vendor-statuses\" layout=\"column\">\n                <div>\n                    <label>Last Disposition: </label>\n                    <time ng-if=\"vendor.encounterDate\">{{vendor.encounterDate | reverseDateFormatFilter}}</time>\n                    <span class=\"vendor-time\" ng-if=\"!vendor.encounterDate\">N/A</span>\n                    <span class=\"vendor-time\"> ( <span class=\"vendor-time\" ng-if=\"vendor.encounterDisposition\">{{vendor.encounterDisposition}}</span>\n                        <span class=\"vendor-time\" ng-if=\"!vendor.encounterDisposition\">N/A</span> )</span>\n                </div>\n                <div>\n                    <label>Last {{vendor.name}} Appointment: </label>\n                    <time ng-if=\"vendor.appointmentDate\">{{vendor.appointmentDate | reverseDateFormatFilter}}</time>\n                    <span class=\"vendor-time\" ng-if=\"!vendor.appointmentDate\">N/A</span>\n                    <span class=\"vendor-time\"> ( <span class=\"vendor-time\" ng-if=\"vendor.appointmentStatus\">{{vendor.appointmentStatus}}</span>\n                        <span class=\"vendor-time\" ng-if=\"!vendor.appointmentStatus\">N/A</span> )</span>\n                </div>\n            </div>\n        </md-card-content>\n        <md-divider></md-divider>\n    </div>\n</md-card>\n");
$templateCache.put("app/components/patients/vendorModal/apm.patients.vendorModal.component.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Vendor</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" aria-label=\"button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content>\n    <div class=\"error-message\">\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n    </div>\n    <patients-vendor-card patient=\"$ctrl.patient.id\" on-error=\"$ctrl.errorHandler(err)\"></patients-vendor-card>\n</md-dialog-content>\n");
$templateCache.put("app/components/providers/details/apm.providers.details.html","<form class=\"provider-details-container\" name=\"providerDetailsForm\">\n    <apm-provider-header ng-if=\"$ctrl.isSelectedProvider()\" provider=\"$ctrl.selectedProvider\" class=\"header-card\"></apm-provider-header>\n\n    <div layout ng-if=\"$ctrl.selectedProvider\">\n        <div flex=\"50\">\n            <md-card>\n                <md-toolbar class=\"_md _md-toolbar-transitions\">\n                    <div class=\"md-toolbar-tools\">\n                        <h2>Approved Tests</h2>\n                    </div>\n                </md-toolbar>\n                <md-card-content>\n                    <div layout=\"column\" class=\"template-container layout-row-mid\" layout-margin ng-cloak>\n                        <div>\n                            <label class=\"expiration-date\">Expiration Date:</label> <span>{{$ctrl.selectedProvider.expirationDate | reverseDateFormatFilter}}</span>\n                        </div>\n                        <sc-checkbox-tree class=\"checkbox-tree\" tree=\"$ctrl.providerDetailsDataCheckBoxes.groups\" on-change=\"$ctrl.onCheckboxChanged($ctrl.providerDetailsDataCheckBoxes.groups)\"></sc-checkbox-tree>\n                    </div>\n                    <div layout=\"row\" layout-margin>\n                        <div flex=\"50\">\n                            <md-input-container ng-if=\"providerDetailsForm.$dirty\" class=\"md-block\">\n                                <input placeholder=\"Comments\" name=\"comments\" ng-model=\"$ctrl.comments\" ng-required=\"!$ctrl.selectedProvider.firstTimeIn\">\n\n                            </md-input-container>\n                        </div>\n                    </div>\n                    <div layout=\"column\">\n                        <div layout-gt-xs=\"row\" layout-margin layout-padding layout-align=\"end none\" class=\"layout-row-bottom\">\n                            <md-input-container>\n                                <md-button class=\"md-accent\" ui-sref=\"providers.list\">CANCEL</md-button>\n                                <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.save();\" ng-disabled=\"$ctrl.saveReadOnly || $ctrl.isLoading\" aria-label=\"button\">\n                                    <span ng-if=\"!$ctrl.isLoading\">SAVE</span>\n                                    <sc-loading-spinner ng-if=\"$ctrl.isLoading\" diameter=\"25\"></sc-loading-spinner>\n                                </md-button>\n                            </md-input-container>\n                        </div>\n                    </div>\n                </md-card-content>\n            </md-card>\n        </div>\n        <div flex=\"50\" layout-align=\"start none\" class=\"sdo-history-card\">\n            <md-expansion-panel>\n                <md-expansion-panel-collapsed>\n                    <div class=\"md-title\">History</div>\n                    <div class=\"md-summary\">\n                        <span ng-hide=\"!$ctrl.selectedProvider.comments.length\">Last Updated {{ $ctrl.selectedProvider.lastUpdated | reverseDateFormatFilter }}</span>\n                    </div>\n                    <md-expansion-panel-icon></md-expansion-panel-icon>\n                </md-expansion-panel-collapsed>\n                <md-expansion-panel-expanded>\n                    <md-expansion-panel-header>\n                        <div class=\"md-title\">History</div>\n                        <div class=\"md-summary\">\n                            <span ng-hide=\"!$ctrl.selectedProvider.comments.length\">Last Updated {{ $ctrl.selectedProvider.lastUpdated | reverseDateFormatFilter }}</span>\n                        </div>\n                        <md-expansion-panel-icon ng-click=\"$panel.collapse()\"></md-expansion-panel-icon>\n                    </md-expansion-panel-header>\n                    <md-expansion-panel-content layout=\"column\">\n                        <span ng-if=\"!$ctrl.selectedProvider.comments\">There are no comments.</span>\n                        <mdt-table mdt-row-paginator-error-message=\"Error happened while loading the patients.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                              \'data\': $ctrl.selectedProvider.comments,\n                              \'column-keys\': [\n                                \'text\',\n                                \'fullName\',\n                                \'date\'\n                              ]\n                            }\" ng-if=\"$ctrl.selectedProvider.comments\" ng-cloak>\n\n                            <mdt-header-row>\n                                <mdt-column align-rule=\"left\" column-sort=\"true\">Comment</mdt-column>\n                                <mdt-column align-rule=\"left\" column-sort=\"true\">User</mdt-column>\n                                <mdt-column align-rule=\"left\" column-sort=\"true\">Date/Time</mdt-column>\n                            </mdt-header-row>\n                        </mdt-table>\n                    </md-expansion-panel-content>\n                </md-expansion-panel-expanded>\n            </md-expansion-panel>\n        </div>\n    </div>\n</form>\n<sc-loading-spinner ng-if=\"!$ctrl.isSelectedProvider()\" class=\"patient-summary\"></sc-loading-spinner>\n");
$templateCache.put("app/components/providers/grid/apm.providers.grid.component.html","<md-card class=\"providers-grid-filter-container top-filter-container providerList-grid one-row\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form id=\"ProvidersGridFilters\" name=\"providersGridFilters\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"grow\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n                    <label>Last Name</label>\n                    <input type=\"text\" name=\"lName\" tabindex=\"1\" ng-model=\"$ctrl.filter.lName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n                    <label>First Name</label>\n                    <input type=\"text\" name=\"fName\" tabindex=\"2\" ng-model=\"$ctrl.filter.fName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <!--<md-input-container class=\"md-block\" flex-gt-sm=\"30\">-->\n                <!--<label>Market</label>-->\n                <!--<input type=\"text\" name=\"market\"-->\n                <!--ng-model=\"$ctrl.filter.market\" />-->\n                <!--</md-input-container>-->\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons sc-filter-buttons-single-line\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"3\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter</md-button>\n            <md-button class=\"md-accent\" tabindex=\"4\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n\n<md-card layout=\"column\" layout-margin>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize)\" mdt-trigger-request=\"$ctrl.getLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading provider list.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                    \'table-row-id-key\': \'resource.id\',\n                    \'column-keys\': [\n                      \'providerFullName\'\n                    ]\n                }\" ng-cloak>\n\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\">Name</mdt-column>\n            <!--<mdt-column align-rule=\"left\">Market</mdt-column>-->\n            <!--<mdt-column align-rule=\"left\">Patient Count</mdt-column>-->\n            <!--<mdt-column align-rule=\"left\">SDO Approved Count</mdt-column>-->\n            <!--<mdt-column align-rule=\"left\">SDO Expiration</mdt-column>-->\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"providerFullName\">\n            <a ui-sref=\"providers.details({ id: rowId })\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/providers/header/apm.providers.header.component.html","<div layout-gt-sm=\"row\" layout=\"column\">\n    <div flex=\"70\">\n        <md-card layout=\"column\">\n            <md-card-content>\n                <div layout-gt-sm=\"row\" layout-align-gt-sm=\"start start\" layout-padding>\n                    <div layout=\"row\" flex>\n                        <h3 class=\"md-headline\">{{ $ctrl.providerName }}</h3>\n                    </div>\n                </div>\n            </md-card-content>\n        </md-card>\n    </div>\n    <div flex=\"30\">\n        <md-input-container class=\"return-button\">\n            <md-button class=\"md-raised md-accent\" ui-sref=\"providers.list\">RETURN TO PROVIDER LIST</md-button>\n        </md-input-container>\n    </div>\n</div>");
$templateCache.put("app/components/reports/actionPlans/apm.reports.actionPlans.component.html","<div layout=\"column\" ng-if=\"$ctrl.actionPlanReport\">\n    <action-plan-report-header ng-if=\"$ctrl.actionPlanReport && $ctrl.vm.actionPlan\" header-data=\"$ctrl.actionPlanReport.headerData\" action-plan=\"$ctrl.vm.actionPlan\"></action-plan-report-header>\n\n    <div layout=\"row\" layout-align=\"center\">\n        <div class=\"action-plan-details-card-container\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n            <action-plan-details-card ng-repeat=\"patientSummary in $ctrl.patientSummaryConfig\" icon=\"{{ patientSummary.icon }}\" label=\"{{ patientSummary.label }}\" value=\"{{ patientSummary.value }}\"></action-plan-details-card>\n        </div>\n    </div>\n\n\n    <apm-details-grid ng-if=\"$ctrl.vm.actionPlan.status === \'COMPLETED\'\" action-plan=\"$ctrl.vm.actionPlan\" current-step=\"$ctrl.vm.actionPlan.currentWorkflowStep\" ng-cloak></apm-details-grid>\n\n    <div class=\"report-grid-container\" layout=\"column\" layout-gt-md=\"row\" ng-if=\"$ctrl.actionPlanReport && $ctrl.vm.actionPlan\">\n        <div>\n            <action-plan-report-grid action-plan=\"$ctrl.vm.actionPlan\" flex sorting=\"[{key: \'_sort:desc\', value: \'gapsPending\' }]\"></action-plan-report-grid>\n        </div>\n        <div>\n            <md-card layout=\"column\" layout-align=\"start center\" layout-padding class=\"action-plan-staff\">\n\n                <span class=\"md-title\">Scheduling Staff</span>\n                <span ng-repeat=\"staff in $ctrl.actionPlanReport.team[1]\">{{ staff }}</span>\n                <span ng-if=\"!$ctrl.actionPlanReport.team[1].length\">None</span>\n\n                <div class=\"divider\"></div>\n\n                <span class=\"md-title\">Reminder Call Staff</span>\n                <span ng-repeat=\"staff in $ctrl.actionPlanReport.team[2]\">{{ staff }}</span>\n                <span ng-if=\"!$ctrl.actionPlanReport.team[2].length\">None</span>\n\n                <div class=\"divider\"></div>\n\n                <span class=\"md-title\">Encounter Staff</span>\n                <span ng-repeat=\"staff in $ctrl.actionPlanReport.team[3]\">{{ staff }}</span>\n                <span ng-if=\"!$ctrl.actionPlanReport.team[3].length\">None</span>\n\n            </md-card>\n        </div>\n    </div>\n\n</div>\n<sc-loading-spinner ng-if=\"!$ctrl.actionPlanReport\" class=\"patient-summary\"></sc-loading-spinner>");
$templateCache.put("app/components/reports/callLog/apm.reports.callLog.grid.component.html","<md-card class=\"call-log-report-filter-container top-filter-container\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form id=\"CallLogFilter\" name=\"callLogFilter\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"grow\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>First Name</label>\n                    <input type=\"text\" name=\"patientFirstName\" autofocus=\"autofocus\" tabindex=\"1\" ng-model=\"$ctrl.filter.patientFirstName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Last Name</label>\n                    <input type=\"text\" name=\"patientLastName\" tabindex=\"2\" ng-model=\"$ctrl.filter.patientLastName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <md-select class=\"disposition-select\" tabindex=\"3\" ng-model=\"$ctrl.filter.dispositionCodes\" multiple=\"multiple\" placeholder=\"Disposition\">\n                        <md-option ng-value=\"callDisposition.code\" ng-repeat=\"callDisposition in $ctrl.callResultList\">{{callDisposition.display}}</md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Caller First Name</label>\n                    <input type=\"text\" name=\"callerFirstName\" tabindex=\"4\" ng-model=\"$ctrl.filter.callerFirstName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Caller Last Name</label>\n                    <input type=\"text\" name=\"callerLastName\" tabindex=\"5\" ng-model=\"$ctrl.filter.callerLastName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Action Plan</label>\n                    <input type=\"text\" name=\"actionPlanTitle\" tabindex=\"6\" ng-model=\"$ctrl.filter.actionPlanTitle\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n            </div>\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <div flex-gt-sm=\"30\">\n                    <md-input-container class=\"date-picker-container\">\n                        <label>Start Date</label>\n                        <md-datepicker name=\"startDate\" tabindex=\"7\" ng-model=\"$ctrl.filter.startDate\" enter-press=\"$ctrl.submitFilter()\"></md-datepicker>\n                    </md-input-container>\n                </div>\n                <div flex-gt-sm=\"30\">\n                    <md-input-container class=\"date-picker-container\">\n                        <label>End Date</label>\n                        <md-datepicker name=\"endDate\" tabindex=\"8\" ng-model=\"$ctrl.filter.endDate\" enter-press=\"$ctrl.submitFilter()\"></md-datepicker>\n                    </md-input-container>\n                </div>\n                <div flex-gt-sm=\"30\"></div>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"9\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter</md-button>\n            <md-button class=\"md-accent\" tabindex=\"10\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n\n<div layout-padding layout-margin ng-show=\"!$ctrl.hasFilter\" layout=\"row\" layout-align=\"start center\">\n    <md-subheader ng-show=\"!$ctrl.hasFilter\" class=\"md-primary\">Please enter Filter Criteria above to view the report.</md-subheader>\n</div>\n\n<md-card layout-margin layout=\"column\" ng-show=\"$ctrl.hasFilter\">\n    <div layout=\"row\" layout-align=\"end center\">\n        <md-button class=\"md-raised md-accent\" tabindex=\"11\" ng-disabled=\"!$ctrl.hasResults()\" ng-click=\"$ctrl.downloadCSV()\" access-type=\"PERMISSION\" access-control=\"scAPReport\">Export to CSV\n        </md-button>\n    </div>\n\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading call logs.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                    \'table-row-id-key\': \'_id\',\n                    \'column-keys\': [\n                        \'patientFullName\',\n                        \'actionPlanTitle\',\n                        \'dispositionDisplayText\',\n                        \'callerFullName\',\n                        \'callTime\'\n                    ]\n                }\" ng-cloak>\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Action Plan</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Call Disposition</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Caller</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Date / Time</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"patientFullName\">\n            <a href=\"\" ng-click=\"clientScope.$ctrl.goToPatient(value)\">{{value}}</a>\n        </mdt-custom-cell>\n        <mdt-custom-cell column-key=\"actionPlanTitle\">\n            <a ui-sref=\"actionPlans.details({ id: clientScope.$ctrl.getRow(rowId).actionPlanId })\" ng-show=\"clientScope.$ctrl.getRow(rowId).actionPlanId\">{{value}}</a>\n            <span ng-show=\"!clientScope.$ctrl.getRow(rowId).actionPlanId\">N/A</span>\n        </mdt-custom-cell>\n        <mdt-custom-cell column-key=\"callTime\">\n            {{value | date : \'short\'}}\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/reports/grid/apm.reports.grid.component.html","<md-card class=\"reports-grid-filter-container top-filter-container one-row\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form id=\"ReportsGridFilters\" name=\"reportsGridFilters\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"grow\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n                    <label>AP Title</label>\n                    <input type=\"text\" name=\"title\" autofocus=\"autofocus\" tabindex=\"1\" ng-model=\"$ctrl.filter.title\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n                    <label>Provider</label>\n                    <input type=\"text\" name=\"practitioner\" tabindex=\"3\" ng-model=\"$ctrl.filter.practitioner\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons sc-filter-buttons-single-line\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"4\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter</md-button>\n            <md-button class=\"md-accent\" tabindex=\"5\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n\n<md-card layout-margin layout=\"column\">\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.getLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading the reports.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                    \'table-row-id-key\': \'_id\',\n                    \'column-keys\': [\n                        \'title\',\n                        \'actionPlanEventType.display\',\n                        \'eventDates\',\n                        \'lastUpdated\'\n                    ]\n                }\" ng-cloak>\n\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Title</mdt-column>\n            <mdt-column align-rule=\"left\">Event Type</mdt-column>\n            <mdt-column align-rule=\"left\">Event Date</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Last Modified</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"title\">\n            <a ui-sref=\"reports.actionPlans({ id: rowId })\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"eventDates\">\n            <div class=\"event-column\">{{value}}</div>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/reports/pendingGaps/apm.reports.pendingGaps.grid.component.html","<md-card class=\"pending-gaps-report-filter-container top-filter-container\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form name=\"pendingGapsFilter\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"grow\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Action Plan Title</label>\n                    <input type=\"text\" name=\"actionPlanTitle\" autofocus=\"autofocus\" tabindex=\"1\" ng-model=\"$ctrl.filter.actionPlanTitle\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Patient Last Name</label>\n                    <input type=\"text\" name=\"patientLastName\" tabindex=\"2\" ng-model=\"$ctrl.filter.patientLastName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"30\">\n                    <label>Patient First Name</label>\n                    <input type=\"text\" name=\"patientFirstName\" tabindex=\"3\" ng-model=\"$ctrl.filter.patientFirstName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n            </div>\n            <div layout-align=\"space-between none\" layout=\"column\" layout-gt-sm=\"row\">\n                <div flex-gt-sm=\"initial\">\n                    <md-input-container id=\"DatePerformed\" class=\"date-picker-container\">\n                        <label>Date Performed</label>\n                        <md-datepicker name=\"datePerformed\" tabindex=\"4\" ng-model=\"$ctrl.filter.datePerformed\" enter-press=\"$ctrl.submitFilter()\"></md-datepicker>\n                    </md-input-container>\n                </div>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\" ng-if=\"false\">\n                    <md-select class=\"measure-select\" tabindex=\"5\" ng-model=\"$ctrl.filter.measureCodes\" multiple=\"multiple\" placeholder=\"Measure Code\">\n                        <md-option ng-value=\"measure.code\" ng-repeat=\"measure in $ctrl.measureList\">{{measure.display}}</md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"8\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter</md-button>\n            <md-button class=\"md-accent\" tabindex=\"9\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n\n<md-card layout=\"column\" layout-margin>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading the Pending Gaps reports.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                    \'table-row-id-key\': \'actionPlanId\',\n                    \'column-keys\': $ctrl.columns\n                }\" ng-cloak>\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">DOB</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Measure</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Action Plan</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Date Performed</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Days Since Performed</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Reopen</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"patientFullName\">\n            <a href=\"\" ng-click=\"clientScope.$ctrl.goToPatient(value)\">{{value}}</a>\n        </mdt-custom-cell>\n        <mdt-custom-cell column-key=\"actionPlanTitle\">\n            <a ui-sref=\"actionPlans.details({ id: clientScope.$ctrl.getRow(rowId).actionPlanId })\">{{value}}</a>\n        </mdt-custom-cell>\n        <mdt-custom-cell column-key=\"reopen\">\n            <md-icon ng-click=\"clientScope.$ctrl.showReopenGapModal(value)\" class=\"reopen-gap\">replay</md-icon>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/reports/pendingGaps/apm.reports.pendingGaps.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Current Pending Gaps</h3>\n</div>\n\n<apm-reports-pending-gaps-grid sorting=\"[{key: \'_sort:desc\', value: \'datePerformed\' }]\"></apm-reports-pending-gaps-grid>\n");
$templateCache.put("app/components/resources/details/apm.resources.details.html","<div layout=\"column\" class=\"apm-resources-details\" ng-if=\"!$ctrl.loading\">\n    <div layout=\"row\" flex=\"auto\">\n        <md-card layout-padding layout-margin class=\"user-info-card\">\n            <div layout=\"column\">\n                <div class=\"user-name\">\n                    <span>{{ $ctrl.resource.fullName }}</span>\n                </div>\n                <div class=\"user-info\">\n                    <label>Role:</label>\n                    <span>{{ $ctrl.resource.roles[0].description}}</span>\n                </div>\n            </div>\n        </md-card>\n    </div>\n\n    <div>\n        <md-card>\n            <md-toolbar class=\"_md _md-toolbar-transitions\">\n                <div class=\"md-toolbar-tools\">\n                    <h2>Vacation &amp; Leave Time</h2>\n                </div>\n            </md-toolbar>\n\n            <md-card-content flex=\"auto\">\n                <div ng-if=\"!$ctrl.loadingEvents\" layout=\"row\">\n                    <div layout=\"column\" flex>\n\n                        <div ng-repeat=\"event in $ctrl.events\" layout=\"column\" class=\"event\">\n                            <div layout=\"row\">\n                                <div layout=\"column\" layout-align=\"start\">\n                                    <div class=\"event-type-badge\">\n                                        <span>{{ event.typeDisplay }}</span>\n                                    </div>\n                                </div>\n                                <div class=\"event-dates\">\n                                    <span>{{ event.displayStartDate }}</span>\n                                    <span ng-if=\"event.endDate !== event.startDate\">&nbsp;to {{ event.displayEndDate }}</span>\n                                </div>\n                                <div layout=\"row\" layout-align=\"center\">\n                                    <md-icon class=\"material-icons action-icon edit-pencil\" ng-click=\"$ctrl.createEditLeave(event)\">mode_edit</md-icon>\n                                    <md-icon class=\"material-icons action-icon\" ng-click=\"$ctrl.confirmDeleteEvent(event._id)\">delete</md-icon>\n                                </div>\n                            </div>\n                            <div>\n                                <label>Entered by:</label>\n                                <span>{{ event.creatorFullName }} on {{ event.displayCreatedDate }}</span>\n                            </div>\n                            <hr>\n                            <md-divider md-inset></md-divider>\n                            <hr>\n                        </div>\n\n                        <div ng-if=\"!$ctrl.events.length\">\n                            <span>This team member does not have any vacation or leave booked yet.</span>\n                        </div>\n                    </div>\n                    <div>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.createEditLeave()\" aria-label=\"Add Leave\">Add</md-button>\n                    </div>\n                </div>\n                <sc-loading-spinner flex ng-if=\"$ctrl.loadingEvents\" class=\"resources-list\"></sc-loading-spinner>\n            </md-card-content>\n        </md-card>\n    </div>\n</div>\n<sc-loading-spinner flex ng-if=\"$ctrl.loading\" class=\"apm-resources-details\"></sc-loading-spinner>\n");
$templateCache.put("app/components/resources/grid/apm.resources.grid.component.html","<md-card class=\"resources-grid-filter-container top-filter-container resourcesList-grid one-row\" layout-padding layout-margin layout=\"column\" layout-gt-sm=\"row\">\n    <form id=\"ResourcesGridFilters\" name=\"resourcesGridFilters\" layout-fill layout=\"column\" layout-gt-sm=\"row\">\n        <div layout=\"column\" flex-gt-sm=\"70\">\n            <div layout-align=\"space-between stretch\" layout=\"column\" layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"35\">\n                    <label>Last Name</label>\n                    <input type=\"text\" name=\"lName\" tabindex=\"1\" ng-model=\"$ctrl.filter.lName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"35\">\n                    <label>First Name</label>\n                    <input type=\"text\" name=\"fName\" tabindex=\"2\" ng-model=\"$ctrl.filter.fName\" enter-press=\"$ctrl.submitFilter()\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"20\">\n                    <md-select placeholder=\"Role\" class=\"role-select\" ng-model=\"$ctrl.filter.roles\">\n                        <md-option selected=\"selected\" value=\"\"></md-option>\n                        <md-option class=\"role-select-option\" ng-value=\"role.role\" ng-repeat=\"role in $ctrl.enabledRoles\">{{ role.roleDescription }}\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" layout-align-sm=\"center end\" flex=\"initial\" class=\"sc-filter-buttons sc-filter-buttons-single-line\" flex-gt-sm=\"30\">\n            <md-button class=\"md-raised md-accent\" tabindex=\"3\" ng-disabled=\"$ctrl.isFilterEmpty()\" ng-click=\"$ctrl.submitFilter()\">Filter</md-button>\n            <md-button class=\"md-accent\" tabindex=\"4\" ng-click=\"$ctrl.clearFilter()\">Clear</md-button>\n        </div>\n    </form>\n</md-card>\n\n<md-card layout=\"column\" layout-margin>\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize)\" mdt-trigger-request=\"$ctrl.getLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading resources list.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                    \'table-row-id-key\': \'_id\',\n                    \'column-keys\': [\n                      \'userFullName\',\n                      \'userRoles\'\n                    ]\n                }\" ng-cloak>\n\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\">Name</mdt-column>\n            <mdt-column align-rule=\"left\">Role(s)</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"userFullName\">\n            <a ng-click=\"clientScope.$ctrl.navigateToUserDetails(rowId)\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/resources/locations/apm.resources.locations.component.html","<div layout=\"column\" flex=\"grow\">\n    <h3 flex=\"none\" class=\"page-title\">Location List</h3>\n</div>\n<div layout=\"column\" layout-gt-md=\"row\">\n    <apm-resources-locations-grid class=\"Apm-resources-locations-grid\" flex=\"70\" checkbox-obj=\"$ctrl.checkboxObj\" addresses-obj=\"$ctrl.addressesObj\"></apm-resources-locations-grid>\n    <apm-resources-locations-bucket class=\"Apm-resources-locations-bucket\" flex=\"30\" checkbox-obj=\"$ctrl.checkboxObj\" addresses-obj=\"$ctrl.addressesObj\"></apm-resources-locations-bucket>\n</div>\n");
$templateCache.put("app/components/actionPlans/actions/encounter/apm.actionPlans.actions.encounter.html","<div class=\"actions-container\" ng-if=\"$ctrl.ready\">\n    <div layout-gt-sm=\"row\" layout=\"column\">\n        <div flex=\"70\">\n            <apm-patient-header patient=\"$ctrl.patient\" ap-patient=\"$ctrl.vm.apPatient\" class=\"header-card\"></apm-patient-header>\n        </div>\n        <div flex=\"30\">\n            <md-input-container class=\"return-button\">\n                <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.goToAPList()\">RETURN TO PATIENT LIST</md-button>\n            </md-input-container>\n        </div>\n    </div>\n\n    <div layout-gt-sm=\"row\" layout=\"column\">\n        <reminder-call-result-actions flex=\"30\" patient=\"$ctrl.apPatient\" has-appointment=\"$ctrl.hasAppointment\" is-read-only=\"true\"></reminder-call-result-actions>\n        <encounter-update-results-actions flex=\"70\" patient=\"$ctrl.apPatient\"></encounter-update-results-actions>\n\n    </div>\n</div>\n<div class=\"loading-message\" ng-if=\"!$ctrl.ready\">Loading ...</div>\n<sc-loading-spinner ng-if=\"!$ctrl.ready\" class=\"actions-container\"></sc-loading-spinner>");
$templateCache.put("app/components/actionPlans/actions/reminder/apm.actionPlans.actions.reminder.html","<div class=\"actions-container\" ng-if=\"$ctrl.ready\">\n    <div layout-gt-sm=\"row\" layout=\"column\">\n        <div flex=\"70\">\n            <apm-patient-header patient=\"$ctrl.patient\" ap-patient=\"$ctrl.vm.apPatient\" class=\"header-card\"></apm-patient-header>\n        </div>\n        <div flex=\"30\">\n            <md-input-container class=\"return-button\">\n                <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.goToAPList()\">RETURN TO PATIENT LIST</md-button>\n            </md-input-container>\n        </div>\n    </div>\n\n    <div layout-gt-sm=\"row\" layout=\"column\">\n        <div flex=\"50\">\n            <schedule-call-result-actions flex=\"50\" ng-if=\"!$ctrl.hasAppointment\" is-read-only=\"$ctrl.isReadOnly\" patient=\"$ctrl.apPatient\">\n            </schedule-call-result-actions>\n            <reminder-call-result-actions flex=\"50\" ng-if=\"$ctrl.hasAppointment\" is-read-only=\"$ctrl.isReadOnly\" patient=\"$ctrl.apPatient\" has-appointment=\"$ctrl.hasAppointment\">\n            </reminder-call-result-actions>\n            <md-card layout=\"row\">\n                <md-card-content>\n                    <apm-edit-phone-number on-error=\"$ctrl.errorHandler(err)\"></apm-edit-phone-number>\n                </md-card-content>\n            </md-card>\n            <patients-vendor-card patient=\"$ctrl.apPatient.patient\" on-error=\"$ctrl.errorHandler(err)\" ng-if=\"$ctrl.getVendorVisibility()\"></patients-vendor-card>\n        </div>\n        <div flex=\"50\" layout=\"column\">\n            <div layout=\"row\" layout-md=\"column\">\n                <apm-patient-active-plans-card class=\"Apm-patient-active-plans-card\" patient=\"$ctrl.vm.patient\">\n                </apm-patient-active-plans-card>\n                <apm-patient-appt-history-card patient=\"$ctrl.apPatient\"></apm-patient-appt-history-card>\n            </div>\n            <div layout=\"row\" layout-md=\"column\">\n                <apm-patient-call-history-card class=\"Apm-patient-call-history-card\" patient=\"$ctrl.vm.patient\">\n                </apm-patient-call-history-card>\n                <apm-patient-contact-info-card class=\"Apm-patient-contact-info-card\" patient=\"$ctrl.patient\">\n                </apm-patient-contact-info-card>\n            </div>\n            <div>\n                <apm-patient-provider-info-card patient=\"$ctrl.patient\"></apm-patient-provider-info-card>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"loading-message\" ng-if=\"!$ctrl.ready\">Loading ...</div>\n<sc-loading-spinner ng-if=\"!$ctrl.ready\" class=\"actions-container\"></sc-loading-spinner>");
$templateCache.put("app/components/actionPlans/actions/schedule/apm.actionPlans.actions.schedule.html","<div class=\"actions-container\" ng-if=\"$ctrl.ready\">\n    <div layout-gt-sm=\"row\" layout=\"column\">\n        <div flex=\"70\">\n            <apm-patient-header patient=\"$ctrl.patient\" ap-patient=\"$ctrl.vm.apPatient\" class=\"header-card\"></apm-patient-header>\n        </div>\n        <div flex=\"30\">\n            <md-input-container class=\"return-button\">\n                <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.goToAPList()\">RETURN TO PATIENT LIST</md-button>\n            </md-input-container>\n        </div>\n    </div>\n\n    <div layout-gt-sm=\"row\" layout=\"column\">\n        <div flex=\"50\">\n        <schedule-call-result-actions flex=\"50\" ng-if=\"!$ctrl.hasAppointment\" is-read-only=\"$ctrl.isReadOnly\" patient=\"$ctrl.apPatient\">\n        </schedule-call-result-actions>\n        <reminder-call-result-actions flex=\"50\" ng-if=\"$ctrl.hasAppointment\" is-read-only=\"$ctrl.isReadOnly\" patient=\"$ctrl.apPatient\" has-appointment=\"$ctrl.hasAppointment\" action-type=\"$ctrl.actionType\">\n        </reminder-call-result-actions>\n        <md-card>\n            <md-card-content>\n                <apm-edit-phone-number on-error=\"$ctrl.errorHandler(err)\"></apm-edit-phone-number>\n            </md-card-content>\n        </md-card>\n            <patients-vendor-card patient=\"$ctrl.apPatient.patient\" on-error=\"$ctrl.errorHandler(err)\" ng-if=\"$ctrl.getVendorVisibility()\"></patients-vendor-card>\n        </div>\n        <div flex=\"50\" layout=\"column\">\n          <div layout=\"row\" layout-md=\"column\">\n              <apm-patient-active-plans-card class=\"Apm-patient-active-plans-card\" patient=\"$ctrl.vm.patient\">\n              </apm-patient-active-plans-card>\n              <apm-patient-appt-history-card patient=\"$ctrl.apPatient\"></apm-patient-appt-history-card>\n          </div>\n          <div layout=\"row\" layout-md=\"column\">\n              <apm-patient-call-history-card class=\"Apm-patient-call-history-card\" patient=\"$ctrl.vm.patient\">\n              </apm-patient-call-history-card>\n              <apm-patient-contact-info-card class=\"Apm-patient-contact-info-card\" patient=\"$ctrl.patient\">\n              </apm-patient-contact-info-card>\n          </div>\n          <div>\n              <apm-patient-provider-info-card patient=\"$ctrl.patient\"></apm-patient-provider-info-card>\n          </div>\n        </div>\n    </div>\n</div>\n<div class=\"loading-message\" ng-if=\"!$ctrl.ready\">Loading ...</div>\n<sc-loading-spinner ng-if=\"!$ctrl.ready\" class=\"actions-container\"></sc-loading-spinner>");
$templateCache.put("app/components/actionPlans/calendar/checkboxResources/apm.actionPlans.calendar.checkboxResources.component.html","<h2>Resource Calendar</h2>\n<div layout=\"column\" ng-cloak>\n    <sc-checkbox-tree ng-repeat=\"resourceSet in $ctrl.availableResources\" class=\"checkbox-tree\" ng-class=\"{\'MA\': resourceSet.id === $ctrl.ROLES.PSU, \'NP\': resourceSet.id === $ctrl.ROLES.NP}\" tree=\"[resourceSet]\" on-change=\"$ctrl.onCheckboxChanged()\"></sc-checkbox-tree>\n</div>\n");
$templateCache.put("app/components/actionPlans/createEdit/header/apm.actionPlans.createEditHeader.component.html","<div class=\"title\" layout=\"row\">\n    <h3 class=\"title__text\">{{ $ctrl.title }}</h3>\n</div>");
$templateCache.put("app/components/actionPlans/createEdit/instructions/apm.actionPlans.createInstructions.html","<form class=\"create-edit-action-plan-container\" name=\"createActionPlanInstructionsForm\">\n    <apm-action-plan-header class=\"Apm-action-plan-header\" title=\"$ctrl.apmActionPlanService.getActionPlanTitle()\"></apm-action-plan-header>\n    <div layout=\"row\" layout-margin>\n        <h4>Instructions <i>(Optional)</i></h4>\n    </div>\n    <div layout=\"column\" layout-margin>\n        <md-input-container class=\"instructions-input\" md-no-float>\n            <label>Scheduling Instructions</label>\n            <input type=\"text\" ng-model=\"$ctrl.schedulingInstructions\" md-maxlength=\"250\" aria-label=\"input\" ng-disabled=\"$ctrl.isLimitedEdit\">\n        </md-input-container>\n        <md-input-container class=\"instructions-input\" md-no-float ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\">\n            <label>Reminder Call Instructions</label>\n            <input type=\"text\" ng-model=\"$ctrl.reminderInstructions\" md-maxlength=\"250\" aria-label=\"input\" ng-disabled=\"$ctrl.isLimitedEdit\">\n        </md-input-container>\n        <md-input-container class=\"instructions-input\" md-no-float ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\">\n            <label>Patient Encounter Instructions</label>\n            <input type=\"text\" ng-model=\"$ctrl.encounterInstructions\" md-maxlength=\"250\" aria-label=\"input\" ng-disabled=\"$ctrl.isLimitedEdit\">\n        </md-input-container>\n        <div>\n            <div class=\"button-container\">\n                <md-button ui-sref=\"actionPlans.list\" class=\"md-primary step-cancel\">CANCEL</md-button>\n                <md-button ng-click=\"$ctrl.back()\" class=\"md-accent md-raised\">BACK</md-button>\n                <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" ng-disabled=\"!createActionPlanInstructionsForm.$valid\">SAVE</md-button>\n            </div>\n        </div>\n    </div>\n</form>\n");
$templateCache.put("app/components/actionPlans/createEdit/location/apm.actionPlans.createLocation.html","<form class=\"create-edit-action-plan-container\" name=\"createActionPlanLocationForm\" ng-cloak>\n    <apm-action-plan-header class=\"Apm-action-plan-header\" title=\"$ctrl.apmActionPlanService.getActionPlanTitle()\"></apm-action-plan-header>\n    <div layout=\"row\">\n        <div layout-margin layout-padding>\n            <h4>Location</h4>\n        </div>\n    </div>\n\n    <div layout=\"row\">\n        <div layout=\"column\" layout-margin layout-padding flex=\"grow\">\n            <p>Event Schedule</p>\n            <div>\n                <div layout-gt-sm=\"row\" layout=\"column\" class=\"timeslot-container\">\n                    <div flex-gt-sm=\"20\">\n                        <md-input-container class=\"appointment\">\n                            <label>Appointment Length</label>\n                            <md-select ng-model=\"$ctrl.appointmentLength\" ng-change=\"$ctrl.resetAppointmentLength($ctrl.appointmentLength)\" required name=\"appointmentLength\" ng-disabled=\"$ctrl.isLimitedEdit\">\n                                <md-option ng-repeat=\"len in $ctrl.appointmentLengths\" value=\"{{len}}\">{{len}}</md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                    <div flex-gt-sm=\"20\">\n                        <md-input-container class=\"appointment\">\n                            <label>First Appointment</label>\n                            <md-select ng-model=\"$ctrl.startTime\" ng-change=\"$ctrl.setTime($ctrl.startTime, \'start\')\" required name=\"startTime\" ng-disabled=\"!$ctrl.appointmentLength || $ctrl.isLimitedEdit\">\n                                <md-option value=\"\"></md-option>\n                                <md-option ng-if=\"!$last\" ng-repeat=\"el in $ctrl.eventTimes\" value=\"{{el}}\">{{el}}</md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                    <div flex-gt-sm=\"20\">\n                        <md-input-container class=\"appointment\">\n                            <label>Last Appointment</label>\n                            <md-select ng-model=\"$ctrl.endTime\" ng-change=\"$ctrl.setTime($ctrl.endTime, \'end\')\" name=\"endTime\" ng-disabled=\"!$ctrl.appointmentLength || !$ctrl.startTime || $ctrl.isLimitedEdit\" required>\n                                <md-option ng-if=\"!$last\" ng-repeat=\"el in $ctrl.eventTimesEnd\" value=\"{{el}}\">{{el}}</md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                    <div flex-gt-sm=\"20\">\n                        <md-checkbox class=\"dbl-label\" ng-model=\"$ctrl.event.doubleBooked\" ng-disabled=\"$ctrl.isLimitedEdit\">\n                            Double-booking\n                        </md-checkbox>\n                    </div>\n                </div>\n            </div>\n            <div layout=\"row\" class=\"timeslot-container\">\n                <div class=\"validation-messages\" ng-if=\"$ctrl.validateRequiredTime() && createActionPlanLocationForm.endTime.$touched\">\n                    <div>Both Start and End are Required Fields.</div>\n                </div>\n\n            </div>\n\n            <p>Add Breaks (<i>Optional</i>)</p>\n            <div class=\"excluded-timeslot-container\" ng-repeat=\"i in $ctrl.event.excludedTimeSlots\" layout-gt-sm=\"row\">\n                <div>\n                    <div layout-gt-sm=\"row\" layout=\"row\">\n                        <div flex-gt-sm=\"20\">\n                            <md-input-container>\n                                <label>Start Time</label>\n                                <input readonly=\"readonly\" type=\"text\" ng-model=\"i.start\" ng-disabled=\"$ctrl.isLimitedEdit\">\n                            </md-input-container>\n                        </div>\n                        <div flex-gt-sm=\"20\" class=\"exclude-end\">\n                            <md-input-container>\n                                <label>End Time</label>\n                                <input readonly=\"readonly\" type=\"text\" ng-model=\"i.end\" ng-disabled=\"$ctrl.isLimitedEdit\">\n                            </md-input-container>\n                        </div>\n                        <md-icon md-ink-ripple=\"rgba(0,0,0,0.54)\" ng-click=\"$ctrl.removeExcluded($index)\" ng-if=\"!$ctrl.isLimitedEdit\" class=\"clear md-ink-ripple material-icons\">clear</md-icon>\n                    </div>\n                </div>\n            </div>\n            <div layout-gt-sm=\"row\" layout=\"column\" class=\"timeslot-container\">\n                <div flex-gt-sm=\"20\">\n                    <md-input-container>\n                        <label>Start Time</label>\n                        <md-select ng-model=\"$ctrl.excludedStart\" ng-disabled=\"!$ctrl.endTime || $ctrl.isLimitedEdit\" name=\"excludedStart\" class=\"exclude-time\" ng-change=\"$ctrl.setExcludeEndArray($ctrl.excludedStart)\">\n                            <md-option selected=\"selected\" value=\"\"></md-option>\n                            <md-option ng-if=\"!$last\" ng-repeat=\"el in $ctrl.excludeArray\" value=\"{{el}}\">{{el}}</md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n                <div flex-gt-sm=\"20\" class=\"exclude-end\">\n                    <md-input-container>\n                        <label>End Time</label>\n                        <md-select ng-model=\"$ctrl.excludedEnd\" ng-disabled=\"!$ctrl.endTime || !$ctrl.excludedStart || $ctrl.isLimitedEdit\" name=\"excludedEnd\" class=\"exclude-time\">\n                            <md-option ng-repeat=\"el in $ctrl.excludeEndArray\" value=\"{{el}}\">{{el}}</md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n            </div>\n\n            <div layout-gt-sm=\"row\" layout=\"column\">\n                <md-button ng-click=\"$ctrl.setExcluded($ctrl.excludedStart, $ctrl.excludedEnd)\" ng-disabled=\"!$ctrl.excludeArray.length || !$ctrl.excludedEnd || $ctrl.validateUniqueDateTime({start: $ctrl.excludedStart, end: $ctrl.excludedEnd}) || $ctrl.validateOverlappingDateTime({start: $ctrl.excludedStart, end: $ctrl.excludedEnd})\" class=\"btn-add-break md-accent md-raised\">ADD BREAK</md-button>\n            </div>\n\n            <div layout=\"row\">\n                <div class=\"validation-messages\" ng-show=\"$ctrl.validateOverlappingDateTime({start: $ctrl.excludedStart, end: $ctrl.excludedEnd})\">\n                    <div>Excluded Time Slots must not overlap.</div>\n                </div>\n                <div class=\"validation-messages\" ng-show=\"$ctrl.validateUniqueDateTime({start: $ctrl.excludedStart, end: $ctrl.excludedEnd})\">\n                    <div>Excluded Time Slots must be Unique.</div>\n                </div>\n                <div class=\"validation-messages\" ng-show=\"createActionPlanLocationForm.excludedEnd.$error.emptyfield && createActionPlanLocationForm.excludedEnd.$touched\">\n                    <div>Both or no fields required.</div>\n                </div>\n            </div>\n\n            <p>Select Location</p>\n            <div ng-if=\"!$ctrl.loadingLocations && $ctrl.locationsCount > 0\" class=\"location-container\" layout=\"row\" layout-align=\"start center\">\n                <div class=\"slide-arrow\"><a ng-if=\"$ctrl.startIndex > 0\" href=\"\" ng-click=\"$ctrl.slide(\'left\')\"><md-icon>keyboard_arrow_left</md-icon></a></div>\n                <md-radio-group ng-if=\"!$ctrl.loadingLocations && $ctrl.locationsCount > 0\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around center\" ng-model=\"$ctrl.selectedLocation\" flex=\"70\">\n                    <div class=\"location\" ng-repeat=\"location in $ctrl.locationsToDisplay\" flex=\"30\" ng-if=\"location.address1\">\n                        <md-radio-button ng-value=\"location.locationId\" ng-disabled=\"$ctrl.isLimitedEdit\">\n                            <p>{{location.name}}</p>\n                            <p>{{location.address1}}</p>\n                            <p>{{location.address2}}</p>\n                            <p><span ng-if=\"location.city\">{{location.city}},</span> {{location.state}} {{location.zip}}</p>\n                        </md-radio-button>\n                    </div>\n                </md-radio-group>\n                <div class=\"slide-arrow\"><a ng-if=\"$ctrl.lastIndex < $ctrl.locationsCount\" href=\"\" ng-click=\"$ctrl.slide(\'right\')\"><md-icon>keyboard_arrow_right</md-icon></a></div>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <sc-loading-spinner ng-if=\"$ctrl.loadingLocations\" diameter=\"25\"></sc-loading-spinner>\n                <span ng-if=\"!$ctrl.loadingLocations && $ctrl.locationsCount === 0\"><i>No locations found</i></span>\n            </div>\n        </div>\n    </div>\n    <div>\n        <div class=\"button-container\">\n            <md-button ng-click=\"$ctrl.goToPreviousPage()\" class=\"md-primary step-cancel\">CANCEL</md-button>\n            <md-button ng-click=\"$ctrl.back()\" class=\"md-accent md-raised\">BACK</md-button>\n            <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" ng-disabled=\"!createActionPlanLocationForm.$valid\">NEXT</md-button>\n        </div>\n    </div>\n</form>\n");
$templateCache.put("app/components/actionPlans/createEdit/population/apm.actionPlans.createPopulation.html","<form class=\"create-edit-action-plan-container\" name=\"createActionPlanPopulationForm\" ng-cloak>\n    <apm-action-plan-header class=\"Apm-action-plan-header\" title=\"$ctrl.apmActionPlanService.getActionPlanTitle()\"></apm-action-plan-header>\n    <div layout=\"row\" class=\"select-container\">\n        <div layout-margin layout-padding>\n            <h4 ng-if=\"$ctrl.templateData.length > 1\">Template</h4>\n            <span ng-if=\"$ctrl.lockTemplate\"><strong>{{$ctrl.actionPlan.template}}</strong> (Template type cannot be edited.)</span>\n            <md-input-container md-no-float ng-if=\"!$ctrl.lockTemplate\">\n                <p>Select the Template.<span ng-if=\"$ctrl.templateData.length > 1\">*</span></p>\n                <p ng-if=\"$ctrl.templateData.length === 1\">{{$ctrl.templateData[0].name}}</p>\n                <md-select ng-if=\"$ctrl.templateData.length > 1\" ng-disabled=\"$ctrl.isLimitedEdit\" placeholder=\"Template\" class=\"criteria-select\" ng-model=\"$ctrl.actionPlan.template\" ng-change=\"$ctrl._getCriteriaData(); $ctrl.templateConfig.template = $ctrl.actionPlan.template\" name=\"template\" required>\n                    <md-option class=\"status-select-option\" ng-value=\"template.type\" ng-repeat=\"template in $ctrl.templateData\">{{ template.name }}</md-option>\n                </md-select>\n            </md-input-container>\n        </div>\n    </div>\n    <div layout=\"row\" class=\"select-container\">\n        <div layout-margin layout-padding>\n            <h4>Population</h4>\n            <md-input-container md-no-float>\n                <p>Select the Criteria. *</p>\n                <md-select ng-disabled=\"$ctrl.isLimitedEdit || !$ctrl.actionPlan.template\" placeholder=\"Criteria\" class=\"criteria-select\" ng-model=\"$ctrl.actionPlan.population.criteria\" name=\"criteria\" required>\n                    <md-option class=\"status-select-option\" ng-value=\"criteria.criteriaName\" ng-repeat=\"criteria in $ctrl.criteriaData track by $index\">{{ criteria.criteriaDisplay }}</md-option>\n                </md-select>\n            </md-input-container>\n        </div>\n    </div>\n    <div class=\"provider-label\">Select the Provider(s). *</div>\n    <div class=\"provider-description\" layout=\"row\" layout-padding layout-margin>\n        <span>Select a Provider or narrow down the provider list by first selecting a Group.</span>\n    </div>\n    <div layout=\"row\" layout-sm=\"column\">\n        <div layout-margin layout-padding flex=\"33\">\n            <div class=\"population-input\" md-no-float>\n                <md-autocomplete class=\"md-autocomplete\" md-floating-label=\"Select Group\" md-items=\"item in $ctrl.getGroupMatches($ctrl.searchGroupText)\" md-selected-item=\"$ctrl.populationItem\" md-selected-item-change=\"$ctrl.setGroupName($ctrl.populationItem)\" md-search-text=\"$ctrl.searchGroupText\" md-search-text-change=\"$ctrl.getGroupMatches($ctrl.searchGroupText)\" enter-press=\"$ctrl.setGroupName($ctrl.populationItem)\" md-item-text=\"item.name\" md-min-length=\"0\" ng-disabled=\"$ctrl.isLimitedEdit\" md-no-cache=\"true\">\n                    <md-item-template>\n                        <span md-highlight-text=\"$ctrl.searchGroupText\" md-highlight-flags=\"^i\">{{item.name}}</span>\n                    </md-item-template>\n                </md-autocomplete>\n            </div>\n        </div>\n        <div layout-margin layout-padding flex=\"33\">\n            <div class=\"population-input\" md-no-float>\n                <md-autocomplete class=\"md-autocomplete\" md-floating-label=\"{{$ctrl.providersPlaceHolder}}\" md-items=\"item in $ctrl.getProviderMatches($ctrl.searchProviderText)\" md-selected-item=\"$ctrl.providerItem\" md-selected-item-change=\"$ctrl.setProviderName($ctrl.providerItem)\" md-search-text=\"$ctrl.searchProviderText\" md-search-text-change=\"$ctrl.getProviderMatches($ctrl.searchProviderText)\" enter-press=\"$ctrl.setProviderName($ctrl.providerItem)\" md-item-text=\"item.name\" ng-blur=\"$ctrl.setProviderName($ctrl.providerItem)\" md-min-length=\"0\" ng-disabled=\"$ctrl.isLimitedEdit\" md-no-cache=\"true\">\n                    <md-item-template>\n                        <span md-highlight-text=\"$ctrl.searchProviderText\" md-highlight-flags=\"^i\">{{item.name}}</span>\n                    </md-item-template>\n                </md-autocomplete>\n            </div>\n        </div>\n        <div layout=\"column\" layout-margin layout-padding flex=\"auto\">\n            <md-chips ng-model=\"$ctrl.actionPlan.population.groupCharacteristic\" class=\"population-chip-container\" layout=\"column\" name=\"provider\" flex=\"auto\" md-on-remove=\"$ctrl.onRemoveChip($chip)\" readonly=\"true\" md-removable=\"!$ctrl.isLimitedEdit\">\n                <md-chip-template>{{$chip.name}}</md-chip-template>\n            </md-chips>\n        </div>\n    </div>\n    <div class=\"provider-label\">Primary Sort.</div>\n    <div class=\"provider-description\" layout=\"row\" layout-padding layout-margin>\n        <span>Set prioritization preferences for the patient list in the Action Plan. This ensures the Action Plan team prioritizes patients in the correct order.</span>\n    </div>\n    <div layout=\"row\">\n        <div layout-margin layout-padding>\n            <md-select ng-disabled=\"$ctrl.isLimitedEdit\" class=\"sort-order-select\" name=\"appointmentSort\" ng-model=\"$ctrl.actionPlan.sortBy\" required aria-label=\"appointment sort\" placeholder=\"Sort Order\">\n                <md-option value=\"LAST_VISIT\">Last Office Visit</md-option>\n                <md-option value=\"MOST_GAPS\">Most Total Gaps</md-option>\n            </md-select>\n        </div>\n    </div>\n\n    <div class=\"button-container\">\n        <md-button ui-sref=\"actionPlans.list\" class=\"md-primary step-cancel\">CANCEL</md-button>\n        <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" ng-disabled=\"!createActionPlanPopulationForm.$valid\">NEXT</md-button>\n    </div>\n\n</form>\n\n");
$templateCache.put("app/components/actionPlans/details/cards/apm.actionPlans.detailsCard.component.html","<md-card md-colors=\"{ background: \'primary\' }\" class=\"actionPlan-details-card\">\n\n    <md-card-content layout=\"row\" flex layout-align=\"space-around center\">\n        <div>\n            <md-icon>{{ $ctrl.icon }}</md-icon>\n        </div>\n        <div layout=\"column\" layout-align=\"center center\" class=\"md-title\">\n            <span>{{ $ctrl.value }}</span>\n            <span>{{ $ctrl.label }}</span>\n        </div>\n    </md-card-content>\n\n</md-card>");
$templateCache.put("app/components/actionPlans/details/grid/apm.details.grid.html","<apm-details-grid-schedule ng-if=\"$ctrl.actionPlan.status === \'SCHEDULING\'\" action-plan=\"$ctrl.actionPlan\" hide-ineligible-patients=\"$ctrl.hideIneligiblePatients\"></apm-details-grid-schedule>\n<apm-details-grid-reminder ng-if=\"$ctrl.actionPlan.status === \'REMINDERS\'\" action-plan=\"$ctrl.actionPlan\" hide-ineligible-patients=\"$ctrl.hideIneligiblePatients\"></apm-details-grid-reminder>\n<apm-details-grid-encounter ng-if=\"$ctrl.actionPlan.status === \'ENCOUNTERS\'\" action-plan=\"$ctrl.actionPlan\" hide-ineligible-patients=\"$ctrl.hideIneligiblePatients\"></apm-details-grid-encounter>\n\n<apm-details-grid-proposed ng-if=\"$ctrl.actionPlan.status === \'PROPOSED\' || $ctrl.actionPlan.status === \'DRAFT\'\" action-plan=\"$ctrl.actionPlan\"></apm-details-grid-proposed>\n<apm-details-grid-cancelled ng-if=\"$ctrl.actionPlan.status === \'CANCELLED\'\" action-plan=\"$ctrl.actionPlan\"></apm-details-grid-cancelled>");
$templateCache.put("app/components/actionPlans/details/header/apm.details.header.calculations.html","<div ng-repeat=\"calculation in $ctrl.calculations\" class=\"box\" md-colors=\"{color: \'primary-700\'}\">\n    <div class=\"container\">\n        <div class=\"content\" layout=\"column\" layout-align=\"center center\">\n            <canvas ng-if=\"calculation.type === $ctrl.calculationTypes.PERCENTAGE\" id=\"doughnut\" class=\"chart-header chart chart-doughnut\" chart-data=\"$ctrl.getChartData(calculation.id)\" chart-options=\"$ctrl.chartOptions\"></canvas>\n            <div ng-if=\"calculation.type === $ctrl.calculationTypes.PERCENTAGE\" class=\"chart-value\">{{ ::calculation.value }}%</div>\n            <div ng-if=\"calculation.type === $ctrl.calculationTypes.COUNT\" class=\"chart-value\">{{ ::calculation.value }}</div>\n        </div>\n        <div class=\"footer\">{{ ::calculation.label }}</div>\n    </div>\n</div>");
$templateCache.put("app/components/actionPlans/details/header/apm.details.header.component.html","<md-card class=\"header-wrapper\" ng-if=\"$ctrl.actionPlanContext.actionPlanStatus != \'COMPLETED\'\">\n    <div class=\"action-plan-header-container\" layout=\"row\" layout-padding>\n        <div class=\"action-plan-header-data\" flex-gt-sm=\"{{($ctrl.actionPlanContext.actionPlanStatus === \'DRAFT\') ? \'60\' : \'40\'}}\" flex=\"{{($ctrl.actionPlanContext.actionPlanStatus === \'DRAFT\') ? \'60\' : \'50\'}}\">\n            <div class=\"action-plan-title md-title\" md-colors=\"{color: \'primary-700\'}\">\n                <a href=\"\" ng-click=\"$ctrl.openDetailsModal()\">{{$ctrl.actionPlan.title}}</a>\n                <md-icon class=\"ng-hide no-select\" ng-show=\"$ctrl.isStatusEditable() && $ctrl.hasEditAccess\" ng-click=\"$ctrl.goToEdit($ctrl.actionPlan._id)\">edit</md-icon>\n                <span hide show-gt-md ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'ON_HOLD\'\">THIS ACTION PLAN IS ON HOLD</span>\n            </div>\n            <div class=\"action-event-date-container\" md-colors=\"{color: \'primary-700\'}\">\n                <div layout=\"row\" layout-align=\"start center\" class=\"event-date\">\n                    <label>Event Date:&nbsp;</label><span>{{$ctrl.actionPlan.dates.eventDate}}</span>\n                </div>\n                <div layout=\"row\" layout-align=\"start center\">\n                    <label>Owner:&nbsp;</label> <apm-details-header-owner-modal-button action-plan=\"$ctrl.actionPlan\"></apm-details-header-owner-modal-button>\n                </div>\n                <div layout=\"row\" layout-align=\"start center\">\n                    <label>Assignee:&nbsp;</label> <apm-details-header-assignee-modal-button action-plan=\"$ctrl.actionPlan\"></apm-details-header-assignee-modal-button>\n                </div>\n                <div layout=\"row\" layout-align=\"start center\" class=\"action-plan-status\">\n                    <label>Status:&nbsp;</label>\n                    <div class=\"header-icon\">\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'CANCELLED\'\">\n                            <img class=\"md-icon\" src=\"assets/svg/actionplan.header.cancelled.svg\">\n                            <label>Cancelled:&nbsp;</label><span>Action Plan has been cancelled.</span>\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'DRAFT\'\">\n                            <md-icon>drafts</md-icon>\n                            <label>Draft:&nbsp;</label>Once all of the required information is entered for the Action Plan, it can be submitted for approval.\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'PENDING\'\">\n                            <md-icon>access_time</md-icon>\n                            <label>Pending:&nbsp;</label><span>Once Approved the Action Plan properties cannot be modified.</span>\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'ON_HOLD\'\">\n                            <md-icon>pan_tool</md-icon>\n                            <label>On Hold:&nbsp;</label><span>Once Approved the action plan can proceed.</span>\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'APPROVED\'\">\n                            <md-icon>thumb_up</md-icon>\n                            <label>Approved:&nbsp;</label><span>Action Plan has been approved.</span>\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'SCHEDULING\'\">\n                            <md-icon>event_available</md-icon>\n                            <label>Scheduling:&nbsp;</label><span>Action Plan is in Scheduling.</span>\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'REMINDERS\'\">\n                            <md-icon>call</md-icon>\n                            <label>Reminders:&nbsp;</label><span>Action Plan is in the reminders state.</span>\n                        </p>\n                        <p ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'ENCOUNTERS\'\">\n                            <img class=\"md-icon\" src=\"assets/svg/actionplan.header.encounters.svg\">\n                            <label>Encounters:&nbsp;</label>Action Plan is ready for encounters.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <apm-details-header-calculations hide show-gt-md flex=\"30\" ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'SCHEDULING\' || $ctrl.actionPlanContext.actionPlanStatus ===\'REMINDERS\' || $ctrl.actionPlanContext.actionPlanStatus === \'ENCOUNTERS\'\" layout-align=\"start center\" ng-if=\"$ctrl.actionPlan.headerCalculations.length\" layout=\"row\" header-calculations=\"$ctrl.actionPlan.headerCalculations\" layout-align=\"center start\"></apm-details-header-calculations>\n\n        <apm-details-header-active-plans class=\"action-plan-header-buttons\" flex layout=\"row\" layout-align=\"end start\" ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'SCHEDULING\' || $ctrl.actionPlanContext.actionPlanStatus === \'REMINDERS\' || $ctrl.actionPlanContext.actionPlanStatus === \'ENCOUNTERS\'\" action-plan=\"$ctrl.actionPlan\" action-plan-context=\"$ctrl.actionPlanContext\"></apm-details-header-active-plans>\n\n        <apm-details-header-proposed class=\"action-plan-header-buttons\" flex layout-align=\"end start\" layout=\"row\" ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'APPROVED\' || $ctrl.actionPlanContext.actionPlanStatus === \'PENDING\' || $ctrl.actionPlanContext.actionPlanStatus === \'ON_HOLD\' || $ctrl.actionPlanContext.actionPlanStatus === \'DRAFT\'\" action-plan=\"$ctrl.actionPlan\" action-plan-context=\"$ctrl.actionPlanContext\"></apm-details-header-proposed>\n\n    </div>\n</md-card>\n\n\n<action-plan-report ng-if=\"$ctrl.actionPlanContext.actionPlanStatus === \'COMPLETED\'\"></action-plan-report>\n");
$templateCache.put("app/components/actionPlans/details/modal/apm.actionPlans.detailsModal.component.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>{{ $ctrl.actionPlan.title }}</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content class=\"action-plan-dialog-content\">\n    <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\">\n\n        <md-tab label=\"general\">\n            <md-content layout=\"column\" layout-margin>\n                <div layout=\"row\">\n                    <span layout=\"column\" flex class=\"status\">\n                        <p>Status: <span class=\"captitalize\">{{ ::$ctrl.actionPlan.statusToDisplay }}</span></p>\n                        <p>Criteria: {{ $ctrl.actionPlan.population.display || \'N/A\' }}</p>\n                    </span>\n                    <div layout=\"column\">\n                        <p>Created By: {{ $ctrl.actionPlan.author || \'N/A\' }}</p>\n                    </div>\n                </div>\n                <div layout=\"column\" class=\"info-container\">\n                    <p>Template: {{ $ctrl.actionPlan.template || \'N/A\' }}</p>\n                    <p>Event Type: {{ $ctrl.actionPlan.actionPlanEventType.display || \'N/A\' }}</p>\n                    <p>Population: {{ $ctrl.population || \'N/A\' }}</p>\n                </div>\n            </md-content>\n        </md-tab>\n\n        <md-tab label=\"appointments\">\n            <md-content layout=\"column\" layout-margin>\n                <div layout=\"column\">\n                    <p>Scheduling Completed: N/A</p>\n                    <p>Instructions: {{ $ctrl.actionPlan.actionPlanComments[0].comment || \'N/A\' }}</p>\n                    <p>Primary Sort: {{ $ctrl.thisActionPlanSortBy || \'N/A\' }}</p>\n                    <p>Available Appointments: {{ $ctrl.availableAppointments || \'N/A\' }}</p>\n                    <p>Excluded Timeslots: {{ $ctrl.excludedTimeSlots || \'N/A\'}}</p>\n                </div>\n            </md-content>\n        </md-tab>\n\n        <md-tab label=\"reminders\" ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\">\n            <md-content layout=\"column\" layout-margin>\n                <div layout=\"column\">\n                    <p>Reminders Completed: N/A</p>\n                    <p>Instructions: {{ $ctrl.actionPlan.actionPlanComments[1].comment || \'N/A\' }}</p>\n                </div>\n            </md-content>\n        </md-tab>\n\n        <md-tab label=\"event\" ng-if=\"$ctrl.actionPlan.template !== \'SCH\'\">\n            <md-content layout=\"column\" layout-margin>\n                <div layout=\"column\">\n                    <p>Event Date: {{ $ctrl.actionPlan.eventDates[0] ? ($ctrl.actionPlan.eventDates[0] | reverseDateFormatFilter) : \'N/A\' }}</p>\n                    <p>Event Staff: {{ $ctrl.eventStaff || \'N/A\' }}</p>\n                    <p>Instructions: {{ $ctrl.actionPlan.actionPlanComments[2].comment || \'N/A\' }}</p>\n                </div>\n            </md-content>\n        </md-tab>\n\n    </md-tabs>\n    <div layout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.showEditActionPlanButton\" access-control=\"scAPAdmin\" access-type=\"PERMISSION\">\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.setEdit($ctrl.actionPlan._id); $ctrl.onEdit()\" ui-sref=\"actionPlans.createEdit\">Edit Action Plan</md-button>\n    </div>\n</md-dialog-content>\n");
$templateCache.put("app/components/patients/activity/modal/apm.patients.activity.gap.measuresModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2 flex=\"90\">{{ $ctrl.gap.measures.title }}</h2>\n        <md-button flex=\"10\" class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content layout=\"column\" layout-padding class=\"action-plan-dialog-content md-dialog-content\">\n    <div layout=\"row\">\n        <span>Patient {{ $ctrl.gap.measures.type }} Measure </span>\n        <div ng-if=\"$ctrl.gap.measures.rateAggregation\">\n            <span>&nbsp;- Weight: {{$ctrl.gap.measures.rateAggregation}} {{$ctrl.gap.measures.rateAggregation > 1 ? \'pts\' : \'pt\'}}</span>\n        </div>\n    </div>\n\n    <div layout=\"column\">\n        <span>Metric</span>\n        <div ng-if=\"$ctrl.gap.measures.guidance\">{{$ctrl.gap.measures.guidance}}</div>\n        <div ng-if=\"$ctrl.gap.measures.description\">{{$ctrl.gap.measures.description}}</div>\n    </div>\n    <div ng-if=\"$ctrl.gap.measures && $ctrl.gap.measures.definition\" layout=\"column\">\n        <span>WellMed Quality Metrics</span>\n        <div>\n            <ul>\n                <li ng-repeat=\"rating in $ctrl.gap.measures.definition\">\n                    Level {{rating.level}}: {{rating.Value}}%\n                </li>\n            </ul>\n        </div>\n    </div>\n</md-dialog-content>\n\n\n");
$templateCache.put("app/components/patients/activity/modal/apm.patients.activity.gapDetails.button.html","<md-icon ng-click=\"$ctrl.showDetailsModal()\">info</md-icon>");
$templateCache.put("app/components/reports/actionPlans/grid/apm.reports.actionPlans.grid.component.html","<div layout=\"row\" layout-align=\"center center\">\n    <span flex class=\"md-title\">Patient List</span>\n    <md-button class=\"md-accent\" ng-click=\"$ctrl.downloadCSV()\">Export to CSV</md-button>\n</div>\n<md-card layout-margin class=\"patients-grid\">\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.pageSizes}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading patients.\" mdt-row-paginator-no-results-message=\"No patients for this action plan.\" mdt-row=\"{\n                    \'table-row-id-key\': \'patientId\',\n                    \'column-keys\': [\n                        \'patientName\',\n                        \'patientDateOfBirth\',\n                        \'gapsTotal\',\n                        \'gapsSDO\',\n                        \'gapsRefused\',\n                        \'gapsNotDone\',\n                        \'gapsTested\',\n                        \'gapsPending\'\n                    ]\n                }\">\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\">DOB</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Total</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">SDO</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Refused</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Not Done</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Tested</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Pending</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"patientName\">\n            <a ui-sref=\"patients.profile({ patientId: rowId })\">{{ value }}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"patientDateOfBirth\">\n            <div>{{ value | date: \'MM/dd/yyyy\' }}</div>\n        </mdt-custom-cell>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/reports/actionPlans/header/apm.reports.actionPlans.header.component.html","<md-card class=\"header-wrapper\">\n    <div class=\"action-plan-header-container\" layout=\"row\" layout-padding>\n        <div class=\"action-plan-header-data\" flex=\"40\">\n            <div class=\"action-plan-title md-title\" md-colors=\"{color: \'primary-700\'}\">\n                <a href=\"\" ng-click=\"$ctrl.openDetailsModal()\">{{$ctrl.headerData.actionPlanTitle}}</a>\n            </div>\n            <div class=\"action-event-date-container\" md-colors=\"{color: \'primary-700\'}\">\n                <div layout=\"row\" layout-align=\"start center\">\n                    <label>Event Date:&nbsp;</label> <span ng-repeat=\"eventDate in $ctrl.headerData.eventDates\">{{ eventDate | date: \'MM/dd/yyyy\' }}<span ng-if=\"!$last\">, </span></span>\n                </div>\n                <div layout=\"row\" layout-align=\"start center\">\n                    <label>Owner:&nbsp;</label> <apm-details-header-owner-modal-button action-plan=\"$ctrl.actionPlan\"></apm-details-header-owner-modal-button>\n                </div>\n                <div layout=\"row\" layout-align=\"start center\">\n                    <label>Assignee:&nbsp;</label> <apm-details-header-assignee-modal-button action-plan=\"$ctrl.actionPlan\"></apm-details-header-assignee-modal-button>\n                </div>\n                <div layout=\"row\" layout-align=\"start center\" class=\"status\">\n                    <label>Status:&nbsp;</label>\n                    <div class=\"header-icon\">\n                        <md-icon>check</md-icon>\n                        <label>Completed: </label><span>Action Plan has been completed.</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <apm-details-header-calculations flex ng-if=\"$ctrl.headerCalculations.length > 0\" layout=\"row\" header-calculations=\"$ctrl.headerCalculations\"></apm-details-header-calculations>\n    </div>\n</md-card>\n");
$templateCache.put("app/components/reports/pendingGaps/modal/apm.reports.pendingGaps.reopenModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>{{ $ctrl.measureReport.measureName }}</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content layout-padding>\n    <div class=\"error-message\">\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n    </div>\n    <div layout=\"column\" flex=\"auto\" layout-align=\"center center\" class=\"confirm-message\">\n        <span>Are you sure you want to re-open this gap?</span>\n    </div>\n    <div layout=\"column\" class=\"gap-info\">\n        <div ng-if=\"$ctrl.measureGap.occurrenceDate.displayValue\" layout=\"row\" flex=\"auto\" layout-align=\"start center\">\n            <md-icon>date_range</md-icon>\n            <span>Follow-up Date:</span>\n            <span flex>{{ $ctrl.measureGap.occurrenceDate.displayValue }}</span>\n        </div>\n        <div layout=\"row\" flex=\"auto\" layout-align=\"start center\">\n            <md-icon>assignment</md-icon>\n            <span>Action Plan:</span>\n            <span flex>\n                <a ui-sref=\"actionPlans.details({ id: $ctrl.measureReport.actionPlanId })\">\n                    {{ $ctrl.measureReport.actionPlanTitle }}\n                </a>\n            </span>\n        </div>\n    </div>\n    <md-dialog-actions>\n        <md-button ng-click=\"$ctrl.close()\" class=\"md-primary\" aria-label=\"button\">CANCEL</md-button>\n        <md-button ng-click=\"$ctrl.save()\" ng-disabled=\"$ctrl.isSaving\" class=\"md-accent md-raised\" aria-label=\"button\">\n            <span ng-if=\"!$ctrl.isSaving\">SAVE</span>\n            <sc-loading-spinner ng-if=\"$ctrl.isSaving\" diameter=\"25\"></sc-loading-spinner>\n        </md-button>\n    </md-dialog-actions>\n</md-dialog-content>");
$templateCache.put("app/components/resources/details/modals/apm.resources.addEditLeaveModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>{{ $ctrl.newEvent._id ? \'Edit\' : \'Add\' }} Leave</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content class=\"dialog-content\">\n    <form name=\"$ctrl.addEventForm\" layout=\"column\" layout-margin layout-padding>\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n        <div layout=\"row\" layout-align=\"space-between center\">\n            <md-input-container class=\"date-picker-container md-block\" flex=\"45\">\n                <label>Start Date</label>\n                <md-datepicker name=\"startDate\" ng-model=\"$ctrl.newEvent.startDate\" ng-change=\"$ctrl.onStartDateChange()\" md-min-date=\"$ctrl.minStartDate\" required>\n                </md-datepicker>\n            </md-input-container>\n\n            <md-input-container class=\"date-picker-container md-block\" flex=\"50\">\n                <label>End Date</label>\n                <md-datepicker name=\"endDate\" ng-model=\"$ctrl.newEvent.endDate\" md-min-date=\"$ctrl.minEndDate\" ng-change=\"$ctrl.onEndDateChange()\" required>\n                </md-datepicker>\n            </md-input-container>\n        </div>\n        <div layout=\"row\">\n            <md-input-container class=\"md-block\" layout-fill>\n                <label>Leave Type</label>\n                <md-select name=\"type\" class=\"status-select\" ng-model=\"$ctrl.newEvent.type\" ng-change=\"$ctrl.onLeaveTypeChange()\" required>\n                      <md-option value=\"\"></md-option>\n                      <md-option ng-repeat=\"type in $ctrl.eventTypes\" ng-value=\"type.code\">{{ type.display }}</md-option>\n                </md-select>\n            </md-input-container>\n        </div>\n    </form>\n</md-dialog-content>\n\n<md-dialog-actions class=\"dialog-actions\">\n    <md-button class=\"md-raised md-accent save-button\" aria-label=\"Save Event\" ng-click=\"$ctrl.saveEvent()\" ng-disabled=\"!$ctrl.addEventForm.$valid || $ctrl.saveClicked\">\n        <span ng-if=\"!$ctrl.saveClicked\">Save</span>\n        <sc-loading-spinner ng-if=\"$ctrl.saveClicked\" diameter=\"25\" class=\"add-edit-leave-modal-dialog\"></sc-loading-spinner>\n    </md-button>\n</md-dialog-actions>\n");
$templateCache.put("app/components/resources/details/modals/apm.resources.deleteLeaveModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Delete Leave</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content layout-padding layout-margin>\n    <span>Would you like to delete this leave event?</span>\n</md-dialog-content>\n\n<md-dialog-actions class=\"dialog-actions\">\n    <md-button class=\"md-primary\" ng-click=\"$ctrl.cancel()\">CANCEL</md-button>\n    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.confirm()\">Ok</md-button>\n</md-dialog-actions>\n");
$templateCache.put("app/components/resources/locations/grid/apm.resources.locations.bucket.component.html","<md-card layout-padding layout-margin layout=\"column\">\n\n    <h4>Merge Locations</h4>\n    <p class=\"apm-resources-locations-bucket__description\" ng-show=\"!!$ctrl.addressesObj.addresses.length\">Select the correct address from the list below:</p>\n    <md-radio-group ng-model=\"$ctrl.radioModel\" ng-show=\"!!$ctrl.addressesObj.addresses.length\">\n        <div ng-repeat=\"location in $ctrl.addressesObj.addresses\">\n            <apm-resources-locations-bucket-item class=\"Apm-resources-location-bucket-item\" item=\"location\" remove-fn=\"$ctrl.onClickRemoveAddress(resource)\"></apm-resources-locations-bucket-item>\n            <md-divider></md-divider>\n        </div>\n    </md-radio-group>\n    <div ng-show=\"!$ctrl.addressesObj.addresses.length\" layout-padding layout-margin layout=\"row\" layout-align=\"start center\">\n        <md-subheader class=\"md-primary\">Please select addresses from the grid to merge.</md-subheader>\n    </div>\n    <div class=\"button-container\" ng-show=\"!!$ctrl.addressesObj.addresses.length\" layout=\"row\" layout-align=\"end center\">\n        <md-button ng-disabled=\"$ctrl.saveClicked\" ng-click=\"$ctrl.cancel()\" class=\"md-primary\">CANCEL</md-button>\n        <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" aria-label=\"button\" ng-disabled=\"$ctrl.radioModel == null || $ctrl.addressesObj.addresses.length < 2 || $ctrl.saveClicked\">\n            <span ng-if=\"!$ctrl.saveClicked\">Save</span>\n        </md-button>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/components/resources/locations/grid/apm.resources.locations.bucket.item.component.html","<div layout=\"row\" layout-align=\"start center\" layout-padding>\n    <div class=\"address-container\" flex=\"100\">\n        <p>{{ $ctrl.item.address1 }}</p>\n        <p ng-if=\"$ctrl.item.address2\">{{ $ctrl.item.address2 }}</p>\n        <p>{{ $ctrl.item.city }} {{ $ctrl.item.state }}, {{ $ctrl.item.zip }}</p>\n    </div>\n    <div flex=\"initial\">\n        <md-icon class=\"no-select\" title=\"Remove Address\" ng-click=\"$ctrl.onClickRemoveAddress($ctrl.item.locationId)\">delete</md-icon>\n    </div>\n    <div flex-md=\"initial\">\n        <md-radio-button aria-label=\"{{ $ctrl.item.address }}\" value=\"{{ $ctrl.item.locationId }}\"></md-radio-button>\n    </div>\n</div>\n");
$templateCache.put("app/components/resources/locations/grid/apm.resources.locations.grid.component.html","<md-card layout-margin layout=\"column\">\n    <mdt-table paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-trigger-request=\"$ctrl.getLoadResultsCallback(loadPageCallback)\" mdt-row-paginator-error-message=\"Error happened while loading the locations.\" mdt-row=\"{\n                    \'table-row-id-key\': \'locationId\'\n                }\" ng-cloak>\n\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Select</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Address</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">City</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">County</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">State</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Zip Code</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">View</mdt-column>\n        </mdt-header-row>\n\n        <mdt-row ng-repeat=\"location in $ctrl.locationsListPage\">\n            <mdt-cell html-content=\"true\">\n                <md-checkbox class=\"apm-resources-locations-grid__checkbox\" ng-model=\"$ctrl.checkboxObj[location.locationId]\" ng-click=\"$ctrl.onCheckboxClick(location, $ctrl.checkboxObj[location.locationId])\" aria-label=\"location.title\"></md-checkbox>\n            </mdt-cell>\n            <mdt-cell html-content=\"true\">\n                <div class=\"address-cell\">\n                    <p>{{ location.address1 }}</p>\n                    <p ng-if=\"location.address2\">{{ location.address2 }}</p>\n                </div>\n            </mdt-cell>\n            <mdt-cell html-content=\"false\">\n                {{ location.city }}\n            </mdt-cell>\n            <mdt-cell html-content=\"false\">\n                {{ location.county }}\n            </mdt-cell>\n            <mdt-cell html-content=\"false\">\n                {{ location.state }}\n            </mdt-cell>\n            <mdt-cell html-content=\"false\">\n                {{ location.zip }}\n            </mdt-cell>\n            <mdt-cell html-content=\"true\">\n                <md-icon class=\"no-select\" alt=\"View\" ng-click=\"$ctrl.onClickLocationView(location)\" ng-show=\"location.children.length\">view_list</md-icon>\n            </mdt-cell>\n\n        </mdt-row>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/actions/encounter/updateResults/apm.actionPlans.actions.encounter.updateResults.html","<form name=\"updateEncountersForm\">\n    <md-card class=\"apm-update-encounters-container\" layout-padding>\n        <div class=\"measures-header\" layout=\"row\">\n            <div>\n                <md-icon>assignment</md-icon>\n            </div>\n            <div>Measures</div>\n        </div>\n        <div layout=\"row\" class=\"no-show-container\" ng-if=\"$ctrl.hasAppointment\">\n            <md-input-container flex=\"100\">\n                <md-checkbox ng-model=\"$ctrl.encounterPostObj.result\" class=\"appointment-input\" ng-true-value=\"\'noshow\'\" ng-false-value=\"\'visit\'\">\n                    <span>No Show</span>\n                </md-checkbox>\n            </md-input-container>\n        </div>\n        <div class=\"test-container\">\n            <md-tabs md-dynamic-height>\n                <md-tab ng-repeat=\"group in $ctrl.testList\" ng-if=\"group.qualifiedTests && group.qualifiedTests.length\">\n                    <md-tab-label>{{group.name | uppercase}}</md-tab-label>\n                    <md-tab-body>\n                        <div ng-repeat=\"test in group.qualifiedTests\">\n                            <div layout=\"row\">\n                                <ul flex=\"50\">\n                                    <li class=\"test-name\">{{test.testName}}</li>\n                                    <li ng-if=\"test.relatedMeasures && test.relatedMeasures.length\">\n                                        <span class=\"measure-label\">Related Measure(s):</span><span ng-repeat=\"measure in test.relatedMeasures\">{{measure.measureName}}<span ng-if=\"!$last\">,&nbsp;</span></span>\n                                    </li>\n                                </ul>\n                                <div flex=\"50\" layout=\"row\" layout-align=\"end center\" class=\"referrals-follow-up\" ng-if=\"group.name === \'Referrals\'\">\n                                    <md-input-container class=\"date-picker-container\">\n                                        <label>Add Follow-up Appt.</label>\n                                        <md-datepicker name=\"followUpDate\" ng-model=\"$ctrl.followupDate[test.testId]\" ng-change=\"$ctrl.submitFollowUpDate(test)\" enter-press=\"$ctrl.submitFollowUpDate(test)\" md-min-date=\"$ctrl.minStartDate\">\n                                        </md-datepicker>\n                                    </md-input-container>\n                                    <div flex=\"30\"></div>\n                                </div>\n                            </div>\n                            <div layout=\"row\">\n                                <md-input-container flex=\"20\">\n                                    <md-checkbox ng-model=\"$ctrl.performed[test.testId]\" ng-click=\"$ctrl.getCheckboxEvent(test.testId)\">\n                                        <span>Completed</span>\n                                    </md-checkbox>\n                                </md-input-container>\n\n                                <md-input-container flex=\"25\">\n                                    <md-select ng-model=\"$ctrl.refusedSelectModel[test.testId]\" ng-change=\"$ctrl.getSelectedEvent($ctrl.refusedSelectModel[test.testId], \'refused\', test.testId)\" placeholder=\"Refused Reason\" ng-if=\"!$ctrl.performed[test.testId]\">\n                                        <md-option value=\"\"></md-option>\n                                        <md-option ng-repeat=\"el in $ctrl.refusedCodes\" value=\"{{el.code}}\">{{el.display}}</md-option>\n                                    </md-select>\n                                </md-input-container>\n\n                                <md-input-container flex=\"25\">\n                                    <md-select ng-model=\"$ctrl.notdoneSelectModel[test.testId]\" ng-change=\"$ctrl.getSelectedEvent($ctrl.notdoneSelectModel[test.testId], \'notdone\', test.testId)\" placeholder=\"Not Done Reason\" ng-if=\"!$ctrl.performed[test.testId]\">\n                                        <md-option value=\"\"></md-option>\n                                        <md-option ng-repeat=\"el in $ctrl.notdoneCodes\" value=\"{{el.code}}\">{{el.display}}</md-option>\n                                    </md-select>\n                                </md-input-container>\n\n                                <md-input-container flex=\"25\" class=\"other-note\" ng-if=\"$ctrl.showRefusedNote[test.testId]\">\n                                    <label>Note</label>\n                                    <input type=\"text\" ng-model=\"$ctrl.refusedNoteModel[test.testId]\" ng-blur=\"$ctrl.setNote($ctrl.reasonType[test.testId], test.testId)\" name=\"{{test.testName}}-ref\" required>\n                                </md-input-container>\n\n                                <md-input-container flex=\"25\" class=\"other-note\" ng-if=\"$ctrl.showNotdoneNote[test.testId]\">\n                                    <label>Note</label>\n                                    <input type=\"text\" ng-model=\"$ctrl.notdoneNoteModel[test.testId]\" ng-blur=\"$ctrl.setNote($ctrl.reasonType[test.testId], test.testId)\" name=\"{{test.testName}}-ref\" required>\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n            </md-tabs>\n        </div>\n\n        <div ng-if=\"!$ctrl.viewIsReadOnly\">\n            <div class=\"button-container\">\n                <md-button ng-click=\"$ctrl.cancel()\" class=\"md-primary\" ng-disabled=\"$ctrl.saveClicked\">CANCEL</md-button>\n                <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" ng-disabled=\"!updateEncountersForm.$dirty || $ctrl.saveClicked\" aria-label=\"button\">\n                    <span ng-if=\"!$ctrl.saveClicked\">Save</span>\n                    <sc-loading-spinner ng-if=\"$ctrl.saveClicked\" diameter=\"25\"></sc-loading-spinner>\n                </md-button>\n            </div>\n        </div>\n\n    </md-card>\n</form>\n");
$templateCache.put("app/components/actionPlans/actions/reminder/callResult/apm.actionPlans.actions.reminder.callResult.html","<form name=\"callResultActionsForm\" class=\"call-result-actions-container\">\n    <md-card>\n        <md-toolbar class=\"_md _md-toolbar-transitions\" ng-if=\"!$ctrl.isReadOnly\">\n            <div class=\"md-toolbar-tools\">\n                <h2>Phone Call Result</h2>\n            </div>\n        </md-toolbar>\n        <div layout=\"column\" ng-if=\"!$ctrl.isReadOnly\">\n            <div layout=\"row\">\n                <md-card-content class=\"appointment-disposition\">\n                    <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.disposition.$error.required && $ctrl.saveClicked}\">\n                        <md-select placeholder=\"Disposition\" ng-model=\"$ctrl.postObj.callResult.callOutcome\" ng-change=\"$ctrl.setDisposition()\" name=\"disposition\" required>\n                            <md-option ng-repeat=\"el in $ctrl.dispositionArray\" value=\"{{el.code}}\">\n                                {{el.display}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block cancelled-comment\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.dispositionComment.$error && $ctrl.saveClicked && $ctrl.postObj.callResult.callOutcome === \'CANCELLED\'}\" ng-if=\"$ctrl.postObj.callResult.callOutcome === \'CANCELLED\'\">\n                        <label ng-if=\"$ctrl.postObj.callResult.callOutcome === \'CANCELLED\'\">Comment</label>\n                        <input name=\"dispositionComment\" ng-model=\"$ctrl.postObj.callResult.comments\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'CANCELLED\'\" ng-if=\"$ctrl.postObj.callResult.callOutcome === \'CANCELLED\'\">\n                    </md-input-container>\n                </md-card-content>\n            </div>\n            <div layout=\"row\" layout-align=\"space-between start\" ng-if=\"$ctrl.providerLocation.address1\" ng-class=\"{ \'with-location-data\': $ctrl.providerLocation.address1 }\">\n                <md-card-content class=\"appointment-schedule\" layout=\"column\" flex=\"30\">\n                    <div layout=\"row\">\n                        <label><md-icon>date_range</md-icon>&nbsp;Appointment</label>\n                    </div>\n                    <div class=\"appointment-date\" layout=\"row\">\n                        <md-radio-group ng-model=\"$ctrl.postObj.appointment\" name=\"appointmentDate\" layout-margin ng-change=\"$ctrl.setTimeSlotsByDate()\" ng-disabled=\"$ctrl.postObj.callResult.callOutcome !== \'APPOINTMENT_SCHEDULED\'\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.saveClicked\">\n                            <md-radio-button ng-if=\"$ctrl.isPluralDates\" ng-repeat=\"date in $ctrl.eventDates\" value=\"{{date}}\">{{date | date: \'MM/dd/yyyy\'}}</md-radio-button>\n                            <span class=\"single-date\" ng-if=\"!$ctrl.isPluralDates\">{{$ctrl.eventDates[0] | date: \'MM/dd/yyyy\'}}</span>\n                        </md-radio-group>\n                    </div>\n                </md-card-content>\n                <md-card-content class=\"appointment-time-card\" layout=\"column\" flex=\"30\">\n                    <div class=\"appointment-time\" layout=\"row\" layout-align=\"end center\">\n                        <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.slotId.$error.required && $ctrl.saveClicked && $ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.postObj.appointment}\">\n                            <label ng-if=\"!$ctrl.hasAppointment\">Appointment Time</label>\n                            <md-select ng-model=\"$ctrl.postObj.slotId\" name=\"slotId\" ng-if=\"!$ctrl.hasAppointment\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'RESCHEDULED\'\">\n                                <md-option ng-repeat=\"el in $ctrl.eventTimes\" value=\"{{el.value}}\">\n                                    {{el.label}}\n                                </md-option>\n                            </md-select>\n                            <span class=\"scheduled-time\" ng-if=\"$ctrl.hasAppointment\">{{$ctrl.appointmentTime}}</span>\n                        </md-input-container>\n                    </div>\n                </md-card-content>\n                <md-card-content class=\"appointment-location\" layout=\"column\" flex=\"30\">\n                    <div layout=\"row\">\n                        <label><md-icon>map</md-icon></label>\n                        <div layout=\"column\">\n                            <div layout=\"row\" ng-if=\"$ctrl.providerLocation.address1\">\n                                {{$ctrl.providerLocation.address1}}\n                            </div>\n                            <div layout=\"row\" ng-if=\"$ctrl.providerLocation.address2\">\n                                {{$ctrl.providerLocation.address2}}\n                            </div>\n                            <div layout=\"row\" ng-if=\"$ctrl.providerLocation.city && $ctrl.providerLocation.state\">\n                                {{$ctrl.providerLocation.city}}, {{$ctrl.providerLocation.state}}\n                                <span ng-if=\"$ctrl.providerLocation.zip || $ctrl.providerLocation.county\"> {{$ctrl.providerLocation.zip || \', \' + $ctrl.providerLocation.county}}</span>\n                            </div>\n                            <div layout=\"row\" ng-if=\"!$ctrl.providerLocation.address1 &&\n                                                        !$ctrl.providerLocation.city &&\n                                                        !$ctrl.providerLocation.state\">\n                                No location data available.\n                            </div>\n                        </div>\n                    </div>\n                </md-card-content>\n            </div>\n            <div layout=\"row\" ng-if=\"!$ctrl.providerLocation.address1\">\n                <md-card-content class=\"appointment-schedule\" layout=\"row\">\n                    <div layout=\"row\">\n                        <label><md-icon>date_range</md-icon>&nbsp;Appointment</label>\n                    </div>\n                    <div class=\"appointment-date\" layout=\"row\">\n                        <md-radio-group ng-model=\"$ctrl.postObj.appointment\" name=\"appointmentDate\" layout-margin ng-change=\"$ctrl.setTimeSlotsByDate()\" ng-disabled=\"$ctrl.postObj.callResult.callOutcome !== \'APPOINTMENT_SCHEDULED\'\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.saveClicked\">\n                            <md-radio-button ng-if=\"$ctrl.isPluralDates\" ng-repeat=\"date in $ctrl.eventDates\" value=\"{{date}}\">{{date | date: \'MM/dd/yyyy\'}}</md-radio-button>\n                            <span class=\"single-date\" ng-if=\"!$ctrl.isPluralDates\">{{$ctrl.eventDates[0] | date: \'MM/dd/yyyy\'}}</span>\n                        </md-radio-group>\n                    </div>\n                    <div class=\"appointment-time\" ng-class=\"{\'has-appointment\': $ctrl.hasAppointment}\" layout=\"row\" layout-align=\"end center\">\n                        <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.slotId.$error.required && $ctrl.saveClicked && $ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.postObj.appointment}\">\n                            <label ng-if=\"!$ctrl.hasAppointment\">Appointment Time</label>\n                            <md-select ng-model=\"$ctrl.postObj.slotId\" name=\"slotId\" ng-if=\"!$ctrl.hasAppointment\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'RESCHEDULED\'\">\n                                <md-option ng-repeat=\"el in $ctrl.eventTimes\" value=\"{{el.value}}\">\n                                    {{el.label}}\n                                </md-option>\n                            </md-select>\n                            <span class=\"scheduled-time\" ng-if=\"$ctrl.hasAppointment\">{{$ctrl.appointmentTime}}</span>\n                        </md-input-container>\n                    </div>\n                </md-card-content>\n            </div>\n            <div layout=\"row\">\n                <md-card-content class=\"appointment-instructions\">\n                    <md-input-container class=\"md-block\">\n                        <label>Special Handling Instructions</label>\n                        <input ng-model=\"$ctrl.postObj.appointmentComment\" name=\"appointmentComment\" ng-disabled=\"$ctrl.postObj.callResult.callOutcome !== \'APPOINTMENT_SCHEDULED\' && $ctrl.postObj.callResult.callOutcome !== \'RESCHEDULED\'\">\n                    </md-input-container>\n                </md-card-content>\n            </div>\n        </div>\n        <div ng-if=\"!$ctrl.isReadOnly\">\n            <div class=\"button-container\">\n                <md-button ng-disabled=\"$ctrl.saveClicked\" ng-click=\"$ctrl.cancel()\" class=\"md-primary\">CANCEL</md-button>\n                <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" aria-label=\"button\" ng-disabled=\"!callResultActionsForm.$valid || $ctrl.saveClicked\">\n                    <span ng-if=\"!$ctrl.saveClicked\">Save</span>\n                    <sc-loading-spinner ng-if=\"$ctrl.saveClicked\" diameter=\"25\"></sc-loading-spinner>\n                </md-button>\n            </div>\n        </div>\n\n        <md-card-content ng-if=\"$ctrl.isReadOnly\">\n            <div class=\"appointment-header\" layout=\"row\">\n                <div><md-icon>date_range</md-icon></div>\n                <div>Appointment</div>\n            </div>\n            <div layout=\"row\">\n                <div class=\"centered-content text\">\n                    <span ng-if=\"$ctrl.hasAppointment\">{{$ctrl.appointmentDateTimeDisplay}}</span>\n                    <span ng-if=\"!$ctrl.hasAppointment\">No Appointment Scheduled</span>\n                </div>\n            </div>\n            <md-input-container class=\"md-block\">\n                <label class=\"read-only\">Special Handling Instructions</label>\n                <p class=\"appointment-comment\">{{$ctrl.postObj.appointmentComment || \'No Instructions\'}}</p>\n            </md-input-container>\n        </md-card-content>\n\n    </md-card>\n</form>\n");
$templateCache.put("app/components/actionPlans/actions/schedule/callResult/apm.actionPlans.actions.schedule.callResult.html","<form name=\"callResultActionsForm\" class=\"call-result-actions-container\">\n    <md-card>\n        <md-toolbar class=\"_md _md-toolbar-transitions\" ng-if=\"!$ctrl.isReadOnly\">\n            <div class=\"md-toolbar-tools\">\n                <h2>Phone Call Result</h2>\n            </div>\n        </md-toolbar>\n        <div layout=\"column\">\n            <div layout=\"row\">\n                <md-card-content class=\"appointment-disposition\" ng-if=\"!$ctrl.isReadOnly\">\n                    <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.disposition.$error.required && $ctrl.saveClicked}\">\n                        <md-select placeholder=\"Disposition\" ng-model=\"$ctrl.postObj.callResult.callOutcome\" ng-change=\"$ctrl.updateAppointment()\" name=\"disposition\" required>\n                            <md-option ng-repeat=\"el in $ctrl.dispositionArray\" value=\"{{el.code}}\">\n                                {{el.display}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.dispositionComment.$error && $ctrl.saveClicked && $ctrl.postObj.callResult.callOutcome === \'REFUSED_OTHER\'}\" ng-if=\"$ctrl.postObj.callResult.callOutcome === \'REFUSED_OTHER\'\">\n                        <label ng-if=\"$ctrl.postObj.callResult.callOutcome === \'REFUSED_OTHER\'\">Comment</label>\n                        <input name=\"dispositionComment\" ng-model=\"$ctrl.postObj.callResult.comments\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'REFUSED_OTHER\'\" ng-if=\"$ctrl.postObj.callResult.callOutcome === \'REFUSED_OTHER\'\">\n                    </md-input-container>\n                </md-card-content>\n            </div>\n            <div layout=\"row\" layout-align=\"space-between start\" ng-if=\"$ctrl.providerLocation.address1\" ng-class=\"{ \'with-location-data\': $ctrl.providerLocation.address1 }\">\n                <md-card-content class=\"appointment-schedule\" layout=\"column\" flex=\"30\">\n                    <div layout=\"row\">\n                        <label><md-icon>date_range</md-icon>&nbsp;Appointment</label>\n                    </div>\n                    <div class=\"appointment-date\" layout=\"row\">\n                        <md-radio-group ng-model=\"$ctrl.postObj.appointment\" name=\"appointmentDate\" layout-margin ng-change=\"$ctrl.setTimeSlotsByDate()\" ng-disabled=\"$ctrl.postObj.callResult.callOutcome !== \'APPOINTMENT_SCHEDULED\'\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.saveClicked\">\n                            <md-radio-button ng-if=\"$ctrl.isPluralDates\" ng-repeat=\"date in $ctrl.eventDates\" value=\"{{date}}\">{{date | date: \'MM/dd/yyyy\'}}</md-radio-button>\n                            <span class=\"single-date\" ng-if=\"!$ctrl.isPluralDates\">{{$ctrl.eventDates[0] | date: \'MM/dd/yyyy\'}}</span>\n                        </md-radio-group>\n                    </div>\n                </md-card-content>\n                <md-card-content class=\"appointment-time\" layout=\"column\" flex=\"30\">\n                    <div class=\"appointment-time-address\" layout=\"row\">\n                        <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.slotId.$error.required && $ctrl.saveClicked && $ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.postObj.appointment}\">\n                            <md-select placeholder=\"Appointment Time\" ng-model=\"$ctrl.postObj.slotId\" name=\"slotId\" ng-disabled=\"$ctrl.isReadOnly\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\'\">\n                                <md-option ng-repeat=\"el in $ctrl.eventTimes\" value=\"{{el.value}}\">\n                                    {{el.label}}\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                </md-card-content>\n                <md-card-content class=\"appointment-location\" layout=\"column\" flex=\"30\">\n                    <div layout=\"row\">\n                        <label><md-icon>map</md-icon></label>\n                        <div layout=\"column\">\n                            <div layout=\"row\" ng-if=\"$ctrl.providerLocation.address1\">\n                                {{$ctrl.providerLocation.address1}}\n                            </div>\n                            <div layout=\"row\" ng-if=\"$ctrl.providerLocation.address2\">\n                                {{$ctrl.providerLocation.address2}}\n                            </div>\n                            <div ng-if=\"$ctrl.providerLocation.city && $ctrl.providerLocation.state\">\n                                <span>{{$ctrl.providerLocation.city}}, {{$ctrl.providerLocation.state}}</span>\n                                <span ng-if=\"$ctrl.providerLocation.postalCode || $ctrl.providerLocation.county\">\n                                    {{$ctrl.providerLocation.postalCode || \', \' + $ctrl.providerLocation.county}}</span>\n                            </div>\n                            <div layout=\"row\" ng-if=\"!$ctrl.providerLocation.address1 &&\n                                                        !$ctrl.providerLocation.city &&\n                                                        !$ctrl.providerLocation.state\">\n                                No location data available.\n                            </div>\n                        </div>\n                    </div>\n                </md-card-content>\n            </div>\n            <div layout=\"row\" ng-if=\"!$ctrl.providerLocation.address1 && !$ctrl.isReadOnly\">\n                <md-card-content class=\"appointment-schedule\" layout=\"row\">\n                    <div layout=\"row\">\n                        <label><md-icon>date_range</md-icon>&nbsp;Appointment</label>\n                    </div>\n                    <div class=\"appointment-date\" layout=\"row\">\n                        <md-radio-group ng-model=\"$ctrl.postObj.appointment\" name=\"appointmentDate\" layout-margin ng-change=\"$ctrl.setTimeSlotsByDate()\" ng-disabled=\"$ctrl.postObj.callResult.callOutcome !== \'APPOINTMENT_SCHEDULED\'\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.saveClicked\" class=\"appointment-date-radio\">\n                            <md-radio-button ng-if=\"$ctrl.isPluralDates\" ng-repeat=\"date in $ctrl.eventDates\" value=\"{{date}}\">{{date | date: \'MM/dd/yyyy\'}}</md-radio-button>\n                            <span class=\"single-date\" ng-if=\"!$ctrl.isPluralDates\">{{$ctrl.eventDates[0] | date: \'MM/dd/yyyy\'}}</span>\n                        </md-radio-group>\n                    </div>\n                    <div class=\"appointment-time\" layout=\"row\">\n                        <md-input-container class=\"md-block\" ng-class=\"{\'md-input-invalid\': callResultActionsForm.slotId.$error.required && $ctrl.saveClicked && $ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\' && $ctrl.postObj.appointment}\">\n                            <md-select placeholder=\"Appointment Time\" ng-model=\"$ctrl.postObj.slotId\" name=\"slotId\" ng-required=\"$ctrl.postObj.callResult.callOutcome === \'APPOINTMENT_SCHEDULED\'\">\n                                <md-option ng-repeat=\"el in $ctrl.eventTimes\" value=\"{{el.value}}\">\n                                    {{el.label}}\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                </md-card-content>\n            </div>\n            <div layout=\"row\">\n                <md-card-content class=\"appointment-instructions\" ng-if=\"!$ctrl.isReadOnly\">\n                    <md-input-container class=\"md-block\">\n                        <label>Special Handling Instructions</label>\n                        <input ng-model=\"$ctrl.postObj.appointmentComment\" name=\"appointmentComment\" ng-disabled=\"$ctrl.postObj.callResult.callOutcome !== \'APPOINTMENT_SCHEDULED\' && $ctrl.postObj.callResult.callOutcome !== \'RESCHEDULED\'\">\n                    </md-input-container>\n                </md-card-content>\n            </div>\n        </div>\n        <div ng-if=\"!$ctrl.isReadOnly\">\n            <div class=\"button-container\">\n                <md-button ng-disabled=\"$ctrl.saveClicked\" ng-click=\"$ctrl.cancel()\" class=\"md-primary\">CANCEL</md-button>\n                <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\" aria-label=\"button\" ng-disabled=\"!callResultActionsForm.$valid || $ctrl.saveClicked\">\n                    <span ng-if=\"!$ctrl.saveClicked\">Save</span>\n                    <sc-loading-spinner ng-if=\"$ctrl.saveClicked\" diameter=\"25\"></sc-loading-spinner>\n                </md-button>\n            </div>\n        </div>\n\n        <md-card-content ng-if=\"$ctrl.isReadOnly\">\n            <div layout=\"row\">\n                <label class=\"centered-content\"><md-icon>date_range</md-icon>&nbsp;Appointment</label>\n            </div>\n            <div layout=\"row\">\n                <div class=\"centered-content text\">\n                    <p>No Appointment Scheduled</p>\n                </div>\n            </div>\n            <md-input-container class=\"md-block\">\n                <label>Special Handling Instructions</label>\n                <p class=\"appointment-comment read-only\">{{$ctrl.postObj.appointmentComment || \'No Instructions\'}}</p>\n            </md-input-container>\n        </md-card-content>\n\n    </md-card>\n</form>\n");
$templateCache.put("app/components/actionPlans/details/grid/cancelled/apm.details.grid.cancelled.html","<md-card ng-if=\"$ctrl.actionPlan\" layout-padding layout-margin layout-align=\"center center\">\n    <p md-colors=\"{color: \'primary-700\'}\">This Action Plan has been cancelled.</p>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/details/grid/encounter/apm.details.grid.encounter.component.html","<md-card ng-if=\"$ctrl.actionPlan\" layout-margin>\n    <mdt-table class=\"action-plan-details-grid\" paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-row-paginator-error-message=\"Error happened while loading patient list.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                \'table-row-id-key\': \'patient\',\n                \'column-keys\': $ctrl.columns\n            }\" ng-cloak>\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\">Contact</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Pending HCC</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Gaps</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Appt</mdt-column>\n            <mdt-column align-rule=\"left\">Results</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"fullName\">\n            <a ng-click=\"clientScope.$ctrl.navigateToPatientDetails(rowId)\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"phone\">\n            <div class=\"event-column\">{{value | phoneNumber}}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"unmetCount\">\n            <span data-tooltip=\"{{::clientScope.$ctrl.getGapsTooltipTemplate(rowId)}}\" ng-class=\"::clientScope.$ctrl.getPatientGaps(rowId) ? \'tooltip-right\' : \'tooltip-hidden\'\">\n                {{::value}}\n            </span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"results\">\n            <md-icon ng-class=\"{\'light-gray\': value.lightGray}\" alt=\"{{value.text}}\" title=\"{{value.text}}\">\n                <a ng-class=\"{\'hidden\': value.hideLink}\" ui-sref=\"actionPlans.encounter({ planId: clientScope.$ctrl.actionPlan._id, patientId: rowId })\">{{value.icon}}</a>\n                <span ng-class=\"{\'hidden\': !value.hideLink}\">{{value.icon}}</span>\n            </md-icon>\n        </mdt-custom-cell>\n\n        <sc-grid-session-store key=\"action-plan-patients-encounter\" save-state-callback=\"$ctrl.setSaveStateCallback(callback)\" restore-state-callback=\"$ctrl.restoreStateCallback(callback)\" get-state-callback=\"$ctrl.setGetStateCallback(callback)\">\n        </sc-grid-session-store>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/details/grid/proposed/apm.details.grid.proposed.html","<md-card ng-if=\"$ctrl.actionPlan\" layout-padding layout-margin layout-align=\"center center\">\n    <p md-colors=\"{color: \'primary-700\'}\">Patients will be added when the Action Plan is started.</p>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/details/grid/reminder/apm.details.grid.reminder.html","<md-card ng-if=\"$ctrl.actionPlan\" layout-margin>\n    <mdt-table class=\"action-plan-details-grid\" paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-row-paginator-error-message=\"Error happened while loading patient list.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                \'table-row-id-key\': \'patient\',\n                \'column-keys\': $ctrl.columns\n            }\" ng-cloak>\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\">Contact</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Pending HCC</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Gaps</mdt-column>\n            <mdt-column align-rule=\"left\">Vendor</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Appt</mdt-column>\n            <mdt-column align-rule=\"left\" ng-if=\"!$ctrl.isCancelled\">Results</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"fullName\">\n            <a ng-click=\"clientScope.$ctrl.navigateToPatientDetails(rowId)\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"phone\">\n            <div class=\"event-column\">{{value | phoneNumber}}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"unmetCount\">\n            <span data-tooltip=\"{{::clientScope.$ctrl.getGapsTooltipTemplate(rowId)}}\" ng-class=\"::clientScope.$ctrl.getPatientGaps(rowId) ? \'tooltip-right\' : \'tooltip-hidden\'\">\n                {{::value}}\n            </span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"careTeamSummaries\">\n            <span data-tooltip=\"{{::clientScope.$ctrl.getVendorTooltipTemplate(value)}}\" ng-class=\"(value.length) ? \'tooltip-right\' : \'hidden\'\">\n                <md-icon>{{::clientScope.$ctrl.getVendorIcon(value)}}</md-icon>\n            </span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"results\">\n            <md-icon ng-class=\"{\'md-accent\': value.accent, \'light-gray\': value.lightGray}\" alt=\"{{value.text}}\" title=\"{{value.text}}\">\n                <a class=\"ng-hide\" ng-show=\"value.icon === \'chat_bubble\' || value.icon === \'chat\'\" ui-sref=\"actionPlans.reminder({ planId: clientScope.$ctrl.actionPlan._id, patientId: rowId })\">{{value.icon}}</a>\n                <span class=\"ng-hide\" ng-hide=\"value.icon === \'chat_bubble\' || value.icon === \'chat\'\">{{value.icon}}</span>\n            </md-icon>\n        </mdt-custom-cell>\n\n        <sc-grid-session-store key=\"action-plan-patients-reminder\" save-state-callback=\"$ctrl.setSaveStateCallback(callback)\" restore-state-callback=\"$ctrl.restoreStateCallback(callback)\" get-state-callback=\"$ctrl.setGetStateCallback(callback)\">\n        </sc-grid-session-store>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/details/grid/schedule/apm.details.grid.schedule.html","<md-card ng-if=\"$ctrl.actionPlan && $ctrl.hasPatients\" layout-margin>\n    <mdt-table class=\"action-plan-details-grid\" paginated-rows=\"{isEnabled: false, rowsPerPageValues: $ctrl.PAGE_SIZES}\" mdt-trigger-request=\"$ctrl.setLoadResultsCallback(loadPageCallback)\" mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-row-paginator-error-message=\"Error happened while loading patient list.\" mdt-row-paginator-no-results-message=\"There are no results that meet that Filter Criteria. Please try again.\" mdt-row=\"{\n                \'table-row-id-key\': \'patient\',\n                \'column-keys\': $ctrl.columns\n            }\" ng-cloak>\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Patient</mdt-column>\n            <mdt-column align-rule=\"left\">Contact</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Last PCP Visit</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Pending HCC</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\">Gaps</mdt-column>\n            <mdt-column align-rule=\"left\">Vendor</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"true\" ng-if=\"!$ctrl.isCancelled\">Appt Status</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"fullName\">\n            <a ng-click=\"clientScope.$ctrl.navigateToPatientDetails(rowId)\">{{value}}</a>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"phone\">\n            <div class=\"event-column\">{{value | phoneNumber}}</div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"unmetCount\">\n            <span data-tooltip=\"{{::clientScope.$ctrl.getGapsTooltipTemplate(rowId)}}\" ng-class=\"::clientScope.$ctrl.getPatientGaps(rowId) ? \'tooltip-right\' : \'tooltip-hidden\'\">\n                {{::value}}\n            </span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"careTeamSummaries\">\n            <span data-tooltip=\"{{::clientScope.$ctrl.getVendorTooltipTemplate(value)}}\" ng-class=\"(value.length) ? \'tooltip-right\' : \'hidden\'\">\n                <md-icon>{{::clientScope.$ctrl.getVendorIcon(value)}}</md-icon>\n            </span>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"apptStatus\">\n            <md-icon ng-show=\"value.icon\" ng-class=\"{\'md-accent\': value.accent, \'light-gray\': !value.accent}\" alt=\"{{value.text}}\" title=\"{{value.text}}\">\n                <a class=\"ng-hide\" ng-hide=\"value.icon === \'close\'\" ui-sref=\"actionPlans.schedule({ planId: clientScope.$ctrl.actionPlan._id, patientId: rowId })\">{{value.icon}}</a>\n                <span class=\"ng-hide\" ng-show=\"value.icon === \'close\'\">{{value.icon}}</span>\n            </md-icon>\n            <a ng-hide=\"value.icon\" ui-sref=\"actionPlans.schedule({ planId: clientScope.$ctrl.actionPlan._id, patientId: rowId })\">{{value.time}}</a>\n        </mdt-custom-cell>\n\n        <sc-grid-session-store key=\"action-plan-patients-schedule\" save-state-callback=\"$ctrl.setSaveStateCallback(callback)\" restore-state-callback=\"$ctrl.restoreStateCallback(callback)\" get-state-callback=\"$ctrl.setGetStateCallback(callback)\">\n        </sc-grid-session-store>\n\n        <sc-grid-pagination></sc-grid-pagination>\n    </mdt-table>\n</md-card>\n\n<md-card ng-if=\"$ctrl.actionPlan && !$ctrl.hasPatients\" layout-padding layout-margin layout-align=\"center center\">\n    <p md-colors=\"{color: \'primary-700\'}\">There are no patients that qualify for the Action Plan you\'ve created. Please cancel this Action Plan and create a new one with different criteria.</p>\n</md-card>\n");
$templateCache.put("app/components/actionPlans/details/header/activePlans/apm.details.header.activePlans.html","\n<div layout=\"column\" flex=\"100\">\n    <div layout=\"row\" layout-align=\"end start\">\n        <span ng-repeat=\"operation in $ctrl.actionPlanContext.allowableOperations\">\n            <md-button class=\"md-raised md-accent\" ng-if=\"::(operation.descriptiveText !== \'Edit\')\" ng-click=\"$ctrl.getClickEvent(operation.operationName)\" access-control=\"{{ $ctrl.getOperationPermissions(operation) }}\" access-type=\"PERMISSION\" aria-label=\"button\" ng-disabled=\"$ctrl.loading\">\n                <span ng-if=\"!$ctrl.loading\">{{operation.descriptiveText}}</span>\n                <sc-loading-spinner ng-if=\"$ctrl.loading\" diameter=\"25\"></sc-loading-spinner>\n            </md-button>\n        </span>\n    </div>\n    <div layout=\"row\" layout-align=\"end start\">\n        <span class=\"md-title hide-ineligible-patients-switch\" layout=\"row\" layout-align=\"end center\">\n            Hide Ineligible Patients\n            <md-switch ng-model=\"$ctrl.hideIneligiblePatients\" ng-change=\"$ctrl.setPatients()\" aria-label=\"Hide Ineligible Patients\" class=\"md-primary\"></md-switch>\n        </span>\n    </div>\n</div>\n");
$templateCache.put("app/components/actionPlans/details/header/proposed/apm.details.header.proposed.html","\n<div ng-if=\"$ctrl.processing\" flex=\"auto\" layout=\"row\" layout-align=\"center center\">\n    <span>{{$ctrl.processingMessage}}</span>\n</div>\n\n<div class=\"action-buttons\" ng-if=\"!$ctrl.actionPlanContext.processing\" layout-align=\"end start\">\n    <span ng-repeat=\"operation in $ctrl.actionPlanContext.allowableOperations\">\n        <md-button class=\"md-raised md-accent\" aria-label=\"button\" ng-if=\"operation.descriptiveText !== \'Edit\'\" ng-disabled=\"$ctrl.loading\" ng-click=\"$ctrl.getClickEvent(operation.operationName)\" access-type=\"PERMISSION\" access-control=\"{{ $ctrl.getOperationPermissions(operation) }}\">\n            <span ng-if=\"!$ctrl.loading\">{{operation.descriptiveText}}</span>\n            <sc-loading-spinner ng-if=\"$ctrl.loading\" diameter=\"25\"></sc-loading-spinner>\n        </md-button>\n    </span>\n</div>\n");
$templateCache.put("app/components/resources/locations/grid/modals/apm.resources.locations.list.modal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Merged Locations</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n\n<md-dialog-content class=\"dialog-content\">\n    <apm-resources-locations-list-modal-grid location=\"$ctrl.location\"></apm-resources-locations-list-modal-grid>\n</md-dialog-content>\n");
$templateCache.put("app/components/actionPlans/details/header/modals/cancel/apm.details.cancelModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>Cancel Reason</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content class=\"dialog-content\">\n    <form class=\"header-modal\" name=\"cancelForm\" layout-padding>\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n        <h4 class=\"title\">Cancellation Reason</h4>\n        <md-input-container class=\"md-block\" flex=\"initial\">\n            <label>Select Reason</label>\n            <md-select ng-model=\"$ctrl.reasonObj.cancellationReason\" aria-label=\"select\" name=\"reasonCode\" ng-change=\"$ctrl.setReason($ctrl.reasonObj.cancellationReason)\" ng-required=\"true\">\n                <md-option ng-value=\"reason.code\" ng-repeat=\"reason in $ctrl.reasonsForCancellation\">{{ reason.display }}</md-option>\n            </md-select>\n        </md-input-container>\n        <div class=\"validation-messages\" ng-messages=\"cancelForm.reasonCode.$error\" ng-show=\"cancelForm.reasonCode.$touched\">\n            <div ng-message=\"required\">Cancellation Reason Required.</div>\n        </div>\n        <md-input-container class=\"comment-container\">\n            <label>Additional Comments</label>\n            <input name=\"comments\" ng-model=\"$ctrl.reasonObj.comments\" ng-disabled=\"!$ctrl.isNoteRequired\" ng-required=\"$ctrl.isNoteRequired\">\n        </md-input-container>\n        <div class=\"validation-messages comment\" ng-messages=\"cancelForm.comments.$error\" ng-show=\"cancelForm.comments.$touched\">\n            <div ng-message=\"required\">Comment required.</div>\n        </div>\n    </form>\n</md-dialog-content>\n<md-dialog-actions class=\"dialog-actions\">\n    <md-button class=\"md-raised\" ng-click=\"$ctrl.cancel()\">CANCEL</md-button>\n    <md-button class=\"md-raised md-accent\" ng-disabled=\"cancelForm.$invalid\" ng-click=\"$ctrl.save()\">SAVE</md-button>\n</md-dialog-actions>");
$templateCache.put("app/components/actionPlans/details/header/modals/onHold/apm.details.onHoldModal.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <h2>On Hold Reason</h2>\n        <span flex></span>\n        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\">\n            <md-icon alt=\"Close dialog\">close</md-icon>\n        </md-button>\n    </div>\n</md-toolbar>\n<md-dialog-content class=\"dialog-content\" layout-padding>\n    <form class=\"header-modal\" name=\"$ctrl.onHoldForm\">\n        <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n        <md-input-container class=\"md-block\" flex=\"initial\">\n            <label>Select Reason</label>\n            <md-select ng-model=\"$ctrl.postObj.onHoldReason\" aria-label=\"select\" name=\"reasonCode\" ng-change=\"$ctrl.setReason($ctrl.postObj.onHoldReason)\" ng-required=\"true\">\n                <md-option value=\"AWAITING_ALTERNATE_DATES\">Awaiting Alternate Dates</md-option>\n                <md-option value=\"AWAITING_SDO\">Awaiting SDO</md-option>\n                <md-option value=\"STAFFING_ISSUE_MA\">Staffing Issue - MA</md-option>\n                <md-option value=\"STAFFING_ISSUE_NP_MD\">Staffing Issue - NP/MD</md-option>\n                <md-option value=\"OTHER\">Other</md-option>\n            </md-select>\n        </md-input-container>\n        <div class=\"validation-messages\" ng-messages=\"$ctrl.onHoldForm.reasonCode.$error\" ng-show=\"$ctrl.onHoldForm.reasonCode.$touched\">\n            <div ng-message=\"required\">On Hold Reason Required.</div>\n        </div>\n        <md-input-container class=\"comment-container\">\n            <label>Additional Comments</label>\n            <input type=\"text\" name=\"comments\" ng-model=\"$ctrl.postObj.onHoldComments\" ng-disabled=\"!$ctrl.isNoteRequired\" ng-required=\"$ctrl.isNoteRequired\">\n        </md-input-container>\n    </form>\n</md-dialog-content>\n<md-dialog-actions class=\"dialog-actions\">\n    <md-button class=\"md-accent\" ng-click=\"$ctrl.cancel()\">CANCEL</md-button>\n    <md-button class=\"on-hold-button md-raised md-accent\" ng-disabled=\"$ctrl.onHoldForm.$invalid\" ng-click=\"$ctrl.save()\">PLACE ON HOLD</md-button>\n</md-dialog-actions>\n");
$templateCache.put("app/components/resources/locations/grid/modals/grid/apm.resources.locations.list.modal.grid.component.html","<div class=\"error-message\">\n    <sc-notify-error-label ng-if=\"$ctrl.errorMessage\" class=\"Sc-notify-error-label\" error-message=\"$ctrl.errorMessage\"></sc-notify-error-label>\n</div>\n<md-card layout=\"column\" layout-padding>\n    <mdt-table mdt-row-paginator=\"$ctrl.fetchPage(page, pageSize, options)\" mdt-row-paginator-error-message=\"Error happened while loading the locations.\" mdt-row=\"{\n                    \'column-keys\': [\n                                \'fullAddress\',\n                                \'city\',\n                                \'county\',\n                                \'state\',\n                                \'zip\',\n                                \'remove\'\n                              ],\n                    \'table-row-id-key\': \'locationId\'\n                }\" ng-cloak>\n\n        <mdt-header-row>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Address</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">City</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">County</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">State</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Zip Code</mdt-column>\n            <mdt-column align-rule=\"left\" column-sort=\"false\">Remove</mdt-column>\n        </mdt-header-row>\n\n        <mdt-custom-cell column-key=\"fullAddress\" html-content=\"true\">\n            <div class=\"address-cell\">\n                <p>{{ value.address1 }}</p>\n                <p ng-show=\"value.address2\">{{ value.address2 }}</p>\n            </div>\n        </mdt-custom-cell>\n\n        <mdt-custom-cell column-key=\"remove\">\n            <md-icon class=\"no-select\" title=\"Remove {{ rowId }}\" ng-click=\"clientScope.$ctrl.onClickLocationRemove($event, rowId)\">delete</md-icon>\n        </mdt-custom-cell>\n    </mdt-table>\n</md-card>\n");}]);